(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-atomicfu.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-atomicfu.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-coroutines-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-coroutines-core'.");
    }
    if (typeof globalThis['kotlinx-atomicfu'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-coroutines-core'. Its dependency 'kotlinx-atomicfu' was not found. Please, check whether 'kotlinx-atomicfu' is loaded prior to 'kotlinx-coroutines-core'.");
    }
    globalThis['kotlinx-coroutines-core'] = factory(typeof globalThis['kotlinx-coroutines-core'] === 'undefined' ? {} : globalThis['kotlinx-coroutines-core'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-atomicfu']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_atomicfu) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var protoOf = kotlin_kotlin.$_$.eh;
  var Continuation = kotlin_kotlin.$_$.rd;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.q2;
  var Key_instance = kotlin_kotlin.$_$.p2;
  var equals = kotlin_kotlin.$_$.sf;
  var createCoroutineUnintercepted = kotlin_kotlin.$_$.id;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var atomic$int$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.e;
  var intercepted = kotlin_kotlin.$_$.jd;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.o6;
  var isInterface = kotlin_kotlin.$_$.rg;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var atomic$ref$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.d;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var hashCode = kotlin_kotlin.$_$.bg;
  var Companion_instance = kotlin_kotlin.$_$.j3;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z;
  var createFailure = kotlin_kotlin.$_$.ko;
  var atomic$boolean$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.b;
  var CancellationException_init_$Create$ = kotlin_kotlin.$_$.q4;
  var Result__exceptionOrNull_impl_p6xea9 = kotlin_kotlin.$_$.a1;
  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.d1;
  var AbstractCoroutineContextKey = kotlin_kotlin.$_$.nd;
  var AbstractCoroutineContextElement = kotlin_kotlin.$_$.md;
  var get = kotlin_kotlin.$_$.od;
  var minusKey = kotlin_kotlin.$_$.pd;
  var ContinuationInterceptor = kotlin_kotlin.$_$.qd;
  var RuntimeException_init_$Create$ = kotlin_kotlin.$_$.l6;
  var addSuppressed = kotlin_kotlin.$_$.eo;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var Enum = kotlin_kotlin.$_$.en;
  var startCoroutine = kotlin_kotlin.$_$.zd;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var Long = kotlin_kotlin.$_$.kn;
  var compare = kotlin_kotlin.$_$.je;
  var Duration__isPositive_impl_tvkkt2 = kotlin_kotlin.$_$.k;
  var Companion_getInstance = kotlin_kotlin.$_$.d3;
  var DurationUnit_NANOSECONDS_getInstance = kotlin_kotlin.$_$.s3;
  var toDuration = kotlin_kotlin.$_$.sm;
  var Duration__plus_impl_yu9v8f = kotlin_kotlin.$_$.l;
  var _Duration___get_inWholeMilliseconds__impl__msfiry = kotlin_kotlin.$_$.i;
  var ArrayDeque_init_$Create$ = kotlin_kotlin.$_$.x3;
  var add = kotlin_kotlin.$_$.fe;
  var subtract = kotlin_kotlin.$_$.af;
  var RuntimeException = kotlin_kotlin.$_$.rn;
  var RuntimeException_init_$Init$ = kotlin_kotlin.$_$.k6;
  var captureStack = kotlin_kotlin.$_$.gf;
  var Error_0 = kotlin_kotlin.$_$.fn;
  var Error_init_$Init$ = kotlin_kotlin.$_$.c5;
  var Element = kotlin_kotlin.$_$.vd;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.ce;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.z3;
  var CancellationException = kotlin_kotlin.$_$.fd;
  var ArrayList = kotlin_kotlin.$_$.x6;
  var SequenceScope = kotlin_kotlin.$_$.aj;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var IllegalStateException_init_$Create$_0 = kotlin_kotlin.$_$.y5;
  var sequence = kotlin_kotlin.$_$.hj;
  var plus = kotlin_kotlin.$_$.wd;
  var get_0 = kotlin_kotlin.$_$.td;
  var fold = kotlin_kotlin.$_$.sd;
  var minusKey_0 = kotlin_kotlin.$_$.ud;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var anyToString = kotlin_kotlin.$_$.df;
  var UnsupportedOperationException = kotlin_kotlin.$_$.do;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var CancellationException_init_$Init$ = kotlin_kotlin.$_$.p4;
  var DurationUnit_MILLISECONDS_getInstance = kotlin_kotlin.$_$.q3;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var charCodeAt = kotlin_kotlin.$_$.jf;
  var toString_1 = kotlin_kotlin.$_$.y;
  var substring = kotlin_kotlin.$_$.ol;
  var returnIfSuspended = kotlin_kotlin.$_$.w3;
  var atomicfu$AtomicRefArray$ofNulls = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.a;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var fromInt = kotlin_kotlin.$_$.pe;
  var multiply = kotlin_kotlin.$_$.ue;
  var divide = kotlin_kotlin.$_$.ne;
  var modulo = kotlin_kotlin.$_$.te;
  var convertToInt = kotlin_kotlin.$_$.le;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var bitwiseAnd = kotlin_kotlin.$_$.ge;
  var shiftRight = kotlin_kotlin.$_$.ze;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var atomic$long$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.c;
  var listOf = kotlin_kotlin.$_$.ta;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.a4;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.b6;
  var compareTo = kotlin_kotlin.$_$.nf;
  var last = kotlin_kotlin.$_$.ok;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var shiftLeft = kotlin_kotlin.$_$.xe;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var NoSuchElementException = kotlin_kotlin.$_$.ln;
  var NoSuchElementException_init_$Init$ = kotlin_kotlin.$_$.c6;
  var IllegalStateException = kotlin_kotlin.$_$.in;
  var IllegalStateException_init_$Init$ = kotlin_kotlin.$_$.v5;
  var getKClass = kotlin_kotlin.$_$.si;
  var Unit = kotlin_kotlin.$_$.co;
  var copyOf = kotlin_kotlin.$_$.v8;
  var get_ONE = kotlin_kotlin.$_$.ee;
  var throwKotlinNothingValueException = kotlin_kotlin.$_$.bp;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var joinToString = kotlin_kotlin.$_$.aa;
  var startCoroutineUninterceptedOrReturnNonGeneratorVersion = kotlin_kotlin.$_$.kd;
  var IndexedValue = kotlin_kotlin.$_$.b7;
  var fill = kotlin_kotlin.$_$.i9;
  var numberToByte = kotlin_kotlin.$_$.zg;
  var isArray = kotlin_kotlin.$_$.jg;
  var arrayCopy = kotlin_kotlin.$_$.q7;
  var coerceAtLeast = kotlin_kotlin.$_$.wh;
  var NoSuchElementException_init_$Create$_0 = kotlin_kotlin.$_$.d6;
  var Exception = kotlin_kotlin.$_$.gn;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.j5;
  var defineProp = kotlin_kotlin.$_$.pf;
  var bitwiseOr = kotlin_kotlin.$_$.he;
  var invert = kotlin_kotlin.$_$.qe;
  var toLongOrNull = kotlin_kotlin.$_$.am;
  var createCoroutineUnintercepted_0 = kotlin_kotlin.$_$.hd;
  var isSuspendFunction = kotlin_kotlin.$_$.tg;
  var Collection = kotlin_kotlin.$_$.y6;
  var KtList = kotlin_kotlin.$_$.e7;
  var plus_0 = kotlin_kotlin.$_$.jb;
  var listOf_0 = kotlin_kotlin.$_$.sa;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var Exception_init_$Create$ = kotlin_kotlin.$_$.i5;
  var CancellationException_init_$Create$_0 = kotlin_kotlin.$_$.s4;
  var CancellationException_init_$Init$_0 = kotlin_kotlin.$_$.r4;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.f4;
  var RuntimeException_init_$Init$_0 = kotlin_kotlin.$_$.i6;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.m4;
  var stackTraceToString = kotlin_kotlin.$_$.yo;
  var removeFirstOrNull = kotlin_kotlin.$_$.mb;
  var KtMutableList = kotlin_kotlin.$_$.i7;
  var coerceIn = kotlin_kotlin.$_$.fi;
  //endregion
  //region block: pre-declaration
  function cancel$default(cause, $super) {
    cause = cause === VOID ? null : cause;
    var tmp;
    if ($super === VOID) {
      this.a1b(cause);
      tmp = Unit_instance;
    } else {
      tmp = $super.a1b.call(this, cause);
    }
    return tmp;
  }
  function invokeOnCompletion$default(onCancelling, invokeImmediately, handler, $super) {
    onCancelling = onCancelling === VOID ? false : onCancelling;
    invokeImmediately = invokeImmediately === VOID ? true : invokeImmediately;
    return $super === VOID ? this.u1a(onCancelling, invokeImmediately, handler) : $super.u1a.call(this, onCancelling, invokeImmediately, handler);
  }
  initMetadataForInterface(Job, 'Job', VOID, VOID, [Element], [0]);
  initMetadataForInterface(ParentJob, 'ParentJob', VOID, VOID, [Job], [0]);
  initMetadataForClass(JobSupport, 'JobSupport', VOID, VOID, [Job, ParentJob], [0]);
  initMetadataForInterface(CoroutineScope, 'CoroutineScope');
  initMetadataForClass(AbstractCoroutine, 'AbstractCoroutine', VOID, JobSupport, [Job, Continuation, CoroutineScope], [0]);
  initMetadataForClass(StandaloneCoroutine, 'StandaloneCoroutine', VOID, AbstractCoroutine, VOID, [0]);
  initMetadataForClass(LazyStandaloneCoroutine, 'LazyStandaloneCoroutine', VOID, StandaloneCoroutine, VOID, [0]);
  initMetadataForCoroutine($awaitCOROUTINE$, CoroutineImpl);
  initMetadataForClass(DeferredCoroutine, 'DeferredCoroutine', VOID, AbstractCoroutine, [Job], [0]);
  initMetadataForClass(LazyDeferredCoroutine, 'LazyDeferredCoroutine', VOID, DeferredCoroutine, VOID, [0]);
  initMetadataForClass(ScopeCoroutine, 'ScopeCoroutine', VOID, AbstractCoroutine, VOID, [0]);
  initMetadataForClass(DispatchedCoroutine, 'DispatchedCoroutine', VOID, ScopeCoroutine, VOID, [0]);
  function cancel$default_0(cause, $super) {
    cause = cause === VOID ? null : cause;
    return $super === VOID ? this.d1d(cause) : $super.d1d.call(this, cause);
  }
  initMetadataForInterface(CancellableContinuation, 'CancellableContinuation', VOID, VOID, [Continuation]);
  initMetadataForInterface(NotCompleted, 'NotCompleted');
  initMetadataForInterface(CancelHandler, 'CancelHandler', VOID, VOID, [NotCompleted]);
  initMetadataForClass(DisposeOnCancel, 'DisposeOnCancel', VOID, VOID, [CancelHandler]);
  initMetadataForClass(UserSupplied, 'UserSupplied', VOID, VOID, [CancelHandler]);
  initMetadataForInterface(Runnable, 'Runnable');
  initMetadataForClass(SchedulerTask, 'SchedulerTask', VOID, VOID, [Runnable]);
  initMetadataForClass(DispatchedTask, 'DispatchedTask', VOID, SchedulerTask);
  initMetadataForInterface(Waiter, 'Waiter');
  initMetadataForClass(CancellableContinuationImpl, 'CancellableContinuationImpl', VOID, DispatchedTask, [CancellableContinuation, Waiter]);
  initMetadataForObject(Active, 'Active', VOID, VOID, [NotCompleted]);
  initMetadataForClass(CompletedContinuation, 'CompletedContinuation');
  initMetadataForClass(LockFreeLinkedListNode, 'LockFreeLinkedListNode', LockFreeLinkedListNode);
  initMetadataForInterface(DisposableHandle, 'DisposableHandle');
  initMetadataForInterface(Incomplete, 'Incomplete');
  initMetadataForClass(JobNode, 'JobNode', VOID, LockFreeLinkedListNode, [DisposableHandle, Incomplete]);
  initMetadataForClass(ChildContinuation, 'ChildContinuation', VOID, JobNode);
  initMetadataForCoroutine($awaitCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(CompletableDeferredImpl, 'CompletableDeferredImpl', VOID, JobSupport, [Job], [0]);
  initMetadataForInterface(CompletableJob, 'CompletableJob', VOID, VOID, [Job], [0]);
  initMetadataForClass(CompletedExceptionally, 'CompletedExceptionally');
  initMetadataForClass(CancelledContinuation, 'CancelledContinuation', VOID, CompletedExceptionally);
  initMetadataForObject(Key, 'Key', VOID, AbstractCoroutineContextKey);
  initMetadataForClass(CoroutineDispatcher, 'CoroutineDispatcher', VOID, AbstractCoroutineContextElement, [ContinuationInterceptor]);
  initMetadataForObject(Key_0, 'Key');
  initMetadataForObject(Key_1, 'Key');
  initMetadataForClass(CoroutineName, 'CoroutineName', VOID, AbstractCoroutineContextElement);
  initMetadataForObject(GlobalScope, 'GlobalScope', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(CoroutineStart, 'CoroutineStart', VOID, Enum);
  initMetadataForInterface(CopyableThrowable, 'CopyableThrowable');
  function invokeOnTimeout(timeMillis, block, context) {
    return get_DefaultDelay().p1h(timeMillis, block, context);
  }
  initMetadataForInterface(Delay, 'Delay', VOID, VOID, VOID, [1]);
  initMetadataForInterface(DelayWithTimeoutDiagnostics, 'DelayWithTimeoutDiagnostics', VOID, VOID, [Delay], [1]);
  initMetadataForClass(EventLoop, 'EventLoop', VOID, CoroutineDispatcher);
  initMetadataForObject(ThreadLocalEventLoop, 'ThreadLocalEventLoop');
  initMetadataForClass(CompletionHandlerException, 'CompletionHandlerException', VOID, RuntimeException);
  initMetadataForClass(CoroutinesInternalError, 'CoroutinesInternalError', VOID, Error_0);
  initMetadataForObject(Key_2, 'Key');
  initMetadataForObject(NonDisposableHandle, 'NonDisposableHandle', VOID, VOID, [DisposableHandle]);
  initMetadataForClass(DisposeOnCompletion, 'DisposeOnCompletion', VOID, JobNode);
  initMetadataForClass(SynchronizedObject, 'SynchronizedObject', SynchronizedObject);
  initMetadataForClass(Finishing, 'Finishing', VOID, SynchronizedObject, [Incomplete]);
  initMetadataForClass(ChildCompletion, 'ChildCompletion', VOID, JobNode);
  initMetadataForClass(AwaitContinuation, 'AwaitContinuation', VOID, CancellableContinuationImpl);
  initMetadataForLambda(JobSupport$_get_children_$slambda_k839f8, CoroutineImpl, VOID, [1]);
  initMetadataForClass(JobImpl, 'JobImpl', VOID, JobSupport, [CompletableJob], [0]);
  initMetadataForClass(Empty, 'Empty', VOID, VOID, [Incomplete]);
  initMetadataForClass(LockFreeLinkedListHead, 'LockFreeLinkedListHead', LockFreeLinkedListHead, LockFreeLinkedListNode);
  initMetadataForClass(NodeList, 'NodeList', NodeList, LockFreeLinkedListHead, [Incomplete]);
  initMetadataForClass(IncompleteStateBox, 'IncompleteStateBox');
  initMetadataForClass(InactiveNodeList, 'InactiveNodeList', VOID, VOID, [Incomplete]);
  initMetadataForClass(InvokeOnCompletion, 'InvokeOnCompletion', VOID, JobNode);
  initMetadataForClass(InvokeOnCancelling, 'InvokeOnCancelling', VOID, JobNode);
  initMetadataForClass(ResumeOnCompletion, 'ResumeOnCompletion', VOID, JobNode);
  initMetadataForClass(ChildHandleNode, 'ChildHandleNode', VOID, JobNode, [DisposableHandle]);
  initMetadataForClass(ResumeAwaitOnCompletion, 'ResumeAwaitOnCompletion', VOID, JobNode);
  initMetadataForClass(MainCoroutineDispatcher, 'MainCoroutineDispatcher', VOID, CoroutineDispatcher);
  initMetadataForClass(SupervisorJobImpl, 'SupervisorJobImpl', VOID, JobImpl, VOID, [0]);
  initMetadataForClass(SupervisorCoroutine, 'SupervisorCoroutine', VOID, ScopeCoroutine, VOID, [0]);
  initMetadataForClass(TimeoutCancellationException, 'TimeoutCancellationException', VOID, CancellationException, [CopyableThrowable]);
  initMetadataForClass(TimeoutCoroutine, 'TimeoutCoroutine', VOID, ScopeCoroutine, [Runnable], [0]);
  initMetadataForCoroutine($withTimeoutOrNullCOROUTINE$, CoroutineImpl);
  initMetadataForObject(Key_3, 'Key');
  initMetadataForClass(YieldContext, 'YieldContext', YieldContext, AbstractCoroutineContextElement);
  initMetadataForObject(Unconfined, 'Unconfined', VOID, CoroutineDispatcher);
  initMetadataForClass(BufferOverflow, 'BufferOverflow', VOID, Enum);
  initMetadataForClass(ConcurrentLinkedListNode, 'ConcurrentLinkedListNode');
  initMetadataForClass(Segment, 'Segment', VOID, ConcurrentLinkedListNode, [NotCompleted]);
  initMetadataForClass(ChannelSegment, 'ChannelSegment', VOID, Segment);
  initMetadataForCoroutine($hasNextCOROUTINE$, CoroutineImpl);
  initMetadataForClass(SendBroadcast, 'SendBroadcast', VOID, VOID, [Waiter]);
  initMetadataForClass(BufferedChannelIterator, 'BufferedChannelIterator', VOID, VOID, [Waiter], [0, 3]);
  initMetadataForCoroutine($sendCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($receiveCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($receiveCatchingCOROUTINE$, CoroutineImpl);
  function cancel$default_1(cause, $super) {
    cause = cause === VOID ? null : cause;
    var tmp;
    if ($super === VOID) {
      this.a1b(cause);
      tmp = Unit_instance;
    } else {
      tmp = $super.a1b.call(this, cause);
    }
    return tmp;
  }
  initMetadataForInterface(ReceiveChannel, 'ReceiveChannel', VOID, VOID, VOID, [0]);
  function close$default(cause, $super) {
    cause = cause === VOID ? null : cause;
    return $super === VOID ? this.z1s(cause) : $super.z1s.call(this, cause);
  }
  initMetadataForInterface(SendChannel, 'SendChannel', VOID, VOID, VOID, [1]);
  initMetadataForClass(BufferedChannel, 'BufferedChannel', VOID, VOID, [ReceiveChannel, SendChannel], [1, 4, 0, 3]);
  initMetadataForClass(WaiterEB, 'WaiterEB');
  initMetadataForClass(ReceiveCatching, 'ReceiveCatching', VOID, VOID, [Waiter]);
  initMetadataForObject(Factory, 'Factory');
  initMetadataForClass(Failed, 'Failed', Failed);
  initMetadataForClass(Closed, 'Closed', VOID, Failed);
  initMetadataForCompanion(Companion);
  initMetadataForClass(ChannelResult, 'ChannelResult');
  initMetadataForClass(ClosedReceiveChannelException, 'ClosedReceiveChannelException', VOID, NoSuchElementException);
  initMetadataForClass(ClosedSendChannelException, 'ClosedSendChannelException', VOID, IllegalStateException);
  initMetadataForClass(ChannelCoroutine, 'ChannelCoroutine', VOID, AbstractCoroutine, [ReceiveChannel, SendChannel], [1, 0]);
  initMetadataForClass(ConflatedBufferedChannel, 'ConflatedBufferedChannel', VOID, BufferedChannel, VOID, [1, 0]);
  initMetadataForInterface(ProducerScope, 'ProducerScope', VOID, VOID, [CoroutineScope, SendChannel], [1]);
  initMetadataForClass(ProducerCoroutine, 'ProducerCoroutine', VOID, ChannelCoroutine, [ProducerScope], [1, 0]);
  initMetadataForInterface(Flow, 'Flow', VOID, VOID, VOID, [1]);
  initMetadataForClass(AbstractFlow, 'AbstractFlow', VOID, VOID, [Flow], [1]);
  initMetadataForClass(SafeFlow, 'SafeFlow', VOID, AbstractFlow, VOID, [1]);
  initMetadataForObject(EmptyFlow, 'EmptyFlow', VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($collectCOROUTINE$, CoroutineImpl);
  initMetadataForClass(asFlow$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($collectCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(flowOf$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($collectCOROUTINE$_1, CoroutineImpl);
  function fuse$default(context, capacity, onBufferOverflow, $super) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    capacity = capacity === VOID ? -3 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    return $super === VOID ? this.a1x(context, capacity, onBufferOverflow) : $super.a1x.call(this, context, capacity, onBufferOverflow);
  }
  initMetadataForInterface(FusibleFlow, 'FusibleFlow', VOID, VOID, [Flow], [1]);
  initMetadataForClass(ChannelFlow, 'ChannelFlow', VOID, VOID, [FusibleFlow], [1]);
  initMetadataForClass(ChannelAsFlow, 'ChannelAsFlow', VOID, ChannelFlow, VOID, [1]);
  initMetadataForCoroutine($emitAllImplCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($collectCOROUTINE$_2, CoroutineImpl);
  initMetadataForInterface(FlowCollector, 'FlowCollector', VOID, VOID, VOID, [1]);
  initMetadataForClass(Emitter, 'Emitter', VOID, VOID, [DisposableHandle]);
  initMetadataForCoroutine($collectCOROUTINE$_3, CoroutineImpl);
  initMetadataForClass(AbstractSharedFlow, 'AbstractSharedFlow', VOID, SynchronizedObject);
  initMetadataForClass(SharedFlowImpl, 'SharedFlowImpl', VOID, AbstractSharedFlow, [Flow, FlowCollector, FusibleFlow], [1]);
  initMetadataForClass(AbstractSharedFlowSlot, 'AbstractSharedFlowSlot');
  initMetadataForClass(SharedFlowSlot, 'SharedFlowSlot', SharedFlowSlot, AbstractSharedFlowSlot);
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(SharingCommand, 'SharingCommand', VOID, Enum);
  initMetadataForClass(StartedEagerly, 'StartedEagerly', StartedEagerly);
  initMetadataForLambda(StartedLazily$command$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_4, CoroutineImpl);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(StartedLazily$command$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(StartedLazily, 'StartedLazily', StartedLazily);
  initMetadataForInterface(StateFlow, 'StateFlow', VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($collectCOROUTINE$_5, CoroutineImpl);
  initMetadataForClass(StateFlowImpl, 'StateFlowImpl', VOID, AbstractSharedFlow, [Flow, StateFlow, FlowCollector, FusibleFlow], [1]);
  initMetadataForClass(StateFlowSlot, 'StateFlowSlot', StateFlowSlot, AbstractSharedFlowSlot, VOID, [0]);
  initMetadataForClass(SubscriptionCountStateFlow, 'SubscriptionCountStateFlow', VOID, SharedFlowImpl, [StateFlow], [1]);
  initMetadataForClass(ChannelFlowOperator, 'ChannelFlowOperator', VOID, ChannelFlow, VOID, [1, 2]);
  initMetadataForClass(ChannelFlowOperatorImpl, 'ChannelFlowOperatorImpl', VOID, ChannelFlowOperator, VOID, [1]);
  initMetadataForLambda(ChannelFlowOperator$collectWithContextUndispatched$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_6, CoroutineImpl);
  initMetadataForLambda(ChannelFlow$_get_collectToFun_$slambda_j53z2e, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ChannelFlow$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(UndispatchedContextCollector$emitRef$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(UndispatchedContextCollector, 'UndispatchedContextCollector', VOID, VOID, [FlowCollector], [1]);
  initMetadataForClass(StackFrameContinuation, 'StackFrameContinuation', VOID, VOID, [Continuation]);
  initMetadataForCoroutine($withContextUndispatchedCOROUTINE$, CoroutineImpl);
  initMetadataForLambda(combineInternal$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(combineInternal$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(combineInternal$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(FlowCoroutine, 'FlowCoroutine', VOID, ScopeCoroutine, VOID, [0]);
  initMetadataForLambda(scopedFlow$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_7, CoroutineImpl);
  initMetadataForClass(scopedFlow$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ChannelFlowTransformLatest$flowCollect$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_1, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(ChannelFlowTransformLatest$flowCollect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ChannelFlowTransformLatest, 'ChannelFlowTransformLatest', VOID, ChannelFlowOperator, VOID, [1]);
  initMetadataForObject(NopCollector, 'NopCollector', VOID, VOID, [FlowCollector], [1]);
  initMetadataForClass(SendingCollector, 'SendingCollector', VOID, VOID, [FlowCollector], [1]);
  initMetadataForLambda(debounceInternal$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_2, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(debounceInternal$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(debounceInternal$slambda$slambda_1, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(debounceInternal$slambda$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(debounceInternal$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_3, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(DistinctFlowImpl$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(DistinctFlowImpl, 'DistinctFlowImpl', VOID, VOID, [Flow], [1]);
  initMetadataForClass(ThrowingCollector, 'ThrowingCollector', VOID, VOID, [FlowCollector], [1]);
  initMetadataForCoroutine($collectCOROUTINE$_8, CoroutineImpl);
  initMetadataForClass(onCompletion$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($collectCOROUTINE$_9, CoroutineImpl);
  initMetadataForClass(onStart$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForCoroutine($invokeSafelyCOROUTINE$, CoroutineImpl);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_4, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForCoroutine($collectCOROUTINE$_10, CoroutineImpl);
  initMetadataForClass(catch$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(catchImpl$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($catchImplCOROUTINE$, CoroutineImpl);
  initMetadataForLambda(mapLatest$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($onSubscriptionCOROUTINE$, CoroutineImpl);
  initMetadataForClass(SubscribedFlowCollector, 'SubscribedFlowCollector', VOID, VOID, [FlowCollector], [0, 1]);
  initMetadataForCoroutine($collectCOROUTINE$_11, CoroutineImpl);
  initMetadataForClass(ReadonlyStateFlow, 'ReadonlyStateFlow', VOID, VOID, [StateFlow, Flow, FusibleFlow], [1]);
  initMetadataForCoroutine($collectCOROUTINE$_12, CoroutineImpl);
  initMetadataForClass(ReadonlySharedFlow, 'ReadonlySharedFlow', VOID, VOID, [Flow, FusibleFlow], [1]);
  initMetadataForClass(SharingConfig, 'SharingConfig');
  initMetadataForLambda(launchSharing$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(launchSharing$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(launchSharing$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_5, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(onEach$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_13, CoroutineImpl);
  initMetadataForClass(onEach$$inlined$unsafeTransform$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_6, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(filterNotNull$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$_14, CoroutineImpl);
  initMetadataForClass(filterNotNull$$inlined$unsafeTransform$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(combine$o$collect$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($collectCOROUTINE$_15, CoroutineImpl);
  initMetadataForClass(combine$$inlined$unsafeFlow$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForLambda(launchIn$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($emitCOROUTINE$, CoroutineImpl);
  initMetadataForClass(first$$inlined$collectWhile$1, VOID, VOID, VOID, [FlowCollector], [1]);
  initMetadataForCoroutine($emitCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(firstOrNull$$inlined$collectWhile$1, VOID, VOID, VOID, [FlowCollector], [1]);
  initMetadataForCoroutine($firstCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($firstOrNullCOROUTINE$, CoroutineImpl);
  initMetadataForClass(SegmentOrClosed, 'SegmentOrClosed');
  initMetadataForObject(ExceptionSuccessfullyProcessed, 'ExceptionSuccessfullyProcessed', VOID, Exception);
  initMetadataForClass(DispatchedContinuation, 'DispatchedContinuation', VOID, DispatchedTask, [Continuation]);
  initMetadataForClass(DispatchException, 'DispatchException', VOID, Exception);
  initMetadataForClass(Worker, 'Worker', VOID, VOID, [Runnable]);
  initMetadataForClass(LimitedDispatcher, 'LimitedDispatcher', VOID, CoroutineDispatcher, [Delay], [1]);
  initMetadataForClass(LockFreeTaskQueue, 'LockFreeTaskQueue');
  initMetadataForClass(Placeholder, 'Placeholder');
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(LockFreeTaskQueueCore, 'LockFreeTaskQueueCore');
  initMetadataForClass(NamedDispatcher, 'NamedDispatcher', VOID, CoroutineDispatcher, [Delay], [1]);
  initMetadataForClass(UndeliveredElementException, 'UndeliveredElementException', VOID, RuntimeException);
  initMetadataForClass(ContextScope, 'ContextScope', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(Symbol, 'Symbol');
  initMetadataForClass(sam$kotlinx_coroutines_Runnable$0, 'sam$kotlinx_coroutines_Runnable$0', VOID, VOID, [Runnable, FunctionAdapter]);
  initMetadataForClass(OnTimeout, 'OnTimeout');
  initMetadataForClass(SelectClause0Impl, 'SelectClause0Impl');
  initMetadataForInterface(SelectInstance, 'SelectInstance');
  initMetadataForClass(SelectClause1Impl, 'SelectClause1Impl');
  initMetadataForCoroutine($invokeBlockCOROUTINE$, CoroutineImpl);
  initMetadataForClass(ClauseData, 'ClauseData', VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($doSelectCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($doSelectSuspendCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($completeCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($processResultAndInvokeBlockRecoveringExceptionCOROUTINE$, CoroutineImpl);
  initMetadataForClass(SelectImplementation, 'SelectImplementation', VOID, VOID, [CancelHandler, SelectInstance, Waiter], [0, 2]);
  initMetadataForClass(TrySelectDetailedResult, 'TrySelectDetailedResult', VOID, Enum);
  function tryLock$default(owner, $super) {
    owner = owner === VOID ? null : owner;
    return $super === VOID ? this.m2u(owner) : $super.m2u.call(this, owner);
  }
  function lock$default(owner, $completion, $super) {
    owner = owner === VOID ? null : owner;
    return $super === VOID ? this.o2u(owner, $completion) : $super.o2u.call(this, owner, $completion);
  }
  function unlock$default(owner, $super) {
    owner = owner === VOID ? null : owner;
    var tmp;
    if ($super === VOID) {
      this.q2u(owner);
      tmp = Unit_instance;
    } else {
      tmp = $super.q2u.call(this, owner);
    }
    return tmp;
  }
  initMetadataForInterface(Mutex, 'Mutex', VOID, VOID, VOID, [1]);
  initMetadataForClass(CancellableContinuationWithOwner, 'CancellableContinuationWithOwner', VOID, VOID, [CancellableContinuation, Waiter]);
  initMetadataForClass(SemaphoreAndMutexImpl, 'SemaphoreAndMutexImpl', VOID, VOID, VOID, [0]);
  initMetadataForClass(MutexImpl, 'MutexImpl', VOID, SemaphoreAndMutexImpl, [Mutex], [1, 0]);
  initMetadataForClass(SemaphoreImpl, 'SemaphoreImpl', VOID, SemaphoreAndMutexImpl, VOID, [0]);
  initMetadataForClass(SemaphoreSegment, 'SemaphoreSegment', VOID, Segment);
  initMetadataForClass(SetTimeoutBasedDispatcher, 'SetTimeoutBasedDispatcher', VOID, CoroutineDispatcher, [Delay], [1]);
  initMetadataForObject(NodeDispatcher, 'NodeDispatcher', VOID, SetTimeoutBasedDispatcher, VOID, [1]);
  initMetadataForClass(MessageQueue, 'MessageQueue', VOID, VOID, [KtMutableList]);
  initMetadataForClass(ScheduledMessageQueue, 'ScheduledMessageQueue', VOID, MessageQueue);
  initMetadataForClass(WindowMessageQueue, 'WindowMessageQueue', VOID, MessageQueue);
  initMetadataForClass(UndispatchedCoroutine, 'UndispatchedCoroutine', VOID, ScopeCoroutine, VOID, [0]);
  initMetadataForObject(Dispatchers, 'Dispatchers');
  initMetadataForClass(JsMainDispatcher, 'JsMainDispatcher', VOID, MainCoroutineDispatcher);
  initMetadataForClass(JobCancellationException, 'JobCancellationException', VOID, CancellationException);
  initMetadataForClass(AbortFlowException, 'AbortFlowException', VOID, CancellationException);
  initMetadataForClass(ChildCancelledException, 'ChildCancelledException', ChildCancelledException, CancellationException);
  initMetadataForClass(SafeCollector, 'SafeCollector', VOID, VOID, [FlowCollector], [1]);
  initMetadataForClass(WorkaroundAtomicReference, 'WorkaroundAtomicReference');
  initMetadataForClass(DiagnosticCoroutineContextException, 'DiagnosticCoroutineContextException', VOID, RuntimeException);
  initMetadataForClass(ListClosed, 'ListClosed', VOID, LockFreeLinkedListNode);
  initMetadataForClass(LocalAtomicInt, 'LocalAtomicInt');
  initMetadataForClass(CommonThreadLocal, 'CommonThreadLocal', CommonThreadLocal);
  initMetadataForClass(UnconfinedEventLoop, 'UnconfinedEventLoop', UnconfinedEventLoop, EventLoop);
  initMetadataForObject(SetTimeoutDispatcher, 'SetTimeoutDispatcher', VOID, SetTimeoutBasedDispatcher, VOID, [1]);
  initMetadataForClass(ClearTimeout, 'ClearTimeout', VOID, VOID, [CancelHandler, DisposableHandle]);
  initMetadataForClass(WindowClearTimeout, 'WindowClearTimeout', VOID, ClearTimeout);
  initMetadataForClass(WindowDispatcher, 'WindowDispatcher', VOID, CoroutineDispatcher, [Delay], [1]);
  //endregion
  function AbstractCoroutine(parentContext, initParentJob, active) {
    JobSupport.call(this, active);
    if (initParentJob) {
      this.m19(parentContext.aa(Key_instance_3));
    }
    this.p19_1 = parentContext.xj(this);
  }
  protoOf(AbstractCoroutine).t9 = function () {
    return this.p19_1;
  };
  protoOf(AbstractCoroutine).q19 = function () {
    return this.p19_1;
  };
  protoOf(AbstractCoroutine).r19 = function () {
    return protoOf(JobSupport).r19.call(this);
  };
  protoOf(AbstractCoroutine).s19 = function (value) {
  };
  protoOf(AbstractCoroutine).t19 = function (cause, handled) {
  };
  protoOf(AbstractCoroutine).u19 = function () {
    return get_classSimpleName(this) + ' was cancelled';
  };
  protoOf(AbstractCoroutine).v19 = function (state) {
    if (state instanceof CompletedExceptionally) {
      this.t19(state.w19_1, state.y19());
    } else {
      this.s19(state);
    }
  };
  protoOf(AbstractCoroutine).y9 = function (result) {
    var state = this.z19(toState_0(result));
    if (state === get_COMPLETING_WAITING_CHILDREN())
      return Unit_instance;
    this.a1a(state);
  };
  protoOf(AbstractCoroutine).a1a = function (state) {
    return this.b1a(state);
  };
  protoOf(AbstractCoroutine).c1a = function (exception) {
    handleCoroutineException(this.p19_1, exception);
  };
  protoOf(AbstractCoroutine).d1a = function () {
    var tmp0_elvis_lhs = get_coroutineName(this.p19_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return protoOf(JobSupport).d1a.call(this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var coroutineName = tmp;
    return '"' + coroutineName + '":' + protoOf(JobSupport).d1a.call(this);
  };
  protoOf(AbstractCoroutine).e1a = function (start, receiver, block) {
    start.h1a(block, receiver, this);
  };
  function launch(_this__u8e3s4, context, start, block) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
    var newContext = newCoroutineContext(_this__u8e3s4, context);
    var coroutine = start.r1b() ? new LazyStandaloneCoroutine(newContext, block) : new StandaloneCoroutine(newContext, true);
    coroutine.e1a(start, coroutine, block);
    return coroutine;
  }
  function async(_this__u8e3s4, context, start, block) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
    var newContext = newCoroutineContext(_this__u8e3s4, context);
    var coroutine = start.r1b() ? new LazyDeferredCoroutine(newContext, block) : new DeferredCoroutine(newContext, true);
    coroutine.e1a(start, coroutine, block);
    return coroutine;
  }
  function withContext(context, block, $completion) {
    var tmp$ret$0;
    $l$block_0: {
      var oldContext = $completion.t9();
      var newContext = newCoroutineContext_0(oldContext, context);
      ensureActive(newContext);
      if (newContext === oldContext) {
        var coroutine = new ScopeCoroutine(newContext, $completion);
        tmp$ret$0 = startUndispatchedOrReturn(coroutine, coroutine, block);
        break $l$block_0;
      }
      if (equals(newContext.aa(Key_instance), oldContext.aa(Key_instance))) {
        var coroutine_0 = new UndispatchedCoroutine(newContext, $completion);
        // Inline function 'kotlinx.coroutines.withCoroutineContext' call
        coroutine_0.p19_1;
        tmp$ret$0 = startUndispatchedOrReturn(coroutine_0, coroutine_0, block);
        break $l$block_0;
      }
      var coroutine_1 = new DispatchedCoroutine(newContext, $completion);
      startCoroutineCancellable_0(block, coroutine_1, coroutine_1);
      tmp$ret$0 = coroutine_1.x1b();
    }
    return tmp$ret$0;
  }
  function StandaloneCoroutine(parentContext, active) {
    AbstractCoroutine.call(this, parentContext, true, active);
  }
  protoOf(StandaloneCoroutine).o1b = function (exception) {
    handleCoroutineException(this.p19_1, exception);
    return true;
  };
  function LazyStandaloneCoroutine(parentContext, block) {
    StandaloneCoroutine.call(this, parentContext, false);
    this.e1c_1 = createCoroutineUnintercepted(block, this, this);
  }
  protoOf(LazyStandaloneCoroutine).p1a = function () {
    startCoroutineCancellable_1(this.e1c_1, this);
  };
  function $awaitCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n1c_1 = _this__u8e3s4;
  }
  protoOf($awaitCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.n1c_1.q1b(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function DeferredCoroutine(parentContext, active) {
    AbstractCoroutine.call(this, parentContext, true, active);
  }
  protoOf(DeferredCoroutine).r1c = function ($completion) {
    var tmp = new $awaitCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function LazyDeferredCoroutine(parentContext, block) {
    DeferredCoroutine.call(this, parentContext, false);
    this.v1c_1 = createCoroutineUnintercepted(block, this, this);
  }
  protoOf(LazyDeferredCoroutine).p1a = function () {
    startCoroutineCancellable_1(this.v1c_1, this);
  };
  function trySuspend($this) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.w1b_1;
    while (true) {
      switch (this_0.kotlinx$atomicfu$value) {
        case 0:
          if ($this.w1b_1.atomicfu$compareAndSet(0, 1))
            return true;
          break;
        case 2:
          return false;
        default:
          // Inline function 'kotlin.error' call

          var message = 'Already suspended';
          throw IllegalStateException_init_$Create$(toString(message));
      }
    }
  }
  function tryResume($this) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.w1b_1;
    while (true) {
      switch (this_0.kotlinx$atomicfu$value) {
        case 0:
          if ($this.w1b_1.atomicfu$compareAndSet(0, 2))
            return true;
          break;
        case 1:
          return false;
        default:
          // Inline function 'kotlin.error' call

          var message = 'Already resumed';
          throw IllegalStateException_init_$Create$(toString(message));
      }
    }
  }
  function DispatchedCoroutine(context, uCont) {
    ScopeCoroutine.call(this, context, uCont);
    this.w1b_1 = atomic$int$1(0);
  }
  protoOf(DispatchedCoroutine).b1a = function (state) {
    this.a1a(state);
  };
  protoOf(DispatchedCoroutine).a1a = function (state) {
    if (tryResume(this))
      return Unit_instance;
    resumeCancellableWithInternal(intercepted(this.z1c_1), recoverResult(state, this.z1c_1));
  };
  protoOf(DispatchedCoroutine).x1b = function () {
    if (trySuspend(this))
      return get_COROUTINE_SUSPENDED();
    var state = unboxState(this.l1a());
    if (state instanceof CompletedExceptionally)
      throw state.w19_1;
    return state;
  };
  function CancellableContinuation() {
  }
  function invokeOnCancellation(_this__u8e3s4, handler) {
    var tmp;
    if (_this__u8e3s4 instanceof CancellableContinuationImpl) {
      _this__u8e3s4.p1d(handler);
      tmp = Unit_instance;
    } else {
      throw UnsupportedOperationException_init_$Create$('third-party implementation of CancellableContinuation is not supported');
    }
    return tmp;
  }
  function disposeOnCancellation(_this__u8e3s4, handle) {
    return invokeOnCancellation(_this__u8e3s4, new DisposeOnCancel(handle));
  }
  function DisposeOnCancel(handle) {
    this.q1d_1 = handle;
  }
  protoOf(DisposeOnCancel).r1d = function (cause) {
    return this.q1d_1.s1d();
  };
  protoOf(DisposeOnCancel).toString = function () {
    return 'DisposeOnCancel[' + toString(this.q1d_1) + ']';
  };
  function getOrCreateCancellableContinuation(delegate) {
    if (!(delegate instanceof DispatchedContinuation)) {
      return new CancellableContinuationImpl(delegate, 1);
    }
    var tmp0_safe_receiver = delegate.z1d();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (tmp0_safe_receiver.a1e()) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    if (tmp1_elvis_lhs == null) {
      return new CancellableContinuationImpl(delegate, 2);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    return tmp_1;
  }
  function get_RESUME_TOKEN() {
    _init_properties_CancellableContinuationImpl_kt__6rrtdd();
    return RESUME_TOKEN;
  }
  var RESUME_TOKEN;
  function UserSupplied(handler) {
    this.b1e_1 = handler;
  }
  protoOf(UserSupplied).r1d = function (cause) {
    this.b1e_1(cause);
  };
  protoOf(UserSupplied).toString = function () {
    return 'CancelHandler.UserSupplied[' + get_classSimpleName(this.b1e_1) + '@' + get_hexAddress(this) + ']';
  };
  function CancelHandler() {
  }
  function _get_parentHandle__f8dcex($this) {
    return $this.o1d_1.kotlinx$atomicfu$value;
  }
  function _get_stateDebugRepresentation__bf18u4($this) {
    var tmp0_subject = $this.l1a();
    var tmp;
    if (!(tmp0_subject == null) ? isInterface(tmp0_subject, NotCompleted) : false) {
      tmp = 'Active';
    } else {
      if (tmp0_subject instanceof CancelledContinuation) {
        tmp = 'Cancelled';
      } else {
        tmp = 'Completed';
      }
    }
    return tmp;
  }
  function isReusable($this) {
    var tmp;
    if (get_isReusableMode($this.d1e_1)) {
      var tmp_0 = $this.k1d_1;
      tmp = (tmp_0 instanceof DispatchedContinuation ? tmp_0 : THROW_CCE()).c1e();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function cancelLater($this, cause) {
    if (!isReusable($this))
      return false;
    var tmp = $this.k1d_1;
    var dispatched = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
    return dispatched.e1e(cause);
  }
  function callSegmentOnCancellation($this, segment, cause) {
    // Inline function 'kotlinx.coroutines.index' call
    var index = $this.m1d_1.kotlinx$atomicfu$value & 536870911;
    // Inline function 'kotlin.check' call
    if (!!(index === 536870911)) {
      var message = 'The index for Segment.onCancellation(..) is broken';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callCancelHandlerSafely' call
    try {
      segment.j1e(index, cause, $this.t9());
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        handleCoroutineException($this.t9(), new CompletionHandlerException('Exception in invokeOnCancellation handler for ' + $this.toString(), ex));
      } else {
        throw $p;
      }
    }
  }
  function trySuspend_0($this) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.m1d_1;
    while (true) {
      var cur = this_0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.decision' call
      switch (cur >> 29) {
        case 0:
          // Inline function 'kotlinx.coroutines.index' call

          // Inline function 'kotlinx.coroutines.decisionAndIndex' call

          var tmp$ret$4 = (1 << 29) + (cur & 536870911) | 0;
          if ($this.m1d_1.atomicfu$compareAndSet(cur, tmp$ret$4))
            return true;
          break;
        case 2:
          return false;
        default:
          // Inline function 'kotlin.error' call

          var message = 'Already suspended';
          throw IllegalStateException_init_$Create$(toString(message));
      }
    }
  }
  function tryResume_0($this) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.m1d_1;
    while (true) {
      var cur = this_0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.decision' call
      switch (cur >> 29) {
        case 0:
          // Inline function 'kotlinx.coroutines.index' call

          // Inline function 'kotlinx.coroutines.decisionAndIndex' call

          var tmp$ret$4 = (2 << 29) + (cur & 536870911) | 0;
          if ($this.m1d_1.atomicfu$compareAndSet(cur, tmp$ret$4))
            return true;
          break;
        case 1:
          return false;
        default:
          // Inline function 'kotlin.error' call

          var message = 'Already resumed';
          throw IllegalStateException_init_$Create$(toString(message));
      }
    }
  }
  function installParentHandle($this) {
    var tmp0_elvis_lhs = $this.t9().aa(Key_instance_3);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    var handle = invokeOnCompletion(parent, VOID, new ChildContinuation($this));
    $this.o1d_1.atomicfu$compareAndSet(null, handle);
    return handle;
  }
  function invokeOnCancellationImpl($this, handler) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.n1d_1;
    while (true) {
      var state = this_0.kotlinx$atomicfu$value;
      if (state instanceof Active) {
        if ($this.n1d_1.atomicfu$compareAndSet(state, handler))
          return Unit_instance;
      } else {
        var tmp;
        if (!(state == null) ? isInterface(state, CancelHandler) : false) {
          tmp = true;
        } else {
          tmp = state instanceof Segment;
        }
        if (tmp) {
          multipleHandlersError($this, handler, state);
        } else {
          if (state instanceof CompletedExceptionally) {
            if (!state.s1e()) {
              multipleHandlersError($this, handler, state);
            }
            if (state instanceof CancelledContinuation) {
              var tmp1_safe_receiver = state instanceof CompletedExceptionally ? state : null;
              var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.w19_1;
              if (isInterface(handler, CancelHandler)) {
                $this.p1e(handler, cause);
              } else {
                var segment = handler instanceof Segment ? handler : THROW_CCE();
                callSegmentOnCancellation($this, segment, cause);
              }
            }
            return Unit_instance;
          } else {
            if (state instanceof CompletedContinuation) {
              if (!(state.l1e_1 == null)) {
                multipleHandlersError($this, handler, state);
              }
              if (handler instanceof Segment)
                return Unit_instance;
              if (!isInterface(handler, CancelHandler))
                THROW_CCE();
              if (state.q1e()) {
                $this.p1e(handler, state.o1e_1);
                return Unit_instance;
              }
              var update = state.r1e(VOID, handler);
              if ($this.n1d_1.atomicfu$compareAndSet(state, update))
                return Unit_instance;
            } else {
              if (handler instanceof Segment)
                return Unit_instance;
              if (!isInterface(handler, CancelHandler))
                THROW_CCE();
              var update_0 = new CompletedContinuation(state, handler);
              if ($this.n1d_1.atomicfu$compareAndSet(state, update_0))
                return Unit_instance;
            }
          }
        }
      }
    }
  }
  function multipleHandlersError($this, handler, state) {
    // Inline function 'kotlin.error' call
    var message = "It's prohibited to register multiple handlers, tried to register " + toString(handler) + ', already has ' + toString_0(state);
    throw IllegalStateException_init_$Create$(toString(message));
  }
  function dispatchResume($this, mode) {
    if (tryResume_0($this))
      return Unit_instance;
    dispatch($this, mode);
  }
  function resumedState($this, state, proposedUpdate, resumeMode, onCancellation, idempotent) {
    var tmp;
    if (proposedUpdate instanceof CompletedExceptionally) {
      // Inline function 'kotlinx.coroutines.assert' call
      // Inline function 'kotlinx.coroutines.assert' call
      tmp = proposedUpdate;
    } else {
      if (!get_isCancellableMode(resumeMode) && idempotent == null) {
        tmp = proposedUpdate;
      } else {
        var tmp_0;
        var tmp_1;
        if (!(onCancellation == null)) {
          tmp_1 = true;
        } else {
          tmp_1 = isInterface(state, CancelHandler);
        }
        if (tmp_1) {
          tmp_0 = true;
        } else {
          tmp_0 = !(idempotent == null);
        }
        if (tmp_0) {
          tmp = new CompletedContinuation(proposedUpdate, isInterface(state, CancelHandler) ? state : null, onCancellation, idempotent);
        } else {
          tmp = proposedUpdate;
        }
      }
    }
    return tmp;
  }
  function tryResumeImpl($this, proposedUpdate, idempotent, onCancellation) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.n1d_1;
    while (true) {
      var tmp0 = this_0.kotlinx$atomicfu$value;
      $l$block: {
        if (!(tmp0 == null) ? isInterface(tmp0, NotCompleted) : false) {
          var update = resumedState($this, tmp0, proposedUpdate, $this.d1e_1, onCancellation, idempotent);
          if (!$this.n1d_1.atomicfu$compareAndSet(tmp0, update)) {
            break $l$block;
          }
          detachChildIfNonReusable($this);
          return get_RESUME_TOKEN();
        } else {
          if (tmp0 instanceof CompletedContinuation) {
            var tmp;
            if (!(idempotent == null) && tmp0.n1e_1 === idempotent) {
              // Inline function 'kotlinx.coroutines.assert' call
              tmp = get_RESUME_TOKEN();
            } else {
              tmp = null;
            }
            return tmp;
          } else {
            return null;
          }
        }
      }
    }
  }
  function alreadyResumedError($this, proposedUpdate) {
    // Inline function 'kotlin.error' call
    var message = 'Already resumed, but proposed with update ' + toString_0(proposedUpdate);
    throw IllegalStateException_init_$Create$(toString(message));
  }
  function detachChildIfNonReusable($this) {
    if (!isReusable($this)) {
      $this.t1e();
    }
  }
  function CancellableContinuationImpl$resume$lambda($onCancellation) {
    return function (cause, _unused_var__etf5q3, _unused_var__etf5q3_0) {
      $onCancellation(cause);
      return Unit_instance;
    };
  }
  function CancellableContinuationImpl(delegate, resumeMode) {
    DispatchedTask.call(this, resumeMode);
    this.k1d_1 = delegate;
    // Inline function 'kotlinx.coroutines.assert' call
    this.l1d_1 = this.k1d_1.t9();
    var tmp = this;
    // Inline function 'kotlinx.coroutines.decisionAndIndex' call
    var tmp$ret$1 = (0 << 29) + 536870911 | 0;
    tmp.m1d_1 = atomic$int$1(tmp$ret$1);
    this.n1d_1 = atomic$ref$1(Active_instance);
    this.o1d_1 = atomic$ref$1(null);
  }
  protoOf(CancellableContinuationImpl).u1e = function () {
    return this.k1d_1;
  };
  protoOf(CancellableContinuationImpl).t9 = function () {
    return this.l1d_1;
  };
  protoOf(CancellableContinuationImpl).l1a = function () {
    return this.n1d_1.kotlinx$atomicfu$value;
  };
  protoOf(CancellableContinuationImpl).r19 = function () {
    var tmp = this.l1a();
    return !(tmp == null) ? isInterface(tmp, NotCompleted) : false;
  };
  protoOf(CancellableContinuationImpl).m1a = function () {
    var tmp = this.l1a();
    return !(!(tmp == null) ? isInterface(tmp, NotCompleted) : false);
  };
  protoOf(CancellableContinuationImpl).n1a = function () {
    var tmp = this.l1a();
    return tmp instanceof CancelledContinuation;
  };
  protoOf(CancellableContinuationImpl).v1e = function () {
    var tmp0_elvis_lhs = installParentHandle(this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var handle = tmp;
    if (this.m1a()) {
      handle.s1d();
      this.o1d_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
    }
  };
  protoOf(CancellableContinuationImpl).a1e = function () {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    var state = this.n1d_1.kotlinx$atomicfu$value;
    // Inline function 'kotlinx.coroutines.assert' call
    var tmp;
    if (state instanceof CompletedContinuation) {
      tmp = !(state.n1e_1 == null);
    } else {
      tmp = false;
    }
    if (tmp) {
      this.t1e();
      return false;
    }
    var tmp_0 = this.m1d_1;
    // Inline function 'kotlinx.coroutines.decisionAndIndex' call
    tmp_0.kotlinx$atomicfu$value = (0 << 29) + 536870911 | 0;
    this.n1d_1.kotlinx$atomicfu$value = Active_instance;
    return true;
  };
  protoOf(CancellableContinuationImpl).w1e = function () {
    return this.l1a();
  };
  protoOf(CancellableContinuationImpl).x1e = function (takenState, cause) {
    var tmp$ret$0;
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.n1d_1;
    while (true) {
      var state = this_0.kotlinx$atomicfu$value;
      if (!(state == null) ? isInterface(state, NotCompleted) : false) {
        // Inline function 'kotlin.error' call
        var message = 'Not completed';
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        if (state instanceof CompletedExceptionally)
          return Unit_instance;
        else {
          if (state instanceof CompletedContinuation) {
            // Inline function 'kotlin.check' call
            if (!!state.q1e()) {
              var message_0 = 'Must be called at most once';
              throw IllegalStateException_init_$Create$(toString(message_0));
            }
            var update = state.r1e(VOID, VOID, VOID, VOID, cause);
            if (this.n1d_1.atomicfu$compareAndSet(state, update)) {
              state.y1e(this, cause);
              return Unit_instance;
            }
          } else {
            if (this.n1d_1.atomicfu$compareAndSet(state, new CompletedContinuation(state, VOID, VOID, VOID, cause))) {
              return Unit_instance;
            }
          }
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(CancellableContinuationImpl).d1d = function (cause) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.n1d_1;
    while (true) {
      var tmp0 = this_0.kotlinx$atomicfu$value;
      $l$block: {
        if (!(!(tmp0 == null) ? isInterface(tmp0, NotCompleted) : false))
          return false;
        var tmp;
        if (isInterface(tmp0, CancelHandler)) {
          tmp = true;
        } else {
          tmp = tmp0 instanceof Segment;
        }
        var update = new CancelledContinuation(this, cause, tmp);
        if (!this.n1d_1.atomicfu$compareAndSet(tmp0, update)) {
          break $l$block;
        }
        if (isInterface(tmp0, CancelHandler)) {
          this.p1e(tmp0, cause);
        } else {
          if (tmp0 instanceof Segment) {
            callSegmentOnCancellation(this, tmp0, cause);
          }
        }
        detachChildIfNonReusable(this);
        dispatchResume(this, this.d1e_1);
        return true;
      }
    }
  };
  protoOf(CancellableContinuationImpl).z1e = function (cause) {
    if (cancelLater(this, cause))
      return Unit_instance;
    this.d1d(cause);
    detachChildIfNonReusable(this);
  };
  protoOf(CancellableContinuationImpl).p1e = function (handler, cause) {
    // Inline function 'kotlinx.coroutines.CancellableContinuationImpl.callCancelHandlerSafely' call
    try {
      handler.r1d(cause);
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        handleCoroutineException(this.t9(), new CompletionHandlerException('Exception in invokeOnCancellation handler for ' + this.toString(), ex));
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  };
  protoOf(CancellableContinuationImpl).a1f = function (onCancellation, cause, value) {
    try {
      onCancellation(cause, value, this.t9());
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        handleCoroutineException(this.t9(), new CompletionHandlerException('Exception in resume onCancellation handler for ' + this.toString(), ex));
      } else {
        throw $p;
      }
    }
  };
  protoOf(CancellableContinuationImpl).b1f = function (parent) {
    return parent.q1a();
  };
  protoOf(CancellableContinuationImpl).x1b = function () {
    var isReusable_0 = isReusable(this);
    if (trySuspend_0(this)) {
      if (_get_parentHandle__f8dcex(this) == null) {
        installParentHandle(this);
      }
      if (isReusable_0) {
        this.c1f();
      }
      return get_COROUTINE_SUSPENDED();
    }
    if (isReusable_0) {
      this.c1f();
    }
    var state = this.l1a();
    if (state instanceof CompletedExceptionally)
      throw recoverStackTrace(state.w19_1, this);
    if (get_isCancellableMode(this.d1e_1)) {
      var job = this.t9().aa(Key_instance_3);
      if (!(job == null) && !job.r19()) {
        var cause = job.q1a();
        this.x1e(state, cause);
        throw recoverStackTrace(cause, this);
      }
    }
    return this.d1f(state);
  };
  protoOf(CancellableContinuationImpl).c1f = function () {
    var tmp = this.k1d_1;
    var tmp0_safe_receiver = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e1f(this);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var cancellationCause = tmp_0;
    this.t1e();
    this.d1d(cancellationCause);
  };
  protoOf(CancellableContinuationImpl).y9 = function (result) {
    return this.f1f(toState(result, this), this.d1e_1);
  };
  protoOf(CancellableContinuationImpl).h1d = function (value, onCancellation) {
    var tmp = this.d1e_1;
    var tmp_0;
    if (onCancellation == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = CancellableContinuationImpl$resume$lambda(onCancellation);
    }
    return this.g1f(value, tmp, tmp_0);
  };
  protoOf(CancellableContinuationImpl).i1d = function (value, onCancellation) {
    return this.g1f(value, this.d1e_1, onCancellation);
  };
  protoOf(CancellableContinuationImpl).h1f = function (segment, index) {
    var tmp0 = this.m1d_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.index' call
        // Inline function 'kotlin.check' call
        if (!((cur & 536870911) === 536870911)) {
          var message = 'invokeOnCancellation should be called at most once';
          throw IllegalStateException_init_$Create$(toString(message));
        }
        // Inline function 'kotlinx.coroutines.decision' call
        // Inline function 'kotlinx.coroutines.decisionAndIndex' call
        var upd = (cur >> 29 << 29) + index | 0;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    invokeOnCancellationImpl(this, segment);
  };
  protoOf(CancellableContinuationImpl).f1d = function (handler) {
    return invokeOnCancellation(this, new UserSupplied(handler));
  };
  protoOf(CancellableContinuationImpl).p1d = function (handler) {
    return invokeOnCancellationImpl(this, handler);
  };
  protoOf(CancellableContinuationImpl).g1f = function (proposedUpdate, resumeMode, onCancellation) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.n1d_1;
    while (true) {
      var tmp0 = this_0.kotlinx$atomicfu$value;
      $l$block: {
        if (!(tmp0 == null) ? isInterface(tmp0, NotCompleted) : false) {
          var update = resumedState(this, tmp0, proposedUpdate, resumeMode, onCancellation, null);
          if (!this.n1d_1.atomicfu$compareAndSet(tmp0, update)) {
            break $l$block;
          }
          detachChildIfNonReusable(this);
          dispatchResume(this, resumeMode);
          return Unit_instance;
        } else {
          if (tmp0 instanceof CancelledContinuation) {
            if (tmp0.l1f()) {
              if (onCancellation == null)
                null;
              else {
                // Inline function 'kotlin.let' call
                this.a1f(onCancellation, tmp0.w19_1, proposedUpdate);
              }
              return Unit_instance;
            }
          }
        }
        alreadyResumedError(this, proposedUpdate);
      }
    }
  };
  protoOf(CancellableContinuationImpl).f1f = function (proposedUpdate, resumeMode, onCancellation, $super) {
    onCancellation = onCancellation === VOID ? null : onCancellation;
    var tmp;
    if ($super === VOID) {
      this.g1f(proposedUpdate, resumeMode, onCancellation);
      tmp = Unit_instance;
    } else {
      tmp = $super.g1f.call(this, proposedUpdate, resumeMode, onCancellation);
    }
    return tmp;
  };
  protoOf(CancellableContinuationImpl).t1e = function () {
    var tmp0_elvis_lhs = _get_parentHandle__f8dcex(this);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var handle = tmp;
    handle.s1d();
    this.o1d_1.kotlinx$atomicfu$value = NonDisposableHandle_instance;
  };
  protoOf(CancellableContinuationImpl).b1d = function (value, idempotent, onCancellation) {
    return tryResumeImpl(this, value, idempotent, onCancellation);
  };
  protoOf(CancellableContinuationImpl).c1d = function (token) {
    // Inline function 'kotlinx.coroutines.assert' call
    dispatchResume(this, this.d1e_1);
  };
  protoOf(CancellableContinuationImpl).g1d = function (_this__u8e3s4, value) {
    var tmp = this.k1d_1;
    var dc = tmp instanceof DispatchedContinuation ? tmp : null;
    var tmp_0;
    if ((dc == null ? null : dc.u1d_1) === _this__u8e3s4) {
      tmp_0 = 4;
    } else {
      tmp_0 = this.d1e_1;
    }
    this.f1f(value, tmp_0);
  };
  protoOf(CancellableContinuationImpl).d1f = function (state) {
    var tmp;
    if (state instanceof CompletedContinuation) {
      tmp = state.k1e_1;
    } else {
      tmp = state;
    }
    return tmp;
  };
  protoOf(CancellableContinuationImpl).m1f = function (state) {
    var tmp0_safe_receiver = protoOf(DispatchedTask).m1f.call(this, state);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = recoverStackTrace(tmp0_safe_receiver, this.k1d_1);
    }
    return tmp;
  };
  protoOf(CancellableContinuationImpl).toString = function () {
    return this.n1f() + '(' + toDebugString(this.k1d_1) + '){' + _get_stateDebugRepresentation__bf18u4(this) + '}@' + get_hexAddress(this);
  };
  protoOf(CancellableContinuationImpl).n1f = function () {
    return 'CancellableContinuation';
  };
  function NotCompleted() {
  }
  function Active() {
  }
  protoOf(Active).toString = function () {
    return 'Active';
  };
  var Active_instance;
  function Active_getInstance() {
    return Active_instance;
  }
  function CompletedContinuation(result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    cancelHandler = cancelHandler === VOID ? null : cancelHandler;
    onCancellation = onCancellation === VOID ? null : onCancellation;
    idempotentResume = idempotentResume === VOID ? null : idempotentResume;
    cancelCause = cancelCause === VOID ? null : cancelCause;
    this.k1e_1 = result;
    this.l1e_1 = cancelHandler;
    this.m1e_1 = onCancellation;
    this.n1e_1 = idempotentResume;
    this.o1e_1 = cancelCause;
  }
  protoOf(CompletedContinuation).q1e = function () {
    return !(this.o1e_1 == null);
  };
  protoOf(CompletedContinuation).y1e = function (cont, cause) {
    var tmp0_safe_receiver = this.l1e_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      cont.p1e(tmp0_safe_receiver, cause);
    }
    var tmp1_safe_receiver = this.m1e_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      cont.a1f(tmp1_safe_receiver, cause, this.k1e_1);
    }
  };
  protoOf(CompletedContinuation).q1f = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause) {
    return new CompletedContinuation(result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  };
  protoOf(CompletedContinuation).r1e = function (result, cancelHandler, onCancellation, idempotentResume, cancelCause, $super) {
    result = result === VOID ? this.k1e_1 : result;
    cancelHandler = cancelHandler === VOID ? this.l1e_1 : cancelHandler;
    onCancellation = onCancellation === VOID ? this.m1e_1 : onCancellation;
    idempotentResume = idempotentResume === VOID ? this.n1e_1 : idempotentResume;
    cancelCause = cancelCause === VOID ? this.o1e_1 : cancelCause;
    return $super === VOID ? this.q1f(result, cancelHandler, onCancellation, idempotentResume, cancelCause) : $super.q1f.call(this, result, cancelHandler, onCancellation, idempotentResume, cancelCause);
  };
  protoOf(CompletedContinuation).toString = function () {
    return 'CompletedContinuation(result=' + toString_0(this.k1e_1) + ', cancelHandler=' + toString_0(this.l1e_1) + ', onCancellation=' + toString_0(this.m1e_1) + ', idempotentResume=' + toString_0(this.n1e_1) + ', cancelCause=' + toString_0(this.o1e_1) + ')';
  };
  protoOf(CompletedContinuation).hashCode = function () {
    var result = this.k1e_1 == null ? 0 : hashCode(this.k1e_1);
    result = imul(result, 31) + (this.l1e_1 == null ? 0 : hashCode(this.l1e_1)) | 0;
    result = imul(result, 31) + (this.m1e_1 == null ? 0 : hashCode(this.m1e_1)) | 0;
    result = imul(result, 31) + (this.n1e_1 == null ? 0 : hashCode(this.n1e_1)) | 0;
    result = imul(result, 31) + (this.o1e_1 == null ? 0 : hashCode(this.o1e_1)) | 0;
    return result;
  };
  protoOf(CompletedContinuation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CompletedContinuation))
      return false;
    if (!equals(this.k1e_1, other.k1e_1))
      return false;
    if (!equals(this.l1e_1, other.l1e_1))
      return false;
    if (!equals(this.m1e_1, other.m1e_1))
      return false;
    if (!equals(this.n1e_1, other.n1e_1))
      return false;
    if (!equals(this.o1e_1, other.o1e_1))
      return false;
    return true;
  };
  function ChildContinuation(child) {
    JobNode.call(this);
    this.v1f_1 = child;
  }
  protoOf(ChildContinuation).w1f = function () {
    return true;
  };
  protoOf(ChildContinuation).r1d = function (cause) {
    this.v1f_1.z1e(this.v1f_1.b1f(this.b1g()));
  };
  var properties_initialized_CancellableContinuationImpl_kt_xtzb03;
  function _init_properties_CancellableContinuationImpl_kt__6rrtdd() {
    if (!properties_initialized_CancellableContinuationImpl_kt_xtzb03) {
      properties_initialized_CancellableContinuationImpl_kt_xtzb03 = true;
      RESUME_TOKEN = new Symbol('RESUME_TOKEN');
    }
  }
  function CompletableDeferred(parent) {
    parent = parent === VOID ? null : parent;
    return new CompletableDeferredImpl(parent);
  }
  function $awaitCOROUTINE$_0(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r1g_1 = _this__u8e3s4;
  }
  protoOf($awaitCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.r1g_1.q1b(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function CompletableDeferredImpl(parent) {
    JobSupport.call(this, true);
    this.m19(parent);
  }
  protoOf(CompletableDeferredImpl).z1a = function () {
    return true;
  };
  protoOf(CompletableDeferredImpl).r1c = function ($completion) {
    var tmp = new $awaitCOROUTINE$_0(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CompletableDeferredImpl).u1g = function (value) {
    return this.i1b(value);
  };
  protoOf(CompletableDeferredImpl).v1g = function (exception) {
    return this.i1b(new CompletedExceptionally(exception));
  };
  function CompletableJob() {
  }
  function recoverResult(state, uCont) {
    var tmp;
    if (state instanceof CompletedExceptionally) {
      // Inline function 'kotlin.Companion.failure' call
      var exception = recoverStackTrace(state.w19_1, uCont);
      tmp = _Result___init__impl__xyqfz8(createFailure(exception));
    } else {
      // Inline function 'kotlin.Companion.success' call
      tmp = _Result___init__impl__xyqfz8(state);
    }
    return tmp;
  }
  function CompletedExceptionally(cause, handled) {
    handled = handled === VOID ? false : handled;
    this.w19_1 = cause;
    this.x19_1 = atomic$boolean$1(handled);
  }
  protoOf(CompletedExceptionally).y19 = function () {
    return this.x19_1.kotlinx$atomicfu$value;
  };
  protoOf(CompletedExceptionally).s1e = function () {
    return this.x19_1.atomicfu$compareAndSet(false, true);
  };
  protoOf(CompletedExceptionally).toString = function () {
    return get_classSimpleName(this) + '[' + this.w19_1.toString() + ']';
  };
  function CancelledContinuation(continuation, cause, handled) {
    CompletedExceptionally.call(this, cause == null ? CancellationException_init_$Create$('Continuation ' + toString(continuation) + ' was cancelled normally') : cause, handled);
    this.k1f_1 = atomic$boolean$1(false);
  }
  protoOf(CancelledContinuation).l1f = function () {
    return this.k1f_1.atomicfu$compareAndSet(false, true);
  };
  function toState(_this__u8e3s4, caller) {
    // Inline function 'kotlin.getOrElse' call
    var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
    var tmp;
    if (exception == null) {
      tmp = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
    } else {
      tmp = new CompletedExceptionally(recoverStackTrace(exception, caller));
    }
    return tmp;
  }
  function toState_0(_this__u8e3s4) {
    // Inline function 'kotlin.getOrElse' call
    var exception = Result__exceptionOrNull_impl_p6xea9(_this__u8e3s4);
    var tmp;
    if (exception == null) {
      tmp = _Result___get_value__impl__bjfvqg(_this__u8e3s4);
    } else {
      tmp = new CompletedExceptionally(exception);
    }
    return tmp;
  }
  function CoroutineDispatcher$Key$_init_$lambda_akl8b5(it) {
    return it instanceof CoroutineDispatcher ? it : null;
  }
  function Key() {
    Key_instance_0 = this;
    var tmp = Key_instance;
    AbstractCoroutineContextKey.call(this, tmp, CoroutineDispatcher$Key$_init_$lambda_akl8b5);
  }
  var Key_instance_0;
  function Key_getInstance() {
    if (Key_instance_0 == null)
      new Key();
    return Key_instance_0;
  }
  function CoroutineDispatcher() {
    Key_getInstance();
    AbstractCoroutineContextElement.call(this, Key_instance);
  }
  protoOf(CoroutineDispatcher).y1g = function (context) {
    return true;
  };
  protoOf(CoroutineDispatcher).z1g = function (parallelism, name) {
    checkParallelism(parallelism);
    return new LimitedDispatcher(this, parallelism, name);
  };
  protoOf(CoroutineDispatcher).a1h = function (parallelism, name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.z1g(parallelism, name) : $super.z1g.call(this, parallelism, name);
  };
  protoOf(CoroutineDispatcher).c1h = function (context, block) {
    return safeDispatch(this, context, block);
  };
  protoOf(CoroutineDispatcher).ba = function (continuation) {
    return new DispatchedContinuation(this, continuation);
  };
  protoOf(CoroutineDispatcher).ca = function (continuation) {
    var dispatched = continuation instanceof DispatchedContinuation ? continuation : THROW_CCE();
    dispatched.d1h();
  };
  protoOf(CoroutineDispatcher).toString = function () {
    return get_classSimpleName(this) + '@' + get_hexAddress(this);
  };
  function Key_0() {
  }
  var Key_instance_1;
  function Key_getInstance_0() {
    return Key_instance_1;
  }
  function handleCoroutineException(context, exception) {
    var tmp;
    if (exception instanceof DispatchException) {
      tmp = exception.e1h_1;
    } else {
      tmp = exception;
    }
    var reportException = tmp;
    try {
      var tmp0_safe_receiver = context.aa(Key_instance_1);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        tmp0_safe_receiver.f1h(context, reportException);
        return Unit_instance;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        handleUncaughtCoroutineException(context, handlerException(reportException, t));
        return Unit_instance;
      } else {
        throw $p;
      }
    }
    handleUncaughtCoroutineException(context, reportException);
  }
  function handlerException(originalException, thrownException) {
    if (originalException === thrownException)
      return originalException;
    // Inline function 'kotlin.apply' call
    var this_0 = RuntimeException_init_$Create$('Exception while trying to handle coroutine exception', thrownException);
    addSuppressed(this_0, originalException);
    return this_0;
  }
  function Key_1() {
  }
  var Key_instance_2;
  function Key_getInstance_1() {
    return Key_instance_2;
  }
  function CoroutineName(name) {
    AbstractCoroutineContextElement.call(this, Key_instance_2);
    this.h1h_1 = name;
  }
  protoOf(CoroutineName).toString = function () {
    return 'CoroutineName(' + this.h1h_1 + ')';
  };
  protoOf(CoroutineName).hashCode = function () {
    return getStringHashCode(this.h1h_1);
  };
  protoOf(CoroutineName).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CoroutineName))
      return false;
    if (!(this.h1h_1 === other.h1h_1))
      return false;
    return true;
  };
  function CoroutineScope() {
  }
  function coroutineScope(block, $completion) {
    var coroutine = new ScopeCoroutine($completion.t9(), $completion);
    return startUndispatchedOrReturn(coroutine, coroutine, block);
  }
  function cancel(_this__u8e3s4, cause) {
    cause = cause === VOID ? null : cause;
    var tmp0_elvis_lhs = _this__u8e3s4.q19().aa(Key_instance_3);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Scope cannot be cancelled because it does not have a job: ' + toString(_this__u8e3s4);
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var job = tmp;
    job.a1b(cause);
  }
  function get_isActive(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.q19().aa(Key_instance_3);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r19();
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  }
  function CoroutineScope_0(context) {
    return new ContextScope(!(context.aa(Key_instance_3) == null) ? context : context.xj(Job_0()));
  }
  function MainScope() {
    return new ContextScope(SupervisorJob().xj(Dispatchers_getInstance().m1h()));
  }
  function GlobalScope() {
  }
  protoOf(GlobalScope).q19 = function () {
    return EmptyCoroutineContext_getInstance();
  };
  var GlobalScope_instance;
  function GlobalScope_getInstance() {
    return GlobalScope_instance;
  }
  function cancel_0(_this__u8e3s4, message, cause) {
    cause = cause === VOID ? null : cause;
    return cancel(_this__u8e3s4, CancellationException_0(message, cause));
  }
  var CoroutineStart_DEFAULT_instance;
  var CoroutineStart_LAZY_instance;
  var CoroutineStart_ATOMIC_instance;
  var CoroutineStart_UNDISPATCHED_instance;
  var CoroutineStart_entriesInitialized;
  function CoroutineStart_initEntries() {
    if (CoroutineStart_entriesInitialized)
      return Unit_instance;
    CoroutineStart_entriesInitialized = true;
    CoroutineStart_DEFAULT_instance = new CoroutineStart('DEFAULT', 0);
    CoroutineStart_LAZY_instance = new CoroutineStart('LAZY', 1);
    CoroutineStart_ATOMIC_instance = new CoroutineStart('ATOMIC', 2);
    CoroutineStart_UNDISPATCHED_instance = new CoroutineStart('UNDISPATCHED', 3);
  }
  function CoroutineStart(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  protoOf(CoroutineStart).h1a = function (block, receiver, completion) {
    var tmp;
    switch (this.a1_1) {
      case 0:
        startCoroutineCancellable_0(block, receiver, completion);
        tmp = Unit_instance;
        break;
      case 2:
        startCoroutine(block, receiver, completion);
        tmp = Unit_instance;
        break;
      case 3:
        startCoroutineUndispatched(block, receiver, completion);
        tmp = Unit_instance;
        break;
      case 1:
        tmp = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(CoroutineStart).r1b = function () {
    return this === CoroutineStart_LAZY_getInstance();
  };
  function CoroutineStart_DEFAULT_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_DEFAULT_instance;
  }
  function CoroutineStart_LAZY_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_LAZY_instance;
  }
  function CoroutineStart_ATOMIC_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_ATOMIC_instance;
  }
  function CoroutineStart_UNDISPATCHED_getInstance() {
    CoroutineStart_initEntries();
    return CoroutineStart_UNDISPATCHED_instance;
  }
  function CopyableThrowable() {
  }
  function delay(timeMillis, $completion) {
    if (compare(timeMillis, new Long(0, 0)) <= 0)
      return Unit_instance;
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.v1e();
    if (compare(timeMillis, new Long(-1, 2147483647)) < 0) {
      get_delay(cancellable.t9()).o1h(timeMillis, cancellable);
    }
    return cancellable.x1b();
  }
  function awaitCancellation($completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.v1e();
    return cancellable.x1b();
  }
  function delay_0(duration, $completion) {
    return delay(toDelayMillis(duration), $completion);
  }
  function Delay() {
  }
  function get_delay(_this__u8e3s4) {
    var tmp = _this__u8e3s4.aa(Key_instance);
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, Delay) : false) ? tmp : null;
    return tmp0_elvis_lhs == null ? get_DefaultDelay() : tmp0_elvis_lhs;
  }
  function toDelayMillis(_this__u8e3s4) {
    var tmp;
    switch (Duration__isPositive_impl_tvkkt2(_this__u8e3s4)) {
      case true:
        Companion_getInstance();
        // Inline function 'kotlin.time.Companion.nanoseconds' call

        var this_0 = new Long(999999, 0);
        var tmp$ret$0 = toDuration(this_0, DurationUnit_NANOSECONDS_getInstance());
        tmp = _Duration___get_inWholeMilliseconds__impl__msfiry(Duration__plus_impl_yu9v8f(_this__u8e3s4, tmp$ret$0));
        break;
      case false:
        tmp = new Long(0, 0);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function DelayWithTimeoutDiagnostics() {
  }
  function delta($this, unconfined) {
    return unconfined ? new Long(0, 1) : new Long(1, 0);
  }
  function EventLoop() {
    CoroutineDispatcher.call(this);
    this.s1h_1 = new Long(0, 0);
    this.t1h_1 = false;
    this.u1h_1 = null;
  }
  protoOf(EventLoop).v1h = function () {
    var tmp0_elvis_lhs = this.u1h_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    var tmp1_elvis_lhs = queue.ch();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var task = tmp_0;
    task.o1f();
    return true;
  };
  protoOf(EventLoop).w1h = function (task) {
    var tmp0_elvis_lhs = this.u1h_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = ArrayDeque_init_$Create$();
      this.u1h_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var queue = tmp;
    queue.ah(task);
  };
  protoOf(EventLoop).x1h = function () {
    return compare(this.s1h_1, delta(this, true)) >= 0;
  };
  protoOf(EventLoop).y1h = function () {
    var tmp0_safe_receiver = this.u1h_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r();
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  };
  protoOf(EventLoop).z1h = function (unconfined) {
    this.s1h_1 = add(this.s1h_1, delta(this, unconfined));
    if (!unconfined)
      this.t1h_1 = true;
  };
  protoOf(EventLoop).a1i = function (unconfined) {
    this.s1h_1 = subtract(this.s1h_1, delta(this, unconfined));
    if (compare(this.s1h_1, new Long(0, 0)) > 0)
      return Unit_instance;
    // Inline function 'kotlinx.coroutines.assert' call
    if (this.t1h_1) {
      this.b1i();
    }
  };
  protoOf(EventLoop).z1g = function (parallelism, name) {
    checkParallelism(parallelism);
    return namedOrThis(this, name);
  };
  protoOf(EventLoop).b1i = function () {
  };
  function ThreadLocalEventLoop() {
    ThreadLocalEventLoop_instance = this;
    this.c1i_1 = commonThreadLocal(new Symbol('ThreadLocalEventLoop'));
  }
  protoOf(ThreadLocalEventLoop).d1i = function () {
    var tmp0_elvis_lhs = this.c1i_1.f1i();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = createEventLoop();
      ThreadLocalEventLoop_getInstance().c1i_1.g1i(this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  var ThreadLocalEventLoop_instance;
  function ThreadLocalEventLoop_getInstance() {
    if (ThreadLocalEventLoop_instance == null)
      new ThreadLocalEventLoop();
    return ThreadLocalEventLoop_instance;
  }
  function CompletionHandlerException(message, cause) {
    RuntimeException_init_$Init$(message, cause, this);
    captureStack(this, CompletionHandlerException);
  }
  function CoroutinesInternalError(message, cause) {
    Error_init_$Init$(message, cause, this);
    captureStack(this, CoroutinesInternalError);
  }
  function Key_2() {
  }
  var Key_instance_3;
  function Key_getInstance_2() {
    return Key_instance_3;
  }
  function Job() {
  }
  function DisposableHandle() {
  }
  function cancelAndJoin(_this__u8e3s4, $completion) {
    _this__u8e3s4.b1b();
    return _this__u8e3s4.x1a($completion);
  }
  function get_isActive_0(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.aa(Key_instance_3);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r19();
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  }
  function get_job(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4.aa(Key_instance_3);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = "Current context doesn't contain Job in it: " + toString(_this__u8e3s4);
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function cancel_1(_this__u8e3s4, message, cause) {
    cause = cause === VOID ? null : cause;
    return _this__u8e3s4.a1b(CancellationException_0(message, cause));
  }
  function Job_0(parent) {
    parent = parent === VOID ? null : parent;
    return new JobImpl(parent);
  }
  function cancel_2(_this__u8e3s4, cause) {
    cause = cause === VOID ? null : cause;
    var tmp0_safe_receiver = _this__u8e3s4.aa(Key_instance_3);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a1b(cause);
    }
  }
  function ensureActive(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.aa(Key_instance_3);
    if (tmp0_safe_receiver == null)
      null;
    else {
      ensureActive_0(tmp0_safe_receiver);
    }
  }
  function invokeOnCompletion(_this__u8e3s4, invokeImmediately, handler) {
    invokeImmediately = invokeImmediately === VOID ? true : invokeImmediately;
    var tmp;
    if (_this__u8e3s4 instanceof JobSupport) {
      tmp = _this__u8e3s4.w1a(invokeImmediately, handler);
    } else {
      var tmp_0 = handler.w1f();
      tmp = _this__u8e3s4.u1a(tmp_0, invokeImmediately, JobNode$invoke$ref(handler));
    }
    return tmp;
  }
  function NonDisposableHandle() {
  }
  protoOf(NonDisposableHandle).k1a = function () {
    return null;
  };
  protoOf(NonDisposableHandle).s1d = function () {
  };
  protoOf(NonDisposableHandle).e1b = function (cause) {
    return false;
  };
  protoOf(NonDisposableHandle).toString = function () {
    return 'NonDisposableHandle';
  };
  var NonDisposableHandle_instance;
  function NonDisposableHandle_getInstance() {
    return NonDisposableHandle_instance;
  }
  function ensureActive_0(_this__u8e3s4) {
    if (!_this__u8e3s4.r19())
      throw _this__u8e3s4.q1a();
  }
  function ParentJob() {
  }
  function disposeOnCompletion(_this__u8e3s4, handle) {
    return invokeOnCompletion(_this__u8e3s4, VOID, new DisposeOnCompletion(handle));
  }
  function DisposeOnCompletion(handle) {
    JobNode.call(this);
    this.l1i_1 = handle;
  }
  protoOf(DisposeOnCompletion).w1f = function () {
    return false;
  };
  protoOf(DisposeOnCompletion).r1d = function (cause) {
    return this.l1i_1.s1d();
  };
  function get_COMPLETING_ALREADY() {
    _init_properties_JobSupport_kt__68f172();
    return COMPLETING_ALREADY;
  }
  var COMPLETING_ALREADY;
  function get_COMPLETING_WAITING_CHILDREN() {
    _init_properties_JobSupport_kt__68f172();
    return COMPLETING_WAITING_CHILDREN;
  }
  var COMPLETING_WAITING_CHILDREN;
  function get_COMPLETING_RETRY() {
    _init_properties_JobSupport_kt__68f172();
    return COMPLETING_RETRY;
  }
  var COMPLETING_RETRY;
  function get_TOO_LATE_TO_CANCEL() {
    _init_properties_JobSupport_kt__68f172();
    return TOO_LATE_TO_CANCEL;
  }
  var TOO_LATE_TO_CANCEL;
  function get_SEALED() {
    _init_properties_JobSupport_kt__68f172();
    return SEALED;
  }
  var SEALED;
  function get_EMPTY_NEW() {
    _init_properties_JobSupport_kt__68f172();
    return EMPTY_NEW;
  }
  var EMPTY_NEW;
  function get_EMPTY_ACTIVE() {
    _init_properties_JobSupport_kt__68f172();
    return EMPTY_ACTIVE;
  }
  var EMPTY_ACTIVE;
  function JobNode() {
    LockFreeLinkedListNode.call(this);
  }
  protoOf(JobNode).b1g = function () {
    var tmp = this.a1g_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('job');
    }
  };
  protoOf(JobNode).r19 = function () {
    return true;
  };
  protoOf(JobNode).c1g = function () {
    return null;
  };
  protoOf(JobNode).s1d = function () {
    return this.b1g().y1a(this);
  };
  protoOf(JobNode).toString = function () {
    return get_classSimpleName(this) + '@' + get_hexAddress(this) + '[job@' + get_hexAddress(this.b1g()) + ']';
  };
  function unboxState(_this__u8e3s4) {
    _init_properties_JobSupport_kt__68f172();
    var tmp0_safe_receiver = _this__u8e3s4 instanceof IncompleteStateBox ? _this__u8e3s4 : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m1i_1;
    return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
  }
  function _set_exceptionsHolder__tqm22h($this, value) {
    $this.q1i_1.kotlinx$atomicfu$value = value;
  }
  function _get_exceptionsHolder__nhszp($this) {
    return $this.q1i_1.kotlinx$atomicfu$value;
  }
  function allocateList($this) {
    return ArrayList_init_$Create$(4);
  }
  function finalizeFinishingState($this, state, proposedUpdate) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
    var proposedException = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w19_1;
    var wasCancelling;
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    wasCancelling = state.r1i();
    var exceptions = state.s1i(proposedException);
    var finalCause = getFinalRootCause($this, state, exceptions);
    if (!(finalCause == null)) {
      addSuppressedExceptions($this, finalCause, exceptions);
    }
    var finalException = finalCause;
    var finalState = finalException == null ? proposedUpdate : finalException === proposedException ? proposedUpdate : new CompletedExceptionally(finalException);
    if (!(finalException == null)) {
      var handled = cancelParent($this, finalException) || $this.o1b(finalException);
      if (handled) {
        (finalState instanceof CompletedExceptionally ? finalState : THROW_CCE()).s1e();
      }
    }
    if (!wasCancelling) {
      $this.l1b(finalException);
    }
    $this.v19(finalState);
    var casSuccess = $this.k19_1.atomicfu$compareAndSet(state, boxIncomplete(finalState));
    // Inline function 'kotlinx.coroutines.assert' call
    completeStateFinalization($this, state, finalState);
    return finalState;
  }
  function getFinalRootCause($this, state, exceptions) {
    if (exceptions.r()) {
      if (state.r1i()) {
        // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
        return new JobCancellationException(null == null ? $this.u19() : null, null, $this);
      }
      return null;
    }
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = exceptions.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (!(element instanceof CancellationException)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var firstNonCancellation = tmp$ret$1;
    if (!(firstNonCancellation == null))
      return firstNonCancellation;
    var first = exceptions.l1(0);
    if (first instanceof TimeoutCancellationException) {
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s_0 = exceptions.t();
        while (_iterator__ex2g4s_0.u()) {
          var element_0 = _iterator__ex2g4s_0.v();
          var tmp;
          if (!(element_0 === first)) {
            tmp = element_0 instanceof TimeoutCancellationException;
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$3 = element_0;
            break $l$block_0;
          }
        }
        tmp$ret$3 = null;
      }
      var detailedTimeoutException = tmp$ret$3;
      if (!(detailedTimeoutException == null))
        return detailedTimeoutException;
    }
    return first;
  }
  function addSuppressedExceptions($this, rootCause, exceptions) {
    if (exceptions.n1() <= 1)
      return Unit_instance;
    var seenExceptions = identitySet(exceptions.n1());
    var unwrappedCause = unwrap(rootCause);
    var _iterator__ex2g4s = exceptions.t();
    while (_iterator__ex2g4s.u()) {
      var exception = _iterator__ex2g4s.v();
      var unwrapped = unwrap(exception);
      var tmp;
      var tmp_0;
      if (!(unwrapped === rootCause) && !(unwrapped === unwrappedCause)) {
        tmp_0 = !(unwrapped instanceof CancellationException);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = seenExceptions.j1(unwrapped);
      } else {
        tmp = false;
      }
      if (tmp) {
        addSuppressed(rootCause, unwrapped);
      }
    }
  }
  function tryFinalizeSimpleState($this, state, update) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    if (!$this.k19_1.atomicfu$compareAndSet(state, boxIncomplete(update)))
      return false;
    $this.l1b(null);
    $this.v19(update);
    completeStateFinalization($this, state, update);
    return true;
  }
  function completeStateFinalization($this, state, update) {
    var tmp0_safe_receiver = $this.j1a();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.s1d();
      $this.i1a(NonDisposableHandle_instance);
    }
    var tmp1_safe_receiver = update instanceof CompletedExceptionally ? update : null;
    var cause = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.w19_1;
    if (state instanceof JobNode) {
      try {
        state.r1d(cause);
      } catch ($p) {
        if ($p instanceof Error) {
          var ex = $p;
          $this.c1a(new CompletionHandlerException('Exception in completion handler ' + state.toString() + ' for ' + $this.toString(), ex));
        } else {
          throw $p;
        }
      }
    } else {
      var tmp2_safe_receiver = state.c1g();
      if (tmp2_safe_receiver == null)
        null;
      else {
        notifyCompletion($this, tmp2_safe_receiver, cause);
      }
    }
  }
  function notifyCancelling($this, list, cause) {
    $this.l1b(cause);
    list.t1i(4);
    // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
    var exception = null;
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
    var cur = list.d1g_1;
    while (!equals(cur, list)) {
      var node = cur;
      var tmp;
      if (node instanceof JobNode) {
        tmp = node.w1f();
      } else {
        tmp = false;
      }
      if (tmp) {
        try {
          node.r1d(cause);
        } catch ($p) {
          if ($p instanceof Error) {
            var ex = $p;
            var tmp0_safe_receiver = exception;
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.apply' call
              addSuppressed(tmp0_safe_receiver, ex);
              tmp_0 = tmp0_safe_receiver;
            }
            if (tmp_0 == null) {
              // Inline function 'kotlin.run' call
              exception = new CompletionHandlerException('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
            }
          } else {
            throw $p;
          }
        }
      }
      cur = cur.d1g_1;
    }
    var tmp0_safe_receiver_0 = exception;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this.c1a(tmp0_safe_receiver_0);
    }
    cancelParent($this, cause);
  }
  function cancelParent($this, cause) {
    if ($this.m1b())
      return true;
    var isCancellation = cause instanceof CancellationException;
    var parent = $this.j1a();
    if (parent === null || parent === NonDisposableHandle_instance) {
      return isCancellation;
    }
    return parent.e1b(cause) || isCancellation;
  }
  function notifyCompletion($this, $receiver, cause) {
    $receiver.t1i(1);
    // Inline function 'kotlinx.coroutines.JobSupport.notifyHandlers' call
    var exception = null;
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
    var cur = $receiver.d1g_1;
    while (!equals(cur, $receiver)) {
      var node = cur;
      var tmp;
      if (node instanceof JobNode) {
        tmp = true;
      } else {
        tmp = false;
      }
      if (tmp) {
        try {
          node.r1d(cause);
        } catch ($p) {
          if ($p instanceof Error) {
            var ex = $p;
            var tmp0_safe_receiver = exception;
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.apply' call
              addSuppressed(tmp0_safe_receiver, ex);
              tmp_0 = tmp0_safe_receiver;
            }
            if (tmp_0 == null) {
              // Inline function 'kotlin.run' call
              exception = new CompletionHandlerException('Exception in completion handler ' + node.toString() + ' for ' + $this.toString(), ex);
            }
          } else {
            throw $p;
          }
        }
      }
      cur = cur.d1g_1;
    }
    var tmp0_safe_receiver_0 = exception;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this.c1a(tmp0_safe_receiver_0);
    }
  }
  function startInternal($this, state) {
    if (state instanceof Empty) {
      if (state.v1i_1)
        return 0;
      if (!$this.k19_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
        return -1;
      $this.p1a();
      return 1;
    } else {
      if (state instanceof InactiveNodeList) {
        if (!$this.k19_1.atomicfu$compareAndSet(state, state.u1i_1))
          return -1;
        $this.p1a();
        return 1;
      } else {
        return 0;
      }
    }
  }
  function promoteEmptyToNodeList($this, state) {
    var list = new NodeList();
    var update = state.v1i_1 ? list : new InactiveNodeList(list);
    $this.k19_1.atomicfu$compareAndSet(state, update);
  }
  function promoteSingleToNodeList($this, state) {
    state.i1g(new NodeList());
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.nextNode' call
    var list = state.d1g_1;
    $this.k19_1.atomicfu$compareAndSet(state, list);
  }
  function joinInternal($this) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var state = $this.l1a();
      if (!(!(state == null) ? isInterface(state, Incomplete) : false))
        return false;
      if (startInternal($this, state) >= 0)
        return true;
    }
  }
  function joinSuspend($this, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.v1e();
    disposeOnCancellation(cancellable, invokeOnCompletion($this, VOID, new ResumeOnCompletion(cancellable)));
    return cancellable.x1b();
  }
  function cancelMakeCompleting($this, cause) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var state = $this.l1a();
      var tmp;
      if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
        tmp = true;
      } else {
        var tmp_0;
        if (state instanceof Finishing) {
          tmp_0 = state.w1i();
        } else {
          tmp_0 = false;
        }
        tmp = tmp_0;
      }
      if (tmp) {
        return get_COMPLETING_ALREADY();
      }
      var proposedUpdate = new CompletedExceptionally(createCauseException($this, cause));
      var finalState = tryMakeCompleting($this, state, proposedUpdate);
      if (!(finalState === get_COMPLETING_RETRY()))
        return finalState;
    }
  }
  function createCauseException($this, cause) {
    var tmp;
    if (cause == null ? true : cause instanceof Error) {
      var tmp_0;
      if (cause == null) {
        // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
        tmp_0 = new JobCancellationException(null == null ? $this.u19() : null, null, $this);
      } else {
        tmp_0 = cause;
      }
      tmp = tmp_0;
    } else {
      tmp = (isInterface(cause, ParentJob) ? cause : THROW_CCE()).h1b();
    }
    return tmp;
  }
  function makeCancelling($this, cause) {
    var causeExceptionCache = null;
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var tmp0 = $this.l1a();
      $l$block: {
        if (tmp0 instanceof Finishing) {
          // Inline function 'kotlinx.coroutines.internal.synchronized' call
          // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
          if (tmp0.x1i())
            return get_TOO_LATE_TO_CANCEL();
          var wasCancelling = tmp0.r1i();
          if (!(cause == null) || !wasCancelling) {
            var tmp0_elvis_lhs = causeExceptionCache;
            var tmp;
            if (tmp0_elvis_lhs == null) {
              // Inline function 'kotlin.also' call
              var this_0 = createCauseException($this, cause);
              causeExceptionCache = this_0;
              tmp = this_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var causeException = tmp;
            tmp0.y1i(causeException);
          }
          // Inline function 'kotlin.takeIf' call
          var this_1 = tmp0.z1i();
          var tmp_0;
          if (!wasCancelling) {
            tmp_0 = this_1;
          } else {
            tmp_0 = null;
          }
          var notifyRootCause = tmp_0;
          if (notifyRootCause == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            notifyCancelling($this, tmp0.n1i_1, notifyRootCause);
          }
          return get_COMPLETING_ALREADY();
        } else {
          if (!(tmp0 == null) ? isInterface(tmp0, Incomplete) : false) {
            var tmp2_elvis_lhs = causeExceptionCache;
            var tmp_1;
            if (tmp2_elvis_lhs == null) {
              // Inline function 'kotlin.also' call
              var this_2 = createCauseException($this, cause);
              causeExceptionCache = this_2;
              tmp_1 = this_2;
            } else {
              tmp_1 = tmp2_elvis_lhs;
            }
            var causeException_0 = tmp_1;
            if (tmp0.r19()) {
              if (tryMakeCancelling($this, tmp0, causeException_0))
                return get_COMPLETING_ALREADY();
            } else {
              var finalState = tryMakeCompleting($this, tmp0, new CompletedExceptionally(causeException_0));
              if (finalState === get_COMPLETING_ALREADY()) {
                // Inline function 'kotlin.error' call
                var message = 'Cannot happen in ' + toString(tmp0);
                throw IllegalStateException_init_$Create$(toString(message));
              } else if (finalState === get_COMPLETING_RETRY()) {
                break $l$block;
              } else
                return finalState;
            }
          } else {
            return get_TOO_LATE_TO_CANCEL();
          }
        }
      }
    }
  }
  function getOrPromoteCancellingList($this, state) {
    var tmp0_elvis_lhs = state.c1g();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0;
      if (state instanceof Empty) {
        tmp_0 = new NodeList();
      } else {
        if (state instanceof JobNode) {
          promoteSingleToNodeList($this, state);
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.error' call
          var message = 'State should have list: ' + toString(state);
          throw IllegalStateException_init_$Create$(toString(message));
        }
      }
      tmp = tmp_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function tryMakeCancelling($this, state, rootCause) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var cancelling = new Finishing(list, false, rootCause);
    if (!$this.k19_1.atomicfu$compareAndSet(state, cancelling))
      return false;
    notifyCancelling($this, list, rootCause);
    return true;
  }
  function tryMakeCompleting($this, state, proposedUpdate) {
    if (!(!(state == null) ? isInterface(state, Incomplete) : false))
      return get_COMPLETING_ALREADY();
    var tmp;
    var tmp_0;
    var tmp_1;
    if (state instanceof Empty) {
      tmp_1 = true;
    } else {
      tmp_1 = state instanceof JobNode;
    }
    if (tmp_1) {
      tmp_0 = !(state instanceof ChildHandleNode);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !(proposedUpdate instanceof CompletedExceptionally);
    } else {
      tmp = false;
    }
    if (tmp) {
      if (tryFinalizeSimpleState($this, state, proposedUpdate)) {
        return proposedUpdate;
      }
      return get_COMPLETING_RETRY();
    }
    return tryMakeCompletingSlowPath($this, state, proposedUpdate);
  }
  function tryMakeCompletingSlowPath($this, state, proposedUpdate) {
    var tmp0_elvis_lhs = getOrPromoteCancellingList($this, state);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return get_COMPLETING_RETRY();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var list = tmp;
    var tmp1_elvis_lhs = state instanceof Finishing ? state : null;
    var finishing = tmp1_elvis_lhs == null ? new Finishing(list, false, null) : tmp1_elvis_lhs;
    var notifyRootCause;
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    if (finishing.w1i())
      return get_COMPLETING_ALREADY();
    finishing.a1j(true);
    if (!(finishing === state)) {
      if (!$this.k19_1.atomicfu$compareAndSet(state, finishing))
        return get_COMPLETING_RETRY();
    }
    // Inline function 'kotlinx.coroutines.assert' call
    var wasCancelling = finishing.r1i();
    var tmp0_safe_receiver = proposedUpdate instanceof CompletedExceptionally ? proposedUpdate : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      finishing.y1i(tmp0_safe_receiver.w19_1);
    }
    // Inline function 'kotlin.takeIf' call
    var this_0 = finishing.z1i();
    var tmp_0;
    if (!wasCancelling) {
      tmp_0 = this_0;
    } else {
      tmp_0 = null;
    }
    notifyRootCause = tmp_0;
    if (notifyRootCause == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      notifyCancelling($this, list, notifyRootCause);
    }
    var child = nextChild($this, list);
    if (!(child == null) && tryWaitForChild($this, finishing, child, proposedUpdate))
      return get_COMPLETING_WAITING_CHILDREN();
    list.t1i(2);
    var anotherChild = nextChild($this, list);
    if (!(anotherChild == null) && tryWaitForChild($this, finishing, anotherChild, proposedUpdate))
      return get_COMPLETING_WAITING_CHILDREN();
    return finalizeFinishingState($this, finishing, proposedUpdate);
  }
  function _get_exceptionOrNull__b3j7js($this, $receiver) {
    var tmp0_safe_receiver = $receiver instanceof CompletedExceptionally ? $receiver : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w19_1;
  }
  function tryWaitForChild($this, state, child, proposedUpdate) {
    var $this_0 = $this;
    var state_0 = state;
    var child_0 = child;
    var proposedUpdate_0 = proposedUpdate;
    $l$1: do {
      $l$0: do {
        var handle = invokeOnCompletion(child_0.f1j_1, false, new ChildCompletion($this_0, state_0, child_0, proposedUpdate_0));
        if (!(handle === NonDisposableHandle_instance))
          return true;
        var tmp0_elvis_lhs = nextChild($this_0, child_0);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var nextChild_0 = tmp;
        var tmp0 = $this_0;
        var tmp1 = state_0;
        var tmp3 = proposedUpdate_0;
        $this_0 = tmp0;
        state_0 = tmp1;
        child_0 = nextChild_0;
        proposedUpdate_0 = tmp3;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function continueCompleting($this, state, lastChild, proposedUpdate) {
    // Inline function 'kotlinx.coroutines.assert' call
    var waitChild = nextChild($this, lastChild);
    if (!(waitChild == null) && tryWaitForChild($this, state, waitChild, proposedUpdate))
      return Unit_instance;
    state.n1i_1.t1i(2);
    var waitChildAgain = nextChild($this, lastChild);
    if (!(waitChildAgain == null) && tryWaitForChild($this, state, waitChildAgain, proposedUpdate)) {
      return Unit_instance;
    }
    var finalState = finalizeFinishingState($this, state, proposedUpdate);
    $this.b1a(finalState);
  }
  function nextChild($this, $receiver) {
    var cur = $receiver;
    $l$loop: while (true) {
      // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.isRemoved' call
      if (!cur.f1g_1) {
        break $l$loop;
      }
      // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.prevNode' call
      cur = cur.e1g_1;
    }
    $l$loop_0: while (true) {
      // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.nextNode' call
      cur = cur.d1g_1;
      // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListNode.isRemoved' call
      if (cur.f1g_1)
        continue $l$loop_0;
      if (cur instanceof ChildHandleNode)
        return cur;
      if (cur instanceof NodeList)
        return null;
    }
  }
  function stateString($this, state) {
    var tmp;
    if (state instanceof Finishing) {
      tmp = state.r1i() ? 'Cancelling' : state.w1i() ? 'Completing' : 'Active';
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        tmp = state.r19() ? 'Active' : 'New';
      } else {
        if (state instanceof CompletedExceptionally) {
          tmp = 'Cancelled';
        } else {
          tmp = 'Completed';
        }
      }
    }
    return tmp;
  }
  function Finishing(list, isCompleting, rootCause) {
    SynchronizedObject.call(this);
    this.n1i_1 = list;
    this.o1i_1 = atomic$boolean$1(isCompleting);
    this.p1i_1 = atomic$ref$1(rootCause);
    this.q1i_1 = atomic$ref$1(null);
  }
  protoOf(Finishing).c1g = function () {
    return this.n1i_1;
  };
  protoOf(Finishing).a1j = function (value) {
    this.o1i_1.kotlinx$atomicfu$value = value;
  };
  protoOf(Finishing).w1i = function () {
    return this.o1i_1.kotlinx$atomicfu$value;
  };
  protoOf(Finishing).g1j = function (value) {
    this.p1i_1.kotlinx$atomicfu$value = value;
  };
  protoOf(Finishing).z1i = function () {
    return this.p1i_1.kotlinx$atomicfu$value;
  };
  protoOf(Finishing).x1i = function () {
    return _get_exceptionsHolder__nhszp(this) === get_SEALED();
  };
  protoOf(Finishing).r1i = function () {
    return !(this.z1i() == null);
  };
  protoOf(Finishing).r19 = function () {
    return this.z1i() == null;
  };
  protoOf(Finishing).s1i = function (proposedException) {
    var eh = _get_exceptionsHolder__nhszp(this);
    var tmp;
    if (eh == null) {
      tmp = allocateList(this);
    } else {
      if (eh instanceof Error) {
        // Inline function 'kotlin.also' call
        var this_0 = allocateList(this);
        this_0.j1(eh);
        tmp = this_0;
      } else {
        if (eh instanceof ArrayList) {
          tmp = eh instanceof ArrayList ? eh : THROW_CCE();
        } else {
          // Inline function 'kotlin.error' call
          var message = 'State is ' + toString(eh);
          throw IllegalStateException_init_$Create$(toString(message));
        }
      }
    }
    var list = tmp;
    var rootCause = this.z1i();
    if (rootCause == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      list.g3(0, rootCause);
    }
    if (!(proposedException == null) && !equals(proposedException, rootCause)) {
      list.j1(proposedException);
    }
    _set_exceptionsHolder__tqm22h(this, get_SEALED());
    return list;
  };
  protoOf(Finishing).y1i = function (exception) {
    var rootCause = this.z1i();
    if (rootCause == null) {
      this.g1j(exception);
      return Unit_instance;
    }
    if (exception === rootCause)
      return Unit_instance;
    var eh = _get_exceptionsHolder__nhszp(this);
    if (eh == null) {
      _set_exceptionsHolder__tqm22h(this, exception);
    } else {
      if (eh instanceof Error) {
        if (exception === eh)
          return Unit_instance;
        // Inline function 'kotlin.apply' call
        var this_0 = allocateList(this);
        this_0.j1(eh);
        this_0.j1(exception);
        _set_exceptionsHolder__tqm22h(this, this_0);
      } else {
        if (eh instanceof ArrayList) {
          (eh instanceof ArrayList ? eh : THROW_CCE()).j1(exception);
        } else {
          // Inline function 'kotlin.error' call
          var message = 'State is ' + toString(eh);
          throw IllegalStateException_init_$Create$(toString(message));
        }
      }
    }
  };
  protoOf(Finishing).toString = function () {
    return 'Finishing[cancelling=' + this.r1i() + ', completing=' + this.w1i() + ', rootCause=' + toString_0(this.z1i()) + ', exceptions=' + toString_0(_get_exceptionsHolder__nhszp(this)) + ', list=' + this.n1i_1.toString() + ']';
  };
  function ChildCompletion(parent, state, child, proposedUpdate) {
    JobNode.call(this);
    this.l1j_1 = parent;
    this.m1j_1 = state;
    this.n1j_1 = child;
    this.o1j_1 = proposedUpdate;
  }
  protoOf(ChildCompletion).w1f = function () {
    return false;
  };
  protoOf(ChildCompletion).r1d = function (cause) {
    continueCompleting(this.l1j_1, this.m1j_1, this.n1j_1, this.o1j_1);
  };
  function AwaitContinuation(delegate, job) {
    CancellableContinuationImpl.call(this, delegate, 1);
    this.v1j_1 = job;
  }
  protoOf(AwaitContinuation).b1f = function (parent) {
    var state = this.v1j_1.l1a();
    if (state instanceof Finishing) {
      var tmp0_safe_receiver = state.z1i();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        return tmp0_safe_receiver;
      }
    }
    if (state instanceof CompletedExceptionally)
      return state.w19_1;
    return parent.q1a();
  };
  protoOf(AwaitContinuation).n1f = function () {
    return 'AwaitContinuation';
  };
  function awaitSuspend($this, $completion) {
    var cont = new AwaitContinuation(intercepted($completion), $this);
    cont.v1e();
    disposeOnCancellation(cont, invokeOnCompletion($this, VOID, new ResumeAwaitOnCompletion(cont)));
    return cont.x1b();
  }
  function JobSupport$_get_children_$slambda_k839f8(this$0, resultContinuation) {
    this.e1k_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JobSupport$_get_children_$slambda_k839f8).j1k = function ($this$sequence, $completion) {
    var tmp = this.k1k($this$sequence, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(JobSupport$_get_children_$slambda_k839f8).ja = function (p1, $completion) {
    return this.j1k(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JobSupport$_get_children_$slambda_k839f8).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            var state = this.e1k_1.l1a();
            if (state instanceof ChildHandleNode) {
              this.n9_1 = 6;
              suspendResult = this.f1k_1.oi(state.f1j_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (!(state == null) ? isInterface(state, Incomplete) : false) {
                var tmp0_safe_receiver = state.c1g();
                if (tmp0_safe_receiver == null) {
                  this.g1k_1 = null;
                  this.n9_1 = 5;
                  continue $sm;
                } else {
                  this.i1k_1 = tmp0_safe_receiver;
                  this.h1k_1 = this.i1k_1.d1g_1;
                  this.n9_1 = 1;
                  continue $sm;
                }
              } else {
                this.n9_1 = 7;
                continue $sm;
              }
            }

          case 1:
            if (!!equals(this.h1k_1, this.i1k_1)) {
              this.n9_1 = 4;
              continue $sm;
            }

            var it = this.h1k_1;
            if (it instanceof ChildHandleNode) {
              this.n9_1 = 2;
              suspendResult = this.f1k_1.oi(it.f1j_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.h1k_1 = this.h1k_1.d1g_1;
            this.n9_1 = 1;
            continue $sm;
          case 4:
            var tmp_0 = this;
            tmp_0.g1k_1 = Unit_instance;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.n9_1 = 7;
            continue $sm;
          case 6:
            this.n9_1 = 7;
            continue $sm;
          case 7:
            return Unit_instance;
          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(JobSupport$_get_children_$slambda_k839f8).k1k = function ($this$sequence, completion) {
    var i = new JobSupport$_get_children_$slambda_k839f8(this.e1k_1, completion);
    i.f1k_1 = $this$sequence;
    return i;
  };
  function JobSupport$_get_children_$slambda_k839f8_0(this$0, resultContinuation) {
    var i = new JobSupport$_get_children_$slambda_k839f8(this$0, resultContinuation);
    return constructCallableReference(function ($this$sequence, $completion) {
      return i.j1k($this$sequence, $completion);
    }, 1);
  }
  function JobSupport(active) {
    this.k19_1 = atomic$ref$1(active ? get_EMPTY_ACTIVE() : get_EMPTY_NEW());
    this.l19_1 = atomic$ref$1(null);
  }
  protoOf(JobSupport).t1 = function () {
    return Key_instance_3;
  };
  protoOf(JobSupport).i1a = function (value) {
    this.l19_1.kotlinx$atomicfu$value = value;
  };
  protoOf(JobSupport).j1a = function () {
    return this.l19_1.kotlinx$atomicfu$value;
  };
  protoOf(JobSupport).k1a = function () {
    var tmp0_safe_receiver = this.j1a();
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k1a();
  };
  protoOf(JobSupport).m19 = function (parent) {
    // Inline function 'kotlinx.coroutines.assert' call
    if (parent == null) {
      this.i1a(NonDisposableHandle_instance);
      return Unit_instance;
    }
    parent.o1a();
    var handle = parent.k1b(this);
    this.i1a(handle);
    if (this.m1a()) {
      handle.s1d();
      this.i1a(NonDisposableHandle_instance);
    }
  };
  protoOf(JobSupport).l1a = function () {
    return this.k19_1.kotlinx$atomicfu$value;
  };
  protoOf(JobSupport).r19 = function () {
    var state = this.l1a();
    var tmp;
    if (!(state == null) ? isInterface(state, Incomplete) : false) {
      tmp = state.r19();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(JobSupport).m1a = function () {
    var tmp = this.l1a();
    return !(!(tmp == null) ? isInterface(tmp, Incomplete) : false);
  };
  protoOf(JobSupport).n1a = function () {
    var state = this.l1a();
    var tmp;
    if (state instanceof CompletedExceptionally) {
      tmp = true;
    } else {
      var tmp_0;
      if (state instanceof Finishing) {
        tmp_0 = state.r1i();
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(JobSupport).o1a = function () {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var state = this.l1a();
      var tmp0_subject = startInternal(this, state);
      if (tmp0_subject === 0)
        return false;
      else if (tmp0_subject === 1)
        return true;
    }
  };
  protoOf(JobSupport).p1a = function () {
  };
  protoOf(JobSupport).q1a = function () {
    var state = this.l1a();
    var tmp;
    if (state instanceof Finishing) {
      var tmp0_safe_receiver = state.z1i();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : this.r1a(tmp0_safe_receiver, get_classSimpleName(this) + ' is cancelling');
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.error' call
        var message = 'Job is still new or active: ' + this.toString();
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      if (!(state == null) ? isInterface(state, Incomplete) : false) {
        // Inline function 'kotlin.error' call
        var message_0 = 'Job is still new or active: ' + this.toString();
        throw IllegalStateException_init_$Create$(toString(message_0));
      } else {
        if (state instanceof CompletedExceptionally) {
          tmp = this.s1a(state.w19_1);
        } else {
          tmp = new JobCancellationException(get_classSimpleName(this) + ' has completed normally', null, this);
        }
      }
    }
    return tmp;
  };
  protoOf(JobSupport).r1a = function (_this__u8e3s4, message) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof CancellationException ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp = new JobCancellationException(message == null ? this.u19() : message, _this__u8e3s4, this);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(JobSupport).s1a = function (_this__u8e3s4, message, $super) {
    message = message === VOID ? null : message;
    return $super === VOID ? this.r1a(_this__u8e3s4, message) : $super.r1a.call(this, _this__u8e3s4, message);
  };
  protoOf(JobSupport).t1a = function (handler) {
    return this.w1a(true, new InvokeOnCompletion(handler));
  };
  protoOf(JobSupport).u1a = function (onCancelling, invokeImmediately, handler) {
    var tmp;
    if (onCancelling) {
      tmp = new InvokeOnCancelling(handler);
    } else {
      tmp = new InvokeOnCompletion(handler);
    }
    return this.w1a(invokeImmediately, tmp);
  };
  protoOf(JobSupport).w1a = function (invokeImmediately, node) {
    node.a1g_1 = this;
    var tmp$ret$0;
    $l$block_1: {
      // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList' call
      // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
      while (true) {
        var state = this.l1a();
        if (state instanceof Empty) {
          if (state.v1i_1) {
            if (this.k19_1.atomicfu$compareAndSet(state, node)) {
              tmp$ret$0 = true;
              break $l$block_1;
            }
          } else {
            promoteEmptyToNodeList(this, state);
          }
        } else {
          if (!(state == null) ? isInterface(state, Incomplete) : false) {
            var list = state.c1g();
            if (list == null) {
              promoteSingleToNodeList(this, state instanceof JobNode ? state : THROW_CCE());
            } else {
              var tmp;
              if (node.w1f()) {
                var tmp0_safe_receiver = state instanceof Finishing ? state : null;
                var rootCause = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z1i();
                var tmp_0;
                if (rootCause == null) {
                  tmp_0 = list.g1g(node, 5);
                } else {
                  if (invokeImmediately) {
                    node.r1d(rootCause);
                  }
                  return NonDisposableHandle_instance;
                }
                tmp = tmp_0;
              } else {
                tmp = list.g1g(node, 1);
              }
              if (tmp) {
                tmp$ret$0 = true;
                break $l$block_1;
              }
            }
          } else {
            tmp$ret$0 = false;
            break $l$block_1;
          }
        }
      }
    }
    var added = tmp$ret$0;
    if (added)
      return node;
    else if (invokeImmediately) {
      var tmp_1 = this.l1a();
      var tmp0_safe_receiver_0 = tmp_1 instanceof CompletedExceptionally ? tmp_1 : null;
      node.r1d(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.w19_1);
    }
    return NonDisposableHandle_instance;
  };
  protoOf(JobSupport).x1a = function ($completion) {
    if (!joinInternal(this)) {
      // Inline function 'kotlin.js.getCoroutineContext' call
      var tmp$ret$0 = $completion.t9();
      ensureActive(tmp$ret$0);
      return Unit_instance;
    }
    return joinSuspend(this, $completion);
  };
  protoOf(JobSupport).y1a = function (node) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var state = this.l1a();
      if (state instanceof JobNode) {
        if (!(state === node))
          return Unit_instance;
        if (this.k19_1.atomicfu$compareAndSet(state, get_EMPTY_ACTIVE()))
          return Unit_instance;
      } else {
        if (!(state == null) ? isInterface(state, Incomplete) : false) {
          if (!(state.c1g() == null)) {
            node.h1g();
          }
          return Unit_instance;
        } else {
          return Unit_instance;
        }
      }
    }
  };
  protoOf(JobSupport).z1a = function () {
    return false;
  };
  protoOf(JobSupport).a1b = function (cause) {
    var tmp;
    if (cause == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp = new JobCancellationException(null == null ? this.u19() : null, null, this);
    } else {
      tmp = cause;
    }
    this.c1b(tmp);
  };
  protoOf(JobSupport).u19 = function () {
    return 'Job was cancelled';
  };
  protoOf(JobSupport).c1b = function (cause) {
    this.g1b(cause);
  };
  protoOf(JobSupport).d1b = function (parentJob) {
    this.g1b(parentJob);
  };
  protoOf(JobSupport).e1b = function (cause) {
    if (cause instanceof CancellationException)
      return true;
    return this.g1b(cause) && this.n1b();
  };
  protoOf(JobSupport).f1b = function (cause) {
    return this.g1b(cause);
  };
  protoOf(JobSupport).g1b = function (cause) {
    var finalState = get_COMPLETING_ALREADY();
    if (this.z1a()) {
      finalState = cancelMakeCompleting(this, cause);
      if (finalState === get_COMPLETING_WAITING_CHILDREN())
        return true;
    }
    if (finalState === get_COMPLETING_ALREADY()) {
      finalState = makeCancelling(this, cause);
    }
    var tmp;
    if (finalState === get_COMPLETING_ALREADY()) {
      tmp = true;
    } else if (finalState === get_COMPLETING_WAITING_CHILDREN()) {
      tmp = true;
    } else if (finalState === get_TOO_LATE_TO_CANCEL()) {
      tmp = false;
    } else {
      this.b1a(finalState);
      tmp = true;
    }
    return tmp;
  };
  protoOf(JobSupport).h1b = function () {
    var state = this.l1a();
    var tmp;
    if (state instanceof Finishing) {
      tmp = state.z1i();
    } else {
      if (state instanceof CompletedExceptionally) {
        tmp = state.w19_1;
      } else {
        if (!(state == null) ? isInterface(state, Incomplete) : false) {
          // Inline function 'kotlin.error' call
          var message = 'Cannot be cancelling child in this state: ' + toString(state);
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp = null;
        }
      }
    }
    var rootCause = tmp;
    var tmp1_elvis_lhs = rootCause instanceof CancellationException ? rootCause : null;
    return tmp1_elvis_lhs == null ? new JobCancellationException('Parent job is ' + stateString(this, state), rootCause, this) : tmp1_elvis_lhs;
  };
  protoOf(JobSupport).i1b = function (proposedUpdate) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var tmp0 = this.l1a();
      $l$block: {
        var finalState = tryMakeCompleting(this, tmp0, proposedUpdate);
        if (finalState === get_COMPLETING_ALREADY())
          return false;
        else if (finalState === get_COMPLETING_WAITING_CHILDREN())
          return true;
        else if (finalState === get_COMPLETING_RETRY()) {
          break $l$block;
        } else {
          this.b1a(finalState);
          return true;
        }
      }
    }
  };
  protoOf(JobSupport).z19 = function (proposedUpdate) {
    // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
    while (true) {
      var tmp0 = this.l1a();
      $l$block: {
        var finalState = tryMakeCompleting(this, tmp0, proposedUpdate);
        if (finalState === get_COMPLETING_ALREADY())
          throw IllegalStateException_init_$Create$_0('Job ' + this.toString() + ' is already complete or completing, ' + ('but is being completed with ' + toString_0(proposedUpdate)), _get_exceptionOrNull__b3j7js(this, proposedUpdate));
        else if (finalState === get_COMPLETING_RETRY()) {
          break $l$block;
        } else
          return finalState;
      }
    }
  };
  protoOf(JobSupport).j1b = function () {
    return sequence(JobSupport$_get_children_$slambda_k839f8_0(this, null));
  };
  protoOf(JobSupport).k1b = function (child) {
    // Inline function 'kotlin.also' call
    var this_0 = new ChildHandleNode(child);
    this_0.a1g_1 = this;
    var node = this_0;
    var tmp$ret$2;
    $l$block_1: {
      // Inline function 'kotlinx.coroutines.JobSupport.tryPutNodeIntoList' call
      // Inline function 'kotlinx.coroutines.JobSupport.loopOnState' call
      while (true) {
        var state = this.l1a();
        if (state instanceof Empty) {
          if (state.v1i_1) {
            if (this.k19_1.atomicfu$compareAndSet(state, node)) {
              tmp$ret$2 = true;
              break $l$block_1;
            }
          } else {
            promoteEmptyToNodeList(this, state);
          }
        } else {
          if (!(state == null) ? isInterface(state, Incomplete) : false) {
            var list = state.c1g();
            if (list == null) {
              promoteSingleToNodeList(this, state instanceof JobNode ? state : THROW_CCE());
            } else {
              var addedBeforeCancellation = list.g1g(node, 7);
              var tmp;
              if (addedBeforeCancellation) {
                tmp = true;
              } else {
                var addedBeforeCompletion = list.g1g(node, 3);
                var latestState = this.l1a();
                var tmp_0;
                if (latestState instanceof Finishing) {
                  tmp_0 = latestState.z1i();
                } else {
                  // Inline function 'kotlinx.coroutines.assert' call
                  var tmp0_safe_receiver = latestState instanceof CompletedExceptionally ? latestState : null;
                  tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w19_1;
                }
                var rootCause = tmp_0;
                node.r1d(rootCause);
                var tmp_1;
                if (addedBeforeCompletion) {
                  // Inline function 'kotlinx.coroutines.assert' call
                  tmp_1 = true;
                } else {
                  return NonDisposableHandle_instance;
                }
                tmp = tmp_1;
              }
              if (tmp) {
                tmp$ret$2 = true;
                break $l$block_1;
              }
            }
          } else {
            tmp$ret$2 = false;
            break $l$block_1;
          }
        }
      }
    }
    var added = tmp$ret$2;
    if (added)
      return node;
    var tmp_2 = this.l1a();
    var tmp0_safe_receiver_0 = tmp_2 instanceof CompletedExceptionally ? tmp_2 : null;
    node.r1d(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.w19_1);
    return NonDisposableHandle_instance;
  };
  protoOf(JobSupport).c1a = function (exception) {
    throw exception;
  };
  protoOf(JobSupport).l1b = function (cause) {
  };
  protoOf(JobSupport).m1b = function () {
    return false;
  };
  protoOf(JobSupport).n1b = function () {
    return true;
  };
  protoOf(JobSupport).o1b = function (exception) {
    return false;
  };
  protoOf(JobSupport).v19 = function (state) {
  };
  protoOf(JobSupport).b1a = function (state) {
  };
  protoOf(JobSupport).toString = function () {
    return this.p1b() + '@' + get_hexAddress(this);
  };
  protoOf(JobSupport).p1b = function () {
    return this.d1a() + '{' + stateString(this, this.l1a()) + '}';
  };
  protoOf(JobSupport).d1a = function () {
    return get_classSimpleName(this);
  };
  protoOf(JobSupport).q1b = function ($completion) {
    $l$loop: while (true) {
      var state = this.l1a();
      if (!(!(state == null) ? isInterface(state, Incomplete) : false)) {
        if (state instanceof CompletedExceptionally) {
          // Inline function 'kotlinx.coroutines.internal.recoverAndThrow' call
          throw state.w19_1;
        }
        return unboxState(state);
      }
      if (startInternal(this, state) >= 0)
        break $l$loop;
    }
    return awaitSuspend(this, $completion);
  };
  function handlesExceptionF($this) {
    var tmp = $this.j1a();
    var tmp0_safe_receiver = tmp instanceof ChildHandleNode ? tmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b1g();
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var parentJob = tmp_0;
    while (true) {
      if (parentJob.n1b())
        return true;
      var tmp_1 = parentJob.j1a();
      var tmp2_safe_receiver = tmp_1 instanceof ChildHandleNode ? tmp_1 : null;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.b1g();
      var tmp_2;
      if (tmp3_elvis_lhs == null) {
        return false;
      } else {
        tmp_2 = tmp3_elvis_lhs;
      }
      parentJob = tmp_2;
    }
  }
  function JobImpl(parent) {
    JobSupport.call(this, true);
    this.m19(parent);
    this.n1k_1 = handlesExceptionF(this);
  }
  protoOf(JobImpl).z1a = function () {
    return true;
  };
  protoOf(JobImpl).n1b = function () {
    return this.n1k_1;
  };
  protoOf(JobImpl).w1g = function () {
    return this.i1b(Unit_instance);
  };
  protoOf(JobImpl).v1g = function (exception) {
    return this.i1b(new CompletedExceptionally(exception));
  };
  function Empty(isActive) {
    this.v1i_1 = isActive;
  }
  protoOf(Empty).r19 = function () {
    return this.v1i_1;
  };
  protoOf(Empty).c1g = function () {
    return null;
  };
  protoOf(Empty).toString = function () {
    return 'Empty{' + (this.v1i_1 ? 'Active' : 'New') + '}';
  };
  function Incomplete() {
  }
  function NodeList() {
    LockFreeLinkedListHead.call(this);
  }
  protoOf(NodeList).r19 = function () {
    return true;
  };
  protoOf(NodeList).c1g = function () {
    return this;
  };
  protoOf(NodeList).r1k = function (state) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    this_0.q('List{');
    this_0.q(state);
    this_0.q('}[');
    var first = true;
    // Inline function 'kotlinx.coroutines.internal.LockFreeLinkedListHead.forEach' call
    var cur = this.d1g_1;
    while (!equals(cur, this)) {
      var node = cur;
      if (node instanceof JobNode) {
        if (first) {
          first = false;
        } else
          this_0.q(', ');
        this_0.w(node);
      }
      cur = cur.d1g_1;
    }
    this_0.q(']');
    return this_0.toString();
  };
  protoOf(NodeList).toString = function () {
    return get_DEBUG() ? this.r1k('Active') : protoOf(LockFreeLinkedListHead).toString.call(this);
  };
  function IncompleteStateBox(state) {
    this.m1i_1 = state;
  }
  function boxIncomplete(_this__u8e3s4) {
    _init_properties_JobSupport_kt__68f172();
    var tmp;
    if (!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Incomplete) : false) {
      tmp = new IncompleteStateBox(_this__u8e3s4);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function InactiveNodeList(list) {
    this.u1i_1 = list;
  }
  protoOf(InactiveNodeList).c1g = function () {
    return this.u1i_1;
  };
  protoOf(InactiveNodeList).r19 = function () {
    return false;
  };
  protoOf(InactiveNodeList).toString = function () {
    return get_DEBUG() ? this.u1i_1.r1k('New') : anyToString(this);
  };
  function InvokeOnCompletion(handler) {
    JobNode.call(this);
    this.w1k_1 = handler;
  }
  protoOf(InvokeOnCompletion).w1f = function () {
    return false;
  };
  protoOf(InvokeOnCompletion).r1d = function (cause) {
    return this.w1k_1(cause);
  };
  function InvokeOnCancelling(handler) {
    JobNode.call(this);
    this.b1l_1 = handler;
    this.c1l_1 = atomic$boolean$1(false);
  }
  protoOf(InvokeOnCancelling).w1f = function () {
    return true;
  };
  protoOf(InvokeOnCancelling).r1d = function (cause) {
    if (this.c1l_1.atomicfu$compareAndSet(false, true))
      this.b1l_1(cause);
  };
  function ResumeOnCompletion(continuation) {
    JobNode.call(this);
    this.h1l_1 = continuation;
  }
  protoOf(ResumeOnCompletion).w1f = function () {
    return false;
  };
  protoOf(ResumeOnCompletion).r1d = function (cause) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = this.h1l_1;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$1 = _Result___init__impl__xyqfz8(Unit_instance);
    this_0.y9(tmp$ret$1);
    return Unit_instance;
  };
  function ChildHandleNode(childJob) {
    JobNode.call(this);
    this.f1j_1 = childJob;
  }
  protoOf(ChildHandleNode).k1a = function () {
    return this.b1g();
  };
  protoOf(ChildHandleNode).w1f = function () {
    return true;
  };
  protoOf(ChildHandleNode).r1d = function (cause) {
    return this.f1j_1.d1b(this.b1g());
  };
  protoOf(ChildHandleNode).e1b = function (cause) {
    return this.b1g().e1b(cause);
  };
  function ResumeAwaitOnCompletion(continuation) {
    JobNode.call(this);
    this.m1l_1 = continuation;
  }
  protoOf(ResumeAwaitOnCompletion).w1f = function () {
    return false;
  };
  protoOf(ResumeAwaitOnCompletion).r1d = function (cause) {
    var state = this.b1g().l1a();
    // Inline function 'kotlinx.coroutines.assert' call
    if (state instanceof CompletedExceptionally) {
      var tmp0 = this.m1l_1;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = state.w19_1;
      var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(exception));
      tmp0.y9(tmp$ret$2);
    } else {
      var tmp0_0 = this.m1l_1;
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var value = unboxState(state);
      var tmp$ret$4 = _Result___init__impl__xyqfz8(value);
      tmp0_0.y9(tmp$ret$4);
    }
  };
  var properties_initialized_JobSupport_kt_5iq8a4;
  function _init_properties_JobSupport_kt__68f172() {
    if (!properties_initialized_JobSupport_kt_5iq8a4) {
      properties_initialized_JobSupport_kt_5iq8a4 = true;
      COMPLETING_ALREADY = new Symbol('COMPLETING_ALREADY');
      COMPLETING_WAITING_CHILDREN = new Symbol('COMPLETING_WAITING_CHILDREN');
      COMPLETING_RETRY = new Symbol('COMPLETING_RETRY');
      TOO_LATE_TO_CANCEL = new Symbol('TOO_LATE_TO_CANCEL');
      SEALED = new Symbol('SEALED');
      EMPTY_NEW = new Empty(false);
      EMPTY_ACTIVE = new Empty(true);
    }
  }
  function JobNode$invoke$ref(p0) {
    return constructCallableReference(function (p0_0) {
      p0.r1d(p0_0);
      return Unit_instance;
    }, 1, 0, 0, 'invoke', [p0]);
  }
  function MainCoroutineDispatcher() {
    CoroutineDispatcher.call(this);
  }
  protoOf(MainCoroutineDispatcher).toString = function () {
    var tmp0_elvis_lhs = this.p1l();
    return tmp0_elvis_lhs == null ? get_classSimpleName(this) + '@' + get_hexAddress(this) : tmp0_elvis_lhs;
  };
  protoOf(MainCoroutineDispatcher).z1g = function (parallelism, name) {
    checkParallelism(parallelism);
    return namedOrThis(this, name);
  };
  protoOf(MainCoroutineDispatcher).p1l = function () {
    var main = Dispatchers_getInstance().m1h();
    if (this === main)
      return 'Dispatchers.Main';
    var tmp;
    try {
      tmp = main.o1l();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof UnsupportedOperationException) {
        var e = $p;
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var immediate = tmp;
    if (this === immediate)
      return 'Dispatchers.Main.immediate';
    return null;
  };
  function SupervisorJob(parent) {
    parent = parent === VOID ? null : parent;
    return new SupervisorJobImpl(parent);
  }
  function supervisorScope(block, $completion) {
    var coroutine = new SupervisorCoroutine($completion.t9(), $completion);
    return startUndispatchedOrReturn(coroutine, coroutine, block);
  }
  function SupervisorJobImpl(parent) {
    JobImpl.call(this, parent);
  }
  protoOf(SupervisorJobImpl).e1b = function (cause) {
    return false;
  };
  function SupervisorCoroutine(context, uCont) {
    ScopeCoroutine.call(this, context, uCont);
  }
  protoOf(SupervisorCoroutine).e1b = function (cause) {
    return false;
  };
  function withTimeoutOrNull(timeMillis, block, $completion) {
    var tmp = new $withTimeoutOrNullCOROUTINE$(timeMillis, block, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function withTimeout(timeMillis, block, $completion) {
    if (compare(timeMillis, new Long(0, 0)) <= 0)
      throw TimeoutCancellationException_init_$Create$('Timed out immediately');
    return setupTimeout(new TimeoutCoroutine(timeMillis, $completion), block);
  }
  function TimeoutCancellationException_init_$Init$(message, $this) {
    TimeoutCancellationException.call($this, message, null);
    return $this;
  }
  function TimeoutCancellationException_init_$Create$(message) {
    var tmp = TimeoutCancellationException_init_$Init$(message, objectCreate(protoOf(TimeoutCancellationException)));
    captureStack(tmp, TimeoutCancellationException_init_$Create$);
    return tmp;
  }
  function TimeoutCancellationException(message, coroutine) {
    CancellationException_init_$Init$(message, this);
    captureStack(this, TimeoutCancellationException);
    this.i1m_1 = coroutine;
  }
  protoOf(TimeoutCancellationException).n1h = function () {
    var tmp0_elvis_lhs = this.message;
    // Inline function 'kotlin.also' call
    var this_0 = new TimeoutCancellationException(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, this.i1m_1);
    initCause(this_0, this);
    return this_0;
  };
  function TimeoutCoroutine(time, uCont) {
    ScopeCoroutine.call(this, uCont.t9(), uCont);
    this.n1m_1 = time;
  }
  protoOf(TimeoutCoroutine).o1f = function () {
    var delay = get_delay(this.p19_1);
    var tmp0_safe_receiver = this.p19_1.aa(Key_instance_2);
    var name = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h1h_1;
    this.f1b(TimeoutCancellationException_0(this.n1m_1, delay, this, name));
  };
  protoOf(TimeoutCoroutine).d1a = function () {
    return protoOf(ScopeCoroutine).d1a.call(this) + '(timeMillis=' + this.n1m_1.toString() + ')';
  };
  function setupTimeout(coroutine, block) {
    var cont = coroutine.z1c_1;
    var context = cont.t9();
    disposeOnCompletion(coroutine, get_delay(context).p1h(coroutine.n1m_1, coroutine, coroutine.p19_1));
    return startUndispatchedOrReturnIgnoreTimeout(coroutine, coroutine, block);
  }
  function TimeoutCancellationException_0(time, delay, coroutine, coroutineName) {
    var tmp0_safe_receiver = isInterface(delay, DelayWithTimeoutDiagnostics) ? delay : null;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$0 = toDuration(time, DurationUnit_MILLISECONDS_getInstance());
      tmp = tmp0_safe_receiver.q1h(tmp$ret$0);
    }
    var tmp1_elvis_lhs = tmp;
    var baseMessage = tmp1_elvis_lhs == null ? 'Timed out waiting for ' + time.toString() + ' ms' : tmp1_elvis_lhs;
    var tmp_0;
    if (!(coroutineName == null)) {
      // Inline function 'kotlin.text.replaceFirstChar' call
      var tmp_1;
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(baseMessage) > 0) {
        // Inline function 'kotlin.text.lowercaseChar' call
        // Inline function 'kotlin.text.lowercase' call
        var this_0 = charCodeAt(baseMessage, 0);
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$5 = toString_1(this_0).toLowerCase();
        var tmp0 = charCodeAt(tmp$ret$5, 0);
        // Inline function 'kotlin.text.plus' call
        var other = substring(baseMessage, 1);
        tmp_1 = toString_1(tmp0) + other;
      } else {
        tmp_1 = baseMessage;
      }
      tmp_0 = 'Coroutine "' + coroutineName + '" ' + tmp_1;
    } else {
      tmp_0 = baseMessage;
    }
    var message = tmp_0;
    return new TimeoutCancellationException(message, coroutine);
  }
  function $withTimeoutOrNullCOROUTINE$(timeMillis, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f1m_1 = timeMillis;
    this.g1m_1 = block;
  }
  protoOf($withTimeoutOrNullCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (compare(this.f1m_1, new Long(0, 0)) <= 0)
              return null;
            this.h1m_1 = {_v: null};
            this.o9_1 = 2;
            this.n9_1 = 1;
            var timeoutCoroutine = new TimeoutCoroutine(this.f1m_1, this);
            this.h1m_1._v = timeoutCoroutine;
            suspendResult = returnIfSuspended(setupTimeout(timeoutCoroutine, this.g1m_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            this.o9_1 = 3;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof TimeoutCancellationException) {
              var e = this.q9_1;
              if (e.i1m_1 === this.h1m_1._v) {
                return null;
              }
              throw e;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 3) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function Key_3() {
  }
  var Key_instance_4;
  function Key_getInstance_3() {
    return Key_instance_4;
  }
  function YieldContext() {
    AbstractCoroutineContextElement.call(this, Key_instance_4);
    this.p1m_1 = false;
  }
  function Unconfined() {
    Unconfined_instance = this;
    CoroutineDispatcher.call(this);
  }
  protoOf(Unconfined).z1g = function (parallelism, name) {
    throw UnsupportedOperationException_init_$Create$('limitedParallelism is not supported for Dispatchers.Unconfined');
  };
  protoOf(Unconfined).y1g = function (context) {
    return false;
  };
  protoOf(Unconfined).b1h = function (context, block) {
    var yieldContext = context.aa(Key_instance_4);
    if (!(yieldContext == null)) {
      yieldContext.p1m_1 = true;
      return Unit_instance;
    }
    throw UnsupportedOperationException_init_$Create$('Dispatchers.Unconfined.dispatch function can only be used by the yield function. If you wrap Unconfined dispatcher in your code, make sure you properly delegate isDispatchNeeded and dispatch calls.');
  };
  protoOf(Unconfined).toString = function () {
    return 'Dispatchers.Unconfined';
  };
  var Unconfined_instance;
  function Unconfined_getInstance() {
    if (Unconfined_instance == null)
      new Unconfined();
    return Unconfined_instance;
  }
  function Waiter() {
  }
  function yield_0($completion) {
    var tmp$ret$0;
    $l$block_0: {
      var context = $completion.t9();
      ensureActive(context);
      var tmp = intercepted($completion);
      var tmp0_elvis_lhs = tmp instanceof DispatchedContinuation ? tmp : null;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var cont = tmp_0;
      if (safeIsDispatchNeeded(cont.u1d_1, context)) {
        cont.r1m(context, Unit_instance);
      } else {
        var yieldContext = new YieldContext();
        cont.r1m(context.xj(yieldContext), Unit_instance);
        if (yieldContext.p1m_1) {
          tmp$ret$0 = yieldUndispatched(cont) ? get_COROUTINE_SUSPENDED() : Unit_instance;
          break $l$block_0;
        }
      }
      tmp$ret$0 = get_COROUTINE_SUSPENDED();
    }
    return tmp$ret$0;
  }
  var BufferOverflow_SUSPEND_instance;
  var BufferOverflow_DROP_OLDEST_instance;
  var BufferOverflow_DROP_LATEST_instance;
  var BufferOverflow_entriesInitialized;
  function BufferOverflow_initEntries() {
    if (BufferOverflow_entriesInitialized)
      return Unit_instance;
    BufferOverflow_entriesInitialized = true;
    BufferOverflow_SUSPEND_instance = new BufferOverflow('SUSPEND', 0);
    BufferOverflow_DROP_OLDEST_instance = new BufferOverflow('DROP_OLDEST', 1);
    BufferOverflow_DROP_LATEST_instance = new BufferOverflow('DROP_LATEST', 2);
  }
  function BufferOverflow(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function BufferOverflow_SUSPEND_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_SUSPEND_instance;
  }
  function BufferOverflow_DROP_OLDEST_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_DROP_OLDEST_instance;
  }
  function BufferOverflow_DROP_LATEST_getInstance() {
    BufferOverflow_initEntries();
    return BufferOverflow_DROP_LATEST_instance;
  }
  function get_NULL_SEGMENT() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return NULL_SEGMENT;
  }
  var NULL_SEGMENT;
  function get_SEGMENT_SIZE() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return SEGMENT_SIZE;
  }
  var SEGMENT_SIZE;
  function get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
  }
  var EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS;
  function get_BUFFERED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return BUFFERED;
  }
  var BUFFERED;
  function get_IN_BUFFER() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return IN_BUFFER;
  }
  var IN_BUFFER;
  function get_RESUMING_BY_RCV() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return RESUMING_BY_RCV;
  }
  var RESUMING_BY_RCV;
  function get_RESUMING_BY_EB() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return RESUMING_BY_EB;
  }
  var RESUMING_BY_EB;
  function get_POISONED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return POISONED;
  }
  var POISONED;
  function get_DONE_RCV() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return DONE_RCV;
  }
  var DONE_RCV;
  function get_INTERRUPTED_SEND() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return INTERRUPTED_SEND;
  }
  var INTERRUPTED_SEND;
  function get_INTERRUPTED_RCV() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return INTERRUPTED_RCV;
  }
  var INTERRUPTED_RCV;
  function get_CHANNEL_CLOSED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return CHANNEL_CLOSED;
  }
  var CHANNEL_CLOSED;
  function get_SUSPEND() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return SUSPEND;
  }
  var SUSPEND;
  function get_SUSPEND_NO_WAITER() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return SUSPEND_NO_WAITER;
  }
  var SUSPEND_NO_WAITER;
  function get_FAILED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return FAILED;
  }
  var FAILED;
  function get_NO_RECEIVE_RESULT() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return NO_RECEIVE_RESULT;
  }
  var NO_RECEIVE_RESULT;
  function get_CLOSE_HANDLER_CLOSED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return CLOSE_HANDLER_CLOSED;
  }
  var CLOSE_HANDLER_CLOSED;
  function get_CLOSE_HANDLER_INVOKED() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return CLOSE_HANDLER_INVOKED;
  }
  var CLOSE_HANDLER_INVOKED;
  function get_NO_CLOSE_CAUSE() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return NO_CLOSE_CAUSE;
  }
  var NO_CLOSE_CAUSE;
  function setElementLazy($this, index, value) {
    // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
    $this.x1m_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value = value;
  }
  function ChannelSegment(id, prev, channel, pointers) {
    Segment.call(this, id, prev, pointers);
    this.w1m_1 = channel;
    this.x1m_1 = atomicfu$AtomicRefArray$ofNulls(imul(get_SEGMENT_SIZE(), 2));
  }
  protoOf(ChannelSegment).y1m = function () {
    return ensureNotNull(this.w1m_1);
  };
  protoOf(ChannelSegment).z1m = function () {
    return get_SEGMENT_SIZE();
  };
  protoOf(ChannelSegment).a1n = function (index, element) {
    setElementLazy(this, index, element);
  };
  protoOf(ChannelSegment).b1n = function (index) {
    return this.x1m_1.atomicfu$get(imul(index, 2)).kotlinx$atomicfu$value;
  };
  protoOf(ChannelSegment).c1n = function (index) {
    // Inline function 'kotlin.also' call
    var this_0 = this.b1n(index);
    this.d1n(index);
    return this_0;
  };
  protoOf(ChannelSegment).d1n = function (index) {
    setElementLazy(this, index, null);
  };
  protoOf(ChannelSegment).e1n = function (index) {
    return this.x1m_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value;
  };
  protoOf(ChannelSegment).f1n = function (index, value) {
    this.x1m_1.atomicfu$get(imul(index, 2) + 1 | 0).kotlinx$atomicfu$value = value;
  };
  protoOf(ChannelSegment).g1n = function (index, from, to) {
    return this.x1m_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$compareAndSet(from, to);
  };
  protoOf(ChannelSegment).h1n = function (index, update) {
    return this.x1m_1.atomicfu$get(imul(index, 2) + 1 | 0).atomicfu$getAndSet(update);
  };
  protoOf(ChannelSegment).j1e = function (index, cause, context) {
    var isSender = index >= get_SEGMENT_SIZE();
    var index_0 = isSender ? index - get_SEGMENT_SIZE() | 0 : index;
    var element = this.b1n(index_0);
    $l$loop: while (true) {
      var cur = this.e1n(index_0);
      var tmp;
      if (!(cur == null) ? isInterface(cur, Waiter) : false) {
        tmp = true;
      } else {
        tmp = cur instanceof WaiterEB;
      }
      if (tmp) {
        var update = isSender ? get_INTERRUPTED_SEND() : get_INTERRUPTED_RCV();
        if (this.g1n(index_0, cur, update)) {
          this.d1n(index_0);
          this.u1n(index_0, !isSender);
          if (isSender) {
            var tmp0_safe_receiver = this.y1m().j1n_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              callUndeliveredElement(tmp0_safe_receiver, element, context);
            }
          }
          return Unit_instance;
        }
      } else {
        if (cur === get_INTERRUPTED_SEND() || cur === get_INTERRUPTED_RCV()) {
          this.d1n(index_0);
          if (isSender) {
            var tmp1_safe_receiver = this.y1m().j1n_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              callUndeliveredElement(tmp1_safe_receiver, element, context);
            }
          }
          return Unit_instance;
        } else {
          if (cur === get_RESUMING_BY_EB() || cur === get_RESUMING_BY_RCV())
            continue $l$loop;
          else {
            if (cur === get_DONE_RCV() || cur === get_BUFFERED())
              return Unit_instance;
            else {
              if (cur === get_CHANNEL_CLOSED())
                return Unit_instance;
              else {
                // Inline function 'kotlin.error' call
                var message = 'unexpected state: ' + toString_0(cur);
                throw IllegalStateException_init_$Create$(toString(message));
              }
            }
          }
        }
      }
    }
  };
  protoOf(ChannelSegment).u1n = function (index, receiver) {
    if (receiver) {
      var tmp = this.y1m();
      var tmp0 = this.h1e_1;
      // Inline function 'kotlin.Long.times' call
      var other = get_SEGMENT_SIZE();
      // Inline function 'kotlin.Long.plus' call
      var this_0 = multiply(tmp0, fromInt(other));
      var tmp$ret$1 = add(this_0, fromInt(index));
      tmp.v1n(tmp$ret$1);
    }
    this.w1n();
  };
  function onClosedHasNext($this) {
    $this.i1o_1 = get_CHANNEL_CLOSED();
    var tmp0_elvis_lhs = $this.k1o_1.l1o();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var cause = tmp;
    throw recoverStackTrace_0(cause);
  }
  function hasNextOnNoWaiterSuspend($this, segment, index, r, $completion) {
    var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
    try {
      $this.j1o_1 = cancellable;
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
      var this_0 = $this.k1o_1;
      var updCellResult = updateCellReceive(this_0, segment, index, r, $this);
      if (updCellResult === get_SUSPEND()) {
        prepareReceiverForSuspension(this_0, $this, segment, index);
      } else if (updCellResult === get_FAILED()) {
        if (compare(r, this_0.m1o()) < 0) {
          segment.g1o();
        }
        $l$block_0: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
          var segment_0 = this_0.p1n_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            if (this_0.n1o()) {
              onClosedHasNextNoWaiterSuspend($this);
              break $l$block_0;
            }
            var r_0 = this_0.l1n_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(r_0, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$6 = modulo(r_0, fromInt(other_0));
            var i = convertToInt(tmp$ret$6);
            if (!equalsLong(segment_0.h1e_1, id)) {
              var tmp0_elvis_lhs = findSegmentReceive(this_0, id, segment_0);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment_0 = tmp;
            }
            var updCellResult_0 = updateCellReceive(this_0, segment_0, i, r_0, $this);
            if (updCellResult_0 === get_SUSPEND()) {
              var tmp1_safe_receiver = (!($this == null) ? isInterface($this, Waiter) : false) ? $this : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(this_0, tmp1_safe_receiver, segment_0, i);
              }
            } else if (updCellResult_0 === get_FAILED()) {
              if (compare(r_0, this_0.m1o()) < 0) {
                segment_0.g1o();
              }
              continue $l$loop_0;
            } else if (updCellResult_0 === get_SUSPEND_NO_WAITER()) {
              // Inline function 'kotlin.error' call
              var message = 'unexpected';
              throw IllegalStateException_init_$Create$(toString(message));
            } else {
              segment_0.g1o();
              $this.i1o_1 = updCellResult_0;
              $this.j1o_1 = null;
              var tmp0_safe_receiver = $this.k1o_1.j1n_1;
              cancellable.i1d(true, tmp0_safe_receiver == null ? null : bindCancellationFun($this.k1o_1, tmp0_safe_receiver, updCellResult_0));
            }
            break $l$block_0;
          }
        }
      } else {
        segment.g1o();
        $this.i1o_1 = updCellResult;
        $this.j1o_1 = null;
        var tmp0_safe_receiver_0 = $this.k1o_1.j1n_1;
        cancellable.i1d(true, tmp0_safe_receiver_0 == null ? null : bindCancellationFun($this.k1o_1, tmp0_safe_receiver_0, updCellResult));
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.c1f();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.x1b();
  }
  function onClosedHasNextNoWaiterSuspend($this) {
    var cont = ensureNotNull($this.j1o_1);
    $this.j1o_1 = null;
    $this.i1o_1 = get_CHANNEL_CLOSED();
    var cause = $this.k1o_1.l1o();
    if (cause == null) {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$1 = _Result___init__impl__xyqfz8(false);
      cont.y9(tmp$ret$1);
    } else {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = recoverStackTrace(cause, cont);
      var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
      cont.y9(tmp$ret$3);
    }
  }
  function $hasNextCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w1o_1 = _this__u8e3s4;
  }
  protoOf($hasNextCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            if (!(this.w1o_1.i1o_1 === get_NO_RECEIVE_RESULT()) && !(this.w1o_1.i1o_1 === get_CHANNEL_CLOSED())) {
              var tmp_0 = this;
              tmp_0.x1o_1 = true;
              this.n9_1 = 11;
              continue $sm;
            } else {
              this.h1p_1 = this.w1o_1.k1o_1;
              this.g1p_1 = null;
              this.n9_1 = 1;
              continue $sm;
            }

          case 1:
            this.d1p_1 = this.h1p_1;
            this.e1p_1 = this.g1p_1;
            this.a1p_1 = this.d1p_1.p1n_1.kotlinx$atomicfu$value;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.n9_1 = 9;
              continue $sm;
            }

            if (this.d1p_1.n1o()) {
              var tmp_1 = this;
              tmp_1.y1o_1 = onClosedHasNext(this.w1o_1);
              this.n9_1 = 10;
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 3:
            this.b1p_1 = this.d1p_1.l1n_1.atomicfu$getAndIncrement$long();
            var tmp0 = this.b1p_1;
            var other = get_SEGMENT_SIZE();
            var id = divide(tmp0, fromInt(other));
            var tmp_2 = this;
            var tmp0_0 = this.b1p_1;
            var other_0 = get_SEGMENT_SIZE();
            tmp_2.c1p_1 = convertToInt(modulo(tmp0_0, fromInt(other_0)));
            if (!equalsLong(this.a1p_1.h1e_1, id)) {
              var tmp0_elvis_lhs = findSegmentReceive(this.d1p_1, id, this.a1p_1);
              if (tmp0_elvis_lhs == null) {
                this.n9_1 = 2;
                var tmp_3 = this;
                continue $sm;
              } else {
                this.f1p_1 = tmp0_elvis_lhs;
                this.n9_1 = 4;
                continue $sm;
              }
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 4:
            this.a1p_1 = this.f1p_1;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            var updCellResult = updateCellReceive(this.d1p_1, this.a1p_1, this.c1p_1, this.b1p_1, this.e1p_1);
            if (updCellResult === get_SUSPEND()) {
              var tmp_4 = this;
              var tmp_5 = this.e1p_1;
              var tmp1_safe_receiver = (!(tmp_5 == null) ? isInterface(tmp_5, Waiter) : false) ? tmp_5 : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(this.d1p_1, tmp1_safe_receiver, this.a1p_1, this.c1p_1);
              }
              this.a1p_1;
              this.c1p_1;
              this.b1p_1;
              var message = 'unreachable';
              throw IllegalStateException_init_$Create$(toString(message));
            } else {
              if (updCellResult === get_FAILED()) {
                if (compare(this.b1p_1, this.d1p_1.m1o()) < 0) {
                  this.a1p_1.g1o();
                }
                this.n9_1 = 2;
                var tmp_6 = this;
                continue $sm;
              } else {
                if (updCellResult === get_SUSPEND_NO_WAITER()) {
                  var tmp0_1 = this.a1p_1;
                  var tmp2 = this.c1p_1;
                  var r = this.b1p_1;
                  this.n9_1 = 6;
                  suspendResult = hasNextOnNoWaiterSuspend(this.w1o_1, tmp0_1, tmp2, r, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_7 = this;
                  this.a1p_1.g1o();
                  this.w1o_1.i1o_1 = updCellResult;
                  tmp_7.z1o_1 = true;
                  this.n9_1 = 7;
                  continue $sm;
                }
              }
            }

          case 6:
            var tmp_8 = this;
            return suspendResult;
          case 7:
            this.y1o_1 = this.z1o_1;
            this.n9_1 = 10;
            continue $sm;
          case 8:
            throw this.q9_1;
          case 9:
            if (false) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 10;
            continue $sm;
          case 10:
            this.x1o_1 = this.y1o_1;
            this.n9_1 = 11;
            continue $sm;
          case 11:
            return this.x1o_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function _get_bufferEndCounter__2d4hee($this) {
    return $this.m1n_1.kotlinx$atomicfu$value;
  }
  function _get_isRendezvousOrUnlimited__3mdufi($this) {
    // Inline function 'kotlin.let' call
    var it = _get_bufferEndCounter__2d4hee($this);
    return equalsLong(it, new Long(0, 0)) || equalsLong(it, new Long(-1, 2147483647));
  }
  function onClosedSend($this, element, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.v1e();
    $l$block: {
      var tmp0_safe_receiver = $this.j1n_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        addSuppressed(tmp1_safe_receiver, $this.i1p());
        // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
        // Inline function 'kotlin.Companion.failure' call
        var exception = recoverStackTrace(tmp1_safe_receiver, cancellable);
        var tmp$ret$5 = _Result___init__impl__xyqfz8(createFailure(exception));
        cancellable.y9(tmp$ret$5);
        break $l$block;
      }
      // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
      var exception_0 = $this.i1p();
      // Inline function 'kotlin.Companion.failure' call
      var exception_1 = recoverStackTrace(exception_0, cancellable);
      var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(exception_1));
      cancellable.y9(tmp$ret$7);
    }
    return cancellable.x1b();
  }
  function sendOnNoWaiterSuspend($this, segment, index, element, s, $completion) {
    var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
    try {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImplOnNoWaiter' call
      switch (updateCellSend($this, segment, index, element, s, cancellable, false)) {
        case 0:
          segment.g1o();
          // Inline function 'kotlin.coroutines.resume' call

          // Inline function 'kotlin.Companion.success' call

          var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
          cancellable.y9(tmp$ret$5);
          break;
        case 1:
          // Inline function 'kotlin.coroutines.resume' call

          // Inline function 'kotlin.Companion.success' call

          var tmp$ret$8 = _Result___init__impl__xyqfz8(Unit_instance);
          cancellable.y9(tmp$ret$8);
          break;
        case 2:
          prepareSenderForSuspension($this, cancellable, segment, index);
          break;
        case 4:
          if (compare(s, $this.j1p()) < 0) {
            segment.g1o();
          }

          onClosedSendOnNoWaiterSuspend($this, element, cancellable);
          break;
        case 5:
          segment.g1o();
          $l$block_5: {
            // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
            var segment_0 = access$_get_sendSegment__111kgq($this).kotlinx$atomicfu$value;
            $l$loop_0: while (true) {
              var sendersAndCloseStatusCur = access$_get_sendersAndCloseStatus__tvw29s($this).atomicfu$getAndIncrement$long();
              // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
              var s_0 = bitwiseAnd(sendersAndCloseStatusCur, new Long(-1, 268435455));
              var closed = access$_get_isClosedForSend0__sm8f7a($this, sendersAndCloseStatusCur);
              // Inline function 'kotlin.Long.div' call
              var other = get_SEGMENT_SIZE();
              var id = divide(s_0, fromInt(other));
              // Inline function 'kotlin.Long.rem' call
              var other_0 = get_SEGMENT_SIZE();
              var tmp$ret$13 = modulo(s_0, fromInt(other_0));
              var i = convertToInt(tmp$ret$13);
              if (!equalsLong(segment_0.h1e_1, id)) {
                var tmp0_elvis_lhs = access$findSegmentSend($this, id, segment_0);
                var tmp;
                if (tmp0_elvis_lhs == null) {
                  var tmp_0;
                  if (closed) {
                    onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                    break $l$block_5;
                  } else {
                    continue $l$loop_0;
                  }
                } else {
                  tmp = tmp0_elvis_lhs;
                }
                segment_0 = tmp;
              }
              switch (access$updateCellSend($this, segment_0, i, element, s_0, cancellable, closed)) {
                case 0:
                  segment_0.g1o();
                  // Inline function 'kotlin.coroutines.resume' call

                  // Inline function 'kotlin.Companion.success' call

                  var tmp$ret$17 = _Result___init__impl__xyqfz8(Unit_instance);
                  cancellable.y9(tmp$ret$17);
                  break $l$block_5;
                case 1:
                  // Inline function 'kotlin.coroutines.resume' call

                  // Inline function 'kotlin.Companion.success' call

                  var tmp$ret$20 = _Result___init__impl__xyqfz8(Unit_instance);
                  cancellable.y9(tmp$ret$20);
                  break $l$block_5;
                case 2:
                  if (closed) {
                    segment_0.w1n();
                    onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                    break $l$block_5;
                  }

                  var tmp2_safe_receiver = (!(cancellable == null) ? isInterface(cancellable, Waiter) : false) ? cancellable : null;
                  if (tmp2_safe_receiver == null)
                    null;
                  else {
                    access$prepareSenderForSuspension($this, tmp2_safe_receiver, segment_0, i);
                  }

                  break $l$block_5;
                case 4:
                  if (compare(s_0, $this.j1p()) < 0) {
                    segment_0.g1o();
                  }

                  onClosedSendOnNoWaiterSuspend($this, element, cancellable);
                  break $l$block_5;
                case 5:
                  segment_0.g1o();
                  continue $l$loop_0;
                case 3:
                  // Inline function 'kotlin.error' call

                  var message = 'unexpected';
                  throw IllegalStateException_init_$Create$(toString(message));
              }
            }
          }

          break;
        default:
          // Inline function 'kotlin.error' call

          var message_0 = 'unexpected';
          throw IllegalStateException_init_$Create$(toString(message_0));
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.c1f();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.x1b();
  }
  function prepareSenderForSuspension($this, $receiver, segment, index) {
    $receiver.h1f(segment, index + get_SEGMENT_SIZE() | 0);
  }
  function onClosedSendOnNoWaiterSuspend($this, element, cont) {
    var tmp0_safe_receiver = $this.j1n_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      callUndeliveredElement(tmp0_safe_receiver, element, cont.t9());
    }
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = recoverStackTrace($this.i1p(), cont);
    var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
    cont.y9(tmp$ret$1);
  }
  function SendBroadcast() {
  }
  function updateCellSend($this, segment, index, element, s, waiter, closed) {
    segment.a1n(index, element);
    if (closed)
      return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
    var state = segment.e1n(index);
    if (state === null) {
      if (bufferOrRendezvousSend($this, s)) {
        if (segment.g1n(index, null, get_BUFFERED())) {
          return 1;
        }
      } else {
        if (waiter == null) {
          return 3;
        } else {
          if (segment.g1n(index, null, waiter))
            return 2;
        }
      }
    } else {
      if (isInterface(state, Waiter)) {
        segment.d1n(index);
        var tmp;
        if (tryResumeReceiver($this, state, element)) {
          segment.f1n(index, get_DONE_RCV());
          $this.k1p();
          tmp = 0;
        } else {
          if (!(segment.h1n(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
            segment.u1n(index, true);
          }
          tmp = 5;
        }
        return tmp;
      }
    }
    return updateCellSendSlow($this, segment, index, element, s, waiter, closed);
  }
  function updateCellSendSlow($this, segment, index, element, s, waiter, closed) {
    while (true) {
      var state = segment.e1n(index);
      if (state === null) {
        if (bufferOrRendezvousSend($this, s) && !closed) {
          if (segment.g1n(index, null, get_BUFFERED())) {
            return 1;
          }
        } else {
          if (closed) {
            if (segment.g1n(index, null, get_INTERRUPTED_SEND())) {
              segment.u1n(index, false);
              return 4;
            }
          } else if (waiter == null)
            return 3;
          else if (segment.g1n(index, null, waiter))
            return 2;
        }
      } else if (state === get_IN_BUFFER()) {
        if (segment.g1n(index, state, get_BUFFERED())) {
          return 1;
        }
      } else if (state === get_INTERRUPTED_RCV()) {
        segment.d1n(index);
        return 5;
      } else if (state === get_POISONED()) {
        segment.d1n(index);
        return 5;
      } else if (state === get_CHANNEL_CLOSED()) {
        segment.d1n(index);
        completeCloseOrCancel($this);
        return 4;
      } else {
        // Inline function 'kotlinx.coroutines.assert' call
        segment.d1n(index);
        var tmp;
        if (state instanceof WaiterEB) {
          tmp = state.l1p_1;
        } else {
          tmp = state;
        }
        var receiver = tmp;
        var tmp_0;
        if (tryResumeReceiver($this, receiver, element)) {
          segment.f1n(index, get_DONE_RCV());
          $this.k1p();
          tmp_0 = 0;
        } else {
          if (!(segment.h1n(index, get_INTERRUPTED_RCV()) === get_INTERRUPTED_RCV())) {
            segment.u1n(index, true);
          }
          tmp_0 = 5;
        }
        return tmp_0;
      }
    }
  }
  function shouldSendSuspend0($this, curSendersAndCloseStatus) {
    if (_get_isClosedForSend0__kxgf9m($this, curSendersAndCloseStatus))
      return false;
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var tmp$ret$0 = bitwiseAnd(curSendersAndCloseStatus, new Long(-1, 268435455));
    return !bufferOrRendezvousSend($this, tmp$ret$0);
  }
  function bufferOrRendezvousSend($this, curSenders) {
    var tmp;
    if (compare(curSenders, _get_bufferEndCounter__2d4hee($this)) < 0) {
      tmp = true;
    } else {
      var tmp0 = $this.j1p();
      // Inline function 'kotlin.Long.plus' call
      var other = $this.i1n_1;
      var tmp$ret$0 = add(tmp0, fromInt(other));
      tmp = compare(curSenders, tmp$ret$0) < 0;
    }
    return tmp;
  }
  function tryResumeReceiver($this, $receiver, element) {
    var tmp;
    if (isInterface($receiver, SelectInstance)) {
      tmp = $receiver.q1p($this, element);
    } else {
      if ($receiver instanceof ReceiveCatching) {
        if (!($receiver instanceof ReceiveCatching))
          THROW_CCE();
        var tmp_0 = Companion_getInstance_0().o1p(element);
        var tmp1_safe_receiver = $this.j1n_1;
        tmp = tryResume0($receiver.p1p_1, new ChannelResult(tmp_0), tmp1_safe_receiver == null ? null : bindCancellationFunResult($this, tmp1_safe_receiver));
      } else {
        if ($receiver instanceof BufferedChannelIterator) {
          if (!($receiver instanceof BufferedChannelIterator))
            THROW_CCE();
          tmp = $receiver.m1p(element);
        } else {
          if (isInterface($receiver, CancellableContinuation)) {
            if (!isInterface($receiver, CancellableContinuation))
              THROW_CCE();
            var tmp2_safe_receiver = $this.j1n_1;
            tmp = tryResume0($receiver, element, tmp2_safe_receiver == null ? null : bindCancellationFun_0($this, tmp2_safe_receiver));
          } else {
            // Inline function 'kotlin.error' call
            var message = 'Unexpected receiver type: ' + toString($receiver);
            throw IllegalStateException_init_$Create$(toString(message));
          }
        }
      }
    }
    return tmp;
  }
  function receiveOnNoWaiterSuspend($this, segment, index, r, $completion) {
    var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
    try {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
      var updCellResult = updateCellReceive($this, segment, index, r, cancellable);
      if (updCellResult === get_SUSPEND()) {
        prepareReceiverForSuspension($this, cancellable, segment, index);
      } else if (updCellResult === get_FAILED()) {
        if (compare(r, $this.m1o()) < 0) {
          segment.g1o();
        }
        $l$block_0: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
          var segment_0 = $this.p1n_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            if ($this.n1o()) {
              onClosedReceiveOnNoWaiterSuspend($this, cancellable);
              break $l$block_0;
            }
            var r_0 = $this.l1n_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(r_0, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$6 = modulo(r_0, fromInt(other_0));
            var i = convertToInt(tmp$ret$6);
            if (!equalsLong(segment_0.h1e_1, id)) {
              var tmp0_elvis_lhs = findSegmentReceive($this, id, segment_0);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment_0 = tmp;
            }
            var updCellResult_0 = updateCellReceive($this, segment_0, i, r_0, cancellable);
            if (updCellResult_0 === get_SUSPEND()) {
              var tmp1_safe_receiver = (!(cancellable == null) ? isInterface(cancellable, Waiter) : false) ? cancellable : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension($this, tmp1_safe_receiver, segment_0, i);
              }
            } else if (updCellResult_0 === get_FAILED()) {
              if (compare(r_0, $this.m1o()) < 0) {
                segment_0.g1o();
              }
              continue $l$loop_0;
            } else if (updCellResult_0 === get_SUSPEND_NO_WAITER()) {
              // Inline function 'kotlin.error' call
              var message = 'unexpected';
              throw IllegalStateException_init_$Create$(toString(message));
            } else {
              segment_0.g1o();
              var tmp0_safe_receiver = $this.j1n_1;
              var onCancellation = tmp0_safe_receiver == null ? null : bindCancellationFun_0($this, tmp0_safe_receiver);
              cancellable.i1d(updCellResult_0, onCancellation);
            }
            break $l$block_0;
          }
        }
      } else {
        segment.g1o();
        var tmp0_safe_receiver_0 = $this.j1n_1;
        var onCancellation_0 = tmp0_safe_receiver_0 == null ? null : bindCancellationFun_0($this, tmp0_safe_receiver_0);
        cancellable.i1d(updCellResult, onCancellation_0);
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.c1f();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.x1b();
  }
  function prepareReceiverForSuspension($this, $receiver, segment, index) {
    $this.r1p();
    $receiver.h1f(segment, index);
  }
  function onClosedReceiveOnNoWaiterSuspend($this, cont) {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = _get_receiveException__foorc1($this);
    var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
    cont.y9(tmp$ret$1);
  }
  function receiveCatchingOnNoWaiterSuspend($this, segment, index, r, $completion) {
    var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
    try {
      var waiter = new ReceiveCatching(cancellable instanceof CancellableContinuationImpl ? cancellable : THROW_CCE());
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImplOnNoWaiter' call
      var updCellResult = updateCellReceive($this, segment, index, r, waiter);
      if (updCellResult === get_SUSPEND()) {
        prepareReceiverForSuspension($this, waiter, segment, index);
      } else if (updCellResult === get_FAILED()) {
        if (compare(r, $this.m1o()) < 0) {
          segment.g1o();
        }
        $l$block_0: {
          // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
          var segment_0 = $this.p1n_1.kotlinx$atomicfu$value;
          $l$loop_0: while (true) {
            if ($this.n1o()) {
              onClosedReceiveCatchingOnNoWaiterSuspend($this, cancellable);
              break $l$block_0;
            }
            var r_0 = $this.l1n_1.atomicfu$getAndIncrement$long();
            // Inline function 'kotlin.Long.div' call
            var other = get_SEGMENT_SIZE();
            var id = divide(r_0, fromInt(other));
            // Inline function 'kotlin.Long.rem' call
            var other_0 = get_SEGMENT_SIZE();
            var tmp$ret$6 = modulo(r_0, fromInt(other_0));
            var i = convertToInt(tmp$ret$6);
            if (!equalsLong(segment_0.h1e_1, id)) {
              var tmp0_elvis_lhs = findSegmentReceive($this, id, segment_0);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                continue $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              segment_0 = tmp;
            }
            var updCellResult_0 = updateCellReceive($this, segment_0, i, r_0, waiter);
            if (updCellResult_0 === get_SUSPEND()) {
              var tmp1_safe_receiver = (!(waiter == null) ? isInterface(waiter, Waiter) : false) ? waiter : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension($this, tmp1_safe_receiver, segment_0, i);
              }
            } else if (updCellResult_0 === get_FAILED()) {
              if (compare(r_0, $this.m1o()) < 0) {
                segment_0.g1o();
              }
              continue $l$loop_0;
            } else if (updCellResult_0 === get_SUSPEND_NO_WAITER()) {
              // Inline function 'kotlin.error' call
              var message = 'unexpected';
              throw IllegalStateException_init_$Create$(toString(message));
            } else {
              segment_0.g1o();
              var tmp_0 = Companion_getInstance_0().o1p(updCellResult_0);
              var tmp0_safe_receiver = $this.j1n_1;
              cancellable.i1d(new ChannelResult(tmp_0), tmp0_safe_receiver == null ? null : bindCancellationFunResult($this, tmp0_safe_receiver));
            }
            break $l$block_0;
          }
        }
      } else {
        segment.g1o();
        var tmp_1 = Companion_getInstance_0().o1p(updCellResult);
        var tmp0_safe_receiver_0 = $this.j1n_1;
        cancellable.i1d(new ChannelResult(tmp_1), tmp0_safe_receiver_0 == null ? null : bindCancellationFunResult($this, tmp0_safe_receiver_0));
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.c1f();
        throw e;
      } else {
        throw $p;
      }
    }
    var tmp_2 = cancellable.x1b();
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      return tmp_2;
    return tmp_2;
  }
  function onClosedReceiveCatchingOnNoWaiterSuspend($this, cont) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var value = new ChannelResult(Companion_getInstance_0().t1p($this.l1o()));
    var tmp$ret$1 = _Result___init__impl__xyqfz8(value);
    cont.y9(tmp$ret$1);
  }
  function updateCellReceive($this, segment, index, r, waiter) {
    var state = segment.e1n(index);
    if (state === null) {
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var this_0 = $this.k1n_1.kotlinx$atomicfu$value;
      var senders = bitwiseAnd(this_0, new Long(-1, 268435455));
      if (compare(r, senders) >= 0) {
        if (waiter === null) {
          return get_SUSPEND_NO_WAITER();
        }
        if (segment.g1n(index, state, waiter)) {
          expandBuffer($this);
          return get_SUSPEND();
        }
      }
    } else if (state === get_BUFFERED())
      if (segment.g1n(index, state, get_DONE_RCV())) {
        expandBuffer($this);
        return segment.c1n(index);
      }
    return updateCellReceiveSlow($this, segment, index, r, waiter);
  }
  function updateCellReceiveSlow($this, segment, index, r, waiter) {
    $l$loop: while (true) {
      var state = segment.e1n(index);
      if (state === null || state === get_IN_BUFFER()) {
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var this_0 = $this.k1n_1.kotlinx$atomicfu$value;
        var senders = bitwiseAnd(this_0, new Long(-1, 268435455));
        if (compare(r, senders) < 0) {
          if (segment.g1n(index, state, get_POISONED())) {
            expandBuffer($this);
            return get_FAILED();
          }
        } else {
          if (waiter === null) {
            return get_SUSPEND_NO_WAITER();
          }
          if (segment.g1n(index, state, waiter)) {
            expandBuffer($this);
            return get_SUSPEND();
          }
        }
      } else if (state === get_BUFFERED()) {
        if (segment.g1n(index, state, get_DONE_RCV())) {
          expandBuffer($this);
          return segment.c1n(index);
        }
      } else if (state === get_INTERRUPTED_SEND())
        return get_FAILED();
      else if (state === get_POISONED())
        return get_FAILED();
      else if (state === get_CHANNEL_CLOSED()) {
        expandBuffer($this);
        return get_FAILED();
      } else if (state === get_RESUMING_BY_EB())
        continue $l$loop;
      else {
        if (segment.g1n(index, state, get_RESUMING_BY_RCV())) {
          var helpExpandBuffer = state instanceof WaiterEB;
          var tmp;
          if (state instanceof WaiterEB) {
            tmp = state.l1p_1;
          } else {
            tmp = state;
          }
          var sender = tmp;
          var tmp_0;
          if (tryResumeSender($this, sender, segment, index)) {
            segment.f1n(index, get_DONE_RCV());
            expandBuffer($this);
            tmp_0 = segment.c1n(index);
          } else {
            segment.f1n(index, get_INTERRUPTED_SEND());
            segment.u1n(index, false);
            if (helpExpandBuffer) {
              expandBuffer($this);
            }
            tmp_0 = get_FAILED();
          }
          return tmp_0;
        }
      }
    }
  }
  function tryResumeSender($this, $receiver, segment, index) {
    var tmp;
    if (isInterface($receiver, CancellableContinuation)) {
      if (!isInterface($receiver, CancellableContinuation))
        THROW_CCE();
      tmp = tryResume0($receiver, Unit_instance);
    } else {
      if (isInterface($receiver, SelectInstance)) {
        if (!($receiver instanceof SelectImplementation))
          THROW_CCE();
        var trySelectResult = $receiver.b1q($this, Unit_instance);
        if (trySelectResult === TrySelectDetailedResult_REREGISTER_getInstance()) {
          segment.d1n(index);
        }
        tmp = trySelectResult === TrySelectDetailedResult_SUCCESSFUL_getInstance();
      } else {
        if ($receiver instanceof SendBroadcast) {
          tmp = tryResume0($receiver.u1p_1, true);
        } else {
          // Inline function 'kotlin.error' call
          var message = 'Unexpected waiter: ' + toString($receiver);
          throw IllegalStateException_init_$Create$(toString(message));
        }
      }
    }
    return tmp;
  }
  function expandBuffer($this) {
    if (_get_isRendezvousOrUnlimited__3mdufi($this))
      return Unit_instance;
    var segment = $this.q1n_1.kotlinx$atomicfu$value;
    try_again: while (true) {
      var b = $this.m1n_1.atomicfu$getAndIncrement$long();
      // Inline function 'kotlin.Long.div' call
      var other = get_SEGMENT_SIZE();
      var id = divide(b, fromInt(other));
      var s = $this.m1o();
      if (compare(s, b) <= 0) {
        if (compare(segment.h1e_1, id) < 0 && !(segment.c1o() == null)) {
          moveSegmentBufferEndToSpecifiedOrLast($this, id, segment);
        }
        incCompletedExpandBufferAttempts($this);
        return Unit_instance;
      }
      if (!equalsLong(segment.h1e_1, id)) {
        var tmp0_elvis_lhs = findSegmentBufferEnd($this, id, segment, b);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue try_again;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      // Inline function 'kotlin.Long.rem' call
      var other_0 = get_SEGMENT_SIZE();
      var tmp$ret$1 = modulo(b, fromInt(other_0));
      var i = convertToInt(tmp$ret$1);
      if (updateCellExpandBuffer($this, segment, i, b)) {
        incCompletedExpandBufferAttempts($this);
        return Unit_instance;
      } else {
        incCompletedExpandBufferAttempts($this);
        continue try_again;
      }
    }
  }
  function updateCellExpandBuffer($this, segment, index, b) {
    var state = segment.e1n(index);
    if (!(state == null) ? isInterface(state, Waiter) : false) {
      if (compare(b, $this.l1n_1.kotlinx$atomicfu$value) >= 0) {
        if (segment.g1n(index, state, get_RESUMING_BY_EB())) {
          var tmp;
          if (tryResumeSender($this, state, segment, index)) {
            segment.f1n(index, get_BUFFERED());
            tmp = true;
          } else {
            segment.f1n(index, get_INTERRUPTED_SEND());
            segment.u1n(index, false);
            tmp = false;
          }
          return tmp;
        }
      }
    }
    return updateCellExpandBufferSlow($this, segment, index, b);
  }
  function updateCellExpandBufferSlow($this, segment, index, b) {
    $l$loop: while (true) {
      var state = segment.e1n(index);
      if (!(state == null) ? isInterface(state, Waiter) : false) {
        if (compare(b, $this.l1n_1.kotlinx$atomicfu$value) < 0) {
          if (segment.g1n(index, state, new WaiterEB(state)))
            return true;
        } else {
          if (segment.g1n(index, state, get_RESUMING_BY_EB())) {
            var tmp;
            if (tryResumeSender($this, state, segment, index)) {
              segment.f1n(index, get_BUFFERED());
              tmp = true;
            } else {
              segment.f1n(index, get_INTERRUPTED_SEND());
              segment.u1n(index, false);
              tmp = false;
            }
            return tmp;
          }
        }
      } else {
        if (state === get_INTERRUPTED_SEND())
          return false;
        else {
          if (state === null) {
            if (segment.g1n(index, state, get_IN_BUFFER()))
              return true;
          } else {
            if (state === get_BUFFERED())
              return true;
            else {
              if (state === get_POISONED() || state === get_DONE_RCV() || state === get_INTERRUPTED_RCV())
                return true;
              else {
                if (state === get_CHANNEL_CLOSED())
                  return true;
                else {
                  if (state === get_RESUMING_BY_RCV())
                    continue $l$loop;
                  else {
                    // Inline function 'kotlin.error' call
                    var message = 'Unexpected cell state: ' + toString(state);
                    throw IllegalStateException_init_$Create$(toString(message));
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  function incCompletedExpandBufferAttempts($this, nAttempts) {
    nAttempts = nAttempts === VOID ? new Long(1, 0) : nAttempts;
    // Inline function 'kotlin.also' call
    var this_0 = $this.n1n_1.atomicfu$addAndGet$long(nAttempts);
    // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
    if (!equalsLong(bitwiseAnd(this_0, new Long(0, 1073741824)), new Long(0, 0))) {
      $l$loop: while (true) {
        // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
        var this_1 = $this.n1n_1.kotlinx$atomicfu$value;
        if (!!equalsLong(bitwiseAnd(this_1, new Long(0, 1073741824)), new Long(0, 0))) {
          break $l$loop;
        }
      }
    }
  }
  function registerSelectForReceive($this, select, ignoredParam) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
      var segment = $this.p1n_1.kotlinx$atomicfu$value;
      $l$loop_0: while (true) {
        if ($this.n1o()) {
          onClosedSelectOnReceive($this, select);
          tmp$ret$0 = Unit_instance;
          break $l$block_0;
        }
        var r = $this.l1n_1.atomicfu$getAndIncrement$long();
        // Inline function 'kotlin.Long.div' call
        var other = get_SEGMENT_SIZE();
        var id = divide(r, fromInt(other));
        // Inline function 'kotlin.Long.rem' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$3 = modulo(r, fromInt(other_0));
        var i = convertToInt(tmp$ret$3);
        if (!equalsLong(segment.h1e_1, id)) {
          var tmp0_elvis_lhs = findSegmentReceive($this, id, segment);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            continue $l$loop_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          segment = tmp;
        }
        var updCellResult = updateCellReceive($this, segment, i, r, select);
        if (updCellResult === get_SUSPEND()) {
          var tmp1_safe_receiver = (!(select == null) ? isInterface(select, Waiter) : false) ? select : null;
          if (tmp1_safe_receiver == null)
            null;
          else {
            prepareReceiverForSuspension($this, tmp1_safe_receiver, segment, i);
          }
        } else if (updCellResult === get_FAILED()) {
          if (compare(r, $this.m1o()) < 0) {
            segment.g1o();
          }
          continue $l$loop_0;
        } else if (updCellResult === get_SUSPEND_NO_WAITER()) {
          // Inline function 'kotlin.error' call
          var message = 'unexpected';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          segment.g1o();
          select.c1q(updCellResult);
        }
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      }
    }
    return tmp$ret$0;
  }
  function onClosedSelectOnReceive($this, select) {
    select.c1q(get_CHANNEL_CLOSED());
  }
  function processResultSelectReceiveCatching($this, ignoredParam, selectResult) {
    return new ChannelResult(selectResult === get_CHANNEL_CLOSED() ? Companion_getInstance_0().t1p($this.l1o()) : Companion_getInstance_0().o1p(selectResult));
  }
  function BufferedChannelIterator($outer) {
    this.k1o_1 = $outer;
    this.i1o_1 = get_NO_RECEIVE_RESULT();
    this.j1o_1 = null;
  }
  protoOf(BufferedChannelIterator).d1q = function ($completion) {
    var tmp = new $hasNextCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BufferedChannelIterator).h1f = function (segment, index) {
    var tmp0_safe_receiver = this.j1o_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.h1f(segment, index);
    }
  };
  protoOf(BufferedChannelIterator).v = function () {
    var result = this.i1o_1;
    // Inline function 'kotlin.check' call
    if (!!(result === get_NO_RECEIVE_RESULT())) {
      var message = '`hasNext()` has not been invoked';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    this.i1o_1 = get_NO_RECEIVE_RESULT();
    if (result === get_CHANNEL_CLOSED())
      throw recoverStackTrace_0(_get_receiveException__foorc1(this.k1o_1));
    return result;
  };
  protoOf(BufferedChannelIterator).m1p = function (element) {
    var cont = ensureNotNull(this.j1o_1);
    this.j1o_1 = null;
    this.i1o_1 = element;
    var tmp0_safe_receiver = this.k1o_1.j1n_1;
    return tryResume0(cont, true, tmp0_safe_receiver == null ? null : bindCancellationFun(this.k1o_1, tmp0_safe_receiver, element));
  };
  protoOf(BufferedChannelIterator).e1q = function () {
    var cont = ensureNotNull(this.j1o_1);
    this.j1o_1 = null;
    this.i1o_1 = get_CHANNEL_CLOSED();
    var cause = this.k1o_1.l1o();
    if (cause == null) {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$1 = _Result___init__impl__xyqfz8(false);
      cont.y9(tmp$ret$1);
    } else {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = recoverStackTrace(cause, cont);
      var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
      cont.y9(tmp$ret$3);
    }
  };
  function _get_receiveException__foorc1($this) {
    var tmp0_elvis_lhs = $this.l1o();
    return tmp0_elvis_lhs == null ? new ClosedReceiveChannelException('Channel was closed') : tmp0_elvis_lhs;
  }
  function invokeCloseHandler($this) {
    var tmp0 = $this.t1n_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.getAndUpdate' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        var tmp;
        if (cur === null) {
          tmp = get_CLOSE_HANDLER_CLOSED();
        } else {
          tmp = get_CLOSE_HANDLER_INVOKED();
        }
        var upd = tmp;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          tmp$ret$0 = cur;
          break $l$block;
        }
      }
    }
    var tmp0_elvis_lhs = tmp$ret$0;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var closeHandler = tmp_0;
    if (typeof closeHandler !== 'function')
      THROW_CCE();
    closeHandler($this.l1o());
  }
  function markClosed($this) {
    var tmp0 = $this.k1n_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
        var tmp;
        switch (convertToInt(shiftRight(cur, 60))) {
          case 0:
            // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

            var tmp$ret$3 = bitwiseAnd(cur, new Long(-1, 268435455));
            tmp = constructSendersAndCloseStatus(tmp$ret$3, 2);
            break;
          case 1:
            // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

            var tmp$ret$4 = bitwiseAnd(cur, new Long(-1, 268435455));
            tmp = constructSendersAndCloseStatus(tmp$ret$4, 3);
            break;
          default:
            return Unit_instance;
        }
        var upd = tmp;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          tmp$ret$0 = Unit_instance;
          break $l$block;
        }
      }
      tmp$ret$0 = Unit_instance;
    }
    return tmp$ret$0;
  }
  function markCancelled($this) {
    var tmp0 = $this.k1n_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var tmp$ret$2 = bitwiseAnd(cur, new Long(-1, 268435455));
        var upd = constructSendersAndCloseStatus(tmp$ret$2, 3);
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          tmp$ret$0 = Unit_instance;
          break $l$block;
        }
      }
      tmp$ret$0 = Unit_instance;
    }
    return tmp$ret$0;
  }
  function markCancellationStarted($this) {
    var tmp0 = $this.k1n_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        var tmp;
        // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
        if (convertToInt(shiftRight(cur, 60)) === 0) {
          // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
          var tmp$ret$3 = bitwiseAnd(cur, new Long(-1, 268435455));
          tmp = constructSendersAndCloseStatus(tmp$ret$3, 1);
        } else {
          return Unit_instance;
        }
        var upd = tmp;
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          tmp$ret$0 = Unit_instance;
          break $l$block;
        }
      }
      tmp$ret$0 = Unit_instance;
    }
    return tmp$ret$0;
  }
  function completeCloseOrCancel($this) {
    $this.f1q();
  }
  function completeClose($this, sendersCur) {
    var lastSegment = closeLinkedList($this);
    if ($this.h1q()) {
      var lastBufferedCellGlobalIndex = markAllEmptyCellsAsClosed($this, lastSegment);
      if (!equalsLong(lastBufferedCellGlobalIndex, new Long(-1, -1))) {
        $this.g1q(lastBufferedCellGlobalIndex);
      }
    }
    cancelSuspendedReceiveRequests($this, lastSegment, sendersCur);
    return lastSegment;
  }
  function completeCancel($this, sendersCur) {
    var lastSegment = completeClose($this, sendersCur);
    removeUnprocessedElements($this, lastSegment);
  }
  function closeLinkedList($this) {
    var lastSegment = $this.q1n_1.kotlinx$atomicfu$value;
    // Inline function 'kotlin.let' call
    var it = $this.o1n_1.kotlinx$atomicfu$value;
    if (compare(it.h1e_1, lastSegment.h1e_1) > 0)
      lastSegment = it;
    // Inline function 'kotlin.let' call
    var it_0 = $this.p1n_1.kotlinx$atomicfu$value;
    if (compare(it_0.h1e_1, lastSegment.h1e_1) > 0)
      lastSegment = it_0;
    return close(lastSegment);
  }
  function markAllEmptyCellsAsClosed($this, lastSegment) {
    var segment = lastSegment;
    while (true) {
      var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var tmp0 = segment.h1e_1;
          // Inline function 'kotlin.Long.times' call
          var other = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call
          var this_0 = multiply(tmp0, fromInt(other));
          var globalIndex = add(this_0, fromInt(index));
          if (compare(globalIndex, $this.j1p()) < 0)
            return new Long(-1, -1);
          cell_update: while (true) {
            var state = segment.e1n(index);
            if (state === null || state === get_IN_BUFFER()) {
              if (segment.g1n(index, state, get_CHANNEL_CLOSED())) {
                segment.w1n();
                break cell_update;
              }
            } else if (state === get_BUFFERED())
              return globalIndex;
            else
              break cell_update;
          }
        }
         while (0 <= inductionVariable);
      var tmp0_elvis_lhs = segment.f1o();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return new Long(-1, -1);
      } else {
        tmp = tmp0_elvis_lhs;
      }
      segment = tmp;
    }
  }
  function removeUnprocessedElements($this, lastSegment) {
    var onUndeliveredElement = $this.j1n_1;
    var undeliveredElementException = null;
    var suspendedSenders = _InlineList___init__impl__z8n56();
    var segment = lastSegment;
    process_segments: while (true) {
      var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var tmp0 = segment.h1e_1;
          // Inline function 'kotlin.Long.times' call
          var other = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call
          var this_0 = multiply(tmp0, fromInt(other));
          var globalIndex = add(this_0, fromInt(index));
          update_cell: while (true) {
            var state = segment.e1n(index);
            if (state === get_DONE_RCV())
              break process_segments;
            else {
              if (state === get_BUFFERED()) {
                if (compare(globalIndex, $this.j1p()) < 0)
                  break process_segments;
                if (segment.g1n(index, state, get_CHANNEL_CLOSED())) {
                  if (!(onUndeliveredElement == null)) {
                    var element = segment.b1n(index);
                    undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element, undeliveredElementException);
                  }
                  segment.d1n(index);
                  segment.w1n();
                  break update_cell;
                }
              } else {
                if (state === get_IN_BUFFER() || state === null) {
                  if (segment.g1n(index, state, get_CHANNEL_CLOSED())) {
                    segment.w1n();
                    break update_cell;
                  }
                } else {
                  var tmp;
                  if (isInterface(state, Waiter)) {
                    tmp = true;
                  } else {
                    tmp = state instanceof WaiterEB;
                  }
                  if (tmp) {
                    if (compare(globalIndex, $this.j1p()) < 0)
                      break process_segments;
                    var tmp_0;
                    if (state instanceof WaiterEB) {
                      tmp_0 = state.l1p_1;
                    } else {
                      tmp_0 = isInterface(state, Waiter) ? state : THROW_CCE();
                    }
                    var sender = tmp_0;
                    if (segment.g1n(index, state, get_CHANNEL_CLOSED())) {
                      if (!(onUndeliveredElement == null)) {
                        var element_0 = segment.b1n(index);
                        undeliveredElementException = callUndeliveredElementCatchingException(onUndeliveredElement, element_0, undeliveredElementException);
                      }
                      suspendedSenders = InlineList__plus_impl_nuetvo(suspendedSenders, sender);
                      segment.d1n(index);
                      segment.w1n();
                      break update_cell;
                    }
                  } else {
                    if (state === get_RESUMING_BY_EB() || state === get_RESUMING_BY_RCV())
                      break process_segments;
                    else {
                      if (state === get_RESUMING_BY_EB())
                        continue update_cell;
                      else {
                        break update_cell;
                      }
                    }
                  }
                }
              }
            }
          }
        }
         while (0 <= inductionVariable);
      var tmp0_elvis_lhs = segment.f1o();
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        break process_segments;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      segment = tmp_1;
    }
    var tmp0_0 = suspendedSenders;
    $l$block: {
      // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
      var tmp0_subject = access$_get_holder__kkflen(tmp0_0);
      if (tmp0_subject == null) {
        break $l$block;
      } else {
        if (!(tmp0_subject instanceof ArrayList)) {
          var tmp_2 = access$_get_holder__kkflen(tmp0_0);
          var it = !(tmp_2 == null) ? tmp_2 : THROW_CCE();
          resumeSenderOnCancelledChannel($this, it);
        } else {
          var tmp_3 = access$_get_holder__kkflen(tmp0_0);
          var list = tmp_3 instanceof ArrayList ? tmp_3 : THROW_CCE();
          var inductionVariable_0 = list.n1() - 1 | 0;
          if (0 <= inductionVariable_0)
            do {
              var i = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + -1 | 0;
              var it_0 = list.l1(i);
              resumeSenderOnCancelledChannel($this, it_0);
            }
             while (0 <= inductionVariable_0);
        }
      }
    }
    var tmp1_safe_receiver = undeliveredElementException;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      throw tmp1_safe_receiver;
    }
  }
  function cancelSuspendedReceiveRequests($this, lastSegment, sendersCounter) {
    var suspendedReceivers = _InlineList___init__impl__z8n56();
    var segment = lastSegment;
    process_segments: while (!(segment == null)) {
      var inductionVariable = get_SEGMENT_SIZE() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var tmp0 = segment.h1e_1;
          // Inline function 'kotlin.Long.times' call
          var other = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call
          var this_0 = multiply(tmp0, fromInt(other));
          var tmp$ret$1 = add(this_0, fromInt(index));
          if (compare(tmp$ret$1, sendersCounter) < 0)
            break process_segments;
          cell_update: while (true) {
            var state = segment.e1n(index);
            if (state === null || state === get_IN_BUFFER()) {
              if (segment.g1n(index, state, get_CHANNEL_CLOSED())) {
                segment.w1n();
                break cell_update;
              }
            } else {
              if (state instanceof WaiterEB) {
                if (segment.g1n(index, state, get_CHANNEL_CLOSED())) {
                  suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state.l1p_1);
                  segment.u1n(index, true);
                  break cell_update;
                }
              } else {
                if (isInterface(state, Waiter)) {
                  if (segment.g1n(index, state, get_CHANNEL_CLOSED())) {
                    suspendedReceivers = InlineList__plus_impl_nuetvo(suspendedReceivers, state);
                    segment.u1n(index, true);
                    break cell_update;
                  }
                } else {
                  break cell_update;
                }
              }
            }
          }
        }
         while (0 <= inductionVariable);
      segment = segment.f1o();
    }
    var tmp0_0 = suspendedReceivers;
    $l$block: {
      // Inline function 'kotlinx.coroutines.internal.InlineList.forEachReversed' call
      var tmp0_subject = access$_get_holder__kkflen(tmp0_0);
      if (tmp0_subject == null) {
        break $l$block;
      } else {
        if (!(tmp0_subject instanceof ArrayList)) {
          var tmp = access$_get_holder__kkflen(tmp0_0);
          var it = !(tmp == null) ? tmp : THROW_CCE();
          resumeReceiverOnClosedChannel($this, it);
        } else {
          var tmp_0 = access$_get_holder__kkflen(tmp0_0);
          var list = tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE();
          var inductionVariable_0 = list.n1() - 1 | 0;
          if (0 <= inductionVariable_0)
            do {
              var i = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + -1 | 0;
              var it_0 = list.l1(i);
              resumeReceiverOnClosedChannel($this, it_0);
            }
             while (0 <= inductionVariable_0);
        }
      }
    }
  }
  function resumeReceiverOnClosedChannel($this, $receiver) {
    return resumeWaiterOnClosedChannel($this, $receiver, true);
  }
  function resumeSenderOnCancelledChannel($this, $receiver) {
    return resumeWaiterOnClosedChannel($this, $receiver, false);
  }
  function resumeWaiterOnClosedChannel($this, $receiver, receiver) {
    if ($receiver instanceof SendBroadcast) {
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = $receiver.u1p_1;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$1 = _Result___init__impl__xyqfz8(false);
      this_0.y9(tmp$ret$1);
    } else {
      if (isInterface($receiver, CancellableContinuation)) {
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var exception = receiver ? _get_receiveException__foorc1($this) : $this.i1p();
        var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception));
        $receiver.y9(tmp$ret$3);
      } else {
        if ($receiver instanceof ReceiveCatching) {
          var tmp0 = $receiver.p1p_1;
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = new ChannelResult(Companion_getInstance_0().t1p($this.l1o()));
          var tmp$ret$5 = _Result___init__impl__xyqfz8(value);
          tmp0.y9(tmp$ret$5);
        } else {
          if ($receiver instanceof BufferedChannelIterator) {
            $receiver.e1q();
          } else {
            if (isInterface($receiver, SelectInstance))
              $receiver.q1p($this, get_CHANNEL_CLOSED());
            else {
              // Inline function 'kotlin.error' call
              var message = 'Unexpected waiter: ' + toString($receiver);
              throw IllegalStateException_init_$Create$(toString(message));
            }
          }
        }
      }
    }
  }
  function _get_isClosedForSend0__kxgf9m($this, $receiver) {
    return isClosed($this, $receiver, false);
  }
  function _get_isClosedForReceive0__f7qknl($this, $receiver) {
    return isClosed($this, $receiver, true);
  }
  function isClosed($this, sendersAndCloseStatusCur, isClosedForReceive) {
    // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
    var tmp;
    switch (convertToInt(shiftRight(sendersAndCloseStatusCur, 60))) {
      case 0:
        tmp = false;
        break;
      case 1:
        tmp = false;
        break;
      case 2:
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

        var tmp$ret$1 = bitwiseAnd(sendersAndCloseStatusCur, new Long(-1, 268435455));
        completeClose($this, tmp$ret$1);
        tmp = isClosedForReceive ? !$this.i1q() : true;
        break;
      case 3:
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call

        var tmp$ret$2 = bitwiseAnd(sendersAndCloseStatusCur, new Long(-1, 268435455));
        completeCancel($this, tmp$ret$2);
        tmp = true;
        break;
      default:
        // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call

        // Inline function 'kotlin.error' call

        var message = 'unexpected close status: ' + convertToInt(shiftRight(sendersAndCloseStatusCur, 60));
        throw IllegalStateException_init_$Create$(toString(message));
    }
    return tmp;
  }
  function isCellNonEmpty($this, segment, index, globalIndex) {
    while (true) {
      var state = segment.e1n(index);
      if (state === null || state === get_IN_BUFFER()) {
        if (segment.g1n(index, state, get_POISONED())) {
          expandBuffer($this);
          return false;
        }
      } else if (state === get_BUFFERED())
        return true;
      else if (state === get_INTERRUPTED_SEND())
        return false;
      else if (state === get_CHANNEL_CLOSED())
        return false;
      else if (state === get_DONE_RCV())
        return false;
      else if (state === get_POISONED())
        return false;
      else if (state === get_RESUMING_BY_EB())
        return true;
      else if (state === get_RESUMING_BY_RCV())
        return false;
      else
        return equalsLong(globalIndex, $this.j1p());
    }
  }
  function findSegmentSend($this, id, startFrom) {
    var tmp0 = $this.o1n_1;
    var tmp6 = createSegmentFunction();
    var tmp$ret$0;
    $l$block_2: {
      // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
      while (true) {
        var s = findSegmentInternal(startFrom, id, tmp6);
        var tmp;
        if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
          tmp = true;
        } else {
          var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
          var tmp$ret$1;
          $l$block_1: {
            // Inline function 'kotlinx.coroutines.internal.moveForward' call
            var tmp$ret$2;
            // Inline function 'kotlinx.atomicfu.loop' call
            while (true) {
              var cur = tmp0.kotlinx$atomicfu$value;
              if (compare(cur.h1e_1, tmp2.h1e_1) >= 0) {
                tmp$ret$1 = true;
                break $l$block_1;
              }
              if (!tmp2.y1n()) {
                tmp$ret$1 = false;
                break $l$block_1;
              }
              if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
                if (cur.z1n()) {
                  cur.l4();
                }
                tmp$ret$1 = true;
                break $l$block_1;
              }
              if (tmp2.z1n()) {
                tmp2.l4();
              }
            }
            tmp$ret$1 = tmp$ret$2;
          }
          tmp = tmp$ret$1;
        }
        if (tmp) {
          tmp$ret$0 = s;
          break $l$block_2;
        }
      }
    }
    // Inline function 'kotlin.let' call
    var it = tmp$ret$0;
    var tmp_0;
    if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
      completeCloseOrCancel($this);
      var tmp0_0 = startFrom.h1e_1;
      // Inline function 'kotlin.Long.times' call
      var other = get_SEGMENT_SIZE();
      var tmp$ret$6 = multiply(tmp0_0, fromInt(other));
      if (compare(tmp$ret$6, $this.j1p()) < 0) {
        startFrom.g1o();
      }
      tmp_0 = null;
    } else {
      var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
      var tmp_1;
      if (compare(segment.h1e_1, id) > 0) {
        var tmp0_1 = segment.h1e_1;
        // Inline function 'kotlin.Long.times' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$7 = multiply(tmp0_1, fromInt(other_0));
        updateSendersCounterIfLower($this, tmp$ret$7);
        var tmp0_2 = segment.h1e_1;
        // Inline function 'kotlin.Long.times' call
        var other_1 = get_SEGMENT_SIZE();
        var tmp$ret$8 = multiply(tmp0_2, fromInt(other_1));
        if (compare(tmp$ret$8, $this.j1p()) < 0) {
          segment.g1o();
        }
        tmp_1 = null;
      } else {
        // Inline function 'kotlinx.coroutines.assert' call
        tmp_1 = segment;
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function findSegmentReceive($this, id, startFrom) {
    var tmp0 = $this.p1n_1;
    var tmp6 = createSegmentFunction();
    var tmp$ret$0;
    $l$block_2: {
      // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
      while (true) {
        var s = findSegmentInternal(startFrom, id, tmp6);
        var tmp;
        if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
          tmp = true;
        } else {
          var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
          var tmp$ret$1;
          $l$block_1: {
            // Inline function 'kotlinx.coroutines.internal.moveForward' call
            var tmp$ret$2;
            // Inline function 'kotlinx.atomicfu.loop' call
            while (true) {
              var cur = tmp0.kotlinx$atomicfu$value;
              if (compare(cur.h1e_1, tmp2.h1e_1) >= 0) {
                tmp$ret$1 = true;
                break $l$block_1;
              }
              if (!tmp2.y1n()) {
                tmp$ret$1 = false;
                break $l$block_1;
              }
              if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
                if (cur.z1n()) {
                  cur.l4();
                }
                tmp$ret$1 = true;
                break $l$block_1;
              }
              if (tmp2.z1n()) {
                tmp2.l4();
              }
            }
            tmp$ret$1 = tmp$ret$2;
          }
          tmp = tmp$ret$1;
        }
        if (tmp) {
          tmp$ret$0 = s;
          break $l$block_2;
        }
      }
    }
    // Inline function 'kotlin.let' call
    var it = tmp$ret$0;
    var tmp_0;
    if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
      completeCloseOrCancel($this);
      var tmp0_0 = startFrom.h1e_1;
      // Inline function 'kotlin.Long.times' call
      var other = get_SEGMENT_SIZE();
      var tmp$ret$6 = multiply(tmp0_0, fromInt(other));
      if (compare(tmp$ret$6, $this.m1o()) < 0) {
        startFrom.g1o();
      }
      tmp_0 = null;
    } else {
      var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
      var tmp_1;
      if (!_get_isRendezvousOrUnlimited__3mdufi($this)) {
        var tmp0_1 = _get_bufferEndCounter__2d4hee($this);
        // Inline function 'kotlin.Long.div' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$7 = divide(tmp0_1, fromInt(other_0));
        tmp_1 = compare(id, tmp$ret$7) <= 0;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        var tmp0_2 = $this.q1n_1;
        $l$block_5: {
          // Inline function 'kotlinx.coroutines.internal.moveForward' call
          // Inline function 'kotlinx.atomicfu.loop' call
          while (true) {
            var cur_0 = tmp0_2.kotlinx$atomicfu$value;
            if (compare(cur_0.h1e_1, segment.h1e_1) >= 0) {
              break $l$block_5;
            }
            if (!segment.y1n()) {
              break $l$block_5;
            }
            if (tmp0_2.atomicfu$compareAndSet(cur_0, segment)) {
              if (cur_0.z1n()) {
                cur_0.l4();
              }
              break $l$block_5;
            }
            if (segment.z1n()) {
              segment.l4();
            }
          }
        }
      }
      var tmp_2;
      if (compare(segment.h1e_1, id) > 0) {
        var tmp0_3 = segment.h1e_1;
        // Inline function 'kotlin.Long.times' call
        var other_1 = get_SEGMENT_SIZE();
        var tmp$ret$11 = multiply(tmp0_3, fromInt(other_1));
        updateReceiversCounterIfLower($this, tmp$ret$11);
        var tmp0_4 = segment.h1e_1;
        // Inline function 'kotlin.Long.times' call
        var other_2 = get_SEGMENT_SIZE();
        var tmp$ret$12 = multiply(tmp0_4, fromInt(other_2));
        if (compare(tmp$ret$12, $this.m1o()) < 0) {
          segment.g1o();
        }
        tmp_2 = null;
      } else {
        // Inline function 'kotlinx.coroutines.assert' call
        tmp_2 = segment;
      }
      tmp_0 = tmp_2;
    }
    return tmp_0;
  }
  function findSegmentBufferEnd($this, id, startFrom, currentBufferEndCounter) {
    var tmp0 = $this.q1n_1;
    var tmp6 = createSegmentFunction();
    var tmp$ret$0;
    $l$block_2: {
      // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
      while (true) {
        var s = findSegmentInternal(startFrom, id, tmp6);
        var tmp;
        if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
          tmp = true;
        } else {
          var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
          var tmp$ret$1;
          $l$block_1: {
            // Inline function 'kotlinx.coroutines.internal.moveForward' call
            var tmp$ret$2;
            // Inline function 'kotlinx.atomicfu.loop' call
            while (true) {
              var cur = tmp0.kotlinx$atomicfu$value;
              if (compare(cur.h1e_1, tmp2.h1e_1) >= 0) {
                tmp$ret$1 = true;
                break $l$block_1;
              }
              if (!tmp2.y1n()) {
                tmp$ret$1 = false;
                break $l$block_1;
              }
              if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
                if (cur.z1n()) {
                  cur.l4();
                }
                tmp$ret$1 = true;
                break $l$block_1;
              }
              if (tmp2.z1n()) {
                tmp2.l4();
              }
            }
            tmp$ret$1 = tmp$ret$2;
          }
          tmp = tmp$ret$1;
        }
        if (tmp) {
          tmp$ret$0 = s;
          break $l$block_2;
        }
      }
    }
    // Inline function 'kotlin.let' call
    var it = tmp$ret$0;
    var tmp_0;
    if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(it)) {
      completeCloseOrCancel($this);
      moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom);
      incCompletedExpandBufferAttempts($this);
      tmp_0 = null;
    } else {
      var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(it);
      var tmp_1;
      if (compare(segment.h1e_1, id) > 0) {
        // Inline function 'kotlin.Long.plus' call
        var tmp_2 = add(currentBufferEndCounter, fromInt(1));
        var tmp0_0 = segment.h1e_1;
        // Inline function 'kotlin.Long.times' call
        var other = get_SEGMENT_SIZE();
        var tmp$ret$7 = multiply(tmp0_0, fromInt(other));
        if ($this.m1n_1.atomicfu$compareAndSet(tmp_2, tmp$ret$7)) {
          var tmp0_1 = segment.h1e_1;
          // Inline function 'kotlin.Long.times' call
          var other_0 = get_SEGMENT_SIZE();
          var tmp$ret$8 = multiply(tmp0_1, fromInt(other_0));
          incCompletedExpandBufferAttempts($this, subtract(tmp$ret$8, currentBufferEndCounter));
        } else {
          incCompletedExpandBufferAttempts($this);
        }
        tmp_1 = null;
      } else {
        // Inline function 'kotlinx.coroutines.assert' call
        tmp_1 = segment;
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function moveSegmentBufferEndToSpecifiedOrLast($this, id, startFrom) {
    var segment = startFrom;
    $l$loop: while (compare(segment.h1e_1, id) < 0) {
      var tmp0_elvis_lhs = segment.c1o();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      segment = tmp;
    }
    while (true) {
      $l$loop_0: while (segment.x1n()) {
        var tmp1_elvis_lhs = segment.c1o();
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          break $l$loop_0;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        segment = tmp_0;
      }
      var tmp0 = $this.q1n_1;
      var tmp2 = segment;
      var tmp$ret$0;
      $l$block_1: {
        // Inline function 'kotlinx.coroutines.internal.moveForward' call
        var tmp$ret$1;
        // Inline function 'kotlinx.atomicfu.loop' call
        while (true) {
          var cur = tmp0.kotlinx$atomicfu$value;
          if (compare(cur.h1e_1, tmp2.h1e_1) >= 0) {
            tmp$ret$0 = true;
            break $l$block_1;
          }
          if (!tmp2.y1n()) {
            tmp$ret$0 = false;
            break $l$block_1;
          }
          if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
            if (cur.z1n()) {
              cur.l4();
            }
            tmp$ret$0 = true;
            break $l$block_1;
          }
          if (tmp2.z1n()) {
            tmp2.l4();
          }
        }
        tmp$ret$0 = tmp$ret$1;
      }
      if (tmp$ret$0)
        return Unit_instance;
    }
  }
  function updateSendersCounterIfLower($this, value) {
    var tmp$ret$0;
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.k1n_1;
    while (true) {
      var cur = this_0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
      var curCounter = bitwiseAnd(cur, new Long(-1, 268435455));
      if (compare(curCounter, value) >= 0)
        return Unit_instance;
      // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
      var tmp$ret$3 = convertToInt(shiftRight(cur, 60));
      var update = constructSendersAndCloseStatus(curCounter, tmp$ret$3);
      if ($this.k1n_1.atomicfu$compareAndSet(cur, update))
        return Unit_instance;
    }
    return tmp$ret$0;
  }
  function updateReceiversCounterIfLower($this, value) {
    var tmp$ret$0;
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.l1n_1;
    while (true) {
      var cur = this_0.kotlinx$atomicfu$value;
      if (compare(cur, value) >= 0)
        return Unit_instance;
      if ($this.l1n_1.atomicfu$compareAndSet(cur, value))
        return Unit_instance;
    }
    return tmp$ret$0;
  }
  function bindCancellationFunResult($this, $receiver) {
    return BufferedChannel$onCancellationChannelResultImplDoNotCall$ref($this);
  }
  function onCancellationChannelResultImplDoNotCall($this, cause, element, context) {
    callUndeliveredElement(ensureNotNull($this.j1n_1), ensureNotNull(ChannelResult__getOrNull_impl_f5e07h(element)), context);
  }
  function bindCancellationFun($this, $receiver, element) {
    return BufferedChannel$bindCancellationFun$lambda($receiver, element);
  }
  function bindCancellationFun_0($this, $receiver) {
    return BufferedChannel$onCancellationImplDoNotCall$ref($this);
  }
  function onCancellationImplDoNotCall($this, cause, element, context) {
    callUndeliveredElement(ensureNotNull($this.j1n_1), element, context);
  }
  function access$_get_sendersAndCloseStatus__tvw29s($this) {
    return $this.k1n_1;
  }
  function access$_get_sendSegment__111kgq($this) {
    return $this.o1n_1;
  }
  function access$prepareSenderForSuspension($this, $receiver, segment, index) {
    return prepareSenderForSuspension($this, $receiver, segment, index);
  }
  function access$updateCellSend($this, segment, index, element, s, waiter, closed) {
    return updateCellSend($this, segment, index, element, s, waiter, closed);
  }
  function access$_get_isClosedForSend0__sm8f7a($this, $receiver) {
    return _get_isClosedForSend0__kxgf9m($this, $receiver);
  }
  function access$findSegmentSend($this, id, startFrom) {
    return findSegmentSend($this, id, startFrom);
  }
  function BufferedChannel$registerSelectForReceive$ref() {
    return constructCallableReference(function (p0, p1, p2) {
      registerSelectForReceive(p0, p1, p2);
      return Unit_instance;
    }, 3, 0, 1, 'registerSelectForReceive');
  }
  function BufferedChannel$processResultSelectReceiveCatching$ref() {
    return constructCallableReference(function (p0, p1, p2) {
      return processResultSelectReceiveCatching(p0, p1, p2);
    }, 3, 0, 2, 'processResultSelectReceiveCatching');
  }
  function BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda$lambda($element, this$0, $select) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
      var tmp;
      if (!($element === get_CHANNEL_CLOSED())) {
        callUndeliveredElement(this$0.j1n_1, $element, $select.t9());
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda(this$0) {
    return function (select, _unused_var__etf5q3, element) {
      return BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda$lambda(element, this$0, select);
    };
  }
  function BufferedChannel$onCancellationChannelResultImplDoNotCall$ref(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      var tmp0 = p0;
      onCancellationChannelResultImplDoNotCall(tmp0, p0_0, p1.s1p_1, p2);
      return Unit_instance;
    }, 3, 0, 3, 'onCancellationChannelResultImplDoNotCall', [p0]);
  }
  function BufferedChannel$bindCancellationFun$lambda($this_bindCancellationFun, $element) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, context) {
      callUndeliveredElement($this_bindCancellationFun, $element, context);
      return Unit_instance;
    };
  }
  function BufferedChannel$onCancellationImplDoNotCall$ref(p0) {
    return constructCallableReference(function (p0_0, p1, p2) {
      var tmp0 = p0;
      onCancellationImplDoNotCall(tmp0, p0_0, p1, p2);
      return Unit_instance;
    }, 3, 0, 4, 'onCancellationImplDoNotCall', [p0]);
  }
  function $sendCOROUTINE$(_this__u8e3s4, element, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s1q_1 = _this__u8e3s4;
    this.t1q_1 = element;
  }
  protoOf($sendCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 11;
            this.e1r_1 = this.s1q_1;
            this.d1r_1 = this.t1q_1;
            this.c1r_1 = null;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.w1q_1 = this.e1r_1;
            this.z1q_1 = this.d1r_1;
            this.x1q_1 = this.c1r_1;
            this.v1q_1 = access$_get_sendSegment__111kgq(this.w1q_1).kotlinx$atomicfu$value;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.n9_1 = 12;
              continue $sm;
            }

            var sendersAndCloseStatusCur = access$_get_sendersAndCloseStatus__tvw29s(this.w1q_1).atomicfu$getAndIncrement$long();
            var tmp_0 = this;
            tmp_0.y1q_1 = bitwiseAnd(sendersAndCloseStatusCur, new Long(-1, 268435455));
            this.a1r_1 = access$_get_isClosedForSend0__sm8f7a(this.w1q_1, sendersAndCloseStatusCur);
            var tmp0 = this.y1q_1;
            var other = get_SEGMENT_SIZE();
            var id = divide(tmp0, fromInt(other));
            var tmp_1 = this;
            var tmp0_0 = this.y1q_1;
            var other_0 = get_SEGMENT_SIZE();
            tmp_1.u1q_1 = convertToInt(modulo(tmp0_0, fromInt(other_0)));
            if (!equalsLong(this.v1q_1.h1e_1, id)) {
              var tmp0_elvis_lhs = access$findSegmentSend(this.w1q_1, id, this.v1q_1);
              if (tmp0_elvis_lhs == null) {
                if (this.a1r_1) {
                  this.n9_1 = 10;
                  suspendResult = onClosedSend(this.s1q_1, this.t1q_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.n9_1 = 2;
                  var tmp_2 = this;
                  continue $sm;
                }
              } else {
                this.b1r_1 = tmp0_elvis_lhs;
                this.n9_1 = 3;
                continue $sm;
              }
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 3:
            this.v1q_1 = this.b1r_1;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            var tmp1_subject = access$updateCellSend(this.w1q_1, this.v1q_1, this.u1q_1, this.z1q_1, this.y1q_1, this.x1q_1, this.a1r_1);
            if (tmp1_subject === 0) {
              this.v1q_1.g1o();
              this.n9_1 = 13;
              continue $sm;
            } else {
              if (tmp1_subject === 1) {
                this.n9_1 = 13;
                continue $sm;
              } else {
                if (tmp1_subject === 2) {
                  if (this.a1r_1) {
                    this.v1q_1.w1n();
                    this.n9_1 = 9;
                    suspendResult = onClosedSend(this.s1q_1, this.t1q_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    this.n9_1 = 8;
                    continue $sm;
                  }
                } else {
                  if (tmp1_subject === 4) {
                    if (compare(this.y1q_1, this.w1q_1.j1p()) < 0) {
                      this.v1q_1.g1o();
                    }
                    this.n9_1 = 7;
                    suspendResult = onClosedSend(this.s1q_1, this.t1q_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (tmp1_subject === 5) {
                      this.v1q_1.g1o();
                      this.n9_1 = 2;
                      continue $sm;
                    } else {
                      if (tmp1_subject === 3) {
                        var tmp0_1 = this.v1q_1;
                        var tmp2 = this.u1q_1;
                        var tmp4 = this.z1q_1;
                        var s = this.y1q_1;
                        this.n9_1 = 6;
                        suspendResult = sendOnNoWaiterSuspend(this.s1q_1, tmp0_1, tmp2, tmp4, s, this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      } else {
                        this.n9_1 = 5;
                        continue $sm;
                      }
                    }
                  }
                }
              }
            }

          case 5:
            this.n9_1 = 2;
            continue $sm;
          case 6:
            this.n9_1 = 13;
            continue $sm;
          case 7:
            this.n9_1 = 13;
            continue $sm;
          case 8:
            var tmp_3 = this.x1q_1;
            var tmp2_safe_receiver = (!(tmp_3 == null) ? isInterface(tmp_3, Waiter) : false) ? tmp_3 : null;
            if (tmp2_safe_receiver == null)
              null;
            else {
              access$prepareSenderForSuspension(this.w1q_1, tmp2_safe_receiver, this.v1q_1, this.u1q_1);
            }

            this.v1q_1;
            this.u1q_1;
            this.n9_1 = 13;
            continue $sm;
          case 9:
            this.n9_1 = 13;
            continue $sm;
          case 10:
            this.n9_1 = 13;
            continue $sm;
          case 11:
            throw this.q9_1;
          case 12:
            if (false) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 13;
            continue $sm;
          case 13:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 11) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $receiveCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n1r_1 = _this__u8e3s4;
  }
  protoOf($receiveCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            this.x1r_1 = this.n1r_1;
            this.w1r_1 = null;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.t1r_1 = this.x1r_1;
            this.u1r_1 = this.w1r_1;
            this.q1r_1 = this.t1r_1.p1n_1.kotlinx$atomicfu$value;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.n9_1 = 9;
              continue $sm;
            }

            if (this.t1r_1.n1o()) {
              var tmp_0 = this;
              throw recoverStackTrace_0(_get_receiveException__foorc1(this.n1r_1));
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 3:
            this.r1r_1 = this.t1r_1.l1n_1.atomicfu$getAndIncrement$long();
            var tmp0 = this.r1r_1;
            var other = get_SEGMENT_SIZE();
            var id = divide(tmp0, fromInt(other));
            var tmp_1 = this;
            var tmp0_0 = this.r1r_1;
            var other_0 = get_SEGMENT_SIZE();
            tmp_1.s1r_1 = convertToInt(modulo(tmp0_0, fromInt(other_0)));
            if (!equalsLong(this.q1r_1.h1e_1, id)) {
              var tmp0_elvis_lhs = findSegmentReceive(this.t1r_1, id, this.q1r_1);
              if (tmp0_elvis_lhs == null) {
                this.n9_1 = 2;
                var tmp_2 = this;
                continue $sm;
              } else {
                this.v1r_1 = tmp0_elvis_lhs;
                this.n9_1 = 4;
                continue $sm;
              }
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 4:
            this.q1r_1 = this.v1r_1;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            var updCellResult = updateCellReceive(this.t1r_1, this.q1r_1, this.s1r_1, this.r1r_1, this.u1r_1);
            if (updCellResult === get_SUSPEND()) {
              var tmp_3 = this;
              var tmp_4 = this.u1r_1;
              var tmp1_safe_receiver = (!(tmp_4 == null) ? isInterface(tmp_4, Waiter) : false) ? tmp_4 : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(this.t1r_1, tmp1_safe_receiver, this.q1r_1, this.s1r_1);
              }
              this.q1r_1;
              this.s1r_1;
              this.r1r_1;
              var message = 'unexpected';
              throw IllegalStateException_init_$Create$(toString(message));
            } else {
              if (updCellResult === get_FAILED()) {
                if (compare(this.r1r_1, this.t1r_1.m1o()) < 0) {
                  this.q1r_1.g1o();
                }
                this.n9_1 = 2;
                var tmp_5 = this;
                continue $sm;
              } else {
                if (updCellResult === get_SUSPEND_NO_WAITER()) {
                  var tmp0_1 = this.q1r_1;
                  var tmp2 = this.s1r_1;
                  var r = this.r1r_1;
                  this.n9_1 = 6;
                  suspendResult = receiveOnNoWaiterSuspend(this.n1r_1, tmp0_1, tmp2, r, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_6 = this;
                  this.q1r_1.g1o();
                  return updCellResult;
                }
              }
            }

          case 6:
            this.p1r_1 = suspendResult;
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.o1r_1 = this.p1r_1;
            this.n9_1 = 10;
            continue $sm;
          case 8:
            throw this.q9_1;
          case 9:
            if (false) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 10;
            continue $sm;
          case 10:
            return this.o1r_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $receiveCatchingCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g1s_1 = _this__u8e3s4;
  }
  protoOf($receiveCatchingCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            this.q1s_1 = this.g1s_1;
            this.p1s_1 = null;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.m1s_1 = this.q1s_1;
            this.n1s_1 = this.p1s_1;
            this.j1s_1 = this.m1s_1.p1n_1.kotlinx$atomicfu$value;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.n9_1 = 10;
              continue $sm;
            }

            if (this.m1s_1.n1o()) {
              var tmp_0 = this;
              tmp_0.h1s_1 = Companion_getInstance_0().t1p(this.g1s_1.l1o());
              this.n9_1 = 11;
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 3:
            this.k1s_1 = this.m1s_1.l1n_1.atomicfu$getAndIncrement$long();
            var tmp0 = this.k1s_1;
            var other = get_SEGMENT_SIZE();
            var id = divide(tmp0, fromInt(other));
            var tmp_1 = this;
            var tmp0_0 = this.k1s_1;
            var other_0 = get_SEGMENT_SIZE();
            tmp_1.l1s_1 = convertToInt(modulo(tmp0_0, fromInt(other_0)));
            if (!equalsLong(this.j1s_1.h1e_1, id)) {
              var tmp0_elvis_lhs = findSegmentReceive(this.m1s_1, id, this.j1s_1);
              if (tmp0_elvis_lhs == null) {
                this.n9_1 = 2;
                var tmp_2 = this;
                continue $sm;
              } else {
                this.o1s_1 = tmp0_elvis_lhs;
                this.n9_1 = 4;
                continue $sm;
              }
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 4:
            this.j1s_1 = this.o1s_1;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            var updCellResult = updateCellReceive(this.m1s_1, this.j1s_1, this.l1s_1, this.k1s_1, this.n1s_1);
            if (updCellResult === get_SUSPEND()) {
              var tmp_3 = this;
              var tmp_4 = this.n1s_1;
              var tmp1_safe_receiver = (!(tmp_4 == null) ? isInterface(tmp_4, Waiter) : false) ? tmp_4 : null;
              if (tmp1_safe_receiver == null)
                null;
              else {
                prepareReceiverForSuspension(this.m1s_1, tmp1_safe_receiver, this.j1s_1, this.l1s_1);
              }
              this.j1s_1;
              this.l1s_1;
              this.k1s_1;
              var message = 'unexpected';
              throw IllegalStateException_init_$Create$(toString(message));
            } else {
              if (updCellResult === get_FAILED()) {
                if (compare(this.k1s_1, this.m1s_1.m1o()) < 0) {
                  this.j1s_1.g1o();
                }
                this.n9_1 = 2;
                var tmp_5 = this;
                continue $sm;
              } else {
                if (updCellResult === get_SUSPEND_NO_WAITER()) {
                  var tmp0_1 = this.j1s_1;
                  var tmp2 = this.l1s_1;
                  var r = this.k1s_1;
                  this.n9_1 = 6;
                  suspendResult = receiveCatchingOnNoWaiterSuspend(this.g1s_1, tmp0_1, tmp2, r, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  this.n9_1 = 7;
                  continue $sm;
                } else {
                  var tmp_6 = this;
                  this.j1s_1.g1o();
                  tmp_6.i1s_1 = new ChannelResult(Companion_getInstance_0().o1p(updCellResult));
                  this.n9_1 = 8;
                  continue $sm;
                }
              }
            }

          case 6:
            var unboxed = suspendResult.s1p_1;
            suspendResult = new ChannelResult(unboxed);
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.i1s_1 = suspendResult;
            this.n9_1 = 8;
            continue $sm;
          case 8:
            this.h1s_1 = this.i1s_1.s1p_1;
            this.n9_1 = 11;
            continue $sm;
          case 9:
            throw this.q9_1;
          case 10:
            if (false) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 11;
            continue $sm;
          case 11:
            return new ChannelResult(this.h1s_1);
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 9) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function BufferedChannel(capacity, onUndeliveredElement) {
    onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
    this.i1n_1 = capacity;
    this.j1n_1 = onUndeliveredElement;
    // Inline function 'kotlin.require' call
    if (!(this.i1n_1 >= 0)) {
      var message = 'Invalid channel capacity: ' + this.i1n_1 + ', should be >=0';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    this.k1n_1 = atomic$long$1(new Long(0, 0));
    this.l1n_1 = atomic$long$1(new Long(0, 0));
    this.m1n_1 = atomic$long$1(initialBufferEnd(this.i1n_1));
    this.n1n_1 = atomic$long$1(_get_bufferEndCounter__2d4hee(this));
    var firstSegment = new ChannelSegment(new Long(0, 0), null, this, 3);
    this.o1n_1 = atomic$ref$1(firstSegment);
    this.p1n_1 = atomic$ref$1(firstSegment);
    var tmp = this;
    var tmp_0;
    if (_get_isRendezvousOrUnlimited__3mdufi(this)) {
      var tmp_1 = get_NULL_SEGMENT();
      tmp_0 = tmp_1 instanceof ChannelSegment ? tmp_1 : THROW_CCE();
    } else {
      tmp_0 = firstSegment;
    }
    tmp.q1n_1 = atomic$ref$1(tmp_0);
    var tmp_2 = this;
    var tmp_3;
    if (this.j1n_1 == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_3 = BufferedChannel$onUndeliveredElementReceiveCancellationConstructor$lambda(this);
    }
    tmp_2.r1n_1 = tmp_3;
    this.s1n_1 = atomic$ref$1(get_NO_CLOSE_CAUSE());
    this.t1n_1 = atomic$ref$1(null);
  }
  protoOf(BufferedChannel).m1o = function () {
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var this_0 = this.k1n_1.kotlinx$atomicfu$value;
    return bitwiseAnd(this_0, new Long(-1, 268435455));
  };
  protoOf(BufferedChannel).j1p = function () {
    return this.l1n_1.kotlinx$atomicfu$value;
  };
  protoOf(BufferedChannel).r1s = function (element, $completion) {
    var tmp = new $sendCOROUTINE$(this, element, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BufferedChannel).s1s = function (element) {
    if (shouldSendSuspend0(this, this.k1n_1.kotlinx$atomicfu$value))
      return Companion_getInstance_0().t1s();
    var tmp4 = get_INTERRUPTED_SEND();
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
      var segment = access$_get_sendSegment__111kgq(this).kotlinx$atomicfu$value;
      $l$loop_0: while (true) {
        var sendersAndCloseStatusCur = access$_get_sendersAndCloseStatus__tvw29s(this).atomicfu$getAndIncrement$long();
        // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
        var s = bitwiseAnd(sendersAndCloseStatusCur, new Long(-1, 268435455));
        var closed = access$_get_isClosedForSend0__sm8f7a(this, sendersAndCloseStatusCur);
        // Inline function 'kotlin.Long.div' call
        var other = get_SEGMENT_SIZE();
        var id = divide(s, fromInt(other));
        // Inline function 'kotlin.Long.rem' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$3 = modulo(s, fromInt(other_0));
        var i = convertToInt(tmp$ret$3);
        if (!equalsLong(segment.h1e_1, id)) {
          var tmp0_elvis_lhs = access$findSegmentSend(this, id, segment);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            var tmp_0;
            if (closed) {
              tmp$ret$0 = Companion_getInstance_0().t1p(this.i1p());
              break $l$block_5;
            } else {
              continue $l$loop_0;
            }
          } else {
            tmp = tmp0_elvis_lhs;
          }
          segment = tmp;
        }
        switch (access$updateCellSend(this, segment, i, element, s, tmp4, closed)) {
          case 0:
            segment.g1o();
            tmp$ret$0 = Companion_getInstance_0().o1p(Unit_instance);
            break $l$block_5;
          case 1:
            tmp$ret$0 = Companion_getInstance_0().o1p(Unit_instance);
            break $l$block_5;
          case 2:
            if (closed) {
              segment.w1n();
              tmp$ret$0 = Companion_getInstance_0().t1p(this.i1p());
              break $l$block_5;
            }

            var tmp2_safe_receiver = (!(tmp4 == null) ? isInterface(tmp4, Waiter) : false) ? tmp4 : null;
            if (tmp2_safe_receiver == null)
              null;
            else {
              access$prepareSenderForSuspension(this, tmp2_safe_receiver, segment, i);
            }

            segment.w1n();
            tmp$ret$0 = Companion_getInstance_0().t1s();
            break $l$block_5;
          case 4:
            if (compare(s, this.j1p()) < 0) {
              segment.g1o();
            }

            tmp$ret$0 = Companion_getInstance_0().t1p(this.i1p());
            break $l$block_5;
          case 5:
            segment.g1o();
            continue $l$loop_0;
          case 3:
            // Inline function 'kotlin.error' call

            var message = 'unexpected';
            throw IllegalStateException_init_$Create$(toString(message));
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(BufferedChannel).r1p = function () {
  };
  protoOf(BufferedChannel).k1p = function () {
  };
  protoOf(BufferedChannel).u1s = function ($completion) {
    var tmp = new $receiveCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BufferedChannel).v1s = function ($completion) {
    var tmp = new $receiveCatchingCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    var tmp_0 = tmp.v9();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  };
  protoOf(BufferedChannel).w1s = function () {
    var r = this.l1n_1.kotlinx$atomicfu$value;
    var sendersAndCloseStatusCur = this.k1n_1.kotlinx$atomicfu$value;
    if (_get_isClosedForReceive0__f7qknl(this, sendersAndCloseStatusCur)) {
      return Companion_getInstance_0().t1p(this.l1o());
    }
    // Inline function 'kotlinx.coroutines.channels.sendersCounter' call
    var s = bitwiseAnd(sendersAndCloseStatusCur, new Long(-1, 268435455));
    if (compare(r, s) >= 0)
      return Companion_getInstance_0().t1s();
    var tmp2 = get_INTERRUPTED_RCV();
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.receiveImpl' call
      var segment = this.p1n_1.kotlinx$atomicfu$value;
      $l$loop_0: while (true) {
        if (this.n1o()) {
          tmp$ret$1 = Companion_getInstance_0().t1p(this.l1o());
          break $l$block_0;
        }
        var r_0 = this.l1n_1.atomicfu$getAndIncrement$long();
        // Inline function 'kotlin.Long.div' call
        var other = get_SEGMENT_SIZE();
        var id = divide(r_0, fromInt(other));
        // Inline function 'kotlin.Long.rem' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$4 = modulo(r_0, fromInt(other_0));
        var i = convertToInt(tmp$ret$4);
        if (!equalsLong(segment.h1e_1, id)) {
          var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            continue $l$loop_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          segment = tmp;
        }
        var updCellResult = updateCellReceive(this, segment, i, r_0, tmp2);
        var tmp_0;
        if (updCellResult === get_SUSPEND()) {
          var tmp1_safe_receiver = (!(tmp2 == null) ? isInterface(tmp2, Waiter) : false) ? tmp2 : null;
          if (tmp1_safe_receiver == null)
            null;
          else {
            prepareReceiverForSuspension(this, tmp1_safe_receiver, segment, i);
          }
          var segm = segment;
          this.v1n(r_0);
          segm.w1n();
          tmp_0 = new ChannelResult(Companion_getInstance_0().t1s());
        } else if (updCellResult === get_FAILED()) {
          if (compare(r_0, this.m1o()) < 0) {
            segment.g1o();
          }
          continue $l$loop_0;
        } else if (updCellResult === get_SUSPEND_NO_WAITER()) {
          // Inline function 'kotlin.error' call
          var message = 'unexpected';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          segment.g1o();
          tmp_0 = new ChannelResult(Companion_getInstance_0().o1p(updCellResult));
        }
        tmp$ret$1 = tmp_0.s1p_1;
        break $l$block_0;
      }
    }
    return tmp$ret$1;
  };
  protoOf(BufferedChannel).g1q = function (globalCellIndex) {
    // Inline function 'kotlinx.coroutines.assert' call
    var segment = this.p1n_1.kotlinx$atomicfu$value;
    $l$loop_0: while (true) {
      var r = this.l1n_1.kotlinx$atomicfu$value;
      // Inline function 'kotlin.Long.plus' call
      var other = this.i1n_1;
      var tmp0 = add(r, fromInt(other));
      // Inline function 'kotlin.math.max' call
      var b = _get_bufferEndCounter__2d4hee(this);
      var tmp$ret$2 = compare(tmp0, b) >= 0 ? tmp0 : b;
      if (compare(globalCellIndex, tmp$ret$2) < 0)
        return Unit_instance;
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$3 = add(r, fromInt(1));
      if (!this.l1n_1.atomicfu$compareAndSet(r, tmp$ret$3))
        continue $l$loop_0;
      // Inline function 'kotlin.Long.div' call
      var other_0 = get_SEGMENT_SIZE();
      var id = divide(r, fromInt(other_0));
      // Inline function 'kotlin.Long.rem' call
      var other_1 = get_SEGMENT_SIZE();
      var tmp$ret$5 = modulo(r, fromInt(other_1));
      var i = convertToInt(tmp$ret$5);
      if (!equalsLong(segment.h1e_1, id)) {
        var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      var updCellResult = updateCellReceive(this, segment, i, r, null);
      if (updCellResult === get_FAILED()) {
        if (compare(r, this.m1o()) < 0) {
          segment.g1o();
        }
      } else {
        segment.g1o();
        var tmp1_safe_receiver = this.j1n_1;
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp1_safe_receiver, updCellResult);
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          throw tmp2_safe_receiver;
        }
      }
    }
  };
  protoOf(BufferedChannel).v1n = function (globalIndex) {
    if (_get_isRendezvousOrUnlimited__3mdufi(this))
      return Unit_instance;
    while (compare(_get_bufferEndCounter__2d4hee(this), globalIndex) <= 0) {
    }
    // Inline function 'kotlin.repeat' call
    var times = get_EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS();
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var b = _get_bufferEndCounter__2d4hee(this);
        // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
        var this_0 = this.n1n_1.kotlinx$atomicfu$value;
        var ebCompleted = bitwiseAnd(this_0, new Long(-1, 1073741823));
        if (equalsLong(b, ebCompleted) && equalsLong(b, _get_bufferEndCounter__2d4hee(this)))
          return Unit_instance;
      }
       while (inductionVariable < times);
    var tmp0 = this.n1n_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
        var tmp$ret$5 = bitwiseAnd(cur, new Long(-1, 1073741823));
        var upd = constructEBCompletedAndPauseFlag(tmp$ret$5, true);
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    while (true) {
      var b_0 = _get_bufferEndCounter__2d4hee(this);
      var ebCompletedAndBit = this.n1n_1.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
      var ebCompleted_0 = bitwiseAnd(ebCompletedAndBit, new Long(-1, 1073741823));
      // Inline function 'kotlinx.coroutines.channels.ebPauseExpandBuffers' call
      var pauseExpandBuffers = !equalsLong(bitwiseAnd(ebCompletedAndBit, new Long(0, 1073741824)), new Long(0, 0));
      if (equalsLong(b_0, ebCompleted_0) && equalsLong(b_0, _get_bufferEndCounter__2d4hee(this))) {
        var tmp0_0 = this.n1n_1;
        $l$block_0: {
          // Inline function 'kotlinx.atomicfu.update' call
          while (true) {
            var cur_0 = tmp0_0.kotlinx$atomicfu$value;
            // Inline function 'kotlinx.coroutines.channels.ebCompletedCounter' call
            var tmp$ret$10 = bitwiseAnd(cur_0, new Long(-1, 1073741823));
            var upd_0 = constructEBCompletedAndPauseFlag(tmp$ret$10, false);
            if (tmp0_0.atomicfu$compareAndSet(cur_0, upd_0)) {
              break $l$block_0;
            }
          }
        }
        return Unit_instance;
      }
      if (!pauseExpandBuffers) {
        this.n1n_1.atomicfu$compareAndSet(ebCompletedAndBit, constructEBCompletedAndPauseFlag(ebCompleted_0, true));
      }
    }
  };
  protoOf(BufferedChannel).x1s = function () {
    var tmp = BufferedChannel$registerSelectForReceive$ref();
    var tmp_0 = typeof tmp === 'function' ? tmp : THROW_CCE();
    var tmp_1 = BufferedChannel$processResultSelectReceiveCatching$ref();
    return new SelectClause1Impl(this, tmp_0, typeof tmp_1 === 'function' ? tmp_1 : THROW_CCE(), this.r1n_1);
  };
  protoOf(BufferedChannel).t = function () {
    return new BufferedChannelIterator(this);
  };
  protoOf(BufferedChannel).l1o = function () {
    var tmp = this.s1n_1.kotlinx$atomicfu$value;
    return (tmp == null ? true : tmp instanceof Error) ? tmp : THROW_CCE();
  };
  protoOf(BufferedChannel).i1p = function () {
    var tmp0_elvis_lhs = this.l1o();
    return tmp0_elvis_lhs == null ? new ClosedSendChannelException('Channel was closed') : tmp0_elvis_lhs;
  };
  protoOf(BufferedChannel).y1s = function () {
  };
  protoOf(BufferedChannel).z1s = function (cause) {
    return this.a1t(cause, false);
  };
  protoOf(BufferedChannel).a1b = function (cause) {
    this.c1t(cause);
  };
  protoOf(BufferedChannel).c1t = function (cause) {
    return this.a1t(cause == null ? CancellationException_init_$Create$('Channel was cancelled') : cause, true);
  };
  protoOf(BufferedChannel).a1t = function (cause, cancel) {
    if (cancel) {
      markCancellationStarted(this);
    }
    var closedByThisOperation = this.s1n_1.atomicfu$compareAndSet(get_NO_CLOSE_CAUSE(), cause);
    if (cancel) {
      markCancelled(this);
    } else {
      markClosed(this);
    }
    completeCloseOrCancel(this);
    // Inline function 'kotlin.also' call
    this.y1s();
    if (closedByThisOperation) {
      invokeCloseHandler(this);
    }
    return closedByThisOperation;
  };
  protoOf(BufferedChannel).h1q = function () {
    return false;
  };
  protoOf(BufferedChannel).f1q = function () {
    return _get_isClosedForSend0__kxgf9m(this, this.k1n_1.kotlinx$atomicfu$value);
  };
  protoOf(BufferedChannel).n1o = function () {
    return _get_isClosedForReceive0__f7qknl(this, this.k1n_1.kotlinx$atomicfu$value);
  };
  protoOf(BufferedChannel).i1q = function () {
    $l$loop: while (true) {
      var segment = this.p1n_1.kotlinx$atomicfu$value;
      var r = this.j1p();
      var s = this.m1o();
      if (compare(s, r) <= 0)
        return false;
      // Inline function 'kotlin.Long.div' call
      var other = get_SEGMENT_SIZE();
      var id = divide(r, fromInt(other));
      if (!equalsLong(segment.h1e_1, id)) {
        var tmp0_elvis_lhs = findSegmentReceive(this, id, segment);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp_0;
          if (compare(this.p1n_1.kotlinx$atomicfu$value.h1e_1, id) < 0) {
            return false;
          } else {
            continue $l$loop;
          }
        } else {
          tmp = tmp0_elvis_lhs;
        }
        segment = tmp;
      }
      segment.g1o();
      // Inline function 'kotlin.Long.rem' call
      var other_0 = get_SEGMENT_SIZE();
      var tmp$ret$1 = modulo(r, fromInt(other_0));
      var i = convertToInt(tmp$ret$1);
      if (isCellNonEmpty(this, segment, i, r))
        return true;
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$2 = add(r, fromInt(1));
      this.l1n_1.atomicfu$compareAndSet(r, tmp$ret$2);
    }
  };
  protoOf(BufferedChannel).toString = function () {
    var sb = StringBuilder_init_$Create$();
    // Inline function 'kotlinx.coroutines.channels.sendersCloseStatus' call
    var this_0 = this.k1n_1.kotlinx$atomicfu$value;
    var tmp0_subject = convertToInt(shiftRight(this_0, 60));
    if (tmp0_subject === 2) {
      sb.q('closed,');
    } else if (tmp0_subject === 3) {
      sb.q('cancelled,');
    }
    sb.q('capacity=' + this.i1n_1 + ',');
    sb.q('data=[');
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = listOf([this.p1n_1.kotlinx$atomicfu$value, this.o1n_1.kotlinx$atomicfu$value, this.q1n_1.kotlinx$atomicfu$value]);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (!(element === get_NULL_SEGMENT())) {
        destination.j1(element);
      }
    }
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlin.collections.minBy' call
      var iterator = destination.t();
      if (!iterator.u())
        throw NoSuchElementException_init_$Create$();
      var minElem = iterator.v();
      if (!iterator.u()) {
        tmp$ret$4 = minElem;
        break $l$block;
      }
      var minValue = minElem.h1e_1;
      do {
        var e = iterator.v();
        var v = e.h1e_1;
        if (compareTo(minValue, v) > 0) {
          minElem = e;
          minValue = v;
        }
      }
       while (iterator.u());
      tmp$ret$4 = minElem;
    }
    var firstSegment = tmp$ret$4;
    var r = this.j1p();
    var s = this.m1o();
    var segment = firstSegment;
    append_elements: while (true) {
      var inductionVariable = 0;
      var last_0 = get_SEGMENT_SIZE();
      if (inductionVariable < last_0)
        process_cell: do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0_0 = segment.h1e_1;
          // Inline function 'kotlin.Long.times' call
          var other = get_SEGMENT_SIZE();
          // Inline function 'kotlin.Long.plus' call
          var this_1 = multiply(tmp0_0, fromInt(other));
          var globalCellIndex = add(this_1, fromInt(i));
          if (compare(globalCellIndex, s) >= 0 && compare(globalCellIndex, r) >= 0)
            break append_elements;
          var cellState = segment.e1n(i);
          var element_0 = segment.b1n(i);
          var tmp;
          if (!(cellState == null) ? isInterface(cellState, CancellableContinuation) : false) {
            tmp = (compare(s, globalCellIndex) <= 0 ? compare(globalCellIndex, r) < 0 : false) ? 'receive' : (compare(r, globalCellIndex) <= 0 ? compare(globalCellIndex, s) < 0 : false) ? 'send' : 'cont';
          } else {
            if (!(cellState == null) ? isInterface(cellState, SelectInstance) : false) {
              tmp = (compare(s, globalCellIndex) <= 0 ? compare(globalCellIndex, r) < 0 : false) ? 'onReceive' : (compare(r, globalCellIndex) <= 0 ? compare(globalCellIndex, s) < 0 : false) ? 'onSend' : 'select';
            } else {
              if (cellState instanceof ReceiveCatching) {
                tmp = 'receiveCatching';
              } else {
                if (cellState instanceof SendBroadcast) {
                  tmp = 'sendBroadcast';
                } else {
                  if (cellState instanceof WaiterEB) {
                    tmp = 'EB(' + cellState.toString() + ')';
                  } else {
                    if (equals(cellState, get_RESUMING_BY_RCV()) || equals(cellState, get_RESUMING_BY_EB())) {
                      tmp = 'resuming_sender';
                    } else {
                      if (cellState == null || (equals(cellState, get_IN_BUFFER()) || equals(cellState, get_DONE_RCV())) || (equals(cellState, get_POISONED()) || equals(cellState, get_INTERRUPTED_RCV()) || (equals(cellState, get_INTERRUPTED_SEND()) || equals(cellState, get_CHANNEL_CLOSED())))) {
                        continue process_cell;
                      } else {
                        tmp = toString(cellState);
                      }
                    }
                  }
                }
              }
            }
          }
          var cellStateString = tmp;
          if (!(element_0 == null)) {
            sb.q('(' + cellStateString + ',' + toString(element_0) + '),');
          } else {
            sb.q(cellStateString + ',');
          }
        }
         while (inductionVariable < last_0);
      var tmp4_elvis_lhs = segment.c1o();
      var tmp_0;
      if (tmp4_elvis_lhs == null) {
        break append_elements;
      } else {
        tmp_0 = tmp4_elvis_lhs;
      }
      segment = tmp_0;
    }
    if (last(sb) === _Char___init__impl__6a9atx(44)) {
      sb.ld(sb.a() - 1 | 0);
    }
    sb.q(']');
    return sb.toString();
  };
  function WaiterEB(waiter) {
    this.l1p_1 = waiter;
  }
  protoOf(WaiterEB).toString = function () {
    return 'WaiterEB(' + toString(this.l1p_1) + ')';
  };
  function initialBufferEnd(capacity) {
    _init_properties_BufferedChannel_kt__d6uc4y();
    switch (capacity) {
      case 0:
        return new Long(0, 0);
      case 2147483647:
        return new Long(-1, 2147483647);
      default:
        return fromInt(capacity);
    }
  }
  function ReceiveCatching(cont) {
    this.p1p_1 = cont;
  }
  protoOf(ReceiveCatching).h1f = function (segment, index) {
    this.p1p_1.h1f(segment, index);
  };
  function tryResume0(_this__u8e3s4, value, onCancellation) {
    onCancellation = onCancellation === VOID ? null : onCancellation;
    _init_properties_BufferedChannel_kt__d6uc4y();
    // Inline function 'kotlin.let' call
    var token = _this__u8e3s4.b1d(value, null, onCancellation);
    var tmp;
    if (!(token == null)) {
      _this__u8e3s4.c1d(token);
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function constructEBCompletedAndPauseFlag(counter, pauseEB) {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return add(pauseEB ? new Long(0, 1073741824) : new Long(0, 0), counter);
  }
  function constructSendersAndCloseStatus(counter, closeStatus) {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return add(shiftLeft(fromInt(closeStatus), 60), counter);
  }
  function createSegmentFunction() {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return createSegment$ref();
  }
  function createSegment(id, prev) {
    _init_properties_BufferedChannel_kt__d6uc4y();
    return new ChannelSegment(id, prev, prev.y1m(), 0);
  }
  function createSegment$ref() {
    return constructCallableReference(function (p0, p1) {
      return createSegment(p0, p1);
    }, 2, 0, 5, 'createSegment');
  }
  var properties_initialized_BufferedChannel_kt_58tjvw;
  function _init_properties_BufferedChannel_kt__d6uc4y() {
    if (!properties_initialized_BufferedChannel_kt_58tjvw) {
      properties_initialized_BufferedChannel_kt_58tjvw = true;
      NULL_SEGMENT = new ChannelSegment(new Long(-1, -1), null, null, 0);
      SEGMENT_SIZE = systemProp('kotlinx.coroutines.bufferedChannel.segmentSize', 32);
      EXPAND_BUFFER_COMPLETION_WAIT_ITERATIONS = systemProp('kotlinx.coroutines.bufferedChannel.expandBufferCompletionWaitIterations', 10000);
      BUFFERED = new Symbol('BUFFERED');
      IN_BUFFER = new Symbol('SHOULD_BUFFER');
      RESUMING_BY_RCV = new Symbol('S_RESUMING_BY_RCV');
      RESUMING_BY_EB = new Symbol('RESUMING_BY_EB');
      POISONED = new Symbol('POISONED');
      DONE_RCV = new Symbol('DONE_RCV');
      INTERRUPTED_SEND = new Symbol('INTERRUPTED_SEND');
      INTERRUPTED_RCV = new Symbol('INTERRUPTED_RCV');
      CHANNEL_CLOSED = new Symbol('CHANNEL_CLOSED');
      SUSPEND = new Symbol('SUSPEND');
      SUSPEND_NO_WAITER = new Symbol('SUSPEND_NO_WAITER');
      FAILED = new Symbol('FAILED');
      NO_RECEIVE_RESULT = new Symbol('NO_RECEIVE_RESULT');
      CLOSE_HANDLER_CLOSED = new Symbol('CLOSE_HANDLER_CLOSED');
      CLOSE_HANDLER_INVOKED = new Symbol('CLOSE_HANDLER_INVOKED');
      NO_CLOSE_CAUSE = new Symbol('NO_CLOSE_CAUSE');
    }
  }
  function Factory() {
    Factory_instance = this;
    this.e1t_1 = 2147483647;
    this.f1t_1 = 0;
    this.g1t_1 = -1;
    this.h1t_1 = -2;
    this.i1t_1 = -3;
    this.j1t_1 = 'kotlinx.coroutines.channels.defaultBuffer';
    this.k1t_1 = systemProp('kotlinx.coroutines.channels.defaultBuffer', 64, 1, 2147483646);
  }
  var Factory_instance;
  function Factory_getInstance() {
    if (Factory_instance == null)
      new Factory();
    return Factory_instance;
  }
  function Channel(capacity, onBufferOverflow, onUndeliveredElement) {
    capacity = capacity === VOID ? 0 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
    var tmp;
    switch (capacity) {
      case 0:
        tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new BufferedChannel(0, onUndeliveredElement) : new ConflatedBufferedChannel(1, onBufferOverflow, onUndeliveredElement);
        break;
      case -1:
        // Inline function 'kotlin.require' call

        if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
          var message = 'CONFLATED capacity cannot be used with non-default onBufferOverflow';
          throw IllegalArgumentException_init_$Create$(toString(message));
        }

        tmp = new ConflatedBufferedChannel(1, BufferOverflow_DROP_OLDEST_getInstance(), onUndeliveredElement);
        break;
      case 2147483647:
        tmp = new BufferedChannel(2147483647, onUndeliveredElement);
        break;
      case -2:
        tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new BufferedChannel(Factory_getInstance().k1t_1, onUndeliveredElement) : new ConflatedBufferedChannel(1, onBufferOverflow, onUndeliveredElement);
        break;
      default:
        tmp = onBufferOverflow === BufferOverflow_SUSPEND_getInstance() ? new BufferedChannel(capacity, onUndeliveredElement) : new ConflatedBufferedChannel(capacity, onBufferOverflow, onUndeliveredElement);
        break;
    }
    return tmp;
  }
  function _ChannelResult___init__impl__siwsuf(holder) {
    return holder;
  }
  function _ChannelResult___get_holder__impl__pm9gzw($this) {
    return $this;
  }
  function _ChannelResult___get_isSuccess__impl__odq1z9($this) {
    var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
    return !(tmp instanceof Failed);
  }
  function _ChannelResult___get_isClosed__impl__mg7kuu($this) {
    var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
    return tmp instanceof Closed;
  }
  function ChannelResult__getOrNull_impl_f5e07h($this) {
    var tmp;
    var tmp_0 = _ChannelResult___get_holder__impl__pm9gzw($this);
    if (!(tmp_0 instanceof Failed)) {
      tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function ChannelResult__exceptionOrNull_impl_16ei30($this) {
    var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
    var tmp0_safe_receiver = tmp instanceof Closed ? tmp : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l1t_1;
  }
  function Failed() {
  }
  protoOf(Failed).toString = function () {
    return 'Failed';
  };
  function Closed(cause) {
    Failed.call(this);
    this.l1t_1 = cause;
  }
  protoOf(Closed).equals = function (other) {
    var tmp;
    if (other instanceof Closed) {
      tmp = equals(this.l1t_1, other.l1t_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Closed).hashCode = function () {
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.l1t_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(Closed).toString = function () {
    return 'Closed(' + toString_0(this.l1t_1) + ')';
  };
  function Companion() {
    Companion_instance_0 = this;
    this.n1p_1 = new Failed();
  }
  protoOf(Companion).o1p = function (value) {
    return _ChannelResult___init__impl__siwsuf(value);
  };
  protoOf(Companion).t1s = function () {
    return _ChannelResult___init__impl__siwsuf(this.n1p_1);
  };
  protoOf(Companion).t1p = function (cause) {
    return _ChannelResult___init__impl__siwsuf(new Closed(cause));
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion();
    return Companion_instance_0;
  }
  function ChannelResult__toString_impl_rrcqu7($this) {
    var tmp;
    if (_ChannelResult___get_holder__impl__pm9gzw($this) instanceof Closed) {
      tmp = _ChannelResult___get_holder__impl__pm9gzw($this).toString();
    } else {
      tmp = 'Value(' + toString_0(_ChannelResult___get_holder__impl__pm9gzw($this)) + ')';
    }
    return tmp;
  }
  function ChannelResult__hashCode_impl_lilec2($this) {
    return $this == null ? 0 : hashCode($this);
  }
  function ChannelResult__equals_impl_f471ri($this, other) {
    if (!(other instanceof ChannelResult))
      return false;
    var tmp0_other_with_cast = other.s1p_1;
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function ChannelResult(holder) {
    Companion_getInstance_0();
    this.s1p_1 = holder;
  }
  protoOf(ChannelResult).toString = function () {
    return ChannelResult__toString_impl_rrcqu7(this.s1p_1);
  };
  protoOf(ChannelResult).hashCode = function () {
    return ChannelResult__hashCode_impl_lilec2(this.s1p_1);
  };
  protoOf(ChannelResult).equals = function (other) {
    return ChannelResult__equals_impl_f471ri(this.s1p_1, other);
  };
  function SendChannel() {
  }
  function ReceiveChannel() {
  }
  function ClosedReceiveChannelException(message) {
    NoSuchElementException_init_$Init$(message, this);
    captureStack(this, ClosedReceiveChannelException);
  }
  function ClosedSendChannelException(message) {
    IllegalStateException_init_$Init$(message, this);
    captureStack(this, ClosedSendChannelException);
  }
  function ChannelCoroutine(parentContext, _channel, initParentJob, active) {
    AbstractCoroutine.call(this, parentContext, initParentJob, active);
    this.p1t_1 = _channel;
  }
  protoOf(ChannelCoroutine).a1b = function (cause) {
    if (this.n1a())
      return Unit_instance;
    var tmp;
    if (cause == null) {
      // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
      tmp = new JobCancellationException(null == null ? this.u19() : null, null, this);
    } else {
      tmp = cause;
    }
    this.c1b(tmp);
  };
  protoOf(ChannelCoroutine).d1t = function (cause, $super) {
    return this.b1b(cause, ($super == null ? true : $super instanceof ChannelCoroutine) ? $super : THROW_CCE());
  };
  protoOf(ChannelCoroutine).c1b = function (cause) {
    var exception = this.s1a(cause);
    this.p1t_1.a1b(exception);
    this.f1b(exception);
  };
  protoOf(ChannelCoroutine).f1q = function () {
    return this.p1t_1.f1q();
  };
  protoOf(ChannelCoroutine).r1s = function (element, $completion) {
    return this.p1t_1.r1s(element, $completion);
  };
  protoOf(ChannelCoroutine).s1s = function (element) {
    return this.p1t_1.s1s(element);
  };
  protoOf(ChannelCoroutine).z1s = function (cause) {
    return this.p1t_1.z1s(cause);
  };
  protoOf(ChannelCoroutine).u1s = function ($completion) {
    return this.p1t_1.u1s($completion);
  };
  protoOf(ChannelCoroutine).v1s = function ($completion) {
    var tmp = this.p1t_1.v1s($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      return tmp;
    return tmp;
  };
  protoOf(ChannelCoroutine).x1s = function () {
    return this.p1t_1.x1s();
  };
  protoOf(ChannelCoroutine).w1s = function () {
    return this.p1t_1.w1s();
  };
  protoOf(ChannelCoroutine).t = function () {
    return this.p1t_1.t();
  };
  function cancelConsumed(_this__u8e3s4, cause) {
    var tmp;
    if (cause == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_elvis_lhs = cause instanceof CancellationException ? cause : null;
      tmp = tmp0_elvis_lhs == null ? CancellationException_0('Channel was consumed, consumer had failed', cause) : tmp0_elvis_lhs;
    }
    _this__u8e3s4.a1b(tmp);
  }
  function trySendImpl($this, element, isSendOp) {
    return $this.d1u_1 === BufferOverflow_DROP_LATEST_getInstance() ? trySendDropLatest($this, element, isSendOp) : trySendDropOldest($this, element);
  }
  function trySendDropLatest($this, element, isSendOp) {
    var result = protoOf(BufferedChannel).s1s.call($this, element);
    if (_ChannelResult___get_isSuccess__impl__odq1z9(result) || _ChannelResult___get_isClosed__impl__mg7kuu(result))
      return result;
    if (isSendOp) {
      var tmp0_safe_receiver = $this.j1n_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        throw tmp1_safe_receiver;
      }
    }
    return Companion_getInstance_0().o1p(Unit_instance);
  }
  function trySendDropOldest($this, element) {
    var tmp4 = get_BUFFERED();
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.coroutines.channels.BufferedChannel.sendImpl' call
      var segment = access$_get_sendSegment__111kgq($this).kotlinx$atomicfu$value;
      $l$loop_0: while (true) {
        var sendersAndCloseStatusCur = access$_get_sendersAndCloseStatus__tvw29s($this).atomicfu$getAndIncrement$long();
        var s = bitwiseAnd(sendersAndCloseStatusCur, new Long(-1, 268435455));
        var closed = access$_get_isClosedForSend0__sm8f7a($this, sendersAndCloseStatusCur);
        // Inline function 'kotlin.Long.div' call
        var other = get_SEGMENT_SIZE();
        var id = divide(s, fromInt(other));
        // Inline function 'kotlin.Long.rem' call
        var other_0 = get_SEGMENT_SIZE();
        var tmp$ret$3 = modulo(s, fromInt(other_0));
        var i = convertToInt(tmp$ret$3);
        if (!equalsLong(segment.h1e_1, id)) {
          var tmp0_elvis_lhs = access$findSegmentSend($this, id, segment);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            var tmp_0;
            if (closed) {
              return Companion_getInstance_0().t1p($this.i1p());
            } else {
              continue $l$loop_0;
            }
          } else {
            tmp = tmp0_elvis_lhs;
          }
          segment = tmp;
        }
        switch (access$updateCellSend($this, segment, i, element, s, tmp4, closed)) {
          case 0:
            segment.g1o();
            return Companion_getInstance_0().o1p(Unit_instance);
          case 1:
            return Companion_getInstance_0().o1p(Unit_instance);
          case 2:
            if (closed) {
              segment.w1n();
              return Companion_getInstance_0().t1p($this.i1p());
            }

            var tmp2_safe_receiver = (!(tmp4 == null) ? isInterface(tmp4, Waiter) : false) ? tmp4 : null;
            if (tmp2_safe_receiver == null)
              null;
            else {
              access$prepareSenderForSuspension($this, tmp2_safe_receiver, segment, i);
            }

            var tmp0 = segment.h1e_1;
            // Inline function 'kotlin.Long.times' call

            var other_1 = get_SEGMENT_SIZE();
            // Inline function 'kotlin.Long.plus' call

            var this_0 = multiply(tmp0, fromInt(other_1));
            var tmp$ret$10 = add(this_0, fromInt(i));
            $this.g1q(tmp$ret$10);
            return Companion_getInstance_0().o1p(Unit_instance);
          case 4:
            if (compare(s, $this.j1p()) < 0) {
              segment.g1o();
            }

            return Companion_getInstance_0().t1p($this.i1p());
          case 5:
            segment.g1o();
            continue $l$loop_0;
          case 3:
            // Inline function 'kotlin.error' call

            var message = 'unexpected';
            throw IllegalStateException_init_$Create$(toString(message));
        }
      }
    }
    return tmp$ret$0;
  }
  function ConflatedBufferedChannel(capacity, onBufferOverflow, onUndeliveredElement) {
    onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
    BufferedChannel.call(this, capacity, onUndeliveredElement);
    this.c1u_1 = capacity;
    this.d1u_1 = onBufferOverflow;
    // Inline function 'kotlin.require' call
    if (!!(this.d1u_1 === BufferOverflow_SUSPEND_getInstance())) {
      var message = 'This implementation does not support suspension for senders, use ' + getKClass(BufferedChannel).o() + ' instead';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!(this.c1u_1 >= 1)) {
      var message_0 = 'Buffered channel capacity must be at least 1, but ' + this.c1u_1 + ' was specified';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
  }
  protoOf(ConflatedBufferedChannel).h1q = function () {
    return this.d1u_1.equals(BufferOverflow_DROP_OLDEST_getInstance());
  };
  protoOf(ConflatedBufferedChannel).r1s = function (element, $completion) {
    // Inline function 'kotlinx.coroutines.channels.onClosed' call
    var this_0 = trySendImpl(this, element, true);
    var tmp = _ChannelResult___get_holder__impl__pm9gzw(this_0);
    if (tmp instanceof Closed) {
      ChannelResult__exceptionOrNull_impl_16ei30(this_0);
      var tmp0_safe_receiver = this.j1n_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : callUndeliveredElementCatchingException(tmp0_safe_receiver, element);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        addSuppressed(tmp1_safe_receiver, this.i1p());
        throw tmp1_safe_receiver;
      }
      throw this.i1p();
    }
    return Unit_instance;
  };
  protoOf(ConflatedBufferedChannel).s1s = function (element) {
    return trySendImpl(this, element, false);
  };
  function produce(_this__u8e3s4, context, capacity, block) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    capacity = capacity === VOID ? 0 : capacity;
    return produce_0(_this__u8e3s4, context, capacity, BufferOverflow_SUSPEND_getInstance(), CoroutineStart_DEFAULT_getInstance(), null, block);
  }
  function ProducerScope() {
  }
  function produce_0(_this__u8e3s4, context, capacity, onBufferOverflow, start, onCompletion, block) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    capacity = capacity === VOID ? 0 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    start = start === VOID ? CoroutineStart_DEFAULT_getInstance() : start;
    onCompletion = onCompletion === VOID ? null : onCompletion;
    var channel = Channel(capacity, onBufferOverflow);
    var newContext = newCoroutineContext(_this__u8e3s4, context);
    var coroutine = new ProducerCoroutine(newContext, channel);
    if (!(onCompletion == null)) {
      coroutine.t1a(onCompletion);
    }
    coroutine.e1a(start, coroutine, block);
    return coroutine;
  }
  function ProducerCoroutine(parentContext, channel) {
    ChannelCoroutine.call(this, parentContext, channel, true, true);
  }
  protoOf(ProducerCoroutine).r19 = function () {
    return protoOf(ChannelCoroutine).r19.call(this);
  };
  protoOf(ProducerCoroutine).i1u = function (value) {
    this.p1t_1.b1t();
  };
  protoOf(ProducerCoroutine).s19 = function (value) {
    return this.i1u(value instanceof Unit ? value : THROW_CCE());
  };
  protoOf(ProducerCoroutine).t19 = function (cause, handled) {
    var processed = this.p1t_1.z1s(cause);
    if (!processed && !handled) {
      handleCoroutineException(this.p19_1, cause);
    }
  };
  protoOf(ProducerCoroutine).d1t = function (cause, $super) {
    return this.b1b(cause, ($super == null ? true : $super instanceof ProducerCoroutine) ? $super : THROW_CCE());
  };
  function flow(block) {
    return new SafeFlow(block);
  }
  function asFlow(_this__u8e3s4) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new asFlow$$inlined$unsafeFlow$1(_this__u8e3s4);
  }
  function SafeFlow(block) {
    AbstractFlow.call(this);
    this.j1u_1 = block;
  }
  protoOf(SafeFlow).k1u = function (collector, $completion) {
    return this.j1u_1(collector, $completion);
  };
  function emptyFlow() {
    return EmptyFlow_instance;
  }
  function flowOf(value) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new flowOf$$inlined$unsafeFlow$1(value);
  }
  function EmptyFlow() {
  }
  protoOf(EmptyFlow).m1u = function (collector, $completion) {
    return Unit_instance;
  };
  protoOf(EmptyFlow).l1u = function (collector, $completion) {
    return this.m1u(collector, $completion);
  };
  var EmptyFlow_instance;
  function EmptyFlow_getInstance() {
    return EmptyFlow_instance;
  }
  function $collectCOROUTINE$(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v1u_1 = _this__u8e3s4;
    this.w1u_1 = collector;
  }
  protoOf($collectCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.x1u_1 = this.w1u_1;
            this.y1u_1 = this.v1u_1.z1u_1.t();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!this.y1u_1.u()) {
              this.n9_1 = 3;
              continue $sm;
            }

            var element = this.y1u_1.v();
            this.n9_1 = 2;
            suspendResult = this.x1u_1.a1v(element, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function asFlow$$inlined$unsafeFlow$1($this_asFlow) {
    this.z1u_1 = $this_asFlow;
  }
  protoOf(asFlow$$inlined$unsafeFlow$1).b1v = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(asFlow$$inlined$unsafeFlow$1).l1u = function (collector, $completion) {
    return this.b1v(collector, $completion);
  };
  function $collectCOROUTINE$_0(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k1v_1 = _this__u8e3s4;
    this.l1v_1 = collector;
  }
  protoOf($collectCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var $this$flow = this.l1v_1;
            this.n9_1 = 1;
            suspendResult = $this$flow.a1v(this.k1v_1.m1v_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function flowOf$$inlined$unsafeFlow$1($value) {
    this.m1v_1 = $value;
  }
  protoOf(flowOf$$inlined$unsafeFlow$1).b1v = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_0(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(flowOf$$inlined$unsafeFlow$1).l1u = function (collector, $completion) {
    return this.b1v(collector, $completion);
  };
  function emitAll(_this__u8e3s4, channel, $completion) {
    return emitAllImpl(_this__u8e3s4, channel, true, $completion);
  }
  function emitAllImpl(_this__u8e3s4, channel, consume, $completion) {
    var tmp = new $emitAllImplCOROUTINE$(_this__u8e3s4, channel, consume, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function receiveAsFlow(_this__u8e3s4) {
    return new ChannelAsFlow(_this__u8e3s4, false);
  }
  function markConsumed($this) {
    if ($this.e1w_1) {
      // Inline function 'kotlin.check' call
      if (!!$this.f1w_1.atomicfu$getAndSet(true)) {
        var message = 'ReceiveChannel.consumeAsFlow can be collected just once';
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
  }
  function $collectCOROUTINE$_1(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o1w_1 = _this__u8e3s4;
    this.p1w_1 = collector;
  }
  protoOf($collectCOROUTINE$_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            if (this.o1w_1.r1w_1 === -3) {
              markConsumed(this.o1w_1);
              this.n9_1 = 2;
              suspendResult = emitAllImpl(this.p1w_1, this.o1w_1.d1w_1, this.o1w_1.e1w_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = protoOf(ChannelFlow).l1u.call(this.o1w_1, this.p1w_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function ChannelAsFlow(channel, consume, context, capacity, onBufferOverflow) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    capacity = capacity === VOID ? -3 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    ChannelFlow.call(this, context, capacity, onBufferOverflow);
    this.d1w_1 = channel;
    this.e1w_1 = consume;
    this.f1w_1 = atomic$boolean$1(false);
  }
  protoOf(ChannelAsFlow).t1w = function (context, capacity, onBufferOverflow) {
    return new ChannelAsFlow(this.d1w_1, this.e1w_1, context, capacity, onBufferOverflow);
  };
  protoOf(ChannelAsFlow).u1w = function () {
    return new ChannelAsFlow(this.d1w_1, this.e1w_1);
  };
  protoOf(ChannelAsFlow).v1w = function (scope, $completion) {
    return emitAllImpl(new SendingCollector(scope), this.d1w_1, this.e1w_1, $completion);
  };
  protoOf(ChannelAsFlow).w1w = function (scope) {
    markConsumed(this);
    var tmp;
    if (this.r1w_1 === -3) {
      tmp = this.d1w_1;
    } else {
      tmp = protoOf(ChannelFlow).w1w.call(this, scope);
    }
    return tmp;
  };
  protoOf(ChannelAsFlow).l1u = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_1(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ChannelAsFlow).x1w = function () {
    return 'channel=' + toString(this.d1w_1);
  };
  function $emitAllImplCOROUTINE$(_this__u8e3s4, channel, consume, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v1v_1 = _this__u8e3s4;
    this.w1v_1 = channel;
    this.x1v_1 = consume;
  }
  protoOf($emitAllImplCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            ensureActive_1(this.v1v_1);
            this.y1v_1 = null;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 7;
            this.o9_1 = 6;
            this.z1v_1 = this.w1v_1.t();
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.z1v_1.d1q(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            if (!suspendResult) {
              this.n9_1 = 5;
              continue $sm;
            }

            var element = this.z1v_1.v();
            this.n9_1 = 4;
            suspendResult = this.v1v_1.a1v(element, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.n9_1 = 2;
            continue $sm;
          case 5:
            this.o9_1 = 9;
            this.n9_1 = 8;
            continue $sm;
          case 6:
            this.o9_1 = 7;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var e = this.q9_1;
              this.y1v_1 = e;
              throw e;
            } else {
              throw this.q9_1;
            }

          case 7:
            this.o9_1 = 9;
            var t = this.q9_1;
            if (this.x1v_1) {
              cancelConsumed(this.w1v_1, this.y1v_1);
            }

            throw t;
          case 8:
            this.o9_1 = 9;
            if (this.x1v_1) {
              cancelConsumed(this.w1v_1, this.y1v_1);
            }

            return Unit_instance;
          case 9:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 9) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function Flow() {
  }
  function $collectCOROUTINE$_2(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k1x_1 = _this__u8e3s4;
    this.l1x_1 = collector;
  }
  protoOf($collectCOROUTINE$_2).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var tmp_0 = this;
            tmp_0.m1x_1 = new SafeCollector(this.l1x_1, this.t9());
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.n9_1 = 2;
            suspendResult = this.k1x_1.k1u(this.m1x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 5;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 5;
            this.m1x_1.x9();
            return Unit_instance;
          case 4:
            this.o9_1 = 5;
            var t = this.q9_1;
            this.m1x_1.x9();
            throw t;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function AbstractFlow() {
  }
  protoOf(AbstractFlow).l1u = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_2(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function FlowCollector() {
  }
  function get_NO_VALUE() {
    _init_properties_SharedFlow_kt__umasnn();
    return NO_VALUE;
  }
  var NO_VALUE;
  function MutableSharedFlow(replay, extraBufferCapacity, onBufferOverflow) {
    replay = replay === VOID ? 0 : replay;
    extraBufferCapacity = extraBufferCapacity === VOID ? 0 : extraBufferCapacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    _init_properties_SharedFlow_kt__umasnn();
    // Inline function 'kotlin.require' call
    if (!(replay >= 0)) {
      var message = 'replay cannot be negative, but was ' + replay;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!(extraBufferCapacity >= 0)) {
      var message_0 = 'extraBufferCapacity cannot be negative, but was ' + extraBufferCapacity;
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    // Inline function 'kotlin.require' call
    if (!(replay > 0 || extraBufferCapacity > 0 || onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()))) {
      var message_1 = 'replay or extraBufferCapacity must be positive with non-default onBufferOverflow strategy ' + onBufferOverflow.toString();
      throw IllegalArgumentException_init_$Create$(toString(message_1));
    }
    var bufferCapacity0 = replay + extraBufferCapacity | 0;
    var bufferCapacity = bufferCapacity0 < 0 ? 2147483647 : bufferCapacity0;
    return new SharedFlowImpl(replay, bufferCapacity, onBufferOverflow);
  }
  function _get_head__d7jo8b($this) {
    var tmp0 = $this.a1y_1;
    // Inline function 'kotlin.comparisons.minOf' call
    var b = $this.z1x_1;
    return compare(tmp0, b) <= 0 ? tmp0 : b;
  }
  function _get_replaySize__dxgnb1($this) {
    var tmp0 = _get_head__d7jo8b($this);
    // Inline function 'kotlin.Long.plus' call
    var other = $this.b1y_1;
    var tmp$ret$0 = add(tmp0, fromInt(other));
    return convertToInt(subtract(tmp$ret$0, $this.z1x_1));
  }
  function _get_totalSize__xhdb3o($this) {
    return $this.b1y_1 + $this.c1y_1 | 0;
  }
  function _get_bufferEndIndex__d2rk18($this) {
    var tmp0 = _get_head__d7jo8b($this);
    // Inline function 'kotlin.Long.plus' call
    var other = $this.b1y_1;
    return add(tmp0, fromInt(other));
  }
  function _get_queueEndIndex__4m025l($this) {
    var tmp0 = _get_head__d7jo8b($this);
    // Inline function 'kotlin.Long.plus' call
    var other = $this.b1y_1;
    var tmp0_0 = add(tmp0, fromInt(other));
    // Inline function 'kotlin.Long.plus' call
    var other_0 = $this.c1y_1;
    return add(tmp0_0, fromInt(other_0));
  }
  function tryEmitLocked($this, value) {
    if ($this.e1y_1 === 0)
      return tryEmitNoCollectorsLocked($this, value);
    if ($this.b1y_1 >= $this.w1x_1 && compare($this.a1y_1, $this.z1x_1) <= 0) {
      switch ($this.x1x_1.a1_1) {
        case 0:
          return false;
        case 2:
          return true;
        case 1:
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    }
    enqueueLocked($this, value);
    $this.b1y_1 = $this.b1y_1 + 1 | 0;
    if ($this.b1y_1 > $this.w1x_1) {
      dropOldestLocked($this);
    }
    if (_get_replaySize__dxgnb1($this) > $this.v1x_1) {
      // Inline function 'kotlin.Long.plus' call
      var this_0 = $this.z1x_1;
      var tmp$ret$0 = add(this_0, fromInt(1));
      updateBufferLocked($this, tmp$ret$0, $this.a1y_1, _get_bufferEndIndex__d2rk18($this), _get_queueEndIndex__4m025l($this));
    }
    return true;
  }
  function tryEmitNoCollectorsLocked($this, value) {
    // Inline function 'kotlinx.coroutines.assert' call
    if ($this.v1x_1 === 0)
      return true;
    enqueueLocked($this, value);
    $this.b1y_1 = $this.b1y_1 + 1 | 0;
    if ($this.b1y_1 > $this.v1x_1) {
      dropOldestLocked($this);
    }
    var tmp = $this;
    var tmp0 = _get_head__d7jo8b($this);
    // Inline function 'kotlin.Long.plus' call
    var other = $this.b1y_1;
    tmp.a1y_1 = add(tmp0, fromInt(other));
    return true;
  }
  function dropOldestLocked($this) {
    setBufferAt(ensureNotNull($this.y1x_1), _get_head__d7jo8b($this), null);
    $this.b1y_1 = $this.b1y_1 - 1 | 0;
    // Inline function 'kotlin.Long.plus' call
    var this_0 = _get_head__d7jo8b($this);
    var newHead = add(this_0, fromInt(1));
    if (compare($this.z1x_1, newHead) < 0)
      $this.z1x_1 = newHead;
    if (compare($this.a1y_1, newHead) < 0) {
      correctCollectorIndexesOnDropOldest($this, newHead);
    }
    // Inline function 'kotlinx.coroutines.assert' call
  }
  function correctCollectorIndexesOnDropOldest($this, newHead) {
    $l$block: {
      // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.forEachSlotLocked' call
      if ($this.e1y_1 === 0) {
        break $l$block;
      }
      var tmp0_safe_receiver = $this.d1y_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          if (!(element == null)) {
            var containsArg = element.h1y_1;
            if (compare(new Long(0, 0), containsArg) <= 0 ? compare(containsArg, newHead) < 0 : false) {
              element.h1y_1 = newHead;
            }
          }
        }
      }
    }
    $this.a1y_1 = newHead;
  }
  function enqueueLocked($this, item) {
    var curSize = _get_totalSize__xhdb3o($this);
    var curBuffer = $this.y1x_1;
    var buffer = curBuffer == null ? growBuffer($this, null, 0, 2) : curSize >= curBuffer.length ? growBuffer($this, curBuffer, curSize, imul(curBuffer.length, 2)) : curBuffer;
    // Inline function 'kotlin.Long.plus' call
    var this_0 = _get_head__d7jo8b($this);
    var tmp$ret$0 = add(this_0, fromInt(curSize));
    setBufferAt(buffer, tmp$ret$0, item);
  }
  function growBuffer($this, curBuffer, curSize, newSize) {
    // Inline function 'kotlin.check' call
    if (!(newSize > 0)) {
      var message = 'Buffer size overflow';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.also' call
    var this_0 = Array(newSize);
    $this.y1x_1 = this_0;
    var newBuffer = this_0;
    if (curBuffer == null)
      return newBuffer;
    var head = _get_head__d7jo8b($this);
    var inductionVariable = 0;
    if (inductionVariable < curSize)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.Long.plus' call
        var tmp = add(head, fromInt(i));
        // Inline function 'kotlin.Long.plus' call
        var tmp$ret$6 = add(head, fromInt(i));
        setBufferAt(newBuffer, tmp, getBufferAt(curBuffer, tmp$ret$6));
      }
       while (inductionVariable < curSize);
    return newBuffer;
  }
  function emitSuspend($this, value, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.v1e();
    var resumes = get_EMPTY_RESUMES();
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    var tmp$ret$4;
    $l$block: {
      if (tryEmitLocked($this, value)) {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$6 = _Result___init__impl__xyqfz8(Unit_instance);
        cancellable.y9(tmp$ret$6);
        resumes = findSlotsToResumeLocked($this, resumes);
        tmp$ret$4 = null;
        break $l$block;
      }
      var tmp0 = _get_head__d7jo8b($this);
      // Inline function 'kotlin.Long.plus' call
      var other = _get_totalSize__xhdb3o($this);
      var tmp$ret$7 = add(tmp0, fromInt(other));
      // Inline function 'kotlin.also' call
      var this_0 = new Emitter($this, tmp$ret$7, value, cancellable);
      enqueueLocked($this, this_0);
      $this.c1y_1 = $this.c1y_1 + 1 | 0;
      if ($this.w1x_1 === 0)
        resumes = findSlotsToResumeLocked($this, resumes);
      tmp$ret$4 = this_0;
    }
    var emitter = tmp$ret$4;
    if (emitter == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      disposeOnCancellation(cancellable, emitter);
    }
    var indexedObject = resumes;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var r = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (r == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$13 = _Result___init__impl__xyqfz8(Unit_instance);
        r.y9(tmp$ret$13);
      }
    }
    return cancellable.x1b();
  }
  function cancelEmitter($this, emitter) {
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    $l$block_0: {
      if (compare(emitter.k1y_1, _get_head__d7jo8b($this)) < 0) {
        break $l$block_0;
      }
      var buffer = ensureNotNull($this.y1x_1);
      if (!(getBufferAt(buffer, emitter.k1y_1) === emitter)) {
        break $l$block_0;
      }
      setBufferAt(buffer, emitter.k1y_1, get_NO_VALUE());
      cleanupTailLocked($this);
    }
    return Unit_instance;
  }
  function updateBufferLocked($this, newReplayIndex, newMinCollectorIndex, newBufferEndIndex, newQueueEndIndex) {
    // Inline function 'kotlin.comparisons.minOf' call
    var newHead = compare(newMinCollectorIndex, newReplayIndex) <= 0 ? newMinCollectorIndex : newReplayIndex;
    // Inline function 'kotlinx.coroutines.assert' call
    var inductionVariable = _get_head__d7jo8b($this);
    if (compare(inductionVariable, newHead) < 0)
      do {
        var index = inductionVariable;
        inductionVariable = add(inductionVariable, new Long(1, 0));
        setBufferAt(ensureNotNull($this.y1x_1), index, null);
      }
       while (compare(inductionVariable, newHead) < 0);
    $this.z1x_1 = newReplayIndex;
    $this.a1y_1 = newMinCollectorIndex;
    $this.b1y_1 = convertToInt(subtract(newBufferEndIndex, newHead));
    $this.c1y_1 = convertToInt(subtract(newQueueEndIndex, newBufferEndIndex));
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
  }
  function cleanupTailLocked($this) {
    if ($this.w1x_1 === 0 && $this.c1y_1 <= 1)
      return Unit_instance;
    var buffer = ensureNotNull($this.y1x_1);
    $l$loop: while (true) {
      var tmp;
      if ($this.c1y_1 > 0) {
        var tmp0 = _get_head__d7jo8b($this);
        // Inline function 'kotlin.Long.plus' call
        var other = _get_totalSize__xhdb3o($this);
        // Inline function 'kotlin.Long.minus' call
        var this_0 = add(tmp0, fromInt(other));
        var tmp$ret$1 = subtract(this_0, fromInt(1));
        tmp = getBufferAt(buffer, tmp$ret$1) === get_NO_VALUE();
      } else {
        tmp = false;
      }
      if (!tmp) {
        break $l$loop;
      }
      $this.c1y_1 = $this.c1y_1 - 1 | 0;
      var tmp0_0 = _get_head__d7jo8b($this);
      // Inline function 'kotlin.Long.plus' call
      var other_0 = _get_totalSize__xhdb3o($this);
      var tmp$ret$2 = add(tmp0_0, fromInt(other_0));
      setBufferAt(buffer, tmp$ret$2, null);
    }
  }
  function tryTakeValue($this, slot) {
    var resumes = get_EMPTY_RESUMES();
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    var index = tryPeekLocked($this, slot);
    var tmp;
    if (compare(index, new Long(0, 0)) < 0) {
      tmp = get_NO_VALUE();
    } else {
      var oldIndex = slot.h1y_1;
      var newValue = getPeekedValueLockedAt($this, index);
      var tmp_0 = slot;
      // Inline function 'kotlin.Long.plus' call
      tmp_0.h1y_1 = add(index, fromInt(1));
      resumes = $this.n1y(oldIndex);
      tmp = newValue;
    }
    var value = tmp;
    var indexedObject = resumes;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var resume = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (resume == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
        resume.y9(tmp$ret$5);
      }
    }
    return value;
  }
  function tryPeekLocked($this, slot) {
    var index = slot.h1y_1;
    if (compare(index, _get_bufferEndIndex__d2rk18($this)) < 0)
      return index;
    if ($this.w1x_1 > 0)
      return new Long(-1, -1);
    if (compare(index, _get_head__d7jo8b($this)) > 0)
      return new Long(-1, -1);
    if ($this.c1y_1 === 0)
      return new Long(-1, -1);
    return index;
  }
  function getPeekedValueLockedAt($this, index) {
    var item = getBufferAt(ensureNotNull($this.y1x_1), index);
    var tmp;
    if (item instanceof Emitter) {
      tmp = item.l1y_1;
    } else {
      tmp = item;
    }
    return tmp;
  }
  function awaitValue($this, slot, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.v1e();
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    $l$block: {
      var index = tryPeekLocked($this, slot);
      if (compare(index, new Long(0, 0)) < 0) {
        slot.i1y_1 = cancellable;
      } else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$6 = _Result___init__impl__xyqfz8(Unit_instance);
        cancellable.y9(tmp$ret$6);
        break $l$block;
      }
      slot.i1y_1 = cancellable;
    }
    return cancellable.x1b();
  }
  function findSlotsToResumeLocked($this, resumesIn) {
    var resumes = resumesIn;
    var resumeCount = resumesIn.length;
    $l$block: {
      // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.forEachSlotLocked' call
      if ($this.e1y_1 === 0) {
        break $l$block;
      }
      var tmp0_safe_receiver = $this.d1y_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          if (!(element == null)) {
            $l$block_1: {
              var tmp0_elvis_lhs = element.i1y_1;
              var tmp;
              if (tmp0_elvis_lhs == null) {
                break $l$block_1;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              var cont = tmp;
              if (compare(tryPeekLocked($this, element), new Long(0, 0)) < 0) {
                break $l$block_1;
              }
              if (resumeCount >= resumes.length) {
                var tmp_0 = resumes;
                // Inline function 'kotlin.comparisons.maxOf' call
                var b = imul(2, resumes.length);
                var tmp$ret$4 = Math.max(2, b);
                resumes = copyOf(tmp_0, tmp$ret$4);
              }
              var tmp_1 = resumes;
              var _unary__edvuaz = resumeCount;
              resumeCount = _unary__edvuaz + 1 | 0;
              tmp_1[_unary__edvuaz] = cont;
              element.i1y_1 = null;
            }
          }
        }
      }
    }
    return resumes;
  }
  function Emitter(flow, index, value, cont) {
    this.j1y_1 = flow;
    this.k1y_1 = index;
    this.l1y_1 = value;
    this.m1y_1 = cont;
  }
  protoOf(Emitter).s1d = function () {
    return cancelEmitter(this.j1y_1, this);
  };
  function $collectCOROUTINE$_3(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w1y_1 = _this__u8e3s4;
    this.x1y_1 = collector;
  }
  protoOf($collectCOROUTINE$_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 13;
            this.y1y_1 = this.w1y_1.b1z();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 12;
            var tmp_0 = this.x1y_1;
            if (tmp_0 instanceof SubscribedFlowCollector) {
              this.n9_1 = 2;
              suspendResult = this.x1y_1.e1z(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            var tmp_1 = this;
            tmp_1.a1z_1 = this.t9().aa(Key_instance_3);
            this.n9_1 = 4;
            continue $sm;
          case 4:
            if (!true) {
              this.n9_1 = 10;
              continue $sm;
            }

            this.n9_1 = 5;
            continue $sm;
          case 5:
            if (!true) {
              this.n9_1 = 8;
              continue $sm;
            }

            this.z1y_1 = tryTakeValue(this.w1y_1, this.y1y_1);
            if (!(this.z1y_1 === get_NO_VALUE())) {
              this.n9_1 = 8;
              continue $sm;
            } else {
              this.n9_1 = 6;
              continue $sm;
            }

          case 6:
            this.n9_1 = 7;
            suspendResult = awaitValue(this.w1y_1, this.y1y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.n9_1 = 5;
            continue $sm;
          case 8:
            var tmp0_safe_receiver = this.a1z_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              ensureActive_0(tmp0_safe_receiver);
            }

            this.n9_1 = 9;
            suspendResult = this.x1y_1.a1v(this.z1y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            this.n9_1 = 4;
            continue $sm;
          case 10:
            this.o9_1 = 13;
            this.n9_1 = 11;
            continue $sm;
          case 11:
            this.o9_1 = 13;
            this.w1y_1.f1z(this.y1y_1);
            return Unit_instance;
          case 12:
            this.o9_1 = 13;
            var t = this.q9_1;
            this.w1y_1.f1z(this.y1y_1);
            throw t;
          case 13:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 13) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function SharedFlowImpl(replay, bufferCapacity, onBufferOverflow) {
    AbstractSharedFlow.call(this);
    this.v1x_1 = replay;
    this.w1x_1 = bufferCapacity;
    this.x1x_1 = onBufferOverflow;
    this.y1x_1 = null;
    this.z1x_1 = new Long(0, 0);
    this.a1y_1 = new Long(0, 0);
    this.b1y_1 = 0;
    this.c1y_1 = 0;
  }
  protoOf(SharedFlowImpl).g1z = function () {
    var tmp = ensureNotNull(this.y1x_1);
    var tmp0 = this.z1x_1;
    // Inline function 'kotlin.Long.plus' call
    var other = _get_replaySize__dxgnb1(this);
    // Inline function 'kotlin.Long.minus' call
    var this_0 = add(tmp0, fromInt(other));
    var tmp$ret$1 = subtract(this_0, fromInt(1));
    return getBufferAt(tmp, tmp$ret$1);
  };
  protoOf(SharedFlowImpl).h1z = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_3(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SharedFlowImpl).l1u = function (collector, $completion) {
    return this.h1z(collector, $completion);
  };
  protoOf(SharedFlowImpl).i1z = function (value) {
    var resumes = get_EMPTY_RESUMES();
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    var tmp;
    if (tryEmitLocked(this, value)) {
      resumes = findSlotsToResumeLocked(this, resumes);
      tmp = true;
    } else {
      tmp = false;
    }
    var emitted = tmp;
    var indexedObject = resumes;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var cont = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (cont == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$4 = _Result___init__impl__xyqfz8(Unit_instance);
        cont.y9(tmp$ret$4);
      }
    }
    return emitted;
  };
  protoOf(SharedFlowImpl).a1v = function (value, $completion) {
    if (this.i1z(value))
      return Unit_instance;
    return emitSuspend(this, value, $completion);
  };
  protoOf(SharedFlowImpl).j1z = function () {
    var index = this.z1x_1;
    if (compare(index, this.a1y_1) < 0)
      this.a1y_1 = index;
    return index;
  };
  protoOf(SharedFlowImpl).n1y = function (oldIndex) {
    // Inline function 'kotlinx.coroutines.assert' call
    if (compare(oldIndex, this.a1y_1) > 0)
      return get_EMPTY_RESUMES();
    var head = _get_head__d7jo8b(this);
    // Inline function 'kotlin.Long.plus' call
    var other = this.b1y_1;
    var newMinCollectorIndex = add(head, fromInt(other));
    if (this.w1x_1 === 0 && this.c1y_1 > 0) {
      var _unary__edvuaz = newMinCollectorIndex;
      newMinCollectorIndex = add(_unary__edvuaz, get_ONE());
    }
    $l$block: {
      // Inline function 'kotlinx.coroutines.flow.internal.AbstractSharedFlow.forEachSlotLocked' call
      if (this.e1y_1 === 0) {
        break $l$block;
      }
      var tmp0_safe_receiver = this.d1y_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          if (!(element == null)) {
            var containsArg = element.h1y_1;
            if (compare(new Long(0, 0), containsArg) <= 0 ? compare(containsArg, newMinCollectorIndex) < 0 : false)
              newMinCollectorIndex = element.h1y_1;
          }
        }
      }
    }
    // Inline function 'kotlinx.coroutines.assert' call
    if (compare(newMinCollectorIndex, this.a1y_1) <= 0)
      return get_EMPTY_RESUMES();
    var newBufferEndIndex = _get_bufferEndIndex__d2rk18(this);
    var tmp;
    if (this.e1y_1 > 0) {
      var newBufferSize0 = convertToInt(subtract(newBufferEndIndex, newMinCollectorIndex));
      var tmp0 = this.c1y_1;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = this.w1x_1 - newBufferSize0 | 0;
      tmp = Math.min(tmp0, b);
    } else {
      tmp = this.c1y_1;
    }
    var maxResumeCount = tmp;
    var resumes = get_EMPTY_RESUMES();
    var tmp0_0 = newBufferEndIndex;
    // Inline function 'kotlin.Long.plus' call
    var other_0 = this.c1y_1;
    var newQueueEndIndex = add(tmp0_0, fromInt(other_0));
    if (maxResumeCount > 0) {
      // Inline function 'kotlin.arrayOfNulls' call
      resumes = Array(maxResumeCount);
      var resumeCount = 0;
      var buffer = ensureNotNull(this.y1x_1);
      var inductionVariable_0 = newBufferEndIndex;
      if (compare(inductionVariable_0, newQueueEndIndex) < 0)
        $l$loop: do {
          var curEmitterIndex = inductionVariable_0;
          inductionVariable_0 = add(inductionVariable_0, new Long(1, 0));
          var emitter = getBufferAt(buffer, curEmitterIndex);
          if (!(emitter === get_NO_VALUE())) {
            if (!(emitter instanceof Emitter))
              THROW_CCE();
            var tmp_0 = resumes;
            var _unary__edvuaz_0 = resumeCount;
            resumeCount = _unary__edvuaz_0 + 1 | 0;
            tmp_0[_unary__edvuaz_0] = emitter.m1y_1;
            setBufferAt(buffer, curEmitterIndex, get_NO_VALUE());
            setBufferAt(buffer, newBufferEndIndex, emitter.l1y_1);
            var _unary__edvuaz_1 = newBufferEndIndex;
            newBufferEndIndex = add(_unary__edvuaz_1, get_ONE());
            if (resumeCount >= maxResumeCount)
              break $l$loop;
          }
        }
         while (compare(inductionVariable_0, newQueueEndIndex) < 0);
    }
    var tmp0_1 = this.z1x_1;
    var tmp0_2 = newBufferEndIndex;
    // Inline function 'kotlin.Long.minus' call
    var other_1 = this.v1x_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_0 = subtract(tmp0_2, fromInt(other_1));
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_1 = compare(head, b_0) >= 0 ? head : b_0;
    var newReplayIndex = compare(tmp0_1, b_1) >= 0 ? tmp0_1 : b_1;
    if (this.w1x_1 === 0 && compare(newReplayIndex, newQueueEndIndex) < 0 && equals(getBufferAt(ensureNotNull(this.y1x_1), newReplayIndex), get_NO_VALUE())) {
      var _unary__edvuaz_2 = newBufferEndIndex;
      newBufferEndIndex = add(_unary__edvuaz_2, get_ONE());
      var _unary__edvuaz_3 = newReplayIndex;
      newReplayIndex = add(_unary__edvuaz_3, get_ONE());
    }
    if (this.e1y_1 === 0)
      newMinCollectorIndex = newBufferEndIndex;
    updateBufferLocked(this, newReplayIndex, newMinCollectorIndex, newBufferEndIndex, newQueueEndIndex);
    cleanupTailLocked(this);
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(resumes.length === 0))
      resumes = findSlotsToResumeLocked(this, resumes);
    return resumes;
  };
  protoOf(SharedFlowImpl).k1z = function () {
    return new SharedFlowSlot();
  };
  protoOf(SharedFlowImpl).l1z = function (size) {
    // Inline function 'kotlin.arrayOfNulls' call
    return Array(size);
  };
  protoOf(SharedFlowImpl).m1z = function () {
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    updateBufferLocked(this, _get_bufferEndIndex__d2rk18(this), this.a1y_1, _get_bufferEndIndex__d2rk18(this), _get_queueEndIndex__4m025l(this));
    return Unit_instance;
  };
  protoOf(SharedFlowImpl).a1x = function (context, capacity, onBufferOverflow) {
    return fuseSharedFlow(this, context, capacity, onBufferOverflow);
  };
  function SharedFlowSlot() {
    AbstractSharedFlowSlot.call(this);
    this.h1y_1 = new Long(-1, -1);
    this.i1y_1 = null;
  }
  protoOf(SharedFlowSlot).o1z = function (flow) {
    if (compare(this.h1y_1, new Long(0, 0)) >= 0)
      return false;
    this.h1y_1 = flow.j1z();
    return true;
  };
  protoOf(SharedFlowSlot).p1z = function (flow) {
    return this.o1z(flow instanceof SharedFlowImpl ? flow : THROW_CCE());
  };
  protoOf(SharedFlowSlot).q1z = function (flow) {
    // Inline function 'kotlinx.coroutines.assert' call
    var oldIndex = this.h1y_1;
    this.h1y_1 = new Long(-1, -1);
    this.i1y_1 = null;
    return flow.n1y(oldIndex);
  };
  protoOf(SharedFlowSlot).r1z = function (flow) {
    return this.q1z(flow instanceof SharedFlowImpl ? flow : THROW_CCE());
  };
  function getBufferAt(_this__u8e3s4, index) {
    _init_properties_SharedFlow_kt__umasnn();
    return _this__u8e3s4[convertToInt(index) & (_this__u8e3s4.length - 1 | 0)];
  }
  function setBufferAt(_this__u8e3s4, index, item) {
    _init_properties_SharedFlow_kt__umasnn();
    return _this__u8e3s4[convertToInt(index) & (_this__u8e3s4.length - 1 | 0)] = item;
  }
  function fuseSharedFlow(_this__u8e3s4, context, capacity, onBufferOverflow) {
    _init_properties_SharedFlow_kt__umasnn();
    if ((capacity === 0 || capacity === -3) && onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
      return _this__u8e3s4;
    }
    return new ChannelFlowOperatorImpl(_this__u8e3s4, context, capacity, onBufferOverflow);
  }
  var properties_initialized_SharedFlow_kt_tmefor;
  function _init_properties_SharedFlow_kt__umasnn() {
    if (!properties_initialized_SharedFlow_kt_tmefor) {
      properties_initialized_SharedFlow_kt_tmefor = true;
      NO_VALUE = new Symbol('NO_VALUE');
    }
  }
  function Companion_0() {
    Companion_instance_1 = this;
    this.s1z_1 = new StartedEagerly();
    this.t1z_1 = new StartedLazily();
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_0();
    return Companion_instance_1;
  }
  var SharingCommand_START_instance;
  var SharingCommand_STOP_instance;
  var SharingCommand_STOP_AND_RESET_REPLAY_CACHE_instance;
  var SharingCommand_entriesInitialized;
  function SharingCommand_initEntries() {
    if (SharingCommand_entriesInitialized)
      return Unit_instance;
    SharingCommand_entriesInitialized = true;
    SharingCommand_START_instance = new SharingCommand('START', 0);
    SharingCommand_STOP_instance = new SharingCommand('STOP', 1);
    SharingCommand_STOP_AND_RESET_REPLAY_CACHE_instance = new SharingCommand('STOP_AND_RESET_REPLAY_CACHE', 2);
  }
  function SharingCommand(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function StartedEagerly() {
  }
  protoOf(StartedEagerly).u1z = function (subscriptionCount) {
    return flowOf(SharingCommand_START_getInstance());
  };
  protoOf(StartedEagerly).toString = function () {
    return 'SharingStarted.Eagerly';
  };
  function StartedLazily$command$o$collect$slambda($started, $$this$unsafeFlow, resultContinuation) {
    this.d20_1 = $started;
    this.e20_1 = $$this$unsafeFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StartedLazily$command$o$collect$slambda).g20 = function (count, $completion) {
    var tmp = this.h20(count, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StartedLazily$command$o$collect$slambda).ja = function (p1, $completion) {
    return this.g20((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(StartedLazily$command$o$collect$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (this.f20_1 > 0 && !this.d20_1._v) {
              this.d20_1._v = true;
              this.n9_1 = 1;
              suspendResult = this.e20_1.a1v(SharingCommand_START_getInstance(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(StartedLazily$command$o$collect$slambda).h20 = function (count, completion) {
    var i = new StartedLazily$command$o$collect$slambda(this.d20_1, this.e20_1, completion);
    i.f20_1 = count;
    return i;
  };
  function StartedLazily$command$o$collect$slambda_0($started, $$this$unsafeFlow, resultContinuation) {
    var i = new StartedLazily$command$o$collect$slambda($started, $$this$unsafeFlow, resultContinuation);
    return constructCallableReference(function (count, $completion) {
      return i.g20(count, $completion);
    }, 1);
  }
  function $collectCOROUTINE$_4(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.q20_1 = _this__u8e3s4;
    this.r20_1 = collector;
  }
  protoOf($collectCOROUTINE$_4).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var $this$unsafeFlow = this.r20_1;
            var started = {_v: false};
            this.n9_1 = 1;
            var tmp_0 = StartedLazily$command$o$collect$slambda_0(started, $this$unsafeFlow, null);
            suspendResult = this.q20_1.s20_1.h1z(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.t20_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).a1v = function (value, $completion) {
    return this.t20_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).q3 = function () {
    return this.t20_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function StartedLazily$command$$inlined$unsafeFlow$1($subscriptionCount) {
    this.s20_1 = $subscriptionCount;
  }
  protoOf(StartedLazily$command$$inlined$unsafeFlow$1).b1v = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_4(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StartedLazily$command$$inlined$unsafeFlow$1).l1u = function (collector, $completion) {
    return this.b1v(collector, $completion);
  };
  function StartedLazily() {
  }
  protoOf(StartedLazily).u1z = function (subscriptionCount) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new StartedLazily$command$$inlined$unsafeFlow$1(subscriptionCount);
  };
  protoOf(StartedLazily).toString = function () {
    return 'SharingStarted.Lazily';
  };
  function SharingCommand_START_getInstance() {
    SharingCommand_initEntries();
    return SharingCommand_START_instance;
  }
  function get_NONE() {
    _init_properties_StateFlow_kt__eu9yi5();
    return NONE;
  }
  var NONE;
  function get_PENDING() {
    _init_properties_StateFlow_kt__eu9yi5();
    return PENDING;
  }
  var PENDING;
  function MutableStateFlow(value) {
    _init_properties_StateFlow_kt__eu9yi5();
    return new StateFlowImpl(value == null ? get_NULL() : value);
  }
  function StateFlow() {
  }
  function updateState($this, expectedState, newState) {
    var curSequence;
    var curSlots;
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    var oldState = $this.y20_1.kotlinx$atomicfu$value;
    if (!(expectedState == null) && !equals(oldState, expectedState))
      return false;
    if (equals(oldState, newState))
      return true;
    $this.y20_1.kotlinx$atomicfu$value = newState;
    curSequence = $this.z20_1;
    if ((curSequence & 1) === 0) {
      curSequence = curSequence + 1 | 0;
      $this.z20_1 = curSequence;
    } else {
      $this.z20_1 = curSequence + 2 | 0;
      return true;
    }
    curSlots = $this.d1y_1;
    while (true) {
      var tmp0_safe_receiver = curSlots;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          if (element == null)
            null;
          else {
            element.b21();
          }
        }
      }
      // Inline function 'kotlinx.coroutines.internal.synchronized' call
      // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
      if ($this.z20_1 === curSequence) {
        $this.z20_1 = curSequence + 1 | 0;
        return true;
      }
      curSequence = $this.z20_1;
      curSlots = $this.d1y_1;
    }
  }
  function $collectCOROUTINE$_5(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k21_1 = _this__u8e3s4;
    this.l21_1 = collector;
  }
  protoOf($collectCOROUTINE$_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 12;
            this.m21_1 = this.k21_1.b1z();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 11;
            var tmp_0 = this.l21_1;
            if (tmp_0 instanceof SubscribedFlowCollector) {
              this.n9_1 = 2;
              suspendResult = this.l21_1.e1z(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            var tmp_1 = this;
            tmp_1.p21_1 = this.t9().aa(Key_instance_3);
            this.n21_1 = null;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            if (!true) {
              this.n9_1 = 9;
              continue $sm;
            }

            this.o21_1 = this.k21_1.y20_1.kotlinx$atomicfu$value;
            var tmp0_safe_receiver = this.p21_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              ensureActive_0(tmp0_safe_receiver);
            }

            if (this.n21_1 == null || !equals(this.n21_1, this.o21_1)) {
              this.n9_1 = 5;
              var tmp0 = get_NULL();
              var value = this.o21_1;
              suspendResult = this.l21_1.a1v(value === tmp0 ? null : value, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 6;
              continue $sm;
            }

          case 5:
            this.n21_1 = this.o21_1;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            if (!this.m21_1.r21()) {
              this.n9_1 = 7;
              suspendResult = this.m21_1.q21(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 8;
              continue $sm;
            }

          case 7:
            this.n9_1 = 8;
            continue $sm;
          case 8:
            this.n9_1 = 4;
            continue $sm;
          case 9:
            this.o9_1 = 12;
            this.n9_1 = 10;
            continue $sm;
          case 10:
            this.o9_1 = 12;
            this.k21_1.f1z(this.m21_1);
            return Unit_instance;
          case 11:
            this.o9_1 = 12;
            var t = this.q9_1;
            this.k21_1.f1z(this.m21_1);
            throw t;
          case 12:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 12) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function StateFlowImpl(initialState) {
    AbstractSharedFlow.call(this);
    this.y20_1 = atomic$ref$1(initialState);
    this.z20_1 = 0;
  }
  protoOf(StateFlowImpl).s21 = function (value) {
    updateState(this, null, value == null ? get_NULL() : value);
  };
  protoOf(StateFlowImpl).u1 = function () {
    var tmp0 = get_NULL();
    // Inline function 'kotlinx.coroutines.internal.Symbol.unbox' call
    var value = this.y20_1.kotlinx$atomicfu$value;
    return value === tmp0 ? null : value;
  };
  protoOf(StateFlowImpl).c9 = function (expect, update) {
    var tmp = expect == null ? get_NULL() : expect;
    return updateState(this, tmp, update == null ? get_NULL() : update);
  };
  protoOf(StateFlowImpl).i1z = function (value) {
    this.s21(value);
    return true;
  };
  protoOf(StateFlowImpl).a1v = function (value, $completion) {
    this.s21(value);
    return Unit_instance;
  };
  protoOf(StateFlowImpl).m1z = function () {
    throw UnsupportedOperationException_init_$Create$('MutableStateFlow.resetReplayCache is not supported');
  };
  protoOf(StateFlowImpl).h1z = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_5(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StateFlowImpl).l1u = function (collector, $completion) {
    return this.h1z(collector, $completion);
  };
  protoOf(StateFlowImpl).k1z = function () {
    return new StateFlowSlot();
  };
  protoOf(StateFlowImpl).l1z = function (size) {
    // Inline function 'kotlin.arrayOfNulls' call
    return Array(size);
  };
  protoOf(StateFlowImpl).a1x = function (context, capacity, onBufferOverflow) {
    return fuseStateFlow(this, context, capacity, onBufferOverflow);
  };
  function StateFlowSlot() {
    AbstractSharedFlowSlot.call(this);
    this.a21_1 = new WorkaroundAtomicReference(null);
  }
  protoOf(StateFlowSlot).t21 = function (flow) {
    if (!(get_value(this.a21_1) == null))
      return false;
    set_value(this.a21_1, get_NONE());
    return true;
  };
  protoOf(StateFlowSlot).p1z = function (flow) {
    return this.t21(flow instanceof StateFlowImpl ? flow : THROW_CCE());
  };
  protoOf(StateFlowSlot).u21 = function (flow) {
    set_value(this.a21_1, null);
    return get_EMPTY_RESUMES();
  };
  protoOf(StateFlowSlot).r1z = function (flow) {
    return this.u21(flow instanceof StateFlowImpl ? flow : THROW_CCE());
  };
  protoOf(StateFlowSlot).b21 = function () {
    // Inline function 'kotlinx.coroutines.internal.loop' call
    var this_0 = this.a21_1;
    while (true) {
      var state = get_value(this_0);
      if (state == null)
        return Unit_instance;
      else if (state === get_PENDING())
        return Unit_instance;
      else if (state === get_NONE()) {
        if (this.a21_1.w21(state, get_PENDING()))
          return Unit_instance;
      } else {
        if (this.a21_1.w21(state, get_NONE())) {
          // Inline function 'kotlin.coroutines.resume' call
          var this_1 = state instanceof CancellableContinuationImpl ? state : THROW_CCE();
          // Inline function 'kotlin.Companion.success' call
          var tmp$ret$3 = _Result___init__impl__xyqfz8(Unit_instance);
          this_1.y9(tmp$ret$3);
          return Unit_instance;
        }
      }
    }
  };
  protoOf(StateFlowSlot).r21 = function () {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlinx.coroutines.assert' call
    return ensureNotNull(this.a21_1.x21(get_NONE())) === get_PENDING();
  };
  protoOf(StateFlowSlot).q21 = function ($completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.v1e();
    $l$block: {
      // Inline function 'kotlinx.coroutines.assert' call
      if (this.a21_1.w21(get_NONE(), cancellable)) {
        break $l$block;
      }
      // Inline function 'kotlinx.coroutines.assert' call
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
      cancellable.y9(tmp$ret$5);
    }
    return cancellable.x1b();
  };
  function fuseStateFlow(_this__u8e3s4, context, capacity, onBufferOverflow) {
    _init_properties_StateFlow_kt__eu9yi5();
    // Inline function 'kotlinx.coroutines.assert' call
    if (((0 <= capacity ? capacity <= 1 : false) || capacity === -2) && onBufferOverflow.equals(BufferOverflow_DROP_OLDEST_getInstance())) {
      return _this__u8e3s4;
    }
    return fuseSharedFlow(_this__u8e3s4, context, capacity, onBufferOverflow);
  }
  var properties_initialized_StateFlow_kt_nsqikx;
  function _init_properties_StateFlow_kt__eu9yi5() {
    if (!properties_initialized_StateFlow_kt_nsqikx) {
      properties_initialized_StateFlow_kt_nsqikx = true;
      NONE = new Symbol('NONE');
      PENDING = new Symbol('PENDING');
    }
  }
  function get_EMPTY_RESUMES() {
    _init_properties_AbstractSharedFlow_kt__h2xygb();
    return EMPTY_RESUMES;
  }
  var EMPTY_RESUMES;
  function AbstractSharedFlow() {
    SynchronizedObject.call(this);
    this.d1y_1 = null;
    this.e1y_1 = 0;
    this.f1y_1 = 0;
    this.g1y_1 = null;
  }
  protoOf(AbstractSharedFlow).n1z = function () {
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    var tmp0_elvis_lhs = this.g1y_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new SubscriptionCountStateFlow(this.e1y_1);
      this.g1y_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(AbstractSharedFlow).b1z = function () {
    var subscriptionCount;
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    var curSlots = this.d1y_1;
    var tmp;
    if (curSlots == null) {
      // Inline function 'kotlin.also' call
      var this_0 = this.l1z(2);
      this.d1y_1 = this_0;
      tmp = this_0;
    } else {
      var tmp_0;
      if (this.e1y_1 >= curSlots.length) {
        // Inline function 'kotlin.also' call
        var this_1 = copyOf(curSlots, imul(2, curSlots.length));
        this.d1y_1 = this_1;
        tmp_0 = this_1;
      } else {
        tmp_0 = curSlots;
      }
      tmp = tmp_0;
    }
    var slots = tmp;
    var index = this.f1y_1;
    var slot;
    $l$loop: while (true) {
      var tmp0_elvis_lhs = slots[index];
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.also' call
        var this_2 = this.k1z();
        slots[index] = this_2;
        tmp_1 = this_2;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      slot = tmp_1;
      index = index + 1 | 0;
      if (index >= slots.length)
        index = 0;
      if ((slot instanceof AbstractSharedFlowSlot ? slot : THROW_CCE()).p1z(this))
        break $l$loop;
    }
    this.f1y_1 = index;
    this.e1y_1 = this.e1y_1 + 1 | 0;
    subscriptionCount = this.g1y_1;
    var slot_0 = slot;
    if (subscriptionCount == null)
      null;
    else
      subscriptionCount.k22(1);
    return slot_0;
  };
  protoOf(AbstractSharedFlow).f1z = function (slot) {
    var subscriptionCount;
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    this.e1y_1 = this.e1y_1 - 1 | 0;
    subscriptionCount = this.g1y_1;
    if (this.e1y_1 === 0)
      this.f1y_1 = 0;
    var resumes = (slot instanceof AbstractSharedFlowSlot ? slot : THROW_CCE()).r1z(this);
    var inductionVariable = 0;
    var last = resumes.length;
    while (inductionVariable < last) {
      var cont = resumes[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (cont == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$4 = _Result___init__impl__xyqfz8(Unit_instance);
        cont.y9(tmp$ret$4);
      }
    }
    if (subscriptionCount == null)
      null;
    else
      subscriptionCount.k22(-1);
  };
  function AbstractSharedFlowSlot() {
  }
  function SubscriptionCountStateFlow(initialValue) {
    SharedFlowImpl.call(this, 1, 2147483647, BufferOverflow_DROP_OLDEST_getInstance());
    this.i1z(initialValue);
  }
  protoOf(SubscriptionCountStateFlow).u1 = function () {
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    return this.g1z();
  };
  protoOf(SubscriptionCountStateFlow).k22 = function (delta) {
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    return this.i1z(this.g1z() + delta | 0);
  };
  var properties_initialized_AbstractSharedFlow_kt_2mpafr;
  function _init_properties_AbstractSharedFlow_kt__h2xygb() {
    if (!properties_initialized_AbstractSharedFlow_kt_2mpafr) {
      properties_initialized_AbstractSharedFlow_kt_2mpafr = true;
      // Inline function 'kotlin.arrayOfNulls' call
      EMPTY_RESUMES = Array(0);
    }
  }
  function FusibleFlow() {
  }
  function ChannelFlowOperatorImpl(flow, context, capacity, onBufferOverflow) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    capacity = capacity === VOID ? -3 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    ChannelFlowOperator.call(this, flow, context, capacity, onBufferOverflow);
  }
  protoOf(ChannelFlowOperatorImpl).t1w = function (context, capacity, onBufferOverflow) {
    return new ChannelFlowOperatorImpl(this.s22_1, context, capacity, onBufferOverflow);
  };
  protoOf(ChannelFlowOperatorImpl).u1w = function () {
    return this.s22_1;
  };
  protoOf(ChannelFlowOperatorImpl).t22 = function (collector, $completion) {
    return this.s22_1.l1u(collector, $completion);
  };
  function collectWithContextUndispatched($this, collector, newContext, $completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.t9();
    var originalContextCollector = withUndispatchedContextCollector(collector, tmp$ret$0);
    return withContextUndispatched(newContext, originalContextCollector, VOID, ChannelFlowOperator$collectWithContextUndispatched$slambda_0($this, null), $completion);
  }
  function ChannelFlowOperator$collectWithContextUndispatched$slambda(this$0, resultContinuation) {
    this.c23_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlowOperator$collectWithContextUndispatched$slambda).e23 = function (it, $completion) {
    var tmp = this.f23(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ChannelFlowOperator$collectWithContextUndispatched$slambda).ja = function (p1, $completion) {
    return this.e23((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChannelFlowOperator$collectWithContextUndispatched$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.c23_1.t22(this.d23_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlowOperator$collectWithContextUndispatched$slambda).f23 = function (it, completion) {
    var i = new ChannelFlowOperator$collectWithContextUndispatched$slambda(this.c23_1, completion);
    i.d23_1 = it;
    return i;
  };
  function ChannelFlowOperator$collectWithContextUndispatched$slambda_0(this$0, resultContinuation) {
    var i = new ChannelFlowOperator$collectWithContextUndispatched$slambda(this$0, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.e23(it, $completion);
    }, 1);
  }
  function $collectCOROUTINE$_6(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o23_1 = _this__u8e3s4;
    this.p23_1 = collector;
  }
  protoOf($collectCOROUTINE$_6).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            if (this.o23_1.r1w_1 === -3) {
              var tmp_0 = this;
              tmp_0.r23_1 = this.t9();
              this.q23_1 = newCoroutineContext_0(this.r23_1, this.o23_1.q1w_1);
              if (equals(this.q23_1, this.r23_1)) {
                this.n9_1 = 6;
                suspendResult = this.o23_1.t22(this.p23_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 1;
                continue $sm;
              }
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 1:
            if (equals(this.q23_1.aa(Key_instance), this.r23_1.aa(Key_instance))) {
              this.n9_1 = 5;
              suspendResult = collectWithContextUndispatched(this.o23_1, this.p23_1, this.q23_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            suspendResult = protoOf(ChannelFlow).l1u.call(this.o23_1, this.p23_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            return Unit_instance;
          case 6:
            return Unit_instance;
          case 7:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 7) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function ChannelFlowOperator(flow, context, capacity, onBufferOverflow) {
    ChannelFlow.call(this, context, capacity, onBufferOverflow);
    this.s22_1 = flow;
  }
  protoOf(ChannelFlowOperator).v1w = function (scope, $completion) {
    return this.t22(new SendingCollector(scope), $completion);
  };
  protoOf(ChannelFlowOperator).l1u = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_6(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ChannelFlowOperator).toString = function () {
    return toString(this.s22_1) + ' -> ' + protoOf(ChannelFlow).toString.call(this);
  };
  function ChannelFlow$_get_collectToFun_$slambda_j53z2e(this$0, resultContinuation) {
    this.a24_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlow$_get_collectToFun_$slambda_j53z2e).c24 = function (it, $completion) {
    var tmp = this.d24(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ChannelFlow$_get_collectToFun_$slambda_j53z2e).ja = function (p1, $completion) {
    return this.c24((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChannelFlow$_get_collectToFun_$slambda_j53z2e).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.a24_1.v1w(this.b24_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlow$_get_collectToFun_$slambda_j53z2e).d24 = function (it, completion) {
    var i = new ChannelFlow$_get_collectToFun_$slambda_j53z2e(this.a24_1, completion);
    i.b24_1 = it;
    return i;
  };
  function ChannelFlow$_get_collectToFun_$slambda_j53z2e_0(this$0, resultContinuation) {
    var i = new ChannelFlow$_get_collectToFun_$slambda_j53z2e(this$0, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.c24(it, $completion);
    }, 1);
  }
  function ChannelFlow$collect$slambda($collector, this$0, resultContinuation) {
    this.m24_1 = $collector;
    this.n24_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlow$collect$slambda).p24 = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ChannelFlow$collect$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChannelFlow$collect$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = emitAll(this.m24_1, this.n24_1.w1w(this.o24_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlow$collect$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new ChannelFlow$collect$slambda(this.m24_1, this.n24_1, completion);
    i.o24_1 = $this$coroutineScope;
    return i;
  };
  function ChannelFlow$collect$slambda_0($collector, this$0, resultContinuation) {
    var i = new ChannelFlow$collect$slambda($collector, this$0, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.p24($this$coroutineScope, $completion);
    }, 1);
  }
  function ChannelFlow(context, capacity, onBufferOverflow) {
    this.q1w_1 = context;
    this.r1w_1 = capacity;
    this.s1w_1 = onBufferOverflow;
    // Inline function 'kotlinx.coroutines.assert' call
  }
  protoOf(ChannelFlow).y1w = function () {
    return ChannelFlow$_get_collectToFun_$slambda_j53z2e_0(this, null);
  };
  protoOf(ChannelFlow).z1w = function () {
    return this.r1w_1 === -3 ? -2 : this.r1w_1;
  };
  protoOf(ChannelFlow).u1w = function () {
    return null;
  };
  protoOf(ChannelFlow).a1x = function (context, capacity, onBufferOverflow) {
    // Inline function 'kotlinx.coroutines.assert' call
    var newContext = context.xj(this.q1w_1);
    var newCapacity;
    var newOverflow;
    if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
      newCapacity = capacity;
      newOverflow = onBufferOverflow;
    } else {
      var tmp;
      if (this.r1w_1 === -3) {
        tmp = capacity;
      } else if (capacity === -3) {
        tmp = this.r1w_1;
      } else if (this.r1w_1 === -2) {
        tmp = capacity;
      } else if (capacity === -2) {
        tmp = this.r1w_1;
      } else {
        // Inline function 'kotlinx.coroutines.assert' call
        // Inline function 'kotlinx.coroutines.assert' call
        var sum = this.r1w_1 + capacity | 0;
        tmp = sum >= 0 ? sum : 2147483647;
      }
      newCapacity = tmp;
      newOverflow = this.s1w_1;
    }
    if (equals(newContext, this.q1w_1) && newCapacity === this.r1w_1 && newOverflow.equals(this.s1w_1))
      return this;
    return this.t1w(newContext, newCapacity, newOverflow);
  };
  protoOf(ChannelFlow).w1w = function (scope) {
    return produce_0(scope, this.q1w_1, this.z1w(), this.s1w_1, CoroutineStart_ATOMIC_getInstance(), VOID, this.y1w());
  };
  protoOf(ChannelFlow).l1u = function (collector, $completion) {
    return coroutineScope(ChannelFlow$collect$slambda_0(collector, this, null), $completion);
  };
  protoOf(ChannelFlow).x1w = function () {
    return null;
  };
  protoOf(ChannelFlow).toString = function () {
    var props = ArrayList_init_$Create$(4);
    var tmp0_safe_receiver = this.x1w();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      props.j1(tmp0_safe_receiver);
    }
    if (!(this.q1w_1 === EmptyCoroutineContext_getInstance())) {
      props.j1('context=' + toString(this.q1w_1));
    }
    if (!(this.r1w_1 === -3)) {
      props.j1('capacity=' + this.r1w_1);
    }
    if (!this.s1w_1.equals(BufferOverflow_SUSPEND_getInstance())) {
      props.j1('onBufferOverflow=' + this.s1w_1.toString());
    }
    return get_classSimpleName(this) + '[' + joinToString(props, ', ') + ']';
  };
  function withUndispatchedContextCollector(_this__u8e3s4, emitContext) {
    var tmp;
    var tmp_0;
    if (_this__u8e3s4 instanceof SendingCollector) {
      tmp_0 = true;
    } else {
      tmp_0 = _this__u8e3s4 instanceof NopCollector;
    }
    if (tmp_0) {
      tmp = _this__u8e3s4;
    } else {
      tmp = new UndispatchedContextCollector(_this__u8e3s4, emitContext);
    }
    return tmp;
  }
  function withContextUndispatched(newContext, value, countOrElement, block, $completion) {
    countOrElement = countOrElement === VOID ? threadContextElements(newContext) : countOrElement;
    var tmp = new $withContextUndispatchedCOROUTINE$(newContext, value, countOrElement, block, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function UndispatchedContextCollector$emitRef$slambda($downstream, resultContinuation) {
    this.l25_1 = $downstream;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(UndispatchedContextCollector$emitRef$slambda).n25 = function (it, $completion) {
    var tmp = this.o25(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(UndispatchedContextCollector$emitRef$slambda).ja = function (p1, $completion) {
    return this.n25(p1, $completion);
  };
  protoOf(UndispatchedContextCollector$emitRef$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.l25_1.a1v(this.m25_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(UndispatchedContextCollector$emitRef$slambda).o25 = function (it, completion) {
    var i = new UndispatchedContextCollector$emitRef$slambda(this.l25_1, completion);
    i.m25_1 = it;
    return i;
  };
  function UndispatchedContextCollector$emitRef$slambda_0($downstream, resultContinuation) {
    var i = new UndispatchedContextCollector$emitRef$slambda($downstream, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.n25(it, $completion);
    }, 1);
  }
  function UndispatchedContextCollector(downstream, emitContext) {
    this.p25_1 = emitContext;
    this.q25_1 = threadContextElements(this.p25_1);
    var tmp = this;
    tmp.r25_1 = UndispatchedContextCollector$emitRef$slambda_0(downstream, null);
  }
  protoOf(UndispatchedContextCollector).a1v = function (value, $completion) {
    return withContextUndispatched(this.p25_1, value, this.q25_1, this.r25_1, $completion);
  };
  function StackFrameContinuation(uCont, context) {
    this.s25_1 = uCont;
    this.t25_1 = context;
  }
  protoOf(StackFrameContinuation).t9 = function () {
    return this.t25_1;
  };
  protoOf(StackFrameContinuation).y9 = function (result) {
    this.s25_1.y9(result);
  };
  function $withContextUndispatchedCOROUTINE$(newContext, value, countOrElement, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z24_1 = newContext;
    this.a25_1 = value;
    this.b25_1 = countOrElement;
    this.c25_1 = block;
  }
  protoOf($withContextUndispatchedCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.z24_1;
            this.b25_1;
            this.n9_1 = 1;
            var tmp0 = this.c25_1;
            var tmp2 = this.a25_1;
            var completion = new StackFrameContinuation(this, this.z24_1);
            suspendResult = returnIfSuspended(startCoroutineUninterceptedOrReturnNonGeneratorVersion(tmp0, tmp2, completion), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function combineInternal(_this__u8e3s4, flows, arrayFactory, transform, $completion) {
    return flowScope(combineInternal$slambda_0(flows, arrayFactory, transform, _this__u8e3s4, null), $completion);
  }
  function combineInternal$slambda$slambda$slambda($resultChannel, $i, resultContinuation) {
    this.c26_1 = $resultChannel;
    this.d26_1 = $i;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(combineInternal$slambda$slambda$slambda).n25 = function (value, $completion) {
    var tmp = this.o25(value, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(combineInternal$slambda$slambda$slambda).ja = function (p1, $completion) {
    return this.n25(p1, $completion);
  };
  protoOf(combineInternal$slambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.c26_1.r1s(new IndexedValue(this.d26_1, this.e26_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = yield_0(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(combineInternal$slambda$slambda$slambda).o25 = function (value, completion) {
    var i = new combineInternal$slambda$slambda$slambda(this.c26_1, this.d26_1, completion);
    i.e26_1 = value;
    return i;
  };
  function combineInternal$slambda$slambda$slambda_0($resultChannel, $i, resultContinuation) {
    var i = new combineInternal$slambda$slambda$slambda($resultChannel, $i, resultContinuation);
    return constructCallableReference(function (value, $completion) {
      return i.n25(value, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_0(function_0) {
    this.f26_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).a1v = function (value, $completion) {
    return this.f26_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).q3 = function () {
    return this.f26_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function combineInternal$slambda$slambda($flows, $i, $nonClosed, $resultChannel, resultContinuation) {
    this.o26_1 = $flows;
    this.p26_1 = $i;
    this.q26_1 = $nonClosed;
    this.r26_1 = $resultChannel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(combineInternal$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(combineInternal$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(combineInternal$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.n9_1 = 2;
            var tmp_0 = this.o26_1[this.p26_1];
            var tmp_1 = combineInternal$slambda$slambda$slambda_0(this.r26_1, this.p26_1, null);
            suspendResult = tmp_0.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_0(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 5;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 5;
            if (this.q26_1.u26() === 0) {
              this.r26_1.b1t();
            }

            return Unit_instance;
          case 4:
            this.o9_1 = 5;
            var t = this.q9_1;
            if (this.q26_1.u26() === 0) {
              this.r26_1.b1t();
            }

            throw t;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(combineInternal$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new combineInternal$slambda$slambda(this.o26_1, this.p26_1, this.q26_1, this.r26_1, completion);
    i.s26_1 = $this$launch;
    return i;
  };
  function combineInternal$slambda$slambda_0($flows, $i, $nonClosed, $resultChannel, resultContinuation) {
    var i = new combineInternal$slambda$slambda($flows, $i, $nonClosed, $resultChannel, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function combineInternal$slambda($flows, $arrayFactory, $transform, $this_combineInternal, resultContinuation) {
    this.d27_1 = $flows;
    this.e27_1 = $arrayFactory;
    this.f27_1 = $transform;
    this.g27_1 = $this_combineInternal;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(combineInternal$slambda).p24 = function ($this$flowScope, $completion) {
    var tmp = this.q24($this$flowScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(combineInternal$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(combineInternal$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 10;
            var size = this.d27_1.length;
            if (size === 0)
              return Unit_instance;
            var tmp_0 = this;
            tmp_0.i27_1 = Array(size);
            fill(this.i27_1, get_UNINITIALIZED());
            this.k27_1 = Channel(size);
            var nonClosed = new LocalAtomicInt(size);
            this.j27_1 = size;
            var inductionVariable = 0;
            if (inductionVariable < size)
              do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                launch(this.h27_1, VOID, VOID, combineInternal$slambda$slambda_0(this.d27_1, i, nonClosed, this.k27_1, null));
              }
               while (inductionVariable < size);
            this.m27_1 = new Int8Array(size);
            this.l27_1 = 0;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.n9_1 = 9;
              continue $sm;
            }

            this.l27_1 = numberToByte(this.l27_1 + 1);
            this.n9_1 = 2;
            suspendResult = this.k27_1.v1s(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            this.n9_1 = 3;
            continue $sm;
          case 2:
            var unboxed = suspendResult.s1p_1;
            suspendResult = new ChannelResult(unboxed);
            this.n9_1 = 3;
            continue $sm;
          case 3:
            var ARGUMENT = suspendResult.s1p_1;
            var tmp0_elvis_lhs = ChannelResult__getOrNull_impl_f5e07h(ARGUMENT);
            if (tmp0_elvis_lhs == null) {
              this.n9_1 = 9;
              var tmp_1 = this;
              continue $sm;
            } else {
              this.n27_1 = tmp0_elvis_lhs;
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            var element = this.n27_1;
            $l$loop_0: while (true) {
              var index = element.nh_1;
              var previous = this.i27_1[index];
              this.i27_1[index] = element.oh_1;
              if (previous === get_UNINITIALIZED()) {
                this.j27_1 = this.j27_1 - 1 | 0;
              }
              if (this.m27_1[index] === this.l27_1)
                break $l$loop_0;
              this.m27_1[index] = this.l27_1;
              var tmp1_elvis_lhs = ChannelResult__getOrNull_impl_f5e07h(this.k27_1.w1s());
              var tmp_2;
              if (tmp1_elvis_lhs == null) {
                break $l$loop_0;
              } else {
                tmp_2 = tmp1_elvis_lhs;
              }
              element = tmp_2;
            }

            if (this.j27_1 === 0) {
              var results = this.e27_1();
              if (results == null) {
                this.n9_1 = 6;
                var tmp_3 = this.i27_1;
                suspendResult = this.f27_1(this.g27_1, isArray(tmp_3) ? tmp_3 : THROW_CCE(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_4 = this.i27_1;
                var this_0 = isArray(tmp_4) ? tmp_4 : THROW_CCE();
                var endIndex = this_0.length;
                arrayCopy(this_0, results, 0, 0, endIndex);
                this.n9_1 = 5;
                suspendResult = this.f27_1(this.g27_1, isArray(results) ? results : THROW_CCE(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              this.n9_1 = 8;
              continue $sm;
            }

          case 5:
            this.n9_1 = 7;
            continue $sm;
          case 6:
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.n9_1 = 8;
            continue $sm;
          case 8:
            this.n9_1 = 1;
            continue $sm;
          case 9:
            return Unit_instance;
          case 10:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 10) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(combineInternal$slambda).q24 = function ($this$flowScope, completion) {
    var i = new combineInternal$slambda(this.d27_1, this.e27_1, this.f27_1, this.g27_1, completion);
    i.h27_1 = $this$flowScope;
    return i;
  };
  function combineInternal$slambda_0($flows, $arrayFactory, $transform, $this_combineInternal, resultContinuation) {
    var i = new combineInternal$slambda($flows, $arrayFactory, $transform, $this_combineInternal, resultContinuation);
    return constructCallableReference(function ($this$flowScope, $completion) {
      return i.p24($this$flowScope, $completion);
    }, 1);
  }
  function scopedFlow(block) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new scopedFlow$$inlined$unsafeFlow$1(block);
  }
  function flowScope(block, $completion) {
    var coroutine = new FlowCoroutine($completion.t9(), $completion);
    return startUndispatchedOrReturn(coroutine, coroutine, block);
  }
  function FlowCoroutine(context, uCont) {
    ScopeCoroutine.call(this, context, uCont);
  }
  protoOf(FlowCoroutine).e1b = function (cause) {
    if (cause instanceof ChildCancelledException)
      return true;
    return this.g1b(cause);
  };
  function scopedFlow$o$collect$slambda($block, $$this$flow, resultContinuation) {
    this.a28_1 = $block;
    this.b28_1 = $$this$flow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(scopedFlow$o$collect$slambda).p24 = function ($this$flowScope, $completion) {
    var tmp = this.q24($this$flowScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(scopedFlow$o$collect$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(scopedFlow$o$collect$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.a28_1(this.c28_1, this.b28_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(scopedFlow$o$collect$slambda).q24 = function ($this$flowScope, completion) {
    var i = new scopedFlow$o$collect$slambda(this.a28_1, this.b28_1, completion);
    i.c28_1 = $this$flowScope;
    return i;
  };
  function scopedFlow$o$collect$slambda_0($block, $$this$flow, resultContinuation) {
    var i = new scopedFlow$o$collect$slambda($block, $$this$flow, resultContinuation);
    return constructCallableReference(function ($this$flowScope, $completion) {
      return i.p24($this$flowScope, $completion);
    }, 1);
  }
  function $collectCOROUTINE$_7(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.l28_1 = _this__u8e3s4;
    this.m28_1 = collector;
  }
  protoOf($collectCOROUTINE$_7).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var $this$flow = this.m28_1;
            this.n9_1 = 1;
            suspendResult = flowScope(scopedFlow$o$collect$slambda_0(this.l28_1.n28_1, $this$flow, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function scopedFlow$$inlined$unsafeFlow$1($block) {
    this.n28_1 = $block;
  }
  protoOf(scopedFlow$$inlined$unsafeFlow$1).b1v = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_7(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(scopedFlow$$inlined$unsafeFlow$1).l1u = function (collector, $completion) {
    return this.b1v(collector, $completion);
  };
  function checkOwnership(_this__u8e3s4, owner) {
    if (!(_this__u8e3s4.o28_1 === owner))
      throw _this__u8e3s4;
  }
  function ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda(this$0, $collector, $value, resultContinuation) {
    this.x28_1 = this$0;
    this.y28_1 = $collector;
    this.z28_1 = $value;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.x28_1.f29_1(this.y28_1, this.z28_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda(this.x28_1, this.y28_1, this.z28_1, completion);
    i.a29_1 = $this$launch;
    return i;
  };
  function ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda_0(this$0, $collector, $value, resultContinuation) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda(this$0, $collector, $value, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ChannelFlowTransformLatest$flowCollect$slambda$slambda($previousFlow, $this_coroutineScope, this$0, $collector, resultContinuation) {
    this.o29_1 = $previousFlow;
    this.p29_1 = $this_coroutineScope;
    this.q29_1 = this$0;
    this.r29_1 = $collector;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda).n25 = function (value, $completion) {
    var tmp = this.o25(value, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda).ja = function (p1, $completion) {
    return this.n25(p1, $completion);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0_safe_receiver = this.o29_1._v;
            if (tmp0_safe_receiver == null) {
              this.t29_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.u29_1 = tmp0_safe_receiver;
              var $this$apply = this.u29_1;
              $this$apply.a1b(new ChildCancelledException());
              this.n9_1 = 1;
              suspendResult = $this$apply.x1a(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.t29_1 = this.u29_1;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
            this.o29_1._v = launch(this.p29_1, VOID, tmp_0, ChannelFlowTransformLatest$flowCollect$slambda$slambda$slambda_0(this.q29_1, this.r29_1, this.s29_1, null));
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda$slambda).o25 = function (value, completion) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda$slambda(this.o29_1, this.p29_1, this.q29_1, this.r29_1, completion);
    i.s29_1 = value;
    return i;
  };
  function ChannelFlowTransformLatest$flowCollect$slambda$slambda_0($previousFlow, $this_coroutineScope, this$0, $collector, resultContinuation) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda$slambda($previousFlow, $this_coroutineScope, this$0, $collector, resultContinuation);
    return constructCallableReference(function (value, $completion) {
      return i.n25(value, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_1(function_0) {
    this.v29_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).a1v = function (value, $completion) {
    return this.v29_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).q3 = function () {
    return this.v29_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).hashCode = function () {
    return hashCode(this.q3());
  };
  function ChannelFlowTransformLatest$flowCollect$slambda(this$0, $collector, resultContinuation) {
    this.e2a_1 = this$0;
    this.f2a_1 = $collector;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda).p24 = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var previousFlow = {_v: null};
            this.n9_1 = 1;
            var tmp_0 = ChannelFlowTransformLatest$flowCollect$slambda$slambda_0(previousFlow, this.g2a_1, this.e2a_1, this.f2a_1, null);
            suspendResult = this.e2a_1.s22_1.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_1(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChannelFlowTransformLatest$flowCollect$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda(this.e2a_1, this.f2a_1, completion);
    i.g2a_1 = $this$coroutineScope;
    return i;
  };
  function ChannelFlowTransformLatest$flowCollect$slambda_0(this$0, $collector, resultContinuation) {
    var i = new ChannelFlowTransformLatest$flowCollect$slambda(this$0, $collector, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.p24($this$coroutineScope, $completion);
    }, 1);
  }
  function ChannelFlowTransformLatest(transform, flow, context, capacity, onBufferOverflow) {
    context = context === VOID ? EmptyCoroutineContext_getInstance() : context;
    capacity = capacity === VOID ? -2 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    ChannelFlowOperator.call(this, flow, context, capacity, onBufferOverflow);
    this.f29_1 = transform;
  }
  protoOf(ChannelFlowTransformLatest).t1w = function (context, capacity, onBufferOverflow) {
    return new ChannelFlowTransformLatest(this.f29_1, this.s22_1, context, capacity, onBufferOverflow);
  };
  protoOf(ChannelFlowTransformLatest).h2a = function (collector, $completion) {
    // Inline function 'kotlinx.coroutines.assert' call
    return coroutineScope(ChannelFlowTransformLatest$flowCollect$slambda_0(this, collector, null), $completion);
  };
  protoOf(ChannelFlowTransformLatest).t22 = function (collector, $completion) {
    return this.h2a(collector, $completion);
  };
  function NopCollector() {
  }
  protoOf(NopCollector).i2a = function (value, $completion) {
    return Unit_instance;
  };
  protoOf(NopCollector).a1v = function (value, $completion) {
    return this.i2a(value, $completion);
  };
  var NopCollector_instance;
  function NopCollector_getInstance() {
    return NopCollector_instance;
  }
  function get_NULL() {
    _init_properties_NullSurrogate_kt__n2yti9();
    return NULL;
  }
  var NULL;
  function get_UNINITIALIZED() {
    _init_properties_NullSurrogate_kt__n2yti9();
    return UNINITIALIZED;
  }
  var UNINITIALIZED;
  function get_DONE() {
    _init_properties_NullSurrogate_kt__n2yti9();
    return DONE;
  }
  var DONE;
  var properties_initialized_NullSurrogate_kt_39v8bl;
  function _init_properties_NullSurrogate_kt__n2yti9() {
    if (!properties_initialized_NullSurrogate_kt_39v8bl) {
      properties_initialized_NullSurrogate_kt_39v8bl = true;
      NULL = new Symbol('NULL');
      UNINITIALIZED = new Symbol('UNINITIALIZED');
      DONE = new Symbol('DONE');
    }
  }
  function checkContext(_this__u8e3s4, currentContext) {
    var result = currentContext.wj(0, checkContext$lambda(_this__u8e3s4));
    if (!(result === _this__u8e3s4.p1x_1)) {
      // Inline function 'kotlin.error' call
      var message = 'Flow invariant is violated:\n' + ('\t\tFlow was collected in ' + toString(_this__u8e3s4.o1x_1) + ',\n') + ('\t\tbut emission happened in ' + toString(currentContext) + '.\n') + "\t\tPlease refer to 'flow' documentation or use 'flowOn' instead";
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  function transitiveCoroutineParent(_this__u8e3s4, collectJob) {
    var $this = _this__u8e3s4;
    var collectJob_0 = collectJob;
    $l$1: do {
      $l$0: do {
        if ($this === null)
          return null;
        if ($this === collectJob_0)
          return $this;
        if (!($this instanceof ScopeCoroutine))
          return $this;
        var tmp0 = $this.k1a();
        var tmp1 = collectJob_0;
        $this = tmp0;
        collectJob_0 = tmp1;
        continue $l$0;
      }
       while (false);
    }
     while (true);
  }
  function checkContext$lambda($this_checkContext) {
    return function (count, element) {
      var key = element.t1();
      var collectElement = $this_checkContext.o1x_1.aa(key);
      var tmp;
      if (!(key === Key_instance_3)) {
        return !(element === collectElement) ? -2147483648 : count + 1 | 0;
      }
      var collectJob = (collectElement == null ? true : isInterface(collectElement, Job)) ? collectElement : THROW_CCE();
      var emissionParentJob = transitiveCoroutineParent(isInterface(element, Job) ? element : THROW_CCE(), collectJob);
      var tmp_0;
      if (!(emissionParentJob === collectJob)) {
        // Inline function 'kotlin.error' call
        var message = 'Flow invariant is violated:\n\t\tEmission from another coroutine is detected.\n' + ('\t\tChild of ' + toString_0(emissionParentJob) + ', expected child of ' + toString_0(collectJob) + '.\n') + "\t\tFlowCollector is not thread-safe and concurrent emissions are prohibited.\n\t\tTo mitigate this restriction please use 'channelFlow' builder instead of 'flow'";
        throw IllegalStateException_init_$Create$(toString(message));
      }
      return collectJob == null ? count : count + 1 | 0;
    };
  }
  function SendingCollector(channel) {
    this.j2a_1 = channel;
  }
  protoOf(SendingCollector).a1v = function (value, $completion) {
    return this.j2a_1.r1s(value, $completion);
  };
  function flowOn(_this__u8e3s4, context) {
    checkFlowContext(context);
    var tmp;
    if (equals(context, EmptyCoroutineContext_getInstance())) {
      tmp = _this__u8e3s4;
    } else {
      if (isInterface(_this__u8e3s4, FusibleFlow)) {
        tmp = _this__u8e3s4.b1x(context);
      } else {
        tmp = new ChannelFlowOperatorImpl(_this__u8e3s4, context);
      }
    }
    return tmp;
  }
  function checkFlowContext(context) {
    // Inline function 'kotlin.require' call
    if (!(context.aa(Key_instance_3) == null)) {
      var message = 'Flow context cannot contain job in it. Had ' + toString(context);
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  }
  function buffer(_this__u8e3s4, capacity, onBufferOverflow) {
    capacity = capacity === VOID ? -2 : capacity;
    onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
    // Inline function 'kotlin.require' call
    if (!(capacity >= 0 || capacity === -2 || capacity === -1)) {
      var message = 'Buffer size should be non-negative, BUFFERED, or CONFLATED, but was ' + capacity;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!(!(capacity === -1) || onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()))) {
      var message_0 = 'CONFLATED capacity cannot be used with non-default onBufferOverflow';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    var capacity_0 = capacity;
    var onBufferOverflow_0 = onBufferOverflow;
    if (capacity_0 === -1) {
      capacity_0 = 0;
      onBufferOverflow_0 = BufferOverflow_DROP_OLDEST_getInstance();
    }
    var tmp;
    if (isInterface(_this__u8e3s4, FusibleFlow)) {
      tmp = _this__u8e3s4.b1x(VOID, capacity_0, onBufferOverflow_0);
    } else {
      tmp = new ChannelFlowOperatorImpl(_this__u8e3s4, VOID, capacity_0, onBufferOverflow_0);
    }
    return tmp;
  }
  function debounce(_this__u8e3s4, timeout) {
    return debounce_0(_this__u8e3s4, toDelayMillis(timeout));
  }
  function debounce_0(_this__u8e3s4, timeoutMillis) {
    // Inline function 'kotlin.require' call
    if (!(compare(timeoutMillis, new Long(0, 0)) >= 0)) {
      var message = 'Debounce timeout should not be negative';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    if (equalsLong(timeoutMillis, new Long(0, 0)))
      return _this__u8e3s4;
    return debounceInternal(_this__u8e3s4, debounce$lambda(timeoutMillis));
  }
  function debounceInternal(_this__u8e3s4, timeoutMillisSelector) {
    return scopedFlow(debounceInternal$slambda_0(timeoutMillisSelector, _this__u8e3s4, null));
  }
  function debounce$lambda($timeoutMillis) {
    return function (it) {
      return $timeoutMillis;
    };
  }
  function debounceInternal$slambda$slambda$slambda($this_produce, resultContinuation) {
    this.s2a_1 = $this_produce;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(debounceInternal$slambda$slambda$slambda).n25 = function (value, $completion) {
    var tmp = this.o25(value, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(debounceInternal$slambda$slambda$slambda).ja = function (p1, $completion) {
    return this.n25(p1, $completion);
  };
  protoOf(debounceInternal$slambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp0_elvis_lhs = this.t2a_1;
            suspendResult = this.s2a_1.r1s(tmp0_elvis_lhs == null ? get_NULL() : tmp0_elvis_lhs, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(debounceInternal$slambda$slambda$slambda).o25 = function (value, completion) {
    var i = new debounceInternal$slambda$slambda$slambda(this.s2a_1, completion);
    i.t2a_1 = value;
    return i;
  };
  function debounceInternal$slambda$slambda$slambda_0($this_produce, resultContinuation) {
    var i = new debounceInternal$slambda$slambda$slambda($this_produce, resultContinuation);
    return constructCallableReference(function (value, $completion) {
      return i.n25(value, $completion);
    }, 1);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_2(function_0) {
    this.u2a_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).a1v = function (value, $completion) {
    return this.u2a_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).q3 = function () {
    return this.u2a_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).hashCode = function () {
    return hashCode(this.q3());
  };
  function debounceInternal$slambda$slambda($this_debounceInternal, resultContinuation) {
    this.d2b_1 = $this_debounceInternal;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(debounceInternal$slambda$slambda).f2b = function ($this$produce, $completion) {
    var tmp = this.g2b($this$produce, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(debounceInternal$slambda$slambda).ja = function (p1, $completion) {
    return this.f2b((!(p1 == null) ? isInterface(p1, ProducerScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(debounceInternal$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = debounceInternal$slambda$slambda$slambda_0(this.e2b_1, null);
            suspendResult = this.d2b_1.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_2(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(debounceInternal$slambda$slambda).g2b = function ($this$produce, completion) {
    var i = new debounceInternal$slambda$slambda(this.d2b_1, completion);
    i.e2b_1 = $this$produce;
    return i;
  };
  function debounceInternal$slambda$slambda_0($this_debounceInternal, resultContinuation) {
    var i = new debounceInternal$slambda$slambda($this_debounceInternal, resultContinuation);
    return constructCallableReference(function ($this$produce, $completion) {
      return i.f2b($this$produce, $completion);
    }, 1);
  }
  function debounceInternal$slambda$slambda_1($downstream, $lastValue, resultContinuation) {
    this.p2b_1 = $downstream;
    this.q2b_1 = $lastValue;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(debounceInternal$slambda$slambda_1).r2b = function ($completion) {
    var tmp = this.s2b($completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(debounceInternal$slambda$slambda_1).ia = function ($completion) {
    return this.r2b($completion);
  };
  protoOf(debounceInternal$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp0 = get_NULL();
            var value = this.q2b_1._v;
            suspendResult = this.p2b_1.a1v(value === tmp0 ? null : value, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.q2b_1._v = null;
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(debounceInternal$slambda$slambda_1).s2b = function (completion) {
    return new debounceInternal$slambda$slambda_1(this.p2b_1, this.q2b_1, completion);
  };
  function debounceInternal$slambda$slambda_2($downstream, $lastValue, resultContinuation) {
    var i = new debounceInternal$slambda$slambda_1($downstream, $lastValue, resultContinuation);
    return constructCallableReference(function ($completion) {
      return i.r2b($completion);
    }, 0);
  }
  function debounceInternal$slambda$slambda_3($lastValue, $downstream, resultContinuation) {
    this.b2c_1 = $lastValue;
    this.c2c_1 = $downstream;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(debounceInternal$slambda$slambda_3).f2c = function (value, $completion) {
    var tmp = this.g2c(value, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(debounceInternal$slambda$slambda_3).ja = function (p1, $completion) {
    return this.f2c(p1 instanceof ChannelResult ? p1.s1p_1 : THROW_CCE(), $completion);
  };
  protoOf(debounceInternal$slambda$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var this_0 = this.d2c_1;
            var tmp_0 = _ChannelResult___get_holder__impl__pm9gzw(this_0);
            if (!(tmp_0 instanceof Failed)) {
              var it = _ChannelResult___get_holder__impl__pm9gzw(this_0);
              this.b2c_1._v = it;
            }

            this.e2c_1 = this_0;
            var tmp_1 = _ChannelResult___get_holder__impl__pm9gzw(this.e2c_1);
            if (tmp_1 instanceof Failed) {
              var tmp0_safe_receiver = ChannelResult__exceptionOrNull_impl_16ei30(this.e2c_1);
              if (tmp0_safe_receiver == null)
                null;
              else {
                throw tmp0_safe_receiver;
              }
              if (!(this.b2c_1._v == null)) {
                this.n9_1 = 1;
                var tmp0 = get_NULL();
                var value = this.b2c_1._v;
                suspendResult = this.c2c_1.a1v(value === tmp0 ? null : value, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 2;
                continue $sm;
              }
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.b2c_1._v = get_DONE();
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(debounceInternal$slambda$slambda_3).g2c = function (value, completion) {
    var i = new debounceInternal$slambda$slambda_3(this.b2c_1, this.c2c_1, completion);
    i.d2c_1 = value;
    return i;
  };
  function debounceInternal$slambda$slambda_4($lastValue, $downstream, resultContinuation) {
    var i = new debounceInternal$slambda$slambda_3($lastValue, $downstream, resultContinuation);
    return constructCallableReference(function (value, $completion) {
      return i.f2c(value.s1p_1, $completion);
    }, 1);
  }
  function debounceInternal$slambda($timeoutMillisSelector, $this_debounceInternal, resultContinuation) {
    this.p2c_1 = $timeoutMillisSelector;
    this.q2c_1 = $this_debounceInternal;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(debounceInternal$slambda).w2c = function ($this$scopedFlow, downstream, $completion) {
    var tmp = this.x2c($this$scopedFlow, downstream, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(debounceInternal$slambda).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE();
    return this.w2c(tmp, (!(p2 == null) ? isInterface(p2, FlowCollector) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(debounceInternal$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            var tmp_0 = this;
            tmp_0.u2c_1 = produce(this.r2c_1, VOID, VOID, debounceInternal$slambda$slambda_0(this.q2c_1, null));
            this.t2c_1 = {_v: null};
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!!(this.t2c_1._v === get_DONE())) {
              this.n9_1 = 6;
              continue $sm;
            }

            this.v2c_1 = {_v: new Long(0, 0)};
            if (!(this.t2c_1._v == null)) {
              var tmp0 = get_NULL();
              var value = this.t2c_1._v;
              this.v2c_1._v = this.p2c_1(value === tmp0 ? null : value);
              if (!(compare(this.v2c_1._v, new Long(0, 0)) >= 0)) {
                var message = 'Debounce timeout should not be negative';
                throw IllegalArgumentException_init_$Create$(toString(message));
              }
              if (equalsLong(this.v2c_1._v, new Long(0, 0))) {
                this.n9_1 = 2;
                var tmp0_0 = get_NULL();
                var value_0 = this.t2c_1._v;
                suspendResult = this.s2c_1.a1v(value_0 === tmp0_0 ? null : value_0, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 3;
                continue $sm;
              }
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 2:
            this.t2c_1._v = null;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            var $this$run = new SelectImplementation(this.t9());
            if (!(this.t2c_1._v == null)) {
              var tmp_1 = this.v2c_1._v;
              onTimeout($this$run, tmp_1, debounceInternal$slambda$slambda_2(this.s2c_1, this.t2c_1, null));
            }

            var tmp_2 = this.u2c_1.x1s();
            $this$run.y2c(tmp_2, debounceInternal$slambda$slambda_4(this.t2c_1, this.s2c_1, null));
            this.n9_1 = 5;
            suspendResult = $this$run.z2c(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.n9_1 = 1;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 7) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(debounceInternal$slambda).x2c = function ($this$scopedFlow, downstream, completion) {
    var i = new debounceInternal$slambda(this.p2c_1, this.q2c_1, completion);
    i.r2c_1 = $this$scopedFlow;
    i.s2c_1 = downstream;
    return i;
  };
  function debounceInternal$slambda_0($timeoutMillisSelector, $this_debounceInternal, resultContinuation) {
    var i = new debounceInternal$slambda($timeoutMillisSelector, $this_debounceInternal, resultContinuation);
    return constructCallableReference(function ($this$scopedFlow, downstream, $completion) {
      return i.w2c($this$scopedFlow, downstream, $completion);
    }, 2);
  }
  function get_defaultKeySelector() {
    _init_properties_Distinct_kt__4eindw();
    return defaultKeySelector;
  }
  var defaultKeySelector;
  function get_defaultAreEquivalent() {
    _init_properties_Distinct_kt__4eindw();
    return defaultAreEquivalent;
  }
  var defaultAreEquivalent;
  function distinctUntilChangedBy(_this__u8e3s4, keySelector, areEquivalent) {
    _init_properties_Distinct_kt__4eindw();
    var tmp;
    var tmp_0;
    var tmp_1;
    if (_this__u8e3s4 instanceof DistinctFlowImpl) {
      tmp_1 = _this__u8e3s4.b2d_1 === keySelector;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = _this__u8e3s4.c2d_1 === areEquivalent;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = _this__u8e3s4;
    } else {
      tmp = new DistinctFlowImpl(_this__u8e3s4, keySelector, areEquivalent);
    }
    return tmp;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_3(function_0) {
    this.d2d_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).a1v = function (value, $completion) {
    return this.d2d_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).q3 = function () {
    return this.d2d_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_3).hashCode = function () {
    return hashCode(this.q3());
  };
  function DistinctFlowImpl$collect$slambda(this$0, $previousKey, $collector, resultContinuation) {
    this.m2d_1 = this$0;
    this.n2d_1 = $previousKey;
    this.o2d_1 = $collector;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DistinctFlowImpl$collect$slambda).n25 = function (value, $completion) {
    var tmp = this.o25(value, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DistinctFlowImpl$collect$slambda).ja = function (p1, $completion) {
    return this.n25(p1, $completion);
  };
  protoOf(DistinctFlowImpl$collect$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var key = this.m2d_1.b2d_1(this.p2d_1);
            if (this.n2d_1._v === get_NULL() || !this.m2d_1.c2d_1(this.n2d_1._v, key)) {
              this.n2d_1._v = key;
              this.n9_1 = 1;
              suspendResult = this.o2d_1.a1v(this.p2d_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DistinctFlowImpl$collect$slambda).o25 = function (value, completion) {
    var i = new DistinctFlowImpl$collect$slambda(this.m2d_1, this.n2d_1, this.o2d_1, completion);
    i.p2d_1 = value;
    return i;
  };
  function DistinctFlowImpl$collect$slambda_0(this$0, $previousKey, $collector, resultContinuation) {
    var i = new DistinctFlowImpl$collect$slambda(this$0, $previousKey, $collector, resultContinuation);
    return constructCallableReference(function (value, $completion) {
      return i.n25(value, $completion);
    }, 1);
  }
  function DistinctFlowImpl(upstream, keySelector, areEquivalent) {
    this.a2d_1 = upstream;
    this.b2d_1 = keySelector;
    this.c2d_1 = areEquivalent;
  }
  protoOf(DistinctFlowImpl).l1u = function (collector, $completion) {
    var previousKey = {_v: get_NULL()};
    var tmp = DistinctFlowImpl$collect$slambda_0(this, previousKey, collector, null);
    return this.a2d_1.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_3(tmp), $completion);
  };
  function distinctUntilChanged(_this__u8e3s4) {
    _init_properties_Distinct_kt__4eindw();
    var tmp;
    if (isInterface(_this__u8e3s4, StateFlow)) {
      tmp = _this__u8e3s4;
    } else {
      tmp = distinctUntilChangedBy(_this__u8e3s4, get_defaultKeySelector(), get_defaultAreEquivalent());
    }
    return tmp;
  }
  function defaultKeySelector$lambda(it) {
    _init_properties_Distinct_kt__4eindw();
    return it;
  }
  function defaultAreEquivalent$lambda(old, new_0) {
    _init_properties_Distinct_kt__4eindw();
    return equals(old, new_0);
  }
  var properties_initialized_Distinct_kt_uy8c72;
  function _init_properties_Distinct_kt__4eindw() {
    if (!properties_initialized_Distinct_kt_uy8c72) {
      properties_initialized_Distinct_kt_uy8c72 = true;
      defaultKeySelector = defaultKeySelector$lambda;
      defaultAreEquivalent = defaultAreEquivalent$lambda;
    }
  }
  function onCompletion(_this__u8e3s4, action) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new onCompletion$$inlined$unsafeFlow$1(_this__u8e3s4, action);
  }
  function invokeSafely(_this__u8e3s4, action, cause, $completion) {
    var tmp = new $invokeSafelyCOROUTINE$(_this__u8e3s4, action, cause, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function ThrowingCollector(e) {
    this.b2e_1 = e;
  }
  protoOf(ThrowingCollector).i2a = function (value, $completion) {
    throw this.b2e_1;
  };
  protoOf(ThrowingCollector).a1v = function (value, $completion) {
    return this.i2a(value, $completion);
  };
  function ensureActive_1(_this__u8e3s4) {
    if (_this__u8e3s4 instanceof ThrowingCollector)
      throw _this__u8e3s4.b2e_1;
  }
  function onStart(_this__u8e3s4, action) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new onStart$$inlined$unsafeFlow$1(action, _this__u8e3s4);
  }
  function $collectCOROUTINE$_8(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k2e_1 = _this__u8e3s4;
    this.l2e_1 = collector;
  }
  protoOf($collectCOROUTINE$_8).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            this.o2e_1 = this.l2e_1;
            this.o9_1 = 7;
            this.n9_1 = 1;
            suspendResult = this.k2e_1.p2e_1.l1u(this.o2e_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.o9_1 = 9;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 9;
            var tmp_0 = this;
            tmp_0.n2e_1 = new SafeCollector(this.o2e_1, this.t9());
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            this.n9_1 = 4;
            suspendResult = this.k2e_1.q2e_1(this.n2e_1, null, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.o9_1 = 9;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.o9_1 = 9;
            this.n2e_1.x9();
            return Unit_instance;
          case 6:
            this.o9_1 = 9;
            var t = this.q9_1;
            this.n2e_1.x9();
            throw t;
          case 7:
            this.o9_1 = 9;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              this.m2e_1 = this.q9_1;
              this.n9_1 = 8;
              suspendResult = invokeSafely(new ThrowingCollector(this.m2e_1), this.k2e_1.q2e_1, this.m2e_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 8:
            throw this.m2e_1;
          case 9:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 9) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function onCompletion$$inlined$unsafeFlow$1($this_onCompletion, $action) {
    this.p2e_1 = $this_onCompletion;
    this.q2e_1 = $action;
  }
  protoOf(onCompletion$$inlined$unsafeFlow$1).b1v = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_8(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(onCompletion$$inlined$unsafeFlow$1).l1u = function (collector, $completion) {
    return this.b1v(collector, $completion);
  };
  function $collectCOROUTINE$_9(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z2e_1 = _this__u8e3s4;
    this.a2f_1 = collector;
  }
  protoOf($collectCOROUTINE$_9).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.c2f_1 = this.a2f_1;
            var tmp_0 = this;
            tmp_0.b2f_1 = new SafeCollector(this.c2f_1, this.t9());
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 5;
            this.n9_1 = 2;
            suspendResult = this.z2e_1.d2f_1(this.b2f_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 6;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            this.b2f_1.x9();
            this.n9_1 = 4;
            suspendResult = this.z2e_1.e2f_1.l1u(this.c2f_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            this.o9_1 = 6;
            var t = this.q9_1;
            this.b2f_1.x9();
            throw t;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function onStart$$inlined$unsafeFlow$1($action, $this_onStart) {
    this.d2f_1 = $action;
    this.e2f_1 = $this_onStart;
  }
  protoOf(onStart$$inlined$unsafeFlow$1).b1v = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_9(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(onStart$$inlined$unsafeFlow$1).l1u = function (collector, $completion) {
    return this.b1v(collector, $completion);
  };
  function $invokeSafelyCOROUTINE$(_this__u8e3s4, action, cause, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.y2d_1 = _this__u8e3s4;
    this.z2d_1 = action;
    this.a2e_1 = cause;
  }
  protoOf($invokeSafelyCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.z2d_1(this.y2d_1, this.a2e_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 4;
            return Unit_instance;
          case 3:
            this.o9_1 = 4;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var e = this.q9_1;
              if (!(this.a2e_1 === null) && !(this.a2e_1 === e)) {
                addSuppressed(e, this.a2e_1);
              }
              throw e;
            } else {
              throw this.q9_1;
            }

          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 4) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function catch_0(_this__u8e3s4, action) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new catch$$inlined$unsafeFlow$1(_this__u8e3s4, action);
  }
  function catchImpl(_this__u8e3s4, collector, $completion) {
    var tmp = new $catchImplCOROUTINE$(_this__u8e3s4, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function isSameExceptionAs(_this__u8e3s4, other) {
    return !(other == null) && equals(unwrap(other), unwrap(_this__u8e3s4));
  }
  function isCancellationCause(_this__u8e3s4, coroutineContext) {
    var job = coroutineContext.aa(Key_instance_3);
    if (job == null || !job.n1a())
      return false;
    return isSameExceptionAs(_this__u8e3s4, job.q1a());
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_4(function_0) {
    this.q2f_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).a1v = function (value, $completion) {
    return this.q2f_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).q3 = function () {
    return this.q2f_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_4).hashCode = function () {
    return hashCode(this.q3());
  };
  function $collectCOROUTINE$_10(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z2f_1 = _this__u8e3s4;
    this.a2g_1 = collector;
  }
  protoOf($collectCOROUTINE$_10).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.b2g_1 = this.a2g_1;
            this.n9_1 = 1;
            suspendResult = catchImpl(this.z2f_1.c2g_1, this.b2g_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var exception = suspendResult;
            if (!(exception == null)) {
              this.n9_1 = 2;
              suspendResult = this.z2f_1.d2g_1(this.b2g_1, exception, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function catch$$inlined$unsafeFlow$1($this_catch, $action) {
    this.c2g_1 = $this_catch;
    this.d2g_1 = $action;
  }
  protoOf(catch$$inlined$unsafeFlow$1).b1v = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_10(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(catch$$inlined$unsafeFlow$1).l1u = function (collector, $completion) {
    return this.b1v(collector, $completion);
  };
  function catchImpl$slambda($collector, $fromDownstream, resultContinuation) {
    this.m2g_1 = $collector;
    this.n2g_1 = $fromDownstream;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(catchImpl$slambda).n25 = function (it, $completion) {
    var tmp = this.o25(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(catchImpl$slambda).ja = function (p1, $completion) {
    return this.n25(p1, $completion);
  };
  protoOf(catchImpl$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.m2g_1.a1v(this.o2g_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 4;
            return Unit_instance;
          case 3:
            this.o9_1 = 4;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var e = this.q9_1;
              this.n2g_1._v = e;
              throw e;
            } else {
              throw this.q9_1;
            }

          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 4) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(catchImpl$slambda).o25 = function (it, completion) {
    var i = new catchImpl$slambda(this.m2g_1, this.n2g_1, completion);
    i.o2g_1 = it;
    return i;
  };
  function catchImpl$slambda_0($collector, $fromDownstream, resultContinuation) {
    var i = new catchImpl$slambda($collector, $fromDownstream, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.n25(it, $completion);
    }, 1);
  }
  function $catchImplCOROUTINE$(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.n2f_1 = _this__u8e3s4;
    this.o2f_1 = collector;
  }
  protoOf($catchImplCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.p2f_1 = {_v: null};
            this.o9_1 = 3;
            this.n9_1 = 1;
            var tmp_0 = catchImpl$slambda_0(this.o2f_1, this.p2f_1, null);
            suspendResult = this.n2f_1.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_4(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 4;
            return null;
          case 3:
            this.o9_1 = 4;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var e = this.q9_1;
              var fromDownstream = this.p2f_1._v;
              var tmp_2;
              if (isSameExceptionAs(e, fromDownstream)) {
                tmp_2 = true;
              } else {
                tmp_2 = isCancellationCause(e, this.t9());
              }
              if (tmp_2) {
                throw e;
              } else {
                if (fromDownstream == null) {
                  return e;
                }
                if (e instanceof CancellationException) {
                  addSuppressed(fromDownstream, e);
                  throw fromDownstream;
                } else {
                  addSuppressed(e, fromDownstream);
                  throw e;
                }
              }
            } else {
              throw this.q9_1;
            }

          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 4) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  var DEFAULT_CONCURRENCY;
  function mapLatest(_this__u8e3s4, transform) {
    _init_properties_Merge_kt__cbpr96();
    return transformLatest(_this__u8e3s4, mapLatest$slambda_0(transform, null));
  }
  function transformLatest(_this__u8e3s4, transform) {
    _init_properties_Merge_kt__cbpr96();
    return new ChannelFlowTransformLatest(transform, _this__u8e3s4);
  }
  function mapLatest$slambda($transform, resultContinuation) {
    this.x2g_1 = $transform;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(mapLatest$slambda).a2h = function ($this$transformLatest, it, $completion) {
    var tmp = this.b2h($this$transformLatest, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(mapLatest$slambda).ha = function (p1, p2, $completion) {
    return this.a2h((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), p2, $completion);
  };
  protoOf(mapLatest$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.x2g_1(this.z2g_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.n9_1 = 2;
            suspendResult = this.y2g_1.a1v(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(mapLatest$slambda).b2h = function ($this$transformLatest, it, completion) {
    var i = new mapLatest$slambda(this.x2g_1, completion);
    i.y2g_1 = $this$transformLatest;
    i.z2g_1 = it;
    return i;
  };
  function mapLatest$slambda_0($transform, resultContinuation) {
    var i = new mapLatest$slambda($transform, resultContinuation);
    return constructCallableReference(function ($this$transformLatest, it, $completion) {
      return i.a2h($this$transformLatest, it, $completion);
    }, 2);
  }
  var properties_initialized_Merge_kt_dhn6vs;
  function _init_properties_Merge_kt__cbpr96() {
    if (!properties_initialized_Merge_kt_dhn6vs) {
      properties_initialized_Merge_kt_dhn6vs = true;
      DEFAULT_CONCURRENCY = systemProp('kotlinx.coroutines.flow.defaultConcurrency', 16, 1, 2147483647);
    }
  }
  function asStateFlow(_this__u8e3s4) {
    return new ReadonlyStateFlow(_this__u8e3s4, null);
  }
  function $onSubscriptionCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k2h_1 = _this__u8e3s4;
  }
  protoOf($onSubscriptionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            var tmp_0 = this;
            tmp_0.l2h_1 = new SafeCollector(this.k2h_1.c1z_1, this.t9());
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 6;
            this.n9_1 = 2;
            suspendResult = this.k2h_1.d1z_1(this.l2h_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 7;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 7;
            this.l2h_1.x9();
            var tmp_1 = this.k2h_1.c1z_1;
            if (tmp_1 instanceof SubscribedFlowCollector) {
              this.n9_1 = 4;
              suspendResult = this.k2h_1.c1z_1.e1z(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            this.o9_1 = 7;
            var t = this.q9_1;
            this.l2h_1.x9();
            throw t;
          case 7:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 7) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function SubscribedFlowCollector() {
  }
  protoOf(SubscribedFlowCollector).e1z = function ($completion) {
    var tmp = new $onSubscriptionCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function $collectCOROUTINE$_11(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u2h_1 = _this__u8e3s4;
    this.v2h_1 = collector;
  }
  protoOf($collectCOROUTINE$_11).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.u2h_1.w2h_1.h1z(this.v2h_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function ReadonlyStateFlow(flow, job) {
    this.w2h_1 = flow;
    this.x2h_1 = job;
  }
  protoOf(ReadonlyStateFlow).a1x = function (context, capacity, onBufferOverflow) {
    return fuseStateFlow(this, context, capacity, onBufferOverflow);
  };
  protoOf(ReadonlyStateFlow).u1 = function () {
    return this.w2h_1.u1();
  };
  protoOf(ReadonlyStateFlow).h1z = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_11(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ReadonlyStateFlow).l1u = function (collector, $completion) {
    return this.h1z(collector, $completion);
  };
  function asSharedFlow(_this__u8e3s4) {
    return new ReadonlySharedFlow(_this__u8e3s4, null);
  }
  function stateIn(_this__u8e3s4, scope, started, initialValue) {
    var config = configureSharing(_this__u8e3s4, 1);
    var state = MutableStateFlow(initialValue);
    var job = launchSharing(scope, config.b2i_1, config.y2h_1, state, started, initialValue);
    return new ReadonlyStateFlow(state, job);
  }
  function $collectCOROUTINE$_12(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.k2i_1 = _this__u8e3s4;
    this.l2i_1 = collector;
  }
  protoOf($collectCOROUTINE$_12).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.k2i_1.m2i_1.h1z(this.l2i_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function ReadonlySharedFlow(flow, job) {
    this.m2i_1 = flow;
    this.n2i_1 = job;
  }
  protoOf(ReadonlySharedFlow).a1x = function (context, capacity, onBufferOverflow) {
    return fuseSharedFlow(this, context, capacity, onBufferOverflow);
  };
  protoOf(ReadonlySharedFlow).h1z = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_12(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ReadonlySharedFlow).l1u = function (collector, $completion) {
    return this.h1z(collector, $completion);
  };
  function SharingConfig(upstream, extraBufferCapacity, onBufferOverflow, context) {
    this.y2h_1 = upstream;
    this.z2h_1 = extraBufferCapacity;
    this.a2i_1 = onBufferOverflow;
    this.b2i_1 = context;
  }
  function configureSharing(_this__u8e3s4, replay) {
    // Inline function 'kotlinx.coroutines.assert' call
    var defaultExtraCapacity = coerceAtLeast(replay, Factory_getInstance().k1t_1) - replay | 0;
    if (_this__u8e3s4 instanceof ChannelFlow) {
      var upstream = _this__u8e3s4.u1w();
      if (!(upstream == null)) {
        var tmp0_subject = _this__u8e3s4.r1w_1;
        return new SharingConfig(upstream, tmp0_subject === -3 || (tmp0_subject === -2 || tmp0_subject === 0) ? _this__u8e3s4.s1w_1.equals(BufferOverflow_SUSPEND_getInstance()) ? _this__u8e3s4.r1w_1 === 0 ? 0 : defaultExtraCapacity : replay === 0 ? 1 : 0 : _this__u8e3s4.r1w_1, _this__u8e3s4.s1w_1, _this__u8e3s4.q1w_1);
      }
    }
    return new SharingConfig(_this__u8e3s4, defaultExtraCapacity, BufferOverflow_SUSPEND_getInstance(), EmptyCoroutineContext_getInstance());
  }
  function launchSharing(_this__u8e3s4, context, upstream, shared, started, initialValue) {
    var start = equals(started, Companion_getInstance_1().s1z_1) ? CoroutineStart_DEFAULT_getInstance() : CoroutineStart_UNDISPATCHED_getInstance();
    return launch(_this__u8e3s4, context, start, launchSharing$slambda_0(started, upstream, shared, initialValue, null));
  }
  function launchSharing$slambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launchSharing$slambda$slambda).x2i = function (it, $completion) {
    var tmp = this.h20(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(launchSharing$slambda$slambda).ja = function (p1, $completion) {
    return this.x2i((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launchSharing$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          return this.w2i_1 > 0;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(launchSharing$slambda$slambda).h20 = function (it, completion) {
    var i = new launchSharing$slambda$slambda(completion);
    i.w2i_1 = it;
    return i;
  };
  function launchSharing$slambda$slambda_0(resultContinuation) {
    var i = new launchSharing$slambda$slambda(resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.x2i(it, $completion);
    }, 1);
  }
  function launchSharing$slambda$slambda_1($upstream, $shared, $initialValue, resultContinuation) {
    this.g2j_1 = $upstream;
    this.h2j_1 = $shared;
    this.i2j_1 = $initialValue;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launchSharing$slambda$slambda_1).l2j = function (it, $completion) {
    var tmp = this.m2j(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(launchSharing$slambda$slambda_1).ja = function (p1, $completion) {
    return this.l2j(p1 instanceof SharingCommand ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launchSharing$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0 = this.j2j_1.a1_1;
            if (tmp0 === 0) {
              this.n9_1 = 1;
              suspendResult = this.g2j_1.l1u(this.h2j_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0 === 1) {
                var tmp_0 = this;
                tmp_0.k2j_1 = Unit_instance;
                this.n9_1 = 2;
                continue $sm;
              } else {
                if (tmp0 === 2) {
                  var tmp_1 = this;
                  var tmp_2;
                  if (this.i2j_1 === get_NO_VALUE()) {
                    this.h2j_1.m1z();
                    tmp_2 = Unit_instance;
                  } else {
                    tmp_2 = this.h2j_1.i1z(this.i2j_1);
                  }
                  tmp_1.k2j_1 = tmp_2;
                  this.n9_1 = 2;
                  continue $sm;
                } else {
                  var tmp_3 = this;
                  noWhenBranchMatchedException();
                }
              }
            }

            break;
          case 1:
            var tmp_4 = this;
            tmp_4.k2j_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(launchSharing$slambda$slambda_1).m2j = function (it, completion) {
    var i = new launchSharing$slambda$slambda_1(this.g2j_1, this.h2j_1, this.i2j_1, completion);
    i.j2j_1 = it;
    return i;
  };
  function launchSharing$slambda$slambda_2($upstream, $shared, $initialValue, resultContinuation) {
    var i = new launchSharing$slambda$slambda_1($upstream, $shared, $initialValue, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.l2j(it, $completion);
    }, 1);
  }
  function launchSharing$slambda($started, $upstream, $shared, $initialValue, resultContinuation) {
    this.v2j_1 = $started;
    this.w2j_1 = $upstream;
    this.x2j_1 = $shared;
    this.y2j_1 = $initialValue;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launchSharing$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(launchSharing$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launchSharing$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            if (this.v2j_1 === Companion_getInstance_1().s1z_1) {
              this.n9_1 = 4;
              suspendResult = this.w2j_1.l1u(this.x2j_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (this.v2j_1 === Companion_getInstance_1().t1z_1) {
                this.n9_1 = 2;
                var tmp_0 = this.x2j_1.n1z();
                suspendResult = first(tmp_0, launchSharing$slambda$slambda_0(null), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 1;
                var tmp_1 = distinctUntilChanged(this.v2j_1.u1z(this.x2j_1.n1z()));
                suspendResult = collectLatest(tmp_1, launchSharing$slambda$slambda_2(this.w2j_1, this.x2j_1, this.y2j_1, null), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }

          case 1:
            this.n9_1 = 5;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = this.w2j_1.l1u(this.x2j_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.n9_1 = 5;
            continue $sm;
          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(launchSharing$slambda).q24 = function ($this$launch, completion) {
    var i = new launchSharing$slambda(this.v2j_1, this.w2j_1, this.x2j_1, this.y2j_1, completion);
    i.z2j_1 = $this$launch;
    return i;
  };
  function launchSharing$slambda_0($started, $upstream, $shared, $initialValue, resultContinuation) {
    var i = new launchSharing$slambda($started, $upstream, $shared, $initialValue, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function onEach(_this__u8e3s4, action) {
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new onEach$$inlined$unsafeTransform$1(_this__u8e3s4, action);
  }
  function filterNotNull(_this__u8e3s4) {
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new filterNotNull$$inlined$unsafeTransform$1(_this__u8e3s4);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_5(function_0) {
    this.a2k_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_5).a1v = function (value, $completion) {
    return this.a2k_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_5).q3 = function () {
    return this.a2k_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_5).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_5).hashCode = function () {
    return hashCode(this.q3());
  };
  function onEach$o$collect$slambda($$this$unsafeFlow, $action, resultContinuation) {
    this.j2k_1 = $$this$unsafeFlow;
    this.k2k_1 = $action;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(onEach$o$collect$slambda).o2k = function (value, $completion) {
    var tmp = this.p2k(value, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(onEach$o$collect$slambda).ja = function (p1, $completion) {
    return this.o2k(p1, $completion);
  };
  protoOf(onEach$o$collect$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0 = this.j2k_1;
            var tmp2 = this.l2k_1;
            this.n2k_1 = tmp0;
            this.m2k_1 = tmp2;
            this.n9_1 = 1;
            suspendResult = this.k2k_1(this.m2k_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.n2k_1.a1v(this.m2k_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(onEach$o$collect$slambda).p2k = function (value, completion) {
    var i = new onEach$o$collect$slambda(this.j2k_1, this.k2k_1, completion);
    i.l2k_1 = value;
    return i;
  };
  function onEach$o$collect$slambda_0($$this$unsafeFlow, $action, resultContinuation) {
    var i = new onEach$o$collect$slambda($$this$unsafeFlow, $action, resultContinuation);
    return constructCallableReference(function (value, $completion) {
      return i.o2k(value, $completion);
    }, 1);
  }
  function $collectCOROUTINE$_13(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.y2k_1 = _this__u8e3s4;
    this.z2k_1 = collector;
  }
  protoOf($collectCOROUTINE$_13).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var $this$unsafeFlow = this.z2k_1;
            this.n9_1 = 1;
            var tmp_0 = onEach$o$collect$slambda_0($this$unsafeFlow, this.y2k_1.b2l_1, null);
            suspendResult = this.y2k_1.a2l_1.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_5(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function onEach$$inlined$unsafeTransform$1($this, $action) {
    this.a2l_1 = $this;
    this.b2l_1 = $action;
  }
  protoOf(onEach$$inlined$unsafeTransform$1).b1v = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_13(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(onEach$$inlined$unsafeTransform$1).l1u = function (collector, $completion) {
    return this.b1v(collector, $completion);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_6(function_0) {
    this.c2l_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_6).a1v = function (value, $completion) {
    return this.c2l_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_6).q3 = function () {
    return this.c2l_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_6).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_6).hashCode = function () {
    return hashCode(this.q3());
  };
  function filterNotNull$o$collect$slambda($$this$unsafeFlow, resultContinuation) {
    this.l2l_1 = $$this$unsafeFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(filterNotNull$o$collect$slambda).o2k = function (value, $completion) {
    var tmp = this.p2k(value, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(filterNotNull$o$collect$slambda).ja = function (p1, $completion) {
    return this.o2k(p1, $completion);
  };
  protoOf(filterNotNull$o$collect$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.o2l_1 = this.l2l_1;
            this.n2l_1 = this.m2l_1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            var $this$transform = this.o2l_1;
            var value = this.n2l_1;
            if (!(value == null)) {
              this.n9_1 = 3;
              suspendResult = $this$transform.a1v(value, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            if (false) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(filterNotNull$o$collect$slambda).p2k = function (value, completion) {
    var i = new filterNotNull$o$collect$slambda(this.l2l_1, completion);
    i.m2l_1 = value;
    return i;
  };
  function filterNotNull$o$collect$slambda_0($$this$unsafeFlow, resultContinuation) {
    var i = new filterNotNull$o$collect$slambda($$this$unsafeFlow, resultContinuation);
    return constructCallableReference(function (value, $completion) {
      return i.o2k(value, $completion);
    }, 1);
  }
  function $collectCOROUTINE$_14(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x2l_1 = _this__u8e3s4;
    this.y2l_1 = collector;
  }
  protoOf($collectCOROUTINE$_14).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var $this$unsafeFlow = this.y2l_1;
            this.n9_1 = 1;
            var tmp_0 = filterNotNull$o$collect$slambda_0($this$unsafeFlow, null);
            suspendResult = this.x2l_1.z2l_1.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_6(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function filterNotNull$$inlined$unsafeTransform$1($this) {
    this.z2l_1 = $this;
  }
  protoOf(filterNotNull$$inlined$unsafeTransform$1).b1v = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_14(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(filterNotNull$$inlined$unsafeTransform$1).l1u = function (collector, $completion) {
    return this.b1v(collector, $completion);
  };
  function combine(flow, flow2, transform) {
    return combine_0(flow, flow2, transform);
  }
  function combine_0(_this__u8e3s4, flow, transform) {
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    return new combine$$inlined$unsafeFlow$1(_this__u8e3s4, flow, transform);
  }
  function nullArrayFactory() {
    return nullArrayFactory$lambda;
  }
  function combine$o$collect$slambda($transform, resultContinuation) {
    this.i2m_1 = $transform;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(combine$o$collect$slambda).l2m = function ($this$combineInternal, it, $completion) {
    var tmp = this.m2m($this$combineInternal, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(combine$o$collect$slambda).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE();
    return this.l2m(tmp, (!(p2 == null) ? isArray(p2) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(combine$o$collect$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.i2m_1(this.k2m_1[0], this.k2m_1[1], this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.n9_1 = 2;
            suspendResult = this.j2m_1.a1v(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(combine$o$collect$slambda).m2m = function ($this$combineInternal, it, completion) {
    var i = new combine$o$collect$slambda(this.i2m_1, completion);
    i.j2m_1 = $this$combineInternal;
    i.k2m_1 = it;
    return i;
  };
  function combine$o$collect$slambda_0($transform, resultContinuation) {
    var i = new combine$o$collect$slambda($transform, resultContinuation);
    return constructCallableReference(function ($this$combineInternal, it, $completion) {
      return i.l2m($this$combineInternal, it, $completion);
    }, 2);
  }
  function $collectCOROUTINE$_15(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v2m_1 = _this__u8e3s4;
    this.w2m_1 = collector;
  }
  protoOf($collectCOROUTINE$_15).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var $this$flow = this.w2m_1;
            this.n9_1 = 1;
            var this_0 = [this.v2m_1.x2m_1, this.v2m_1.y2m_1];
            var tmp_0 = nullArrayFactory();
            suspendResult = combineInternal($this$flow, this_0, tmp_0, combine$o$collect$slambda_0(this.v2m_1.z2m_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function combine$$inlined$unsafeFlow$1($this_combine, $flow, $transform) {
    this.x2m_1 = $this_combine;
    this.y2m_1 = $flow;
    this.z2m_1 = $transform;
  }
  protoOf(combine$$inlined$unsafeFlow$1).b1v = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$_15(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(combine$$inlined$unsafeFlow$1).l1u = function (collector, $completion) {
    return this.b1v(collector, $completion);
  };
  function nullArrayFactory$lambda() {
    return null;
  }
  function collectLatest(_this__u8e3s4, action, $completion) {
    return collect(buffer(mapLatest(_this__u8e3s4, action), 0), $completion);
  }
  function collect(_this__u8e3s4, $completion) {
    return _this__u8e3s4.l1u(NopCollector_instance, $completion);
  }
  function launchIn(_this__u8e3s4, scope) {
    return launch(scope, VOID, VOID, launchIn$slambda_0(_this__u8e3s4, null));
  }
  function emitAll_0(_this__u8e3s4, flow, $completion) {
    ensureActive_1(_this__u8e3s4);
    return flow.l1u(_this__u8e3s4, $completion);
  }
  function launchIn$slambda($this_launchIn, resultContinuation) {
    this.i2n_1 = $this_launchIn;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(launchIn$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(launchIn$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(launchIn$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = collect(this.i2n_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(launchIn$slambda).q24 = function ($this$launch, completion) {
    var i = new launchIn$slambda(this.i2n_1, completion);
    i.j2n_1 = $this$launch;
    return i;
  };
  function launchIn$slambda_0($this_launchIn, resultContinuation) {
    var i = new launchIn$slambda($this_launchIn, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function first(_this__u8e3s4, predicate, $completion) {
    var tmp = new $firstCOROUTINE$(_this__u8e3s4, predicate, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function firstOrNull(_this__u8e3s4, predicate, $completion) {
    var tmp = new $firstOrNullCOROUTINE$(_this__u8e3s4, predicate, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function $emitCOROUTINE$(_this__u8e3s4, value, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.q2o_1 = _this__u8e3s4;
    this.r2o_1 = value;
  }
  protoOf($emitCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.t2o_1 = this.r2o_1;
            this.n9_1 = 1;
            suspendResult = this.q2o_1.u2o_1(this.t2o_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              var tmp_0 = this;
              this.q2o_1.v2o_1._v = this.t2o_1;
              tmp_0.s2o_1 = false;
              this.n9_1 = 2;
              continue $sm;
            } else {
              var tmp_1 = this;
              tmp_1.s2o_1 = true;
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            if (!this.s2o_1) {
              throw new AbortFlowException(this.q2o_1);
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function first$$inlined$collectWhile$1($predicate, $result) {
    this.u2o_1 = $predicate;
    this.v2o_1 = $result;
  }
  protoOf(first$$inlined$collectWhile$1).i2a = function (value, $completion) {
    var tmp = new $emitCOROUTINE$(this, value, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(first$$inlined$collectWhile$1).a1v = function (value, $completion) {
    return this.i2a(value, $completion);
  };
  function $emitCOROUTINE$_0(_this__u8e3s4, value, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.e2p_1 = _this__u8e3s4;
    this.f2p_1 = value;
  }
  protoOf($emitCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.h2p_1 = this.f2p_1;
            this.n9_1 = 1;
            suspendResult = this.e2p_1.i2p_1(this.h2p_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            if (suspendResult) {
              var tmp_0 = this;
              this.e2p_1.j2p_1._v = this.h2p_1;
              tmp_0.g2p_1 = false;
              this.n9_1 = 2;
              continue $sm;
            } else {
              var tmp_1 = this;
              tmp_1.g2p_1 = true;
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            if (!this.g2p_1) {
              throw new AbortFlowException(this.e2p_1);
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function firstOrNull$$inlined$collectWhile$1($predicate, $result) {
    this.i2p_1 = $predicate;
    this.j2p_1 = $result;
  }
  protoOf(firstOrNull$$inlined$collectWhile$1).i2a = function (value, $completion) {
    var tmp = new $emitCOROUTINE$_0(this, value, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(firstOrNull$$inlined$collectWhile$1).a1v = function (value, $completion) {
    return this.i2a(value, $completion);
  };
  function $firstCOROUTINE$(_this__u8e3s4, predicate, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s2n_1 = _this__u8e3s4;
    this.t2n_1 = predicate;
  }
  protoOf($firstCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.u2n_1 = {_v: get_NULL()};
            var this_0 = this.s2n_1;
            var tmp_0 = this;
            tmp_0.v2n_1 = new first$$inlined$collectWhile$1(this.t2n_1, this.u2n_1);
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this_0.l1u(this.v2n_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof AbortFlowException) {
              var e = this.q9_1;
              checkOwnership(e, this.v2n_1);
              ensureActive(this.t9());
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            if (this.u2n_1._v === get_NULL())
              throw NoSuchElementException_init_$Create$_0('Expected at least one element matching the predicate');
            return this.u2n_1._v;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 3) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function $firstOrNullCOROUTINE$(_this__u8e3s4, predicate, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.e2o_1 = _this__u8e3s4;
    this.f2o_1 = predicate;
  }
  protoOf($firstOrNullCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.g2o_1 = {_v: null};
            var this_0 = this.e2o_1;
            var tmp_0 = this;
            tmp_0.h2o_1 = new firstOrNull$$inlined$collectWhile$1(this.f2o_1, this.g2o_1);
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this_0.l1u(this.h2o_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.o9_1 = 4;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof AbortFlowException) {
              var e = this.q9_1;
              checkOwnership(e, this.h2o_1);
              ensureActive(this.t9());
              this.n9_1 = 3;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            this.o9_1 = 4;
            return this.g2o_1._v;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 4) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function set_value(_this__u8e3s4, value) {
    return _this__u8e3s4.k2p(value);
  }
  function get_value(_this__u8e3s4) {
    return _this__u8e3s4.f1i();
  }
  function get_CLOSED() {
    _init_properties_ConcurrentLinkedList_kt__5gcgzy();
    return CLOSED;
  }
  var CLOSED;
  function Segment(id, prev, pointers) {
    ConcurrentLinkedListNode.call(this, prev);
    this.h1e_1 = id;
    this.i1e_1 = atomic$int$1(pointers << 16);
  }
  protoOf(Segment).x1n = function () {
    return this.i1e_1.kotlinx$atomicfu$value === this.z1m() && !this.e1o();
  };
  protoOf(Segment).y1n = function () {
    var tmp0 = this.i1e_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.internal.addConditionally' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        if (!(!(cur === this.z1m()) || this.e1o())) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        if (tmp0.atomicfu$compareAndSet(cur, cur + 65536 | 0)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
    }
    return tmp$ret$0;
  };
  protoOf(Segment).z1n = function () {
    return this.i1e_1.atomicfu$addAndGet(-65536) === this.z1m() && !this.e1o();
  };
  protoOf(Segment).w1n = function () {
    if (this.i1e_1.atomicfu$incrementAndGet() === this.z1m()) {
      this.l4();
    }
  };
  function close(_this__u8e3s4) {
    _init_properties_ConcurrentLinkedList_kt__5gcgzy();
    var cur = _this__u8e3s4;
    while (true) {
      // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
      var this_0 = cur;
      // Inline function 'kotlin.let' call
      var it = access$_get_nextOrClosed__ywzond(this_0);
      var tmp;
      if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
        return cur;
      } else {
        tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
      }
      var next = tmp;
      if (next === null) {
        if (cur.h1o())
          return cur;
      } else {
        cur = next;
      }
    }
  }
  function _SegmentOrClosed___init__impl__jnexvb(value) {
    return value;
  }
  function _get_value__a43j40($this) {
    return $this;
  }
  function _SegmentOrClosed___get_isClosed__impl__qmxmlo($this) {
    return _get_value__a43j40($this) === get_CLOSED();
  }
  function _SegmentOrClosed___get_segment__impl__jvcr9l($this) {
    var tmp;
    if (_get_value__a43j40($this) === get_CLOSED()) {
      // Inline function 'kotlin.error' call
      var message = 'Does not contain segment';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      var tmp_0 = _get_value__a43j40($this);
      tmp = tmp_0 instanceof Segment ? tmp_0 : THROW_CCE();
    }
    return tmp;
  }
  function SegmentOrClosed__toString_impl_pzb2an($this) {
    return 'SegmentOrClosed(value=' + toString_0($this) + ')';
  }
  function SegmentOrClosed__hashCode_impl_4855hs($this) {
    return $this == null ? 0 : hashCode($this);
  }
  function SegmentOrClosed__equals_impl_6erq1g($this, other) {
    if (!(other instanceof SegmentOrClosed))
      return false;
    var tmp0_other_with_cast = other.j1q_1;
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function SegmentOrClosed(value) {
    this.j1q_1 = value;
  }
  protoOf(SegmentOrClosed).toString = function () {
    return SegmentOrClosed__toString_impl_pzb2an(this.j1q_1);
  };
  protoOf(SegmentOrClosed).hashCode = function () {
    return SegmentOrClosed__hashCode_impl_4855hs(this.j1q_1);
  };
  protoOf(SegmentOrClosed).equals = function (other) {
    return SegmentOrClosed__equals_impl_6erq1g(this.j1q_1, other);
  };
  function _get_nextOrClosed__w0gmuv($this) {
    return $this.a1o_1.kotlinx$atomicfu$value;
  }
  function _get_aliveSegmentLeft__mr4ndu($this) {
    var cur = $this.f1o();
    while (!(cur === null) && cur.x1n())
      cur = cur.b1o_1.kotlinx$atomicfu$value;
    return cur;
  }
  function _get_aliveSegmentRight__7ulr0b($this) {
    // Inline function 'kotlinx.coroutines.assert' call
    var cur = ensureNotNull($this.c1o());
    while (cur.x1n()) {
      var tmp0_elvis_lhs = cur.c1o();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return cur;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      cur = tmp;
    }
    return cur;
  }
  function access$_get_nextOrClosed__ywzond($this) {
    return _get_nextOrClosed__w0gmuv($this);
  }
  function ConcurrentLinkedListNode(prev) {
    this.a1o_1 = atomic$ref$1(null);
    this.b1o_1 = atomic$ref$1(prev);
  }
  protoOf(ConcurrentLinkedListNode).c1o = function () {
    // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
    // Inline function 'kotlin.let' call
    var it = access$_get_nextOrClosed__ywzond(this);
    var tmp;
    if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
      return null;
    } else {
      tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
    }
    return tmp;
  };
  protoOf(ConcurrentLinkedListNode).d1o = function (value) {
    return this.a1o_1.atomicfu$compareAndSet(null, value);
  };
  protoOf(ConcurrentLinkedListNode).e1o = function () {
    return this.c1o() == null;
  };
  protoOf(ConcurrentLinkedListNode).f1o = function () {
    return this.b1o_1.kotlinx$atomicfu$value;
  };
  protoOf(ConcurrentLinkedListNode).g1o = function () {
    // Inline function 'kotlinx.atomicfu.AtomicRef.lazySet' call
    this.b1o_1.kotlinx$atomicfu$value = null;
  };
  protoOf(ConcurrentLinkedListNode).h1o = function () {
    return this.a1o_1.atomicfu$compareAndSet(null, get_CLOSED());
  };
  protoOf(ConcurrentLinkedListNode).l4 = function () {
    // Inline function 'kotlinx.coroutines.assert' call
    if (this.e1o())
      return Unit_instance;
    $l$loop_0: while (true) {
      var prev = _get_aliveSegmentLeft__mr4ndu(this);
      var next = _get_aliveSegmentRight__7ulr0b(this);
      var tmp0 = next.b1o_1;
      $l$block: {
        // Inline function 'kotlinx.atomicfu.update' call
        while (true) {
          var cur = tmp0.kotlinx$atomicfu$value;
          var upd = cur === null ? null : prev;
          if (tmp0.atomicfu$compareAndSet(cur, upd)) {
            break $l$block;
          }
        }
      }
      if (!(prev === null))
        prev.a1o_1.kotlinx$atomicfu$value = next;
      if (next.x1n() && !next.e1o())
        continue $l$loop_0;
      if (!(prev === null) && prev.x1n())
        continue $l$loop_0;
      return Unit_instance;
    }
  };
  function findSegmentInternal(_this__u8e3s4, id, createNewSegment) {
    _init_properties_ConcurrentLinkedList_kt__5gcgzy();
    var cur = _this__u8e3s4;
    $l$loop: while (compare(cur.h1e_1, id) < 0 || cur.x1n()) {
      // Inline function 'kotlinx.coroutines.internal.ConcurrentLinkedListNode.nextOrIfClosed' call
      var this_0 = cur;
      // Inline function 'kotlin.let' call
      var it = access$_get_nextOrClosed__ywzond(this_0);
      var tmp;
      if (it === access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy()) {
        return _SegmentOrClosed___init__impl__jnexvb(get_CLOSED());
      } else {
        tmp = (it == null ? true : it instanceof ConcurrentLinkedListNode) ? it : THROW_CCE();
      }
      var next = tmp;
      if (!(next == null)) {
        cur = next;
        continue $l$loop;
      }
      // Inline function 'kotlin.Long.plus' call
      var this_1 = cur.h1e_1;
      var newTail = createNewSegment(add(this_1, fromInt(1)), cur);
      if (cur.d1o(newTail)) {
        if (cur.x1n()) {
          cur.l4();
        }
        cur = newTail;
      }
    }
    return _SegmentOrClosed___init__impl__jnexvb(cur);
  }
  function access$_get_CLOSED_$tConcurrentLinkedListKt_wmtpdy() {
    return get_CLOSED();
  }
  var properties_initialized_ConcurrentLinkedList_kt_kwt434;
  function _init_properties_ConcurrentLinkedList_kt__5gcgzy() {
    if (!properties_initialized_ConcurrentLinkedList_kt_kwt434) {
      properties_initialized_ConcurrentLinkedList_kt_kwt434 = true;
      CLOSED = new Symbol('CLOSED');
    }
  }
  function handleUncaughtCoroutineException(context, exception) {
    var _iterator__ex2g4s = get_platformExceptionHandlers().t();
    while (_iterator__ex2g4s.u()) {
      var handler = _iterator__ex2g4s.v();
      try {
        handler.f1h(context, exception);
      } catch ($p) {
        if ($p instanceof ExceptionSuccessfullyProcessed) {
          var _unused_var__etf5q3 = $p;
          return Unit_instance;
        } else {
          if ($p instanceof Error) {
            var t = $p;
            propagateExceptionFinalResort(handlerException(exception, t));
          } else {
            throw $p;
          }
        }
      }
    }
    try {
      addSuppressed(exception, new DiagnosticCoroutineContextException(context));
    } catch ($p_0) {
      if ($p_0 instanceof Error) {
        var e = $p_0;
      } else {
        throw $p_0;
      }
    }
    propagateExceptionFinalResort(exception);
  }
  function ExceptionSuccessfullyProcessed() {
  }
  function get_UNDEFINED() {
    _init_properties_DispatchedContinuation_kt__tnmqc0();
    return UNDEFINED;
  }
  var UNDEFINED;
  function get_REUSABLE_CLAIMED() {
    _init_properties_DispatchedContinuation_kt__tnmqc0();
    return REUSABLE_CLAIMED;
  }
  var REUSABLE_CLAIMED;
  function resumeCancellableWithInternal(_this__u8e3s4, result) {
    _init_properties_DispatchedContinuation_kt__tnmqc0();
    var tmp;
    if (_this__u8e3s4 instanceof DispatchedContinuation) {
      // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancellableWith' call
      var state = toState_0(result);
      if (safeIsDispatchNeeded(_this__u8e3s4.u1d_1, _this__u8e3s4.t9())) {
        _this__u8e3s4.w1d_1 = state;
        _this__u8e3s4.d1e_1 = 1;
        safeDispatch(_this__u8e3s4.u1d_1, _this__u8e3s4.t9(), _this__u8e3s4);
      } else {
        $l$block: {
          // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
          // Inline function 'kotlinx.coroutines.assert' call
          var eventLoop = ThreadLocalEventLoop_getInstance().d1i();
          if (false && eventLoop.y1h()) {
            break $l$block;
          }
          var tmp_0;
          if (eventLoop.x1h()) {
            _this__u8e3s4.w1d_1 = state;
            _this__u8e3s4.d1e_1 = 1;
            eventLoop.w1h(_this__u8e3s4);
            tmp_0 = true;
          } else {
            // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
            eventLoop.z1h(true);
            try {
              var tmp$ret$5;
              $l$block_0: {
                // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeCancelled' call
                var job = _this__u8e3s4.t9().aa(Key_instance_3);
                if (!(job == null) && !job.r19()) {
                  var cause = job.q1a();
                  _this__u8e3s4.x1e(state, cause);
                  // Inline function 'kotlin.coroutines.resumeWithException' call
                  // Inline function 'kotlin.Companion.failure' call
                  var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(cause));
                  _this__u8e3s4.y9(tmp$ret$7);
                  tmp$ret$5 = true;
                  break $l$block_0;
                }
                tmp$ret$5 = false;
              }
              if (!tmp$ret$5) {
                // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
                _this__u8e3s4.v1d_1;
                // Inline function 'kotlinx.coroutines.withContinuationContext' call
                _this__u8e3s4.x1d_1;
                _this__u8e3s4.v1d_1.y9(result);
              }
              $l$loop: while (eventLoop.v1h()) {
              }
            } catch ($p) {
              if ($p instanceof Error) {
                var e = $p;
                _this__u8e3s4.p1f(e);
              } else {
                throw $p;
              }
            }
            finally {
              eventLoop.a1i(true);
            }
            tmp_0 = false;
          }
        }
      }
      tmp = Unit_instance;
    } else {
      _this__u8e3s4.y9(result);
      tmp = Unit_instance;
    }
    return tmp;
  }
  function _get_reusableCancellableContinuation__9qex09($this) {
    var tmp = $this.y1d_1.kotlinx$atomicfu$value;
    return tmp instanceof CancellableContinuationImpl ? tmp : null;
  }
  function DispatchedContinuation(dispatcher, continuation) {
    DispatchedTask.call(this, -1);
    this.u1d_1 = dispatcher;
    this.v1d_1 = continuation;
    this.w1d_1 = get_UNDEFINED();
    this.x1d_1 = threadContextElements(this.t9());
    this.y1d_1 = atomic$ref$1(null);
  }
  protoOf(DispatchedContinuation).c1e = function () {
    return !(this.y1d_1.kotlinx$atomicfu$value == null);
  };
  protoOf(DispatchedContinuation).l2p = function () {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.y1d_1;
    while (true) {
      if (!(this_0.kotlinx$atomicfu$value === get_REUSABLE_CLAIMED()))
        return Unit_instance;
    }
  };
  protoOf(DispatchedContinuation).d1h = function () {
    this.l2p();
    var tmp0_safe_receiver = _get_reusableCancellableContinuation__9qex09(this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.t1e();
    }
  };
  protoOf(DispatchedContinuation).z1d = function () {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.y1d_1;
    while (true) {
      var state = this_0.kotlinx$atomicfu$value;
      if (state === null) {
        this.y1d_1.kotlinx$atomicfu$value = get_REUSABLE_CLAIMED();
        return null;
      } else {
        if (state instanceof CancellableContinuationImpl) {
          if (this.y1d_1.atomicfu$compareAndSet(state, get_REUSABLE_CLAIMED())) {
            return state instanceof CancellableContinuationImpl ? state : THROW_CCE();
          }
        } else {
          if (state !== get_REUSABLE_CLAIMED()) {
            if (!(state instanceof Error)) {
              // Inline function 'kotlin.error' call
              var message = 'Inconsistent state ' + toString(state);
              throw IllegalStateException_init_$Create$(toString(message));
            }
          }
        }
      }
    }
  };
  protoOf(DispatchedContinuation).e1f = function (continuation) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.y1d_1;
    while (true) {
      var state = this_0.kotlinx$atomicfu$value;
      if (state === get_REUSABLE_CLAIMED()) {
        if (this.y1d_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), continuation))
          return null;
      } else {
        if (state instanceof Error) {
          // Inline function 'kotlin.require' call
          // Inline function 'kotlin.require' call
          if (!this.y1d_1.atomicfu$compareAndSet(state, null)) {
            var message = 'Failed requirement.';
            throw IllegalArgumentException_init_$Create$(toString(message));
          }
          return state;
        } else {
          // Inline function 'kotlin.error' call
          var message_0 = 'Inconsistent state ' + toString_0(state);
          throw IllegalStateException_init_$Create$(toString(message_0));
        }
      }
    }
  };
  protoOf(DispatchedContinuation).e1e = function (cause) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.y1d_1;
    while (true) {
      var state = this_0.kotlinx$atomicfu$value;
      if (equals(state, get_REUSABLE_CLAIMED())) {
        if (this.y1d_1.atomicfu$compareAndSet(get_REUSABLE_CLAIMED(), cause))
          return true;
      } else {
        if (state instanceof Error)
          return true;
        else {
          if (this.y1d_1.atomicfu$compareAndSet(state, null))
            return false;
        }
      }
    }
  };
  protoOf(DispatchedContinuation).w1e = function () {
    var state = this.w1d_1;
    // Inline function 'kotlinx.coroutines.assert' call
    this.w1d_1 = get_UNDEFINED();
    return state;
  };
  protoOf(DispatchedContinuation).u1e = function () {
    return this;
  };
  protoOf(DispatchedContinuation).y9 = function (result) {
    var state = toState_0(result);
    if (safeIsDispatchNeeded(this.u1d_1, this.t9())) {
      this.w1d_1 = state;
      this.d1e_1 = 0;
      safeDispatch(this.u1d_1, this.t9(), this);
    } else {
      $l$block: {
        // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
        // Inline function 'kotlinx.coroutines.assert' call
        var eventLoop = ThreadLocalEventLoop_getInstance().d1i();
        if (false && eventLoop.y1h()) {
          break $l$block;
        }
        var tmp;
        if (eventLoop.x1h()) {
          this.w1d_1 = state;
          this.d1e_1 = 0;
          eventLoop.w1h(this);
          tmp = true;
        } else {
          // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
          eventLoop.z1h(true);
          try {
            this.t9();
            // Inline function 'kotlinx.coroutines.withCoroutineContext' call
            this.x1d_1;
            this.v1d_1.y9(result);
            $l$loop: while (eventLoop.v1h()) {
            }
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              this.p1f(e);
            } else {
              throw $p;
            }
          }
          finally {
            eventLoop.a1i(true);
          }
          tmp = false;
        }
      }
    }
  };
  protoOf(DispatchedContinuation).r1m = function (context, value) {
    this.w1d_1 = value;
    this.d1e_1 = 1;
    this.u1d_1.c1h(context, this);
  };
  protoOf(DispatchedContinuation).toString = function () {
    return 'DispatchedContinuation[' + this.u1d_1.toString() + ', ' + toDebugString(this.v1d_1) + ']';
  };
  protoOf(DispatchedContinuation).t9 = function () {
    return this.v1d_1.t9();
  };
  function safeDispatch(_this__u8e3s4, context, runnable) {
    _init_properties_DispatchedContinuation_kt__tnmqc0();
    try {
      _this__u8e3s4.b1h(context, runnable);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        throw new DispatchException(e, _this__u8e3s4, context);
      } else {
        throw $p;
      }
    }
  }
  function safeIsDispatchNeeded(_this__u8e3s4, context) {
    _init_properties_DispatchedContinuation_kt__tnmqc0();
    try {
      return _this__u8e3s4.y1g(context);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        throw new DispatchException(e, _this__u8e3s4, context);
      } else {
        throw $p;
      }
    }
  }
  function yieldUndispatched(_this__u8e3s4) {
    _init_properties_DispatchedContinuation_kt__tnmqc0();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.coroutines.internal.executeUnconfined' call
      // Inline function 'kotlinx.coroutines.assert' call
      var eventLoop = ThreadLocalEventLoop_getInstance().d1i();
      if (true && eventLoop.y1h()) {
        tmp$ret$0 = false;
        break $l$block;
      }
      var tmp;
      if (eventLoop.x1h()) {
        _this__u8e3s4.w1d_1 = Unit_instance;
        _this__u8e3s4.d1e_1 = 1;
        eventLoop.w1h(_this__u8e3s4);
        tmp = true;
      } else {
        // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
        eventLoop.z1h(true);
        try {
          _this__u8e3s4.o1f();
          $l$loop: while (eventLoop.v1h()) {
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            _this__u8e3s4.p1f(e);
          } else {
            throw $p;
          }
        }
        finally {
          eventLoop.a1i(true);
        }
        tmp = false;
      }
      tmp$ret$0 = tmp;
    }
    return tmp$ret$0;
  }
  var properties_initialized_DispatchedContinuation_kt_2siadq;
  function _init_properties_DispatchedContinuation_kt__tnmqc0() {
    if (!properties_initialized_DispatchedContinuation_kt_2siadq) {
      properties_initialized_DispatchedContinuation_kt_2siadq = true;
      UNDEFINED = new Symbol('UNDEFINED');
      REUSABLE_CLAIMED = new Symbol('REUSABLE_CLAIMED');
    }
  }
  function DispatchedTask(resumeMode) {
    SchedulerTask.call(this);
    this.d1e_1 = resumeMode;
  }
  protoOf(DispatchedTask).x1e = function (takenState, cause) {
  };
  protoOf(DispatchedTask).d1f = function (state) {
    return state;
  };
  protoOf(DispatchedTask).m1f = function (state) {
    var tmp0_safe_receiver = state instanceof CompletedExceptionally ? state : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w19_1;
  };
  protoOf(DispatchedTask).o1f = function () {
    // Inline function 'kotlinx.coroutines.assert' call
    try {
      var tmp = this.u1e();
      var delegate = tmp instanceof DispatchedContinuation ? tmp : THROW_CCE();
      var continuation = delegate.v1d_1;
      // Inline function 'kotlinx.coroutines.withContinuationContext' call
      delegate.x1d_1;
      var context = continuation.t9();
      var state = this.w1e();
      var exception = this.m1f(state);
      var job = exception == null && get_isCancellableMode(this.d1e_1) ? context.aa(Key_instance_3) : null;
      if (!(job == null) && !job.r19()) {
        var cause = job.q1a();
        this.x1e(state, cause);
        // Inline function 'kotlinx.coroutines.resumeWithStackTrace' call
        // Inline function 'kotlin.Companion.failure' call
        var exception_0 = recoverStackTrace(cause, continuation);
        var tmp$ret$4 = _Result___init__impl__xyqfz8(createFailure(exception_0));
        continuation.y9(tmp$ret$4);
      } else {
        if (!(exception == null)) {
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var tmp$ret$6 = _Result___init__impl__xyqfz8(createFailure(exception));
          continuation.y9(tmp$ret$6);
        } else {
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = this.d1f(state);
          var tmp$ret$8 = _Result___init__impl__xyqfz8(value);
          continuation.y9(tmp$ret$8);
        }
      }
    } catch ($p) {
      if ($p instanceof DispatchException) {
        var e = $p;
        handleCoroutineException(this.u1e().t9(), e.e1h_1);
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          this.p1f(e_0);
        } else {
          throw $p;
        }
      }
    }
  };
  protoOf(DispatchedTask).p1f = function (exception) {
    var reason = new CoroutinesInternalError('Fatal exception in coroutines machinery for ' + toString(this) + '. ' + "Please read KDoc to 'handleFatalException' method and report this incident to maintainers", exception);
    handleCoroutineException(this.u1e().t9(), reason);
  };
  function get_isReusableMode(_this__u8e3s4) {
    return _this__u8e3s4 === 2;
  }
  function get_isCancellableMode(_this__u8e3s4) {
    return _this__u8e3s4 === 1 || _this__u8e3s4 === 2;
  }
  function dispatch(_this__u8e3s4, mode) {
    // Inline function 'kotlinx.coroutines.assert' call
    var delegate = _this__u8e3s4.u1e();
    var undispatched = mode === 4;
    var tmp;
    var tmp_0;
    if (!undispatched) {
      tmp_0 = delegate instanceof DispatchedContinuation;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = get_isCancellableMode(mode) === get_isCancellableMode(_this__u8e3s4.d1e_1);
    } else {
      tmp = false;
    }
    if (tmp) {
      var dispatcher = delegate.u1d_1;
      var context = delegate.t9();
      if (safeIsDispatchNeeded(dispatcher, context)) {
        safeDispatch(dispatcher, context, _this__u8e3s4);
      } else {
        resumeUnconfined(_this__u8e3s4);
      }
    } else {
      resume(_this__u8e3s4, delegate, undispatched);
    }
  }
  function DispatchException(cause, dispatcher, context) {
    Exception_init_$Init$('Coroutine dispatcher ' + dispatcher.toString() + ' threw an exception, context = ' + toString(context), cause, this);
    captureStack(this, DispatchException);
    this.e1h_1 = cause;
    delete this.cause;
  }
  protoOf(DispatchException).f = function () {
    return this.e1h_1;
  };
  function resumeUnconfined(_this__u8e3s4) {
    var eventLoop = ThreadLocalEventLoop_getInstance().d1i();
    if (eventLoop.x1h()) {
      eventLoop.w1h(_this__u8e3s4);
    } else {
      // Inline function 'kotlinx.coroutines.runUnconfinedEventLoop' call
      eventLoop.z1h(true);
      try {
        resume(_this__u8e3s4, _this__u8e3s4.u1e(), true);
        $l$loop: while (eventLoop.v1h()) {
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          _this__u8e3s4.p1f(e);
        } else {
          throw $p;
        }
      }
      finally {
        eventLoop.a1i(true);
      }
    }
  }
  function resume(_this__u8e3s4, delegate, undispatched) {
    var state = _this__u8e3s4.w1e();
    var exception = _this__u8e3s4.m1f(state);
    var tmp;
    if (!(exception == null)) {
      // Inline function 'kotlin.Companion.failure' call
      tmp = _Result___init__impl__xyqfz8(createFailure(exception));
    } else {
      // Inline function 'kotlin.Companion.success' call
      var value = _this__u8e3s4.d1f(state);
      tmp = _Result___init__impl__xyqfz8(value);
    }
    var result = tmp;
    if (undispatched) {
      // Inline function 'kotlinx.coroutines.internal.DispatchedContinuation.resumeUndispatchedWith' call
      var this_0 = delegate instanceof DispatchedContinuation ? delegate : THROW_CCE();
      this_0.v1d_1;
      // Inline function 'kotlinx.coroutines.withContinuationContext' call
      this_0.x1d_1;
      this_0.v1d_1.y9(result);
    } else {
      delegate.y9(result);
    }
  }
  function _InlineList___init__impl__z8n56(holder) {
    holder = holder === VOID ? null : holder;
    return holder;
  }
  function _get_holder__f6h5pd($this) {
    return $this;
  }
  function InlineList__plus_impl_nuetvo($this, element) {
    // Inline function 'kotlinx.coroutines.assert' call
    var tmp0_subject = _get_holder__f6h5pd($this);
    var tmp;
    if (tmp0_subject == null) {
      tmp = _InlineList___init__impl__z8n56(element);
    } else {
      if (tmp0_subject instanceof ArrayList) {
        var tmp_0 = _get_holder__f6h5pd($this);
        (tmp_0 instanceof ArrayList ? tmp_0 : THROW_CCE()).j1(element);
        tmp = _InlineList___init__impl__z8n56(_get_holder__f6h5pd($this));
      } else {
        var list = ArrayList_init_$Create$(4);
        list.j1(_get_holder__f6h5pd($this));
        list.j1(element);
        tmp = _InlineList___init__impl__z8n56(list);
      }
    }
    return tmp;
  }
  function access$_get_holder__kkflen($this) {
    return _get_holder__f6h5pd($this);
  }
  function checkParallelism(_this__u8e3s4) {
    // Inline function 'kotlin.require' call
    if (!(_this__u8e3s4 >= 1)) {
      var message = 'Expected positive parallelism level, but got ' + _this__u8e3s4;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return Unit_instance;
  }
  function tryAllocateWorker($this) {
    // Inline function 'kotlinx.coroutines.internal.synchronized' call
    // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
    $this.t2p_1;
    if ($this.r2p_1.kotlinx$atomicfu$value >= $this.p2p_1)
      return false;
    $this.r2p_1.atomicfu$incrementAndGet();
    return true;
  }
  function obtainTaskOrDeallocateWorker($this) {
    while (true) {
      var nextTask = $this.s2p_1.ch();
      if (nextTask == null) {
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        $this.t2p_1;
        $this.r2p_1.atomicfu$decrementAndGet();
        if ($this.s2p_1.n1() === 0)
          return null;
        $this.r2p_1.atomicfu$incrementAndGet();
      } else
        return nextTask;
    }
  }
  function Worker($outer, currentTask) {
    this.w2p_1 = $outer;
    this.v2p_1 = currentTask;
  }
  protoOf(Worker).o1f = function () {
    try {
      var fairnessCounter = 0;
      while (true) {
        try {
          this.v2p_1.o1f();
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            handleCoroutineException(EmptyCoroutineContext_getInstance(), e);
          } else {
            throw $p;
          }
        }
        var tmp = this;
        var tmp0_elvis_lhs = obtainTaskOrDeallocateWorker(this.w2p_1);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp.v2p_1 = tmp_0;
        var tmp_1;
        fairnessCounter = fairnessCounter + 1 | 0;
        if (fairnessCounter >= 16) {
          tmp_1 = safeIsDispatchNeeded(this.w2p_1.o2p_1, this.w2p_1);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          safeDispatch(this.w2p_1.o2p_1, this.w2p_1, this);
          return Unit_instance;
        }
      }
    } catch ($p_0) {
      if ($p_0 instanceof Error) {
        var e_0 = $p_0;
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        this.w2p_1.t2p_1;
        this.w2p_1.r2p_1.atomicfu$decrementAndGet();
        throw e_0;
      } else {
        throw $p_0;
      }
    }
  };
  function LimitedDispatcher(dispatcher, parallelism, name) {
    CoroutineDispatcher.call(this);
    var tmp = this;
    var tmp0_elvis_lhs = isInterface(dispatcher, Delay) ? dispatcher : null;
    tmp.n2p_1 = tmp0_elvis_lhs == null ? get_DefaultDelay() : tmp0_elvis_lhs;
    this.o2p_1 = dispatcher;
    this.p2p_1 = parallelism;
    this.q2p_1 = name;
    this.r2p_1 = atomic$int$1(0);
    this.s2p_1 = new LockFreeTaskQueue(false);
    this.t2p_1 = new SynchronizedObject();
  }
  protoOf(LimitedDispatcher).z1g = function (parallelism, name) {
    checkParallelism(parallelism);
    if (parallelism >= this.p2p_1)
      return namedOrThis(this, name);
    return protoOf(CoroutineDispatcher).z1g.call(this, parallelism, name);
  };
  protoOf(LimitedDispatcher).b1h = function (context, block) {
    $l$block_1: {
      // Inline function 'kotlinx.coroutines.internal.LimitedDispatcher.dispatchInternal' call
      this.s2p_1.x2p(block);
      if (this.r2p_1.kotlinx$atomicfu$value >= this.p2p_1) {
        break $l$block_1;
      }
      if (!tryAllocateWorker(this)) {
        break $l$block_1;
      }
      var tmp0_elvis_lhs = obtainTaskOrDeallocateWorker(this);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var task = tmp;
      try {
        var worker = new Worker(this, task);
        safeDispatch(this.o2p_1, this, worker);
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          this.r2p_1.atomicfu$decrementAndGet();
          throw e;
        } else {
          throw $p;
        }
      }
    }
  };
  protoOf(LimitedDispatcher).c1h = function (context, block) {
    $l$block_1: {
      // Inline function 'kotlinx.coroutines.internal.LimitedDispatcher.dispatchInternal' call
      this.s2p_1.x2p(block);
      if (this.r2p_1.kotlinx$atomicfu$value >= this.p2p_1) {
        break $l$block_1;
      }
      if (!tryAllocateWorker(this)) {
        break $l$block_1;
      }
      var tmp0_elvis_lhs = obtainTaskOrDeallocateWorker(this);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var task = tmp;
      try {
        var worker = new Worker(this, task);
        this.o2p_1.c1h(this, worker);
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          this.r2p_1.atomicfu$decrementAndGet();
          throw e;
        } else {
          throw $p;
        }
      }
    }
  };
  protoOf(LimitedDispatcher).toString = function () {
    var tmp0_elvis_lhs = this.q2p_1;
    return tmp0_elvis_lhs == null ? this.o2p_1.toString() + '.limitedParallelism(' + this.p2p_1 + ')' : tmp0_elvis_lhs;
  };
  protoOf(LimitedDispatcher).o1h = function (timeMillis, continuation) {
    this.n2p_1.o1h(timeMillis, continuation);
  };
  protoOf(LimitedDispatcher).p1h = function (timeMillis, block, context) {
    return this.n2p_1.p1h(timeMillis, block, context);
  };
  function namedOrThis(_this__u8e3s4, name) {
    if (!(name == null))
      return new NamedDispatcher(_this__u8e3s4, name);
    return _this__u8e3s4;
  }
  function LockFreeTaskQueue(singleConsumer) {
    this.u2p_1 = atomic$ref$1(new LockFreeTaskQueueCore(8, singleConsumer));
  }
  protoOf(LockFreeTaskQueue).n1 = function () {
    return this.u2p_1.kotlinx$atomicfu$value.n1();
  };
  protoOf(LockFreeTaskQueue).x2p = function (element) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.u2p_1;
    while (true) {
      var cur = this_0.kotlinx$atomicfu$value;
      switch (cur.x2p(element)) {
        case 0:
          return true;
        case 2:
          return false;
        case 1:
          this.u2p_1.atomicfu$compareAndSet(cur, cur.v());
          break;
      }
    }
  };
  protoOf(LockFreeTaskQueue).ch = function () {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.u2p_1;
    while (true) {
      var cur = this_0.kotlinx$atomicfu$value;
      var result = cur.ch();
      if (!(result === Companion_getInstance_2().q2q_1))
        return result;
      this.u2p_1.atomicfu$compareAndSet(cur, cur.v());
    }
  };
  function fillPlaceholder($this, index, element) {
    var old = $this.d2q_1.atomicfu$get(index & $this.a2q_1).kotlinx$atomicfu$value;
    var tmp;
    if (old instanceof Placeholder) {
      tmp = old.u2q_1 === index;
    } else {
      tmp = false;
    }
    if (tmp) {
      $this.d2q_1.atomicfu$get(index & $this.a2q_1).kotlinx$atomicfu$value = element;
      return $this;
    }
    return null;
  }
  function removeSlowPath($this, oldHead, newHead) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.c2q_1;
    while (true) {
      var state = this_0.kotlinx$atomicfu$value;
      // Inline function 'kotlinx.coroutines.internal.Companion.withState' call
      Companion_getInstance_2();
      var head = convertToInt(shiftRight(bitwiseAnd(state, new Long(1073741823, 0)), 0));
      var tail = convertToInt(shiftRight(bitwiseAnd(state, new Long(-1073741824, 268435455)), 30));
      // Inline function 'kotlinx.coroutines.assert' call
      if (!equalsLong(bitwiseAnd(state, new Long(0, 268435456)), new Long(0, 0))) {
        return $this.v();
      }
      if ($this.c2q_1.atomicfu$compareAndSet(state, Companion_getInstance_2().v2q(state, newHead))) {
        $this.d2q_1.atomicfu$get(head & $this.a2q_1).kotlinx$atomicfu$value = null;
        return null;
      }
    }
  }
  function markFrozen($this) {
    var tmp0 = $this.c2q_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        if (!equalsLong(bitwiseAnd(cur, new Long(0, 268435456)), new Long(0, 0)))
          return cur;
        var upd = bitwiseOr(cur, new Long(0, 268435456));
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          tmp$ret$0 = upd;
          break $l$block;
        }
      }
    }
    return tmp$ret$0;
  }
  function allocateOrGetNextCopy($this, state) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = $this.b2q_1;
    while (true) {
      var next = this_0.kotlinx$atomicfu$value;
      if (!(next == null))
        return next;
      $this.b2q_1.atomicfu$compareAndSet(null, allocateNextCopy($this, state));
    }
  }
  function allocateNextCopy($this, state) {
    var next = new LockFreeTaskQueueCore(imul($this.y2p_1, 2), $this.z2p_1);
    // Inline function 'kotlinx.coroutines.internal.Companion.withState' call
    Companion_getInstance_2();
    var head = convertToInt(shiftRight(bitwiseAnd(state, new Long(1073741823, 0)), 0));
    var tail = convertToInt(shiftRight(bitwiseAnd(state, new Long(-1073741824, 268435455)), 30));
    var index = head;
    while (!((index & $this.a2q_1) === (tail & $this.a2q_1))) {
      var tmp0_elvis_lhs = $this.d2q_1.atomicfu$get(index & $this.a2q_1).kotlinx$atomicfu$value;
      var value = tmp0_elvis_lhs == null ? new Placeholder(index) : tmp0_elvis_lhs;
      next.d2q_1.atomicfu$get(index & next.a2q_1).kotlinx$atomicfu$value = value;
      index = index + 1 | 0;
    }
    next.c2q_1.kotlinx$atomicfu$value = Companion_getInstance_2().w2q(state, new Long(0, 268435456));
    return next;
  }
  function Placeholder(index) {
    this.u2q_1 = index;
  }
  function Companion_1() {
    Companion_instance_2 = this;
    this.e2q_1 = 8;
    this.f2q_1 = 30;
    this.g2q_1 = 1073741823;
    this.h2q_1 = 0;
    this.i2q_1 = new Long(1073741823, 0);
    this.j2q_1 = 30;
    this.k2q_1 = new Long(-1073741824, 268435455);
    this.l2q_1 = 60;
    this.m2q_1 = new Long(0, 268435456);
    this.n2q_1 = 61;
    this.o2q_1 = new Long(0, 536870912);
    this.p2q_1 = 1024;
    this.q2q_1 = new Symbol('REMOVE_FROZEN');
    this.r2q_1 = 0;
    this.s2q_1 = 1;
    this.t2q_1 = 2;
  }
  protoOf(Companion_1).w2q = function (_this__u8e3s4, other) {
    return bitwiseAnd(_this__u8e3s4, invert(other));
  };
  protoOf(Companion_1).v2q = function (_this__u8e3s4, newHead) {
    return bitwiseOr(this.w2q(_this__u8e3s4, new Long(1073741823, 0)), shiftLeft(fromInt(newHead), 0));
  };
  protoOf(Companion_1).x2q = function (_this__u8e3s4, newTail) {
    return bitwiseOr(this.w2q(_this__u8e3s4, new Long(-1073741824, 268435455)), shiftLeft(fromInt(newTail), 30));
  };
  protoOf(Companion_1).y2q = function (_this__u8e3s4) {
    return !equalsLong(bitwiseAnd(_this__u8e3s4, new Long(0, 536870912)), new Long(0, 0)) ? 2 : 1;
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_1();
    return Companion_instance_2;
  }
  function LockFreeTaskQueueCore(capacity, singleConsumer) {
    Companion_getInstance_2();
    this.y2p_1 = capacity;
    this.z2p_1 = singleConsumer;
    this.a2q_1 = this.y2p_1 - 1 | 0;
    this.b2q_1 = atomic$ref$1(null);
    this.c2q_1 = atomic$long$1(new Long(0, 0));
    this.d2q_1 = atomicfu$AtomicRefArray$ofNulls(this.y2p_1);
    // Inline function 'kotlin.check' call
    if (!(this.a2q_1 <= 1073741823)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
    // Inline function 'kotlin.check' call
    if (!((this.y2p_1 & this.a2q_1) === 0)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
  }
  protoOf(LockFreeTaskQueueCore).n1 = function () {
    Companion_getInstance_2();
    // Inline function 'kotlinx.coroutines.internal.Companion.withState' call
    var this_0 = this.c2q_1.kotlinx$atomicfu$value;
    var head = convertToInt(shiftRight(bitwiseAnd(this_0, new Long(1073741823, 0)), 0));
    var tail = convertToInt(shiftRight(bitwiseAnd(this_0, new Long(-1073741824, 268435455)), 30));
    return (tail - head | 0) & 1073741823;
  };
  protoOf(LockFreeTaskQueueCore).x2p = function (element) {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.c2q_1;
    while (true) {
      var tmp0 = this_0.kotlinx$atomicfu$value;
      $l$block: {
        if (!equalsLong(bitwiseAnd(tmp0, new Long(0, 805306368)), new Long(0, 0)))
          return Companion_getInstance_2().y2q(tmp0);
        // Inline function 'kotlinx.coroutines.internal.Companion.withState' call
        Companion_getInstance_2();
        var head = convertToInt(shiftRight(bitwiseAnd(tmp0, new Long(1073741823, 0)), 0));
        var tail = convertToInt(shiftRight(bitwiseAnd(tmp0, new Long(-1073741824, 268435455)), 30));
        var mask = this.a2q_1;
        if (((tail + 2 | 0) & mask) === (head & mask))
          return 1;
        if (!this.z2p_1 && !(this.d2q_1.atomicfu$get(tail & mask).kotlinx$atomicfu$value == null)) {
          if (this.y2p_1 < 1024 || ((tail - head | 0) & 1073741823) > this.y2p_1 >> 1) {
            return 1;
          }
          break $l$block;
        }
        var newTail = (tail + 1 | 0) & 1073741823;
        if (this.c2q_1.atomicfu$compareAndSet(tmp0, Companion_getInstance_2().x2q(tmp0, newTail))) {
          this.d2q_1.atomicfu$get(tail & mask).kotlinx$atomicfu$value = element;
          var cur = this;
          $l$loop_0: while (!equalsLong(bitwiseAnd(cur.c2q_1.kotlinx$atomicfu$value, new Long(0, 268435456)), new Long(0, 0))) {
            var tmp0_elvis_lhs = fillPlaceholder(cur.v(), tail, element);
            var tmp;
            if (tmp0_elvis_lhs == null) {
              break $l$loop_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            cur = tmp;
          }
          return 0;
        }
      }
    }
  };
  protoOf(LockFreeTaskQueueCore).ch = function () {
    // Inline function 'kotlinx.atomicfu.loop' call
    var this_0 = this.c2q_1;
    while (true) {
      var tmp0 = this_0.kotlinx$atomicfu$value;
      $l$block_0: {
        if (!equalsLong(bitwiseAnd(tmp0, new Long(0, 268435456)), new Long(0, 0)))
          return Companion_getInstance_2().q2q_1;
        // Inline function 'kotlinx.coroutines.internal.Companion.withState' call
        Companion_getInstance_2();
        var head = convertToInt(shiftRight(bitwiseAnd(tmp0, new Long(1073741823, 0)), 0));
        var tail = convertToInt(shiftRight(bitwiseAnd(tmp0, new Long(-1073741824, 268435455)), 30));
        if ((tail & this.a2q_1) === (head & this.a2q_1))
          return null;
        var element = this.d2q_1.atomicfu$get(head & this.a2q_1).kotlinx$atomicfu$value;
        if (element == null) {
          if (this.z2p_1)
            return null;
          break $l$block_0;
        }
        if (element instanceof Placeholder)
          return null;
        var newHead = (head + 1 | 0) & 1073741823;
        if (this.c2q_1.atomicfu$compareAndSet(tmp0, Companion_getInstance_2().v2q(tmp0, newHead))) {
          this.d2q_1.atomicfu$get(head & this.a2q_1).kotlinx$atomicfu$value = null;
          return element;
        }
        if (!this.z2p_1) {
          break $l$block_0;
        }
        var cur = this;
        while (true) {
          var tmp0_elvis_lhs = removeSlowPath(cur, head, newHead);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return element;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          cur = tmp;
        }
      }
    }
  };
  protoOf(LockFreeTaskQueueCore).v = function () {
    return allocateOrGetNextCopy(this, markFrozen(this));
  };
  function NamedDispatcher(dispatcher, name) {
    CoroutineDispatcher.call(this);
    var tmp = this;
    var tmp0_elvis_lhs = isInterface(dispatcher, Delay) ? dispatcher : null;
    tmp.a2r_1 = tmp0_elvis_lhs == null ? get_DefaultDelay() : tmp0_elvis_lhs;
    this.b2r_1 = dispatcher;
    this.c2r_1 = name;
  }
  protoOf(NamedDispatcher).y1g = function (context) {
    return this.b2r_1.y1g(context);
  };
  protoOf(NamedDispatcher).b1h = function (context, block) {
    return this.b2r_1.b1h(context, block);
  };
  protoOf(NamedDispatcher).c1h = function (context, block) {
    return this.b2r_1.c1h(context, block);
  };
  protoOf(NamedDispatcher).toString = function () {
    return this.c2r_1;
  };
  protoOf(NamedDispatcher).o1h = function (timeMillis, continuation) {
    this.a2r_1.o1h(timeMillis, continuation);
  };
  protoOf(NamedDispatcher).p1h = function (timeMillis, block, context) {
    return this.a2r_1.p1h(timeMillis, block, context);
  };
  function callUndeliveredElement(_this__u8e3s4, element, context) {
    var tmp0_safe_receiver = callUndeliveredElementCatchingException(_this__u8e3s4, element, null);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      handleCoroutineException(context, tmp0_safe_receiver);
    }
  }
  function UndeliveredElementException(message, cause) {
    RuntimeException_init_$Init$(message, cause, this);
    captureStack(this, UndeliveredElementException);
  }
  function callUndeliveredElementCatchingException(_this__u8e3s4, element, undeliveredElementException) {
    undeliveredElementException = undeliveredElementException === VOID ? null : undeliveredElementException;
    try {
      _this__u8e3s4(element);
    } catch ($p) {
      if ($p instanceof Error) {
        var ex = $p;
        if (!(undeliveredElementException == null) && !(undeliveredElementException.cause === ex)) {
          addSuppressed(undeliveredElementException, ex);
        } else {
          return new UndeliveredElementException('Exception in undelivered element handler for ' + toString_0(element), ex);
        }
      } else {
        throw $p;
      }
    }
    return undeliveredElementException;
  }
  function ScopeCoroutine(context, uCont) {
    AbstractCoroutine.call(this, context, true, true);
    this.z1c_1 = uCont;
  }
  protoOf(ScopeCoroutine).m1b = function () {
    return true;
  };
  protoOf(ScopeCoroutine).b1a = function (state) {
    resumeCancellableWithInternal(intercepted(this.z1c_1), recoverResult(state, this.z1c_1));
  };
  protoOf(ScopeCoroutine).a1d = function () {
  };
  protoOf(ScopeCoroutine).a1a = function (state) {
    this.z1c_1.y9(recoverResult(state, this.z1c_1));
  };
  function ContextScope(context) {
    this.d2r_1 = context;
  }
  protoOf(ContextScope).q19 = function () {
    return this.d2r_1;
  };
  protoOf(ContextScope).toString = function () {
    return 'CoroutineScope(coroutineContext=' + toString(this.d2r_1) + ')';
  };
  function Symbol(symbol) {
    this.e2r_1 = symbol;
  }
  protoOf(Symbol).toString = function () {
    return '<' + this.e2r_1 + '>';
  };
  function systemProp(propertyName, defaultValue, minValue, maxValue) {
    minValue = minValue === VOID ? 1 : minValue;
    maxValue = maxValue === VOID ? 2147483647 : maxValue;
    return convertToInt(systemProp_0(propertyName, fromInt(defaultValue), fromInt(minValue), fromInt(maxValue)));
  }
  function systemProp_0(propertyName, defaultValue, minValue, maxValue) {
    minValue = minValue === VOID ? new Long(1, 0) : minValue;
    maxValue = maxValue === VOID ? new Long(-1, 2147483647) : maxValue;
    var tmp0_elvis_lhs = systemProp_1(propertyName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return defaultValue;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp1_elvis_lhs = toLongOrNull(value);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = "System property '" + propertyName + "' has unrecognized value '" + value + "'";
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var parsed = tmp_0;
    if (!(compare(minValue, parsed) <= 0 ? compare(parsed, maxValue) <= 0 : false)) {
      // Inline function 'kotlin.error' call
      var message_0 = "System property '" + propertyName + "' should be in range " + minValue.toString() + '..' + maxValue.toString() + ", but is '" + parsed.toString() + "'";
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
    return parsed;
  }
  function startCoroutineCancellable(_this__u8e3s4, completion) {
    // Inline function 'kotlinx.coroutines.intrinsics.runSafely' call
    try {
      var tmp = intercepted(createCoroutineUnintercepted_0(_this__u8e3s4, completion));
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
      resumeCancellableWithInternal(tmp, tmp$ret$2);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        dispatcherFailure(completion, e);
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }
  function startCoroutineCancellable_0(_this__u8e3s4, receiver, completion) {
    // Inline function 'kotlinx.coroutines.intrinsics.runSafely' call
    try {
      var tmp = intercepted(createCoroutineUnintercepted(_this__u8e3s4, receiver, completion));
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
      resumeCancellableWithInternal(tmp, tmp$ret$2);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        dispatcherFailure(completion, e);
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }
  function startCoroutineCancellable_1(_this__u8e3s4, fatalCompletion) {
    // Inline function 'kotlinx.coroutines.intrinsics.runSafely' call
    try {
      var tmp = intercepted(_this__u8e3s4);
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
      resumeCancellableWithInternal(tmp, tmp$ret$2);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        dispatcherFailure(fatalCompletion, e);
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }
  function dispatcherFailure(completion, e) {
    var tmp;
    if (e instanceof DispatchException) {
      tmp = e.e1h_1;
    } else {
      tmp = e;
    }
    var reportException = tmp;
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(reportException));
    completion.y9(tmp$ret$0);
    throw reportException;
  }
  function startUndispatchedOrReturn(_this__u8e3s4, receiver, block) {
    return startUndispatched(_this__u8e3s4, true, receiver, block);
  }
  function startCoroutineUndispatched(_this__u8e3s4, receiver, completion) {
    // Inline function 'kotlinx.coroutines.internal.probeCoroutineCreated' call
    var actualCompletion = completion;
    var tmp;
    try {
      // Inline function 'kotlinx.coroutines.withCoroutineContext' call
      actualCompletion.t9();
      // Inline function 'kotlinx.coroutines.internal.probeCoroutineResumed' call
      // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
      tmp = startCoroutineUninterceptedOrReturnNonGeneratorVersion(_this__u8e3s4, receiver, actualCompletion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        var tmp_1;
        if (e instanceof DispatchException) {
          tmp_1 = e.e1h_1;
        } else {
          tmp_1 = e;
        }
        var reportException = tmp_1;
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$6 = _Result___init__impl__xyqfz8(createFailure(reportException));
        actualCompletion.y9(tmp$ret$6);
        return Unit_instance;
      } else {
        throw $p;
      }
    }
    var value = tmp;
    if (!(value === get_COROUTINE_SUSPENDED())) {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$8 = _Result___init__impl__xyqfz8(value);
      actualCompletion.y9(tmp$ret$8);
    }
  }
  function startUndispatchedOrReturnIgnoreTimeout(_this__u8e3s4, receiver, block) {
    return startUndispatched(_this__u8e3s4, false, receiver, block);
  }
  function startUndispatched(_this__u8e3s4, alwaysRethrow, receiver, block) {
    var tmp;
    try {
      // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
      tmp = startCoroutineUninterceptedOrReturnNonGeneratorVersion(block, receiver, _this__u8e3s4);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof DispatchException) {
        var e = $p;
        dispatchExceptionAndMakeCompleting(_this__u8e3s4, e);
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          tmp_0 = new CompletedExceptionally(e_0);
        } else {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    var result = tmp;
    if (result === get_COROUTINE_SUSPENDED())
      return get_COROUTINE_SUSPENDED();
    var state = _this__u8e3s4.z19(result);
    if (state === get_COMPLETING_WAITING_CHILDREN())
      return get_COROUTINE_SUSPENDED();
    _this__u8e3s4.a1d();
    var tmp_1;
    if (state instanceof CompletedExceptionally) {
      var tmp_2;
      if (alwaysRethrow || notOwnTimeout(_this__u8e3s4, state.w19_1)) {
        throw recoverStackTrace(state.w19_1, _this__u8e3s4.z1c_1);
      } else {
        if (result instanceof CompletedExceptionally) {
          throw recoverStackTrace(result.w19_1, _this__u8e3s4.z1c_1);
        } else {
          tmp_2 = result;
        }
      }
      tmp_1 = tmp_2;
    } else {
      tmp_1 = unboxState(state);
    }
    return tmp_1;
  }
  function dispatchExceptionAndMakeCompleting(_this__u8e3s4, e) {
    _this__u8e3s4.i1b(new CompletedExceptionally(e.e1h_1));
    throw recoverStackTrace(e.e1h_1, _this__u8e3s4.z1c_1);
  }
  function notOwnTimeout(_this__u8e3s4, cause) {
    var tmp;
    if (!(cause instanceof TimeoutCancellationException)) {
      tmp = true;
    } else {
      tmp = !(cause.i1m_1 === _this__u8e3s4);
    }
    return tmp;
  }
  function onTimeout(_this__u8e3s4, timeMillis, block) {
    return _this__u8e3s4.h2r((new OnTimeout(timeMillis)).g2r(), block);
  }
  function register($this, select, ignoredParam) {
    if (compare($this.f2r_1, new Long(0, 0)) <= 0) {
      select.c1q(Unit_instance);
      return Unit_instance;
    }
    var tmp = OnTimeout$register$lambda(select, $this);
    var action = new sam$kotlinx_coroutines_Runnable$0(tmp);
    if (!(select instanceof SelectImplementation))
      THROW_CCE();
    var context = select.t9();
    var disposableHandle = get_delay(context).p1h($this.f2r_1, action, context);
    select.i2r(disposableHandle);
  }
  function sam$kotlinx_coroutines_Runnable$0(function_0) {
    this.j2r_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_Runnable$0).o1f = function () {
    return this.j2r_1();
  };
  protoOf(sam$kotlinx_coroutines_Runnable$0).q3 = function () {
    return this.j2r_1;
  };
  protoOf(sam$kotlinx_coroutines_Runnable$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Runnable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_Runnable$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function OnTimeout$register$ref() {
    return constructCallableReference(function (p0, p1, p2) {
      register(p0, p1, p2);
      return Unit_instance;
    }, 3, 0, 6, 'register');
  }
  function OnTimeout$register$lambda($select, this$0) {
    return function () {
      $select.q1p(this$0, Unit_instance);
      return Unit_instance;
    };
  }
  function OnTimeout(timeMillis) {
    this.f2r_1 = timeMillis;
  }
  protoOf(OnTimeout).g2r = function () {
    var tmp = OnTimeout$register$ref();
    return new SelectClause0Impl(this, typeof tmp === 'function' ? tmp : THROW_CCE());
  };
  function get_DUMMY_PROCESS_RESULT_FUNCTION() {
    _init_properties_Select_kt__zhm2jg();
    return DUMMY_PROCESS_RESULT_FUNCTION;
  }
  var DUMMY_PROCESS_RESULT_FUNCTION;
  function get_STATE_REG() {
    _init_properties_Select_kt__zhm2jg();
    return STATE_REG;
  }
  var STATE_REG;
  function get_STATE_COMPLETED() {
    _init_properties_Select_kt__zhm2jg();
    return STATE_COMPLETED;
  }
  var STATE_COMPLETED;
  function get_STATE_CANCELLED() {
    _init_properties_Select_kt__zhm2jg();
    return STATE_CANCELLED;
  }
  var STATE_CANCELLED;
  function get_NO_RESULT() {
    _init_properties_Select_kt__zhm2jg();
    return NO_RESULT;
  }
  var NO_RESULT;
  function get_PARAM_CLAUSE_0() {
    _init_properties_Select_kt__zhm2jg();
    return PARAM_CLAUSE_0;
  }
  var PARAM_CLAUSE_0;
  function SelectClause0Impl(clauseObject, regFunc, onCancellationConstructor) {
    onCancellationConstructor = onCancellationConstructor === VOID ? null : onCancellationConstructor;
    this.k2r_1 = clauseObject;
    this.l2r_1 = regFunc;
    this.m2r_1 = onCancellationConstructor;
    this.n2r_1 = get_DUMMY_PROCESS_RESULT_FUNCTION();
  }
  protoOf(SelectClause0Impl).o2r = function () {
    return this.k2r_1;
  };
  protoOf(SelectClause0Impl).p2r = function () {
    return this.l2r_1;
  };
  protoOf(SelectClause0Impl).q2r = function () {
    return this.m2r_1;
  };
  protoOf(SelectClause0Impl).r2r = function () {
    return this.n2r_1;
  };
  function SelectInstance() {
  }
  function SelectClause1Impl(clauseObject, regFunc, processResFunc, onCancellationConstructor) {
    onCancellationConstructor = onCancellationConstructor === VOID ? null : onCancellationConstructor;
    this.s2r_1 = clauseObject;
    this.t2r_1 = regFunc;
    this.u2r_1 = processResFunc;
    this.v2r_1 = onCancellationConstructor;
  }
  protoOf(SelectClause1Impl).o2r = function () {
    return this.s2r_1;
  };
  protoOf(SelectClause1Impl).p2r = function () {
    return this.t2r_1;
  };
  protoOf(SelectClause1Impl).r2r = function () {
    return this.u2r_1;
  };
  protoOf(SelectClause1Impl).q2r = function () {
    return this.v2r_1;
  };
  function $invokeBlockCOROUTINE$(_this__u8e3s4, argument, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.e2s_1 = _this__u8e3s4;
    this.f2s_1 = argument;
  }
  protoOf($invokeBlockCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var block = this.e2s_1.l2s_1;
            if (this.e2s_1.k2s_1 === get_PARAM_CLAUSE_0()) {
              if (!isSuspendFunction(block, 0))
                THROW_CCE();
              this.n9_1 = 2;
              suspendResult = block(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (!isSuspendFunction(block, 1))
                THROW_CCE();
              this.n9_1 = 1;
              suspendResult = block(this.f2s_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.g2s_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.g2s_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return this.g2s_1;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function _get_isSelected__uy0hmu($this) {
    var tmp = $this.w1p_1.kotlinx$atomicfu$value;
    return tmp instanceof ClauseData;
  }
  function doSelectSuspend($this, $completion) {
    var tmp = new $doSelectSuspendCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function checkClauseObject($this, clauseObject) {
    var clauses = ensureNotNull($this.x1p_1);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var tmp;
      if (isInterface(clauses, Collection)) {
        tmp = clauses.r();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = clauses.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element.h2s_1 === clauseObject) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    // Inline function 'kotlin.check' call
    if (!tmp$ret$0) {
      var message = 'Cannot use select clauses on the same object: ' + toString(clauseObject);
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  function waitUntilSelected($this, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.v1e();
    $l$block_0: {
      // Inline function 'kotlinx.atomicfu.loop' call
      var this_0 = $this.w1p_1;
      while (true) {
        var curState = this_0.kotlinx$atomicfu$value;
        if (curState === get_STATE_REG()) {
          if ($this.w1p_1.atomicfu$compareAndSet(curState, cancellable)) {
            invokeOnCancellation(cancellable, $this);
            break $l$block_0;
          }
        } else {
          if (isInterface(curState, KtList)) {
            if ($this.w1p_1.atomicfu$compareAndSet(curState, get_STATE_REG())) {
              if (!isInterface(curState, KtList))
                THROW_CCE();
              // Inline function 'kotlin.collections.forEach' call
              var _iterator__ex2g4s = curState.t();
              while (_iterator__ex2g4s.u()) {
                var element = _iterator__ex2g4s.v();
                reregisterClause($this, element);
              }
            }
          } else {
            if (curState instanceof ClauseData) {
              cancellable.i1d(Unit_instance, curState.z2s($this, $this.a1q_1));
              break $l$block_0;
            } else {
              // Inline function 'kotlin.error' call
              var message = 'unexpected state: ' + toString(curState);
              throw IllegalStateException_init_$Create$(toString(message));
            }
          }
        }
      }
    }
    return cancellable.x1b();
  }
  function reregisterClause($this, clauseObject) {
    var clause = ensureNotNull(findClause($this, clauseObject));
    clause.n2s_1 = null;
    clause.o2s_1 = -1;
    $this.a2t(clause, true);
  }
  function trySelectInternal($this, clauseObject, internalResult) {
    $l$loop: while (true) {
      var curState = $this.w1p_1.kotlinx$atomicfu$value;
      if (isInterface(curState, CancellableContinuation)) {
        var tmp0_elvis_lhs = findClause($this, clauseObject);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var clause = tmp;
        var onCancellation = clause.z2s($this, internalResult);
        if ($this.w1p_1.atomicfu$compareAndSet(curState, clause)) {
          var cont = isInterface(curState, CancellableContinuation) ? curState : THROW_CCE();
          $this.a1q_1 = internalResult;
          if (tryResume_1(cont, onCancellation))
            return 0;
          $this.a1q_1 = get_NO_RESULT();
          return 2;
        }
      } else {
        var tmp_0;
        if (equals(curState, get_STATE_COMPLETED())) {
          tmp_0 = true;
        } else {
          tmp_0 = curState instanceof ClauseData;
        }
        if (tmp_0)
          return 3;
        else {
          if (equals(curState, get_STATE_CANCELLED()))
            return 2;
          else {
            if (equals(curState, get_STATE_REG())) {
              if ($this.w1p_1.atomicfu$compareAndSet(curState, listOf_0(clauseObject)))
                return 1;
            } else {
              if (isInterface(curState, KtList)) {
                if ($this.w1p_1.atomicfu$compareAndSet(curState, plus_0(curState, clauseObject)))
                  return 1;
              } else {
                // Inline function 'kotlin.error' call
                var message = 'Unexpected state: ' + toString(curState);
                throw IllegalStateException_init_$Create$(toString(message));
              }
            }
          }
        }
      }
    }
  }
  function findClause($this, clauseObject) {
    var tmp0_elvis_lhs = $this.x1p_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var clauses = tmp;
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = clauses.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        if (element.h2s_1 === clauseObject) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp1_elvis_lhs = tmp$ret$1;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Clause with object ' + toString(clauseObject) + ' is not found';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  }
  function complete($this, $completion) {
    var tmp = new $completeCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function processResultAndInvokeBlockRecoveringException($this, clause, internalResult, $completion) {
    var tmp = new $processResultAndInvokeBlockRecoveringExceptionCOROUTINE$($this, clause, internalResult, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function cleanup($this, selectedClause) {
    // Inline function 'kotlinx.coroutines.assert' call
    var tmp0_elvis_lhs = $this.x1p_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var clauses = tmp;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = clauses.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (!(element === selectedClause)) {
        element.s1d();
      }
    }
    $this.w1p_1.kotlinx$atomicfu$value = get_STATE_COMPLETED();
    $this.a1q_1 = get_NO_RESULT();
    $this.x1p_1 = null;
  }
  function ClauseData($outer, clauseObject, regFunc, processResFunc, param, block, onCancellationConstructor) {
    this.p2s_1 = $outer;
    this.h2s_1 = clauseObject;
    this.i2s_1 = regFunc;
    this.j2s_1 = processResFunc;
    this.k2s_1 = param;
    this.l2s_1 = block;
    this.m2s_1 = onCancellationConstructor;
    this.n2s_1 = null;
    this.o2s_1 = -1;
  }
  protoOf(ClauseData).x2t = function (select) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlinx.coroutines.assert' call
    this.i2s_1(this.h2s_1, select, this.k2s_1);
    return select.a1q_1 === get_NO_RESULT();
  };
  protoOf(ClauseData).y2t = function (result) {
    return this.j2s_1(this.h2s_1, this.k2s_1, result);
  };
  protoOf(ClauseData).z2t = function (argument, $completion) {
    var tmp = new $invokeBlockCOROUTINE$(this, argument, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ClauseData).s1d = function () {
    // Inline function 'kotlin.with' call
    var $this$with = this.n2s_1;
    var tmp;
    if ($this$with instanceof Segment) {
      $this$with.j1e(this.o2s_1, null, this.p2s_1.t9());
      tmp = Unit_instance;
    } else {
      var tmp0_safe_receiver = (!($this$with == null) ? isInterface($this$with, DisposableHandle) : false) ? $this$with : null;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        tmp0_safe_receiver.s1d();
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
  };
  protoOf(ClauseData).z2s = function (select, internalResult) {
    var tmp0_safe_receiver = this.m2s_1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver(select, this.k2s_1, internalResult);
  };
  function $doSelectCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i2u_1 = _this__u8e3s4;
  }
  protoOf($doSelectCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            if (_get_isSelected__uy0hmu(this.i2u_1)) {
              this.n9_1 = 2;
              suspendResult = complete(this.i2u_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = doSelectSuspend(this.i2u_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.j2u_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.j2u_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return this.j2u_1;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $doSelectSuspendCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.y2s_1 = _this__u8e3s4;
  }
  protoOf($doSelectSuspendCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = waitUntilSelected(this.y2s_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = complete(this.y2s_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $completeCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j2t_1 = _this__u8e3s4;
  }
  protoOf($completeCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var tmp_0 = this.j2t_1.w1p_1.kotlinx$atomicfu$value;
            var selectedClause = tmp_0 instanceof ClauseData ? tmp_0 : THROW_CCE();
            var internalResult = this.j2t_1.a1q_1;
            cleanup(this.j2t_1, selectedClause);
            if (!get_RECOVER_STACK_TRACES()) {
              var blockArgument = selectedClause.y2t(internalResult);
              this.n9_1 = 2;
              suspendResult = selectedClause.z2t(blockArgument, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = processResultAndInvokeBlockRecoveringException(this.j2t_1, selectedClause, internalResult, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.k2t_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.k2t_1 = suspendResult;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return this.k2t_1;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $processResultAndInvokeBlockRecoveringExceptionCOROUTINE$(_this__u8e3s4, clause, internalResult, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t2t_1 = _this__u8e3s4;
    this.u2t_1 = clause;
    this.v2t_1 = internalResult;
  }
  protoOf($processResultAndInvokeBlockRecoveringExceptionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            var blockArgument = this.u2t_1.y2t(this.v2t_1);
            this.n9_1 = 1;
            suspendResult = this.u2t_1.z2t(blockArgument, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.w2t_1 = suspendResult;
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var e = this.q9_1;
              var tmp_1 = this;
              throw e;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.w2t_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.o9_1 === 3) {
          throw e_0;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_0;
        }
      }
     while (true);
  };
  function SelectImplementation(context) {
    this.v1p_1 = context;
    this.w1p_1 = atomic$ref$1(get_STATE_REG());
    this.x1p_1 = ArrayList_init_$Create$(2);
    this.y1p_1 = null;
    this.z1p_1 = -1;
    this.a1q_1 = get_NO_RESULT();
  }
  protoOf(SelectImplementation).t9 = function () {
    return this.v1p_1;
  };
  protoOf(SelectImplementation).z2c = function ($completion) {
    var tmp = new $doSelectCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SelectImplementation).h2r = function (_this__u8e3s4, block) {
    return this.k2u(new ClauseData(this, _this__u8e3s4.o2r(), _this__u8e3s4.p2r(), _this__u8e3s4.r2r(), get_PARAM_CLAUSE_0(), block, _this__u8e3s4.q2r()));
  };
  protoOf(SelectImplementation).y2c = function (_this__u8e3s4, block) {
    return this.k2u(new ClauseData(this, _this__u8e3s4.o2r(), _this__u8e3s4.p2r(), _this__u8e3s4.r2r(), null, block, _this__u8e3s4.q2r()));
  };
  protoOf(SelectImplementation).a2t = function (_this__u8e3s4, reregister) {
    // Inline function 'kotlinx.coroutines.assert' call
    // Inline function 'kotlin.let' call
    if (this.w1p_1.kotlinx$atomicfu$value instanceof ClauseData)
      return Unit_instance;
    if (!reregister) {
      checkClauseObject(this, _this__u8e3s4.h2s_1);
    }
    if (_this__u8e3s4.x2t(this)) {
      if (!reregister) {
        // Inline function 'kotlin.collections.plusAssign' call
        ensureNotNull(this.x1p_1).j1(_this__u8e3s4);
      }
      _this__u8e3s4.n2s_1 = this.y1p_1;
      _this__u8e3s4.o2s_1 = this.z1p_1;
      this.y1p_1 = null;
      this.z1p_1 = -1;
    } else {
      this.w1p_1.kotlinx$atomicfu$value = _this__u8e3s4;
    }
  };
  protoOf(SelectImplementation).k2u = function (_this__u8e3s4, reregister, $super) {
    reregister = reregister === VOID ? false : reregister;
    var tmp;
    if ($super === VOID) {
      this.a2t(_this__u8e3s4, reregister);
      tmp = Unit_instance;
    } else {
      tmp = $super.a2t.call(this, _this__u8e3s4, reregister);
    }
    return tmp;
  };
  protoOf(SelectImplementation).i2r = function (disposableHandle) {
    this.y1p_1 = disposableHandle;
  };
  protoOf(SelectImplementation).h1f = function (segment, index) {
    this.y1p_1 = segment;
    this.z1p_1 = index;
  };
  protoOf(SelectImplementation).c1q = function (internalResult) {
    this.a1q_1 = internalResult;
  };
  protoOf(SelectImplementation).q1p = function (clauseObject, result) {
    return trySelectInternal(this, clauseObject, result) === 0;
  };
  protoOf(SelectImplementation).b1q = function (clauseObject, result) {
    return TrySelectDetailedResult_0(trySelectInternal(this, clauseObject, result));
  };
  protoOf(SelectImplementation).r1d = function (cause) {
    var tmp0 = this.w1p_1;
    $l$block: {
      // Inline function 'kotlinx.atomicfu.update' call
      while (true) {
        var cur = tmp0.kotlinx$atomicfu$value;
        if (cur === get_STATE_COMPLETED())
          return Unit_instance;
        var upd = get_STATE_CANCELLED();
        if (tmp0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    var tmp0_elvis_lhs = this.x1p_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var clauses = tmp;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = clauses.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      element.s1d();
    }
    this.a1q_1 = get_NO_RESULT();
    this.x1p_1 = null;
  };
  var TrySelectDetailedResult_SUCCESSFUL_instance;
  var TrySelectDetailedResult_REREGISTER_instance;
  var TrySelectDetailedResult_CANCELLED_instance;
  var TrySelectDetailedResult_ALREADY_SELECTED_instance;
  var TrySelectDetailedResult_entriesInitialized;
  function TrySelectDetailedResult_initEntries() {
    if (TrySelectDetailedResult_entriesInitialized)
      return Unit_instance;
    TrySelectDetailedResult_entriesInitialized = true;
    TrySelectDetailedResult_SUCCESSFUL_instance = new TrySelectDetailedResult('SUCCESSFUL', 0);
    TrySelectDetailedResult_REREGISTER_instance = new TrySelectDetailedResult('REREGISTER', 1);
    TrySelectDetailedResult_CANCELLED_instance = new TrySelectDetailedResult('CANCELLED', 2);
    TrySelectDetailedResult_ALREADY_SELECTED_instance = new TrySelectDetailedResult('ALREADY_SELECTED', 3);
  }
  function TrySelectDetailedResult(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function TrySelectDetailedResult_0(trySelectInternalResult) {
    _init_properties_Select_kt__zhm2jg();
    var tmp;
    switch (trySelectInternalResult) {
      case 0:
        tmp = TrySelectDetailedResult_SUCCESSFUL_getInstance();
        break;
      case 1:
        tmp = TrySelectDetailedResult_REREGISTER_getInstance();
        break;
      case 2:
        tmp = TrySelectDetailedResult_CANCELLED_getInstance();
        break;
      case 3:
        tmp = TrySelectDetailedResult_ALREADY_SELECTED_getInstance();
        break;
      default:
        // Inline function 'kotlin.error' call

        var message = 'Unexpected internal result: ' + trySelectInternalResult;
        throw IllegalStateException_init_$Create$(toString(message));
    }
    return tmp;
  }
  function tryResume_1(_this__u8e3s4, onCancellation) {
    _init_properties_Select_kt__zhm2jg();
    var tmp0_elvis_lhs = _this__u8e3s4.b1d(Unit_instance, null, onCancellation);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var token = tmp;
    _this__u8e3s4.c1d(token);
    return true;
  }
  function DUMMY_PROCESS_RESULT_FUNCTION$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
    _init_properties_Select_kt__zhm2jg();
    return null;
  }
  function TrySelectDetailedResult_SUCCESSFUL_getInstance() {
    TrySelectDetailedResult_initEntries();
    return TrySelectDetailedResult_SUCCESSFUL_instance;
  }
  function TrySelectDetailedResult_REREGISTER_getInstance() {
    TrySelectDetailedResult_initEntries();
    return TrySelectDetailedResult_REREGISTER_instance;
  }
  function TrySelectDetailedResult_CANCELLED_getInstance() {
    TrySelectDetailedResult_initEntries();
    return TrySelectDetailedResult_CANCELLED_instance;
  }
  function TrySelectDetailedResult_ALREADY_SELECTED_getInstance() {
    TrySelectDetailedResult_initEntries();
    return TrySelectDetailedResult_ALREADY_SELECTED_instance;
  }
  var properties_initialized_Select_kt_7rpl36;
  function _init_properties_Select_kt__zhm2jg() {
    if (!properties_initialized_Select_kt_7rpl36) {
      properties_initialized_Select_kt_7rpl36 = true;
      DUMMY_PROCESS_RESULT_FUNCTION = DUMMY_PROCESS_RESULT_FUNCTION$lambda;
      STATE_REG = new Symbol('STATE_REG');
      STATE_COMPLETED = new Symbol('STATE_COMPLETED');
      STATE_CANCELLED = new Symbol('STATE_CANCELLED');
      NO_RESULT = new Symbol('NO_RESULT');
      PARAM_CLAUSE_0 = new Symbol('PARAM_CLAUSE_0');
    }
  }
  function get_NO_OWNER() {
    _init_properties_Mutex_kt__jod56b();
    return NO_OWNER;
  }
  var NO_OWNER;
  var ON_LOCK_ALREADY_LOCKED_BY_OWNER;
  function Mutex() {
  }
  function Mutex_0(locked) {
    locked = locked === VOID ? false : locked;
    _init_properties_Mutex_kt__jod56b();
    return new MutexImpl(locked);
  }
  function MutexImpl$CancellableContinuationWithOwner$tryResume$lambda(this$0, this$1) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
      // Inline function 'kotlinx.coroutines.assert' call
      this$0.z2u_1.kotlinx$atomicfu$value = this$1.c2v_1;
      this$0.q2u(this$1.c2v_1);
      return Unit_instance;
    };
  }
  function MutexImpl$CancellableContinuationWithOwner$resume$lambda(this$0, this$1) {
    return function (it) {
      this$0.q2u(this$1.c2v_1);
      return Unit_instance;
    };
  }
  function holdsLockImpl($this, owner) {
    $l$loop: while (true) {
      if (!$this.l2u())
        return 0;
      var curOwner = $this.z2u_1.kotlinx$atomicfu$value;
      if (curOwner === get_NO_OWNER())
        continue $l$loop;
      return curOwner === owner ? 1 : 2;
    }
  }
  function lockSuspend($this, owner, $completion) {
    var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
    try {
      var contWithOwner = new CancellableContinuationWithOwner($this, cancellable, owner);
      $this.acquireCont(contWithOwner);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.c1f();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.x1b();
  }
  function tryLockImpl($this, owner) {
    $l$loop: while (true) {
      if ($this.l2v()) {
        // Inline function 'kotlinx.coroutines.assert' call
        $this.z2u_1.kotlinx$atomicfu$value = owner;
        return 0;
      } else {
        if (owner == null)
          return 1;
        switch (holdsLockImpl($this, owner)) {
          case 1:
            return 2;
          case 2:
            return 1;
          case 0:
            continue $l$loop;
        }
      }
    }
  }
  function CancellableContinuationWithOwner($outer, cont, owner) {
    this.d2v_1 = $outer;
    this.b2v_1 = cont;
    this.c2v_1 = owner;
  }
  protoOf(CancellableContinuationWithOwner).m2v = function (value, idempotent, onCancellation) {
    // Inline function 'kotlinx.coroutines.assert' call
    var token = this.b2v_1.b1d(value, idempotent, MutexImpl$CancellableContinuationWithOwner$tryResume$lambda(this.d2v_1, this));
    if (!(token == null)) {
      // Inline function 'kotlinx.coroutines.assert' call
      this.d2v_1.z2u_1.kotlinx$atomicfu$value = this.c2v_1;
    }
    return token;
  };
  protoOf(CancellableContinuationWithOwner).b1d = function (value, idempotent, onCancellation) {
    return this.m2v(value instanceof Unit ? value : THROW_CCE(), idempotent, onCancellation);
  };
  protoOf(CancellableContinuationWithOwner).n2v = function (value, onCancellation) {
    // Inline function 'kotlinx.coroutines.assert' call
    this.d2v_1.z2u_1.kotlinx$atomicfu$value = this.c2v_1;
    this.b2v_1.h1d(Unit_instance, MutexImpl$CancellableContinuationWithOwner$resume$lambda(this.d2v_1, this));
  };
  protoOf(CancellableContinuationWithOwner).i1d = function (value, onCancellation) {
    return this.n2v(value instanceof Unit ? value : THROW_CCE(), onCancellation);
  };
  protoOf(CancellableContinuationWithOwner).r19 = function () {
    return this.b2v_1.r19();
  };
  protoOf(CancellableContinuationWithOwner).n1a = function () {
    return this.b2v_1.n1a();
  };
  protoOf(CancellableContinuationWithOwner).c1d = function (token) {
    this.b2v_1.c1d(token);
  };
  protoOf(CancellableContinuationWithOwner).d1d = function (cause) {
    return this.b2v_1.d1d(cause);
  };
  protoOf(CancellableContinuationWithOwner).f1d = function (handler) {
    this.b2v_1.f1d(handler);
  };
  protoOf(CancellableContinuationWithOwner).h1f = function (segment, index) {
    this.b2v_1.h1f(segment, index);
  };
  protoOf(CancellableContinuationWithOwner).o2v = function (_this__u8e3s4, value) {
    this.b2v_1.g1d(_this__u8e3s4, Unit_instance);
  };
  protoOf(CancellableContinuationWithOwner).g1d = function (_this__u8e3s4, value) {
    return this.o2v(_this__u8e3s4, value instanceof Unit ? value : THROW_CCE());
  };
  protoOf(CancellableContinuationWithOwner).p2v = function (value, onCancellation) {
    this.b2v_1.h1d(Unit_instance, onCancellation);
  };
  protoOf(CancellableContinuationWithOwner).h1d = function (value, onCancellation) {
    return this.p2v(value instanceof Unit ? value : THROW_CCE(), onCancellation);
  };
  protoOf(CancellableContinuationWithOwner).ti = function (result) {
    this.b2v_1.y9(result);
  };
  protoOf(CancellableContinuationWithOwner).y9 = function (result) {
    return this.ti(result);
  };
  protoOf(CancellableContinuationWithOwner).t9 = function () {
    return this.b2v_1.t9();
  };
  function MutexImpl$onSelectCancellationUnlockConstructor$lambda$lambda(this$0, $owner) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
      this$0.q2u($owner);
      return Unit_instance;
    };
  }
  function MutexImpl$onSelectCancellationUnlockConstructor$lambda(this$0) {
    return function (_unused_var__etf5q3, owner, _unused_var__etf5q3_0) {
      return MutexImpl$onSelectCancellationUnlockConstructor$lambda$lambda(this$0, owner);
    };
  }
  function MutexImpl(locked) {
    SemaphoreAndMutexImpl.call(this, 1, locked ? 1 : 0);
    this.z2u_1 = atomic$ref$1(locked ? null : get_NO_OWNER());
    var tmp = this;
    tmp.a2v_1 = MutexImpl$onSelectCancellationUnlockConstructor$lambda(this);
  }
  protoOf(MutexImpl).l2u = function () {
    return this.q2v() === 0;
  };
  protoOf(MutexImpl).o2u = function (owner, $completion) {
    if (this.m2u(owner))
      return Unit_instance;
    return lockSuspend(this, owner, $completion);
  };
  protoOf(MutexImpl).m2u = function (owner) {
    var tmp;
    switch (tryLockImpl(this, owner)) {
      case 0:
        tmp = true;
        break;
      case 1:
        tmp = false;
        break;
      case 2:
        // Inline function 'kotlin.error' call

        var message = 'This mutex is already locked by the specified owner: ' + toString_0(owner);
        throw IllegalStateException_init_$Create$(toString(message));
      default:
        // Inline function 'kotlin.error' call

        var message_0 = 'unexpected';
        throw IllegalStateException_init_$Create$(toString(message_0));
    }
    return tmp;
  };
  protoOf(MutexImpl).q2u = function (owner) {
    $l$loop_0: while (true) {
      // Inline function 'kotlin.check' call
      if (!this.l2u()) {
        var message = 'This mutex is not locked';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      var curOwner = this.z2u_1.kotlinx$atomicfu$value;
      if (curOwner === get_NO_OWNER())
        continue $l$loop_0;
      // Inline function 'kotlin.check' call
      if (!(curOwner === owner || owner == null)) {
        var message_0 = 'This mutex is locked by ' + toString_0(curOwner) + ', but ' + toString_0(owner) + ' is expected';
        throw IllegalStateException_init_$Create$(toString(message_0));
      }
      if (!this.z2u_1.atomicfu$compareAndSet(curOwner, get_NO_OWNER()))
        continue $l$loop_0;
      this.r2v();
      return Unit_instance;
    }
  };
  protoOf(MutexImpl).toString = function () {
    return 'Mutex@' + get_hexAddress(this) + '[isLocked=' + this.l2u() + ',owner=' + toString_0(this.z2u_1.kotlinx$atomicfu$value) + ']';
  };
  var properties_initialized_Mutex_kt_yv4p3j;
  function _init_properties_Mutex_kt__jod56b() {
    if (!properties_initialized_Mutex_kt_yv4p3j) {
      properties_initialized_Mutex_kt_yv4p3j = true;
      NO_OWNER = new Symbol('NO_OWNER');
      ON_LOCK_ALREADY_LOCKED_BY_OWNER = new Symbol('ALREADY_LOCKED_BY_OWNER');
    }
  }
  function get_MAX_SPIN_CYCLES() {
    _init_properties_Semaphore_kt__t514r6();
    return MAX_SPIN_CYCLES;
  }
  var MAX_SPIN_CYCLES;
  function get_PERMIT() {
    _init_properties_Semaphore_kt__t514r6();
    return PERMIT;
  }
  var PERMIT;
  function get_TAKEN() {
    _init_properties_Semaphore_kt__t514r6();
    return TAKEN;
  }
  var TAKEN;
  function get_BROKEN() {
    _init_properties_Semaphore_kt__t514r6();
    return BROKEN;
  }
  var BROKEN;
  function get_CANCELLED() {
    _init_properties_Semaphore_kt__t514r6();
    return CANCELLED;
  }
  var CANCELLED;
  function get_SEGMENT_SIZE_0() {
    _init_properties_Semaphore_kt__t514r6();
    return SEGMENT_SIZE_0;
  }
  var SEGMENT_SIZE_0;
  function Semaphore(permits, acquiredPermits) {
    acquiredPermits = acquiredPermits === VOID ? 0 : acquiredPermits;
    _init_properties_Semaphore_kt__t514r6();
    return new SemaphoreImpl(permits, acquiredPermits);
  }
  function acquireSlowPath($this, $completion) {
    var cancellable = getOrCreateCancellableContinuation(intercepted($completion));
    try {
      $l$block: {
        if (addAcquireToQueue($this, cancellable)) {
          break $l$block;
        }
        $this.acquireCont(cancellable);
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        cancellable.c1f();
        throw e;
      } else {
        throw $p;
      }
    }
    return cancellable.x1b();
  }
  function decPermits($this) {
    $l$loop: while (true) {
      var p = $this.j2v_1.atomicfu$getAndDecrement();
      if (p > $this.e2v_1)
        continue $l$loop;
      return p;
    }
  }
  function coerceAvailablePermitsAtMaximum($this) {
    $l$loop_0: while (true) {
      var cur = $this.j2v_1.kotlinx$atomicfu$value;
      if (cur <= $this.e2v_1)
        break $l$loop_0;
      if ($this.j2v_1.atomicfu$compareAndSet(cur, $this.e2v_1))
        break $l$loop_0;
    }
  }
  function addAcquireToQueue($this, waiter) {
    var curTail = $this.h2v_1.kotlinx$atomicfu$value;
    var enqIdx = $this.i2v_1.atomicfu$getAndIncrement$long();
    var createNewSegment = createSegment$ref_0();
    var tmp0 = $this.h2v_1;
    // Inline function 'kotlin.Long.div' call
    var other = get_SEGMENT_SIZE_0();
    var tmp2 = divide(enqIdx, fromInt(other));
    var tmp$ret$1;
    $l$block_2: {
      // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
      while (true) {
        var s = findSegmentInternal(curTail, tmp2, createNewSegment);
        var tmp;
        if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
          tmp = true;
        } else {
          var tmp2_0 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
          var tmp$ret$2;
          $l$block_1: {
            // Inline function 'kotlinx.coroutines.internal.moveForward' call
            var tmp$ret$3;
            // Inline function 'kotlinx.atomicfu.loop' call
            while (true) {
              var cur = tmp0.kotlinx$atomicfu$value;
              if (compare(cur.h1e_1, tmp2_0.h1e_1) >= 0) {
                tmp$ret$2 = true;
                break $l$block_1;
              }
              if (!tmp2_0.y1n()) {
                tmp$ret$2 = false;
                break $l$block_1;
              }
              if (tmp0.atomicfu$compareAndSet(cur, tmp2_0)) {
                if (cur.z1n()) {
                  cur.l4();
                }
                tmp$ret$2 = true;
                break $l$block_1;
              }
              if (tmp2_0.z1n()) {
                tmp2_0.l4();
              }
            }
            tmp$ret$2 = tmp$ret$3;
          }
          tmp = tmp$ret$2;
        }
        if (tmp) {
          tmp$ret$1 = s;
          break $l$block_2;
        }
      }
    }
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(tmp$ret$1);
    // Inline function 'kotlin.Long.rem' call
    var other_0 = get_SEGMENT_SIZE_0();
    var tmp$ret$5 = modulo(enqIdx, fromInt(other_0));
    var i = convertToInt(tmp$ret$5);
    // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
    if (segment.w2v_1.atomicfu$get(i).atomicfu$compareAndSet(null, waiter)) {
      waiter.h1f(segment, i);
      return true;
    }
    var tmp4 = get_PERMIT();
    // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
    var value = get_TAKEN();
    if (segment.w2v_1.atomicfu$get(i).atomicfu$compareAndSet(tmp4, value)) {
      if (isInterface(waiter, CancellableContinuation)) {
        if (!isInterface(waiter, CancellableContinuation))
          THROW_CCE();
        waiter.i1d(Unit_instance, $this.k2v_1);
      } else {
        if (isInterface(waiter, SelectInstance)) {
          waiter.c1q(Unit_instance);
        } else {
          // Inline function 'kotlin.error' call
          var message = 'unexpected: ' + toString(waiter);
          throw IllegalStateException_init_$Create$(toString(message));
        }
      }
      return true;
    }
    // Inline function 'kotlinx.coroutines.assert' call
    return false;
  }
  function tryResumeNextFromQueue($this) {
    var curHead = $this.f2v_1.kotlinx$atomicfu$value;
    var deqIdx = $this.g2v_1.atomicfu$getAndIncrement$long();
    // Inline function 'kotlin.Long.div' call
    var other = get_SEGMENT_SIZE_0();
    var id = divide(deqIdx, fromInt(other));
    var createNewSegment = createSegment$ref_0();
    var tmp0 = $this.f2v_1;
    var tmp$ret$1;
    $l$block_2: {
      // Inline function 'kotlinx.coroutines.internal.findSegmentAndMoveForward' call
      while (true) {
        var s = findSegmentInternal(curHead, id, createNewSegment);
        var tmp;
        if (_SegmentOrClosed___get_isClosed__impl__qmxmlo(s)) {
          tmp = true;
        } else {
          var tmp2 = _SegmentOrClosed___get_segment__impl__jvcr9l(s);
          var tmp$ret$2;
          $l$block_1: {
            // Inline function 'kotlinx.coroutines.internal.moveForward' call
            var tmp$ret$3;
            // Inline function 'kotlinx.atomicfu.loop' call
            while (true) {
              var cur = tmp0.kotlinx$atomicfu$value;
              if (compare(cur.h1e_1, tmp2.h1e_1) >= 0) {
                tmp$ret$2 = true;
                break $l$block_1;
              }
              if (!tmp2.y1n()) {
                tmp$ret$2 = false;
                break $l$block_1;
              }
              if (tmp0.atomicfu$compareAndSet(cur, tmp2)) {
                if (cur.z1n()) {
                  cur.l4();
                }
                tmp$ret$2 = true;
                break $l$block_1;
              }
              if (tmp2.z1n()) {
                tmp2.l4();
              }
            }
            tmp$ret$2 = tmp$ret$3;
          }
          tmp = tmp$ret$2;
        }
        if (tmp) {
          tmp$ret$1 = s;
          break $l$block_2;
        }
      }
    }
    var segment = _SegmentOrClosed___get_segment__impl__jvcr9l(tmp$ret$1);
    segment.g1o();
    if (compare(segment.h1e_1, id) > 0)
      return false;
    // Inline function 'kotlin.Long.rem' call
    var other_0 = get_SEGMENT_SIZE_0();
    var tmp$ret$5 = modulo(deqIdx, fromInt(other_0));
    var i = convertToInt(tmp$ret$5);
    // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.getAndSet' call
    var value = get_PERMIT();
    var cellState = segment.w2v_1.atomicfu$get(i).atomicfu$getAndSet(value);
    if (cellState === null) {
      // Inline function 'kotlin.repeat' call
      var times = get_MAX_SPIN_CYCLES();
      var inductionVariable = 0;
      if (inductionVariable < times)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.get' call
          if (segment.w2v_1.atomicfu$get(i).kotlinx$atomicfu$value === get_TAKEN())
            return true;
        }
         while (inductionVariable < times);
      var tmp4 = get_PERMIT();
      // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.cas' call
      var value_0 = get_BROKEN();
      return !segment.w2v_1.atomicfu$get(i).atomicfu$compareAndSet(tmp4, value_0);
    } else if (cellState === get_CANCELLED())
      return false;
    else
      return tryResumeAcquire($this, cellState);
  }
  function tryResumeAcquire($this, $receiver) {
    var tmp;
    if (isInterface($receiver, CancellableContinuation)) {
      if (!isInterface($receiver, CancellableContinuation))
        THROW_CCE();
      var token = $receiver.b1d(Unit_instance, null, $this.k2v_1);
      var tmp_0;
      if (!(token == null)) {
        $receiver.c1d(token);
        tmp_0 = true;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      if (isInterface($receiver, SelectInstance)) {
        tmp = $receiver.q1p($this, Unit_instance);
      } else {
        // Inline function 'kotlin.error' call
        var message = 'unexpected: ' + toString($receiver);
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
    return tmp;
  }
  function SemaphoreAndMutexImpl$onCancellationRelease$lambda(this$0) {
    return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1) {
      this$0.r2v();
      return Unit_instance;
    };
  }
  function createSegment$ref_0() {
    return constructCallableReference(function (p0, p1) {
      return createSegment_0(p0, p1);
    }, 2, 0, 7, 'createSegment');
  }
  function SemaphoreAndMutexImpl(permits, acquiredPermits) {
    this.e2v_1 = permits;
    this.g2v_1 = atomic$long$1(new Long(0, 0));
    this.i2v_1 = atomic$long$1(new Long(0, 0));
    // Inline function 'kotlin.require' call
    if (!(this.e2v_1 > 0)) {
      var message = 'Semaphore should have at least 1 permit, but had ' + this.e2v_1;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!(0 <= acquiredPermits ? acquiredPermits <= this.e2v_1 : false)) {
      var message_0 = 'The number of acquired permits should be in 0..' + this.e2v_1;
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    var s = new SemaphoreSegment(new Long(0, 0), null, 2);
    this.f2v_1 = atomic$ref$1(s);
    this.h2v_1 = atomic$ref$1(s);
    this.j2v_1 = atomic$int$1(this.e2v_1 - acquiredPermits | 0);
    var tmp = this;
    tmp.k2v_1 = SemaphoreAndMutexImpl$onCancellationRelease$lambda(this);
  }
  protoOf(SemaphoreAndMutexImpl).q2v = function () {
    // Inline function 'kotlin.math.max' call
    var a = this.j2v_1.kotlinx$atomicfu$value;
    return Math.max(a, 0);
  };
  protoOf(SemaphoreAndMutexImpl).l2v = function () {
    $l$loop: while (true) {
      var p = this.j2v_1.kotlinx$atomicfu$value;
      if (p > this.e2v_1) {
        coerceAvailablePermitsAtMaximum(this);
        continue $l$loop;
      }
      if (p <= 0)
        return false;
      if (this.j2v_1.atomicfu$compareAndSet(p, p - 1 | 0))
        return true;
    }
  };
  protoOf(SemaphoreAndMutexImpl).x2v = function ($completion) {
    var p = decPermits(this);
    if (p > 0)
      return Unit_instance;
    return acquireSlowPath(this, $completion);
  };
  protoOf(SemaphoreAndMutexImpl).acquireCont = function (waiter) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlinx.coroutines.sync.SemaphoreAndMutexImpl.acquire' call
      while (true) {
        var p = decPermits(this);
        if (p > 0) {
          waiter.i1d(Unit_instance, this.k2v_1);
          tmp$ret$0 = Unit_instance;
          break $l$block_0;
        }
        if (addAcquireToQueue(this, isInterface(waiter, Waiter) ? waiter : THROW_CCE())) {
          tmp$ret$0 = Unit_instance;
          break $l$block_0;
        }
      }
      tmp$ret$0 = Unit_instance;
    }
    return tmp$ret$0;
  };
  protoOf(SemaphoreAndMutexImpl).r2v = function () {
    while (true) {
      var p = this.j2v_1.atomicfu$getAndIncrement();
      if (p >= this.e2v_1) {
        coerceAvailablePermitsAtMaximum(this);
        // Inline function 'kotlin.error' call
        var message = 'The number of released permits cannot be greater than ' + this.e2v_1;
        throw IllegalStateException_init_$Create$(toString(message));
      }
      if (p >= 0)
        return Unit_instance;
      if (tryResumeNextFromQueue(this))
        return Unit_instance;
    }
  };
  function SemaphoreImpl(permits, acquiredPermits) {
    SemaphoreAndMutexImpl.call(this, permits, acquiredPermits);
  }
  function SemaphoreSegment(id, prev, pointers) {
    Segment.call(this, id, prev, pointers);
    this.w2v_1 = atomicfu$AtomicRefArray$ofNulls(get_SEGMENT_SIZE_0());
  }
  protoOf(SemaphoreSegment).z1m = function () {
    return get_SEGMENT_SIZE_0();
  };
  protoOf(SemaphoreSegment).j1e = function (index, cause, context) {
    // Inline function 'kotlinx.coroutines.sync.SemaphoreSegment.set' call
    var value = get_CANCELLED();
    this.w2v_1.atomicfu$get(index).kotlinx$atomicfu$value = value;
    this.w1n();
  };
  protoOf(SemaphoreSegment).toString = function () {
    return 'SemaphoreSegment[id=' + this.h1e_1.toString() + ', hashCode=' + hashCode(this) + ']';
  };
  function createSegment_0(id, prev) {
    _init_properties_Semaphore_kt__t514r6();
    return new SemaphoreSegment(id, prev, 0);
  }
  var properties_initialized_Semaphore_kt_uqcwok;
  function _init_properties_Semaphore_kt__t514r6() {
    if (!properties_initialized_Semaphore_kt_uqcwok) {
      properties_initialized_Semaphore_kt_uqcwok = true;
      MAX_SPIN_CYCLES = systemProp('kotlinx.coroutines.semaphore.maxSpinCycles', 100);
      PERMIT = new Symbol('PERMIT');
      TAKEN = new Symbol('TAKEN');
      BROKEN = new Symbol('BROKEN');
      CANCELLED = new Symbol('CANCELLED');
      SEGMENT_SIZE_0 = systemProp('kotlinx.coroutines.semaphore.segmentSize', 16);
    }
  }
  function createDefaultDispatcher() {
    var tmp;
    if (isJsdom()) {
      tmp = NodeDispatcher_getInstance();
    } else {
      var tmp_0;
      var tmp_1;
      if (!(typeof window === 'undefined')) {
        // Inline function 'kotlin.js.asDynamic' call
        tmp_1 = window != null;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = !(typeof window.addEventListener === 'undefined');
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = asCoroutineDispatcher(window);
      } else {
        if (typeof process === 'undefined' || typeof process.nextTick === 'undefined') {
          tmp = SetTimeoutDispatcher_getInstance();
        } else {
          tmp = NodeDispatcher_getInstance();
        }
      }
    }
    return tmp;
  }
  function isJsdom() {
    return !(typeof navigator === 'undefined') && navigator != null && navigator.userAgent != null && !(typeof navigator.userAgent === 'undefined') && !(typeof navigator.userAgent.match === 'undefined') && navigator.userAgent.match('\\bjsdom\\b');
  }
  var counter;
  function get_DEBUG() {
    return DEBUG;
  }
  var DEBUG;
  function get_classSimpleName(_this__u8e3s4) {
    var tmp0_elvis_lhs = getKClassFromExpression(_this__u8e3s4).o();
    return tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
  }
  function get_hexAddress(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    var result = _this__u8e3s4.__debug_counter;
    if (!(typeof result === 'number')) {
      counter = counter + 1 | 0;
      result = counter;
      // Inline function 'kotlin.js.asDynamic' call
      _this__u8e3s4.__debug_counter = result;
    }
    return ((!(result == null) ? typeof result === 'number' : false) ? result : THROW_CCE()).toString();
  }
  function NodeDispatcher() {
    NodeDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  protoOf(NodeDispatcher).a2w = function () {
    process.nextTick(this.h2w_1.f2w_1);
  };
  var NodeDispatcher_instance;
  function NodeDispatcher_getInstance() {
    if (NodeDispatcher_instance == null)
      new NodeDispatcher();
    return NodeDispatcher_instance;
  }
  function ScheduledMessageQueue$processQueue$lambda(this$0) {
    return function () {
      this$0.l2w();
      return Unit_instance;
    };
  }
  function ScheduledMessageQueue(dispatcher) {
    MessageQueue.call(this);
    this.e2w_1 = dispatcher;
    var tmp = this;
    tmp.f2w_1 = ScheduledMessageQueue$processQueue$lambda(this);
  }
  protoOf(ScheduledMessageQueue).m2w = function () {
    this.e2w_1.a2w();
  };
  protoOf(ScheduledMessageQueue).n2w = function () {
    setTimeout(this.f2w_1, 0);
  };
  protoOf(ScheduledMessageQueue).o2w = function (timeout) {
    setTimeout(this.f2w_1, timeout);
  };
  function w3cSetTimeout(handler, timeout) {
    return setTimeout(handler, timeout);
  }
  function WindowMessageQueue$lambda(this$0) {
    return function (event) {
      var tmp;
      if (event.source == this$0.c2x_1 && event.data == this$0.d2x_1) {
        event.stopPropagation();
        this$0.l2w();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function WindowMessageQueue$schedule$lambda(this$0) {
    return function (it) {
      this$0.l2w();
      return Unit_instance;
    };
  }
  function WindowMessageQueue(window_0) {
    MessageQueue.call(this);
    this.c2x_1 = window_0;
    this.d2x_1 = 'dispatchCoroutine';
    this.c2x_1.addEventListener('message', WindowMessageQueue$lambda(this), true);
  }
  protoOf(WindowMessageQueue).m2w = function () {
    var tmp = Promise.resolve(Unit_instance);
    tmp.then(WindowMessageQueue$schedule$lambda(this));
  };
  protoOf(WindowMessageQueue).n2w = function () {
    this.c2x_1.postMessage(this.d2x_1, '*');
  };
  function w3cSetTimeout_0(window_0, handler, timeout) {
    return setTimeout_0(window_0, handler, timeout);
  }
  function w3cClearTimeout(window_0, handle) {
    return window_0.clearTimeout(handle);
  }
  function w3cClearTimeout_0(handle) {
    return clearTimeout(handle);
  }
  function setTimeout_0(window_0, handler, timeout) {
    return window_0.setTimeout(handler, timeout);
  }
  function toThrowable(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof Error ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? Exception_init_$Create$("Promise resolved with a non-Throwable exception '" + _this__u8e3s4.toString() + "' (type " + toString(getKClassFromExpression(_this__u8e3s4)) + ')') : tmp0_elvis_lhs;
  }
  function asCoroutineDispatcher(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_elvis_lhs = _this__u8e3s4.coroutineDispatcher;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new WindowDispatcher(_this__u8e3s4);
      // Inline function 'kotlin.js.asDynamic' call
      _this__u8e3s4.coroutineDispatcher = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function newCoroutineContext(_this__u8e3s4, context) {
    var combined = _this__u8e3s4.q19().xj(context);
    return !(combined === Dispatchers_getInstance().i1h_1) && combined.aa(Key_instance) == null ? combined.xj(Dispatchers_getInstance().i1h_1) : combined;
  }
  function newCoroutineContext_0(_this__u8e3s4, addedContext) {
    return _this__u8e3s4.xj(addedContext);
  }
  function UndispatchedCoroutine(context, uCont) {
    ScopeCoroutine.call(this, context, uCont);
  }
  protoOf(UndispatchedCoroutine).a1a = function (state) {
    return this.z1c_1.y9(recoverResult(state, this.z1c_1));
  };
  function toDebugString(_this__u8e3s4) {
    return toString(_this__u8e3s4);
  }
  function get_DefaultDelay() {
    var tmp = Dispatchers_getInstance().i1h_1;
    return isInterface(tmp, Delay) ? tmp : THROW_CCE();
  }
  function get_coroutineName(_this__u8e3s4) {
    return null;
  }
  function Dispatchers() {
    Dispatchers_instance = this;
    this.i1h_1 = createDefaultDispatcher();
    this.j1h_1 = Unconfined_getInstance();
    this.k1h_1 = new JsMainDispatcher(this.i1h_1, false);
    this.l1h_1 = null;
  }
  protoOf(Dispatchers).m1h = function () {
    var tmp0_elvis_lhs = this.l1h_1;
    return tmp0_elvis_lhs == null ? this.k1h_1 : tmp0_elvis_lhs;
  };
  var Dispatchers_instance;
  function Dispatchers_getInstance() {
    if (Dispatchers_instance == null)
      new Dispatchers();
    return Dispatchers_instance;
  }
  function JsMainDispatcher(delegate, invokeImmediately) {
    MainCoroutineDispatcher.call(this);
    this.j2x_1 = delegate;
    this.k2x_1 = invokeImmediately;
    this.l2x_1 = this.k2x_1 ? this : new JsMainDispatcher(this.j2x_1, true);
  }
  protoOf(JsMainDispatcher).o1l = function () {
    return this.l2x_1;
  };
  protoOf(JsMainDispatcher).y1g = function (context) {
    return !this.k2x_1;
  };
  protoOf(JsMainDispatcher).b1h = function (context, block) {
    return this.j2x_1.b1h(context, block);
  };
  protoOf(JsMainDispatcher).c1h = function (context, block) {
    return this.j2x_1.c1h(context, block);
  };
  protoOf(JsMainDispatcher).toString = function () {
    var tmp0_elvis_lhs = this.p1l();
    return tmp0_elvis_lhs == null ? this.j2x_1.toString() : tmp0_elvis_lhs;
  };
  function get_RECOVER_STACK_TRACES() {
    return RECOVER_STACK_TRACES;
  }
  var RECOVER_STACK_TRACES;
  function CancellationException_0(message, cause) {
    return CancellationException_init_$Create$_0(message, cause);
  }
  function JobCancellationException(message, cause, job) {
    CancellationException_init_$Init$_0(message, cause, this);
    captureStack(this, JobCancellationException);
    this.m2x_1 = job;
  }
  protoOf(JobCancellationException).toString = function () {
    return protoOf(CancellationException).toString.call(this) + '; job=' + toString(this.m2x_1);
  };
  protoOf(JobCancellationException).equals = function (other) {
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof JobCancellationException) {
        tmp_2 = other.message == this.message;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = equals(other.m2x_1, this.m2x_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = equals(other.cause, this.cause);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(JobCancellationException).hashCode = function () {
    var tmp = imul(imul(getStringHashCode(ensureNotNull(this.message)), 31) + hashCode(this.m2x_1) | 0, 31);
    var tmp0_safe_receiver = this.cause;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  };
  function Runnable() {
  }
  function Runnable$run$ref(p0) {
    return constructCallableReference(function () {
      p0.o1f();
      return Unit_instance;
    }, 0, 0, 8, 'run', [p0]);
  }
  function SchedulerTask() {
  }
  function AbortFlowException(owner) {
    CancellationException_init_$Init$('Flow was aborted, no more elements needed', this);
    captureStack(this, AbortFlowException);
    this.o28_1 = owner;
  }
  function ChildCancelledException() {
    CancellationException_init_$Init$('Child of the scoped flow was cancelled', this);
    captureStack(this, ChildCancelledException);
  }
  function SafeCollector$collectContextSize$lambda(count, _unused_var__etf5q3) {
    return count + 1 | 0;
  }
  function SafeCollector(collector, collectContext) {
    this.n1x_1 = collector;
    this.o1x_1 = collectContext;
    var tmp = this;
    tmp.p1x_1 = this.o1x_1.wj(0, SafeCollector$collectContextSize$lambda);
    this.q1x_1 = null;
  }
  protoOf(SafeCollector).a1v = function (value, $completion) {
    // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
    // Inline function 'kotlin.js.getCoroutineContext' call
    var currentContext = $completion.t9();
    ensureActive(currentContext);
    if (!(this.q1x_1 === currentContext)) {
      checkContext(this, currentContext);
      this.q1x_1 = currentContext;
    }
    return this.n1x_1.a1v(value, $completion);
  };
  protoOf(SafeCollector).x9 = function () {
  };
  function identitySet(expectedSize) {
    return HashSet_init_$Create$(expectedSize);
  }
  function WorkaroundAtomicReference(value) {
    this.v21_1 = value;
  }
  protoOf(WorkaroundAtomicReference).f1i = function () {
    return this.v21_1;
  };
  protoOf(WorkaroundAtomicReference).k2p = function (value) {
    this.v21_1 = value;
  };
  protoOf(WorkaroundAtomicReference).x21 = function (value) {
    var prev = this.v21_1;
    this.v21_1 = value;
    return prev;
  };
  protoOf(WorkaroundAtomicReference).w21 = function (expected, value) {
    if (this.v21_1 === expected) {
      this.v21_1 = value;
      return true;
    }
    return false;
  };
  function get_platformExceptionHandlers_() {
    _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
    return platformExceptionHandlers_;
  }
  var platformExceptionHandlers_;
  function get_platformExceptionHandlers() {
    _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
    return get_platformExceptionHandlers_();
  }
  function DiagnosticCoroutineContextException(context) {
    RuntimeException_init_$Init$_0(toString(context), this);
    captureStack(this, DiagnosticCoroutineContextException);
  }
  var properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx;
  function _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf() {
    if (!properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx) {
      properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx = true;
      // Inline function 'kotlin.collections.mutableSetOf' call
      platformExceptionHandlers_ = LinkedHashSet_init_$Create$();
    }
  }
  function LockFreeLinkedListNode() {
    this.d1g_1 = this;
    this.e1g_1 = this;
    this.f1g_1 = false;
  }
  protoOf(LockFreeLinkedListNode).g1g = function (node, permissionsBitmask) {
    var prev = this.e1g_1;
    var tmp;
    if (prev instanceof ListClosed) {
      tmp = ((prev.q2x_1 & permissionsBitmask) === 0 && prev.g1g(node, permissionsBitmask));
    } else {
      node.d1g_1 = this;
      node.e1g_1 = prev;
      prev.d1g_1 = node;
      this.e1g_1 = node;
      tmp = true;
    }
    return tmp;
  };
  protoOf(LockFreeLinkedListNode).t1i = function (forbiddenElementsBit) {
    this.g1g(new ListClosed(forbiddenElementsBit), forbiddenElementsBit);
  };
  protoOf(LockFreeLinkedListNode).h1g = function () {
    if (this.f1g_1)
      return false;
    var prev = this.e1g_1;
    var next = this.d1g_1;
    prev.d1g_1 = next;
    next.e1g_1 = prev;
    this.f1g_1 = true;
    return true;
  };
  protoOf(LockFreeLinkedListNode).i1g = function (node) {
    if (!(this.d1g_1 === this))
      return false;
    this.g1g(node, -2147483648);
    return true;
  };
  function LockFreeLinkedListHead() {
    LockFreeLinkedListNode.call(this);
  }
  function ListClosed(forbiddenElementsBitmask) {
    LockFreeLinkedListNode.call(this);
    this.q2x_1 = forbiddenElementsBitmask;
  }
  function LocalAtomicInt(value) {
    this.t26_1 = value;
  }
  protoOf(LocalAtomicInt).u26 = function () {
    this.t26_1 = this.t26_1 - 1 | 0;
    return this.t26_1;
  };
  function recoverStackTrace(exception, continuation) {
    return exception;
  }
  function unwrap(exception) {
    return exception;
  }
  function initCause(_this__u8e3s4, cause) {
  }
  function recoverStackTrace_0(exception) {
    return exception;
  }
  function SynchronizedObject() {
  }
  function systemProp_1(propertyName) {
    return null;
  }
  function threadContextElements(context) {
    return 0;
  }
  function CommonThreadLocal() {
    this.e1i_1 = null;
  }
  protoOf(CommonThreadLocal).f1i = function () {
    return this.e1i_1;
  };
  protoOf(CommonThreadLocal).g1i = function (value) {
    this.e1i_1 = value;
  };
  function commonThreadLocal(name) {
    return new CommonThreadLocal();
  }
  function createEventLoop() {
    return new UnconfinedEventLoop();
  }
  function UnconfinedEventLoop() {
    EventLoop.call(this);
  }
  protoOf(UnconfinedEventLoop).b1h = function (context, block) {
    unsupported();
  };
  function unsupported() {
    throw UnsupportedOperationException_init_$Create$('runBlocking event loop is not supported');
  }
  function await_0(_this__u8e3s4, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.v1e();
    var tmp = await$lambda(cancellable);
    _this__u8e3s4.then(tmp, await$lambda_0(cancellable));
    return cancellable.x1b();
  }
  function await$lambda($cont) {
    return function (it) {
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = $cont;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$1 = _Result___init__impl__xyqfz8(it);
      this_0.y9(tmp$ret$1);
      return null;
    };
  }
  function await$lambda_0($cont) {
    return function (it) {
      var tmp0 = $cont;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = toThrowable(it);
      var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
      tmp0.y9(tmp$ret$1);
      return null;
    };
  }
  function propagateExceptionFinalResort(exception) {
    // Inline function 'kotlin.with' call
    throwAsyncJsError(exception.message, getKClassFromExpression(exception).o(), stackTraceToString(exception));
    return Unit_instance;
  }
  function throwAsyncJsError(message, className, stack) {
    var error = new Error();
    error.message = message;
    error.name = className;
    error.stack = stack;
    if (typeof globalThis.reportError === 'function') {
      // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
      globalThis.reportError(error);
    } else {
      // Fallback for old browsers (pre-2022), Node.js
      setTimeout(function () {
        throw error;
      }, 0);
    }
  }
  function SetTimeoutDispatcher() {
    SetTimeoutDispatcher_instance = this;
    SetTimeoutBasedDispatcher.call(this);
  }
  protoOf(SetTimeoutDispatcher).a2w = function () {
    this.h2w_1.o2w(0);
  };
  var SetTimeoutDispatcher_instance;
  function SetTimeoutDispatcher_getInstance() {
    if (SetTimeoutDispatcher_instance == null)
      new SetTimeoutDispatcher();
    return SetTimeoutDispatcher_instance;
  }
  function SetTimeoutBasedDispatcher$invokeOnTimeout$lambda($block) {
    return function () {
      $block.o1f();
      return Unit_instance;
    };
  }
  function SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
    return function () {
      // Inline function 'kotlin.with' call
      $continuation.g1d(this$0, Unit_instance);
      return Unit_instance;
    };
  }
  function SetTimeoutBasedDispatcher() {
    CoroutineDispatcher.call(this);
    this.h2w_1 = new ScheduledMessageQueue(this);
  }
  protoOf(SetTimeoutBasedDispatcher).z1g = function (parallelism, name) {
    checkParallelism(parallelism);
    return namedOrThis(this, name);
  };
  protoOf(SetTimeoutBasedDispatcher).b1h = function (context, block) {
    this.h2w_1.p2w(block);
  };
  protoOf(SetTimeoutBasedDispatcher).p1h = function (timeMillis, block, context) {
    var handle = w3cSetTimeout(SetTimeoutBasedDispatcher$invokeOnTimeout$lambda(block), delayToInt(timeMillis));
    return new ClearTimeout(handle);
  };
  protoOf(SetTimeoutBasedDispatcher).o1h = function (timeMillis, continuation) {
    var handle = w3cSetTimeout(SetTimeoutBasedDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
    invokeOnCancellation(continuation, new ClearTimeout(handle));
  };
  function MessageQueue() {
    this.i2w_1 = ArrayDeque_init_$Create$();
    this.j2w_1 = 16;
    this.k2w_1 = false;
  }
  protoOf(MessageQueue).p2w = function (element) {
    this.q2w(element);
    if (!this.k2w_1) {
      this.k2w_1 = true;
      this.m2w();
    }
  };
  protoOf(MessageQueue).l2w = function () {
    try {
      // Inline function 'kotlin.repeat' call
      var times = this.j2w_1;
      var inductionVariable = 0;
      if (inductionVariable < times)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0_elvis_lhs = removeFirstOrNull(this);
          var tmp;
          if (tmp0_elvis_lhs == null) {
            return Unit_instance;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var element = tmp;
          element.o1f();
        }
         while (inductionVariable < times);
    }finally {
      if (this.r()) {
        this.k2w_1 = false;
      } else {
        this.n2w();
      }
    }
  };
  protoOf(MessageQueue).q2w = function (element) {
    return this.i2w_1.j1(element);
  };
  protoOf(MessageQueue).j1 = function (element) {
    return this.q2w((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).r2w = function (index, element) {
    this.i2w_1.g3(index, element);
  };
  protoOf(MessageQueue).g3 = function (index, element) {
    return this.r2w(index, (!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).s2w = function (element) {
    return this.i2w_1.d3(element);
  };
  protoOf(MessageQueue).d3 = function (element) {
    if (!(!(element == null) ? isInterface(element, Runnable) : false))
      return false;
    return this.s2w((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).t2w = function (elements) {
    return this.i2w_1.o1(elements);
  };
  protoOf(MessageQueue).o1 = function (elements) {
    return this.t2w(elements);
  };
  protoOf(MessageQueue).u2w = function (index, elements) {
    return this.i2w_1.e3(index, elements);
  };
  protoOf(MessageQueue).e3 = function (index, elements) {
    return this.u2w(index, elements);
  };
  protoOf(MessageQueue).c3 = function () {
    this.i2w_1.c3();
  };
  protoOf(MessageQueue).v2w = function (index, element) {
    return this.i2w_1.f3(index, element);
  };
  protoOf(MessageQueue).f3 = function (index, element) {
    return this.v2w(index, (!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).h3 = function (index) {
    return this.i2w_1.h3(index);
  };
  protoOf(MessageQueue).p1 = function (index) {
    return this.i2w_1.p1(index);
  };
  protoOf(MessageQueue).t2 = function (fromIndex, toIndex) {
    return this.i2w_1.t2(fromIndex, toIndex);
  };
  protoOf(MessageQueue).r = function () {
    return this.i2w_1.r();
  };
  protoOf(MessageQueue).w2w = function (element) {
    return this.i2w_1.m1(element);
  };
  protoOf(MessageQueue).m1 = function (element) {
    if (!(!(element == null) ? isInterface(element, Runnable) : false))
      return false;
    return this.w2w((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).t = function () {
    return this.i2w_1.t();
  };
  protoOf(MessageQueue).x2w = function (elements) {
    return this.i2w_1.r2(elements);
  };
  protoOf(MessageQueue).r2 = function (elements) {
    return this.x2w(elements);
  };
  protoOf(MessageQueue).l1 = function (index) {
    return this.i2w_1.l1(index);
  };
  protoOf(MessageQueue).y2w = function (element) {
    return this.i2w_1.q1(element);
  };
  protoOf(MessageQueue).q1 = function (element) {
    if (!(!(element == null) ? isInterface(element, Runnable) : false))
      return -1;
    return this.y2w((!(element == null) ? isInterface(element, Runnable) : false) ? element : THROW_CCE());
  };
  protoOf(MessageQueue).n1 = function () {
    return this.i2w_1.sg_1;
  };
  function WindowClearTimeout($outer, handle) {
    this.y2x_1 = $outer;
    ClearTimeout.call(this, handle);
  }
  protoOf(WindowClearTimeout).s1d = function () {
    w3cClearTimeout(this.y2x_1.a2y_1, this.c2y_1);
  };
  function WindowDispatcher$scheduleResumeAfterDelay$lambda($continuation, this$0) {
    return function () {
      // Inline function 'kotlin.with' call
      $continuation.g1d(this$0, Unit_instance);
      return Unit_instance;
    };
  }
  function WindowDispatcher(window_0) {
    CoroutineDispatcher.call(this);
    this.a2y_1 = window_0;
    this.b2y_1 = new WindowMessageQueue(this.a2y_1);
  }
  protoOf(WindowDispatcher).b1h = function (context, block) {
    return this.b2y_1.p2w(block);
  };
  protoOf(WindowDispatcher).o1h = function (timeMillis, continuation) {
    var handle = w3cSetTimeout_0(this.a2y_1, WindowDispatcher$scheduleResumeAfterDelay$lambda(continuation, this), delayToInt(timeMillis));
    invokeOnCancellation(continuation, new WindowClearTimeout(this, handle));
  };
  protoOf(WindowDispatcher).p1h = function (timeMillis, block, context) {
    var handle = w3cSetTimeout_0(this.a2y_1, Runnable$run$ref(block), delayToInt(timeMillis));
    return new WindowClearTimeout(this, handle);
  };
  function delayToInt(timeMillis) {
    return convertToInt(coerceIn(timeMillis, new Long(0, 0), new Long(2147483647, 0)));
  }
  function ClearTimeout(handle) {
    this.c2y_1 = handle;
  }
  protoOf(ClearTimeout).s1d = function () {
    w3cClearTimeout_0(this.c2y_1);
  };
  protoOf(ClearTimeout).r1d = function (cause) {
    this.s1d();
  };
  protoOf(ClearTimeout).toString = function () {
    return 'ClearTimeout[' + this.c2y_1 + ']';
  };
  //region block: post-declaration
  protoOf(JobSupport).v1a = invokeOnCompletion$default;
  protoOf(JobSupport).b1b = cancel$default;
  protoOf(JobSupport).xj = plus;
  protoOf(JobSupport).aa = get_0;
  protoOf(JobSupport).wj = fold;
  protoOf(JobSupport).vj = minusKey_0;
  protoOf(CancellableContinuationImpl).e1d = cancel$default_0;
  protoOf(CoroutineDispatcher).aa = get;
  protoOf(CoroutineDispatcher).vj = minusKey;
  protoOf(BufferedChannel).b1t = close$default;
  protoOf(BufferedChannel).d1t = cancel$default_1;
  protoOf(ChannelCoroutine).b1t = close$default;
  protoOf(ChannelFlow).b1x = fuse$default;
  protoOf(SharedFlowImpl).b1x = fuse$default;
  protoOf(StateFlowImpl).b1x = fuse$default;
  protoOf(ReadonlyStateFlow).b1x = fuse$default;
  protoOf(ReadonlySharedFlow).b1x = fuse$default;
  defineProp(protoOf(DispatchException), 'cause', function () {
    return this.f();
  });
  protoOf(CancellableContinuationWithOwner).e1d = cancel$default_0;
  protoOf(MutexImpl).p2u = lock$default;
  protoOf(MutexImpl).n2u = tryLock$default;
  protoOf(MutexImpl).r2u = unlock$default;
  //endregion
  //region block: init
  Active_instance = new Active();
  Key_instance_1 = new Key_0();
  Key_instance_2 = new Key_1();
  GlobalScope_instance = new GlobalScope();
  Key_instance_3 = new Key_2();
  NonDisposableHandle_instance = new NonDisposableHandle();
  Key_instance_4 = new Key_3();
  EmptyFlow_instance = new EmptyFlow();
  NopCollector_instance = new NopCollector();
  counter = 0;
  DEBUG = false;
  RECOVER_STACK_TRACES = false;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = ChannelResult__getOrNull_impl_f5e07h;
  _.$_$.b = _ChannelResult___get_isClosed__impl__mg7kuu;
  _.$_$.c = _ChannelResult___get_isSuccess__impl__odq1z9;
  _.$_$.d = Factory_getInstance;
  _.$_$.e = Companion_getInstance_1;
  _.$_$.f = Key_instance_1;
  _.$_$.g = Key_instance_2;
  _.$_$.h = Dispatchers_getInstance;
  _.$_$.i = GlobalScope_instance;
  _.$_$.j = Key_instance_3;
  _.$_$.k = BufferOverflow_DROP_LATEST_getInstance;
  _.$_$.l = BufferOverflow_DROP_OLDEST_getInstance;
  _.$_$.m = BufferOverflow_SUSPEND_getInstance;
  _.$_$.n = CoroutineStart_LAZY_getInstance;
  _.$_$.o = CoroutineStart_UNDISPATCHED_getInstance;
  _.$_$.p = collectLatest;
  _.$_$.q = emitAll_0;
  _.$_$.r = firstOrNull;
  _.$_$.s = first;
  _.$_$.t = awaitCancellation;
  _.$_$.u = await_0;
  _.$_$.v = cancelAndJoin;
  _.$_$.w = coroutineScope;
  _.$_$.x = delay;
  _.$_$.y = delay_0;
  _.$_$.z = supervisorScope;
  _.$_$.a1 = withContext;
  _.$_$.b1 = withTimeoutOrNull;
  _.$_$.c1 = withTimeout;
  _.$_$.d1 = yield_0;
  _.$_$.e1 = cancel$default_1;
  _.$_$.f1 = close$default;
  _.$_$.g1 = ChannelResult;
  _.$_$.h1 = Channel;
  _.$_$.i1 = ClosedReceiveChannelException;
  _.$_$.j1 = ClosedSendChannelException;
  _.$_$.k1 = ProducerScope;
  _.$_$.l1 = ReceiveChannel;
  _.$_$.m1 = SendChannel;
  _.$_$.n1 = cancelConsumed;
  _.$_$.o1 = produce;
  _.$_$.p1 = FlowCollector;
  _.$_$.q1 = Flow;
  _.$_$.r1 = MutableSharedFlow;
  _.$_$.s1 = MutableStateFlow;
  _.$_$.t1 = asFlow;
  _.$_$.u1 = asSharedFlow;
  _.$_$.v1 = asStateFlow;
  _.$_$.w1 = catch_0;
  _.$_$.x1 = combine;
  _.$_$.y1 = debounce;
  _.$_$.z1 = emptyFlow;
  _.$_$.a2 = filterNotNull;
  _.$_$.b2 = flowOf;
  _.$_$.c2 = flowOn;
  _.$_$.d2 = flow;
  _.$_$.e2 = launchIn;
  _.$_$.f2 = onCompletion;
  _.$_$.g2 = onEach;
  _.$_$.h2 = onStart;
  _.$_$.i2 = receiveAsFlow;
  _.$_$.j2 = stateIn;
  _.$_$.k2 = transformLatest;
  _.$_$.l2 = SynchronizedObject;
  _.$_$.m2 = recoverStackTrace;
  _.$_$.n2 = startCoroutineCancellable;
  _.$_$.o2 = Mutex_0;
  _.$_$.p2 = Semaphore;
  _.$_$.q2 = CancellableContinuationImpl;
  _.$_$.r2 = CancellationException_0;
  _.$_$.s2 = CompletableDeferred;
  _.$_$.t2 = CompletableJob;
  _.$_$.u2 = CopyableThrowable;
  _.$_$.v2 = CoroutineDispatcher;
  _.$_$.w2 = CoroutineName;
  _.$_$.x2 = CoroutineScope_0;
  _.$_$.y2 = CoroutineScope;
  _.$_$.z2 = invokeOnTimeout;
  _.$_$.a3 = Delay;
  _.$_$.b3 = DisposableHandle;
  _.$_$.c3 = Job_0;
  _.$_$.d3 = Job;
  _.$_$.e3 = MainScope;
  _.$_$.f3 = Runnable;
  _.$_$.g3 = SupervisorJob;
  _.$_$.h3 = async;
  _.$_$.i3 = cancel;
  _.$_$.j3 = cancel_2;
  _.$_$.k3 = cancel_0;
  _.$_$.l3 = cancel_1;
  _.$_$.m3 = ensureActive;
  _.$_$.n3 = get_isActive_0;
  _.$_$.o3 = get_isActive;
  _.$_$.p3 = get_job;
  _.$_$.q3 = launch;
  //endregion
  return _;
}));

//# sourceMappingURL=kotlinx-coroutines-core.js.map
